webpackJsonp([5],{

/***/ "+K3d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Xrt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__ = __webpack_require__("MPt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UorNaoParticipante',
  components: {
    PaginaErro: __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default.a
  }
});

/***/ }),

/***/ "+h9g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var ErrorHelper = function () {
  function ErrorHelper() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ErrorHelper);

    throw 'Não é possível instanciar ErrorHelper';
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ErrorHelper, null, [{
    key: 'trataMensagem',
    value: function trataMensagem(error) {
      var message = 'Ocorreu um erro inesperado, tente novamente mais tarde.';

      if (!!error && !!error.body && !error.data) {
        message = Array.isArray(error.body) ? error.body[0].message : error.body.message;
      }

      if (!!error && !!error.data) {
        message = Array.isArray(error.data) ? error.data[0].message : error.data.message;
      }

      if (!!error && !!error.message && typeof error.message === 'string') {
        message = error.message;
      }

      return message;
    }
  }]);

  return ErrorHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (ErrorHelper);

/***/ }),

/***/ "/1hM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/97V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ErrorHelper__ = __webpack_require__("+h9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_obtemImpressao__ = __webpack_require__("8QDf");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Fim',

  data: function data() {
    return {
      step: 7,
      cadastrado: this.$store.state.funcionarioCadastrado,
      apiErrors: null,
      titulo: ""
    };
  },


  methods: {
    chamaComponente: function chamaComponente(nomeComponente) {
      this.$router.push({ name: nomeComponente });
    },
    imprime: function imprime(id, protocolo) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint, mensagem;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = 'recadastramento-servidores/' + id + '/comprovantes/' + protocolo;
                _context.prev = 1;
                _context.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_obtemImpressao__["a" /* default */])(endpoint);

              case 4:
                _context.next = 11;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_3__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context.t0);

                if (mensagem === 'Desbloqueie as pop-ups para este site') {
                  _this.$root.$refs.toastr.w(mensagem, 'Pop-up bloqueada');
                }
                _this.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 6]]);
      }))();
    }
  },

  mounted: function mounted() {
    window.scrollTo(0, 0);
  },
  created: function created() {
    var _this2 = this;

    this.$root.$data.stepNumber = this.step;
    if (this.cadastrado.mostraMultiplosRegistros) {
      this.$root.$refs.toastr.w('Os dados do seu outro Registro serão atualizados automaticamente.', 'Atenção');
    }
    this.$eventBus.$on('salvaAvanca', function (nomeComponente) {
      _this2.chamaComponente(nomeComponente);
    });

    if (this.cadastrado && this.cadastrado.competencia) {
      this.titulo = 'Atualiza\xE7\xE3o Cadastral ' + this.cadastrado.competencia.ano;
    } else {
      this.titulo = "Atualização Cadastral"; // Valor padrão
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off('salvaAvanca');
  },


  components: {
    botao: __WEBPACK_IMPORTED_MODULE_2__components_botao___default.a
  }
});

/***/ }),

/***/ "/aLi":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "finalizaModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "finalizaModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal",
      "dismiss": "modal"
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde",
      "rotulo": "Não",
      "icone": "fa-times fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.discorda()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Sim",
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.concorda()
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-lg-5 col-md-5 col-sm-5"
  }, [_c('label', [_vm._v("Nome:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.avaliado.pessoa.nome))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
  }, [_c('label', [_vm._v("Registro:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.avaliado.registroFormatado))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
  }, [_c('label', [_vm._v("Cargo:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.avaliado.cargoPrincipal))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-lg-5 col-md-5 col-sm-5"
  }, [_c('label', [_vm._v("Nome:")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.avaliacao.avaliador && _vm.avaliacao.avaliador.pessoa && _vm.avaliacao.avaliador.pessoa.nome ? _vm.avaliacao.avaliador.pessoa.nome : 'Nome não disponível') + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
  }, [_c('label', [_vm._v("Registro:")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.avaliacao.avaliador ? _vm.avaliacao.avaliador.registroFormatado : 'Sem registro') + "\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-3 col-xs-6"
  }, [_c('label', [_vm._v("Número de Faltas:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeFaltas))]), _vm._v(" "), _c('label', [_vm._v("Deduções:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeDeducoesFaltas))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-3 col-xs-6"
  }, [_c('label', [_vm._v("Número de Atrasos:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeAtrasos))]), _vm._v(" "), _c('label', [_vm._v("Deduções:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeDeducoesAtrasos))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-3 col-xs-6"
  }, [_c('label', [_vm._v("Repreensões:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeRepreensoes))]), _vm._v(" "), _c('label', [_vm._v("Deduções:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeDeducoesRepreensoes))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-3 col-xs-6"
  }, [_c('label', [_vm._v("NOTA FINAL (A):")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.notaFichaFuncional))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Avaliação de Desempenho")]), _vm._v(" "), (_vm.ehRecemEstavel) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                      O estatutário que\n                      "), _c('strong', [_vm._v("se tornou estável no segundo semestre de\n                        " + _vm._s(_vm.avaliacao.competencia.ano))]), _vm._v("\n                      terá sua nota de desempenho atribuída automaticamente no\n                      sistema, considerando a 5º avaliação do estágio\n                      probatório. "), _c('strong', [_vm._v("Não será necessário")]), _vm._v(" incluir\n                      notas de "), _c('strong', [_vm._v("autoavaliação")]), _vm._v(",\n                      "), _c('strong', [_vm._v("nem ser avaliado")]), _vm._v(" pelo chefe imediato. A\n                      ficha de avaliação de\n                      " + _vm._s(_vm.avaliacao.competencia.ano) + " estará disponível\n                      "), _c('strong', [_vm._v("somente para visualização")]), _vm._v(".\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', [_vm._v("AVALIAÇÃO FICHA FUNCIONAL:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.notaFichaFuncional))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', [_vm._v("AVALIAÇÃO ESTÁGIO PROBATÓRIO:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.mediaEstagioProbatorio))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', [_vm._v("PONTUAÇÃO FINAL:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.pontuacaoFinalProbatorio))])])])])])]) : _c('div', [_c('b', [_vm._v("Parâmetros ")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-condensed hidden-xs"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.notasOrdenadas), function(nota, index) {
    return _c('tr', {
      key: nota.id,
      class: {
        'has-error': _vm.errors.has('name' + index)
      }
    }, [_c('td', {
      attrs: {
        "data-title": "",
        "align": "left"
      }
    }, [_vm._v("\n                          " + _vm._s(nota.item.codigo) + "\n                        ")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Indicadores de Desempenho",
        "align": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(nota.item.titulo) + " ")]), _vm._v(" "), _c('esconde-div', [_vm._v(_vm._s(nota.item.descricao))])], 1), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Autoavaliação (B)",
        "align": "left"
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (
          'required|numeric|min_value:1|max_value:8'
        ),
        expression: "\n                              'required|numeric|min_value:1|max_value:8'\n                            "
      }, {
        name: "model",
        rawName: "v-model",
        value: (nota.notaAutoAvaliacao),
        expression: "nota.notaAutoAvaliacao"
      }],
      attrs: {
        "type": "text",
        "size": "3",
        "name": 'notaB' + index,
        "id": 'notaB' + index,
        "data-vv-as": "Nota",
        "disabled": _vm.habilitaCampoAvaliado
      },
      domProps: {
        "value": (nota.notaAutoAvaliacao)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(nota, "notaAutoAvaliacao", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('notaB' + index)),
        expression: "errors.has('notaB' + index)"
      }],
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.errors.first('notaB' + index)))])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Avaliador (C)",
        "align": "left"
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (
          'required|numeric|min_value:1|max_value:8'
        ),
        expression: "\n                              'required|numeric|min_value:1|max_value:8'\n                            "
      }, {
        name: "model",
        rawName: "v-model",
        value: (nota.notaAvaliador),
        expression: "nota.notaAvaliador"
      }],
      attrs: {
        "type": "text",
        "size": "3",
        "name": 'notaC' + index,
        "id": 'notaC' + index,
        "data-vv-as": "Nota",
        "disabled": _vm.habilitaNotasAvaliador
      },
      domProps: {
        "value": (nota.notaAvaliador)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(nota, "notaAvaliador", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('notaC' + index)),
        expression: "errors.has('notaC' + index)"
      }],
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.errors.first('notaC' + index)))])])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "12px"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.somaAutoavaliacao) + "\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "12px"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.somaAvaliador) + "\n                        ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-condensed visible-xs"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.notasOrdenadas), function(nota, index) {
    return _c('tr', {
      key: nota.id,
      class: {
        'has-error': _vm.errors.has('name' + index)
      }
    }, [_c('td', {
      attrs: {
        "data-title": "",
        "align": "left"
      }
    }, [_vm._v("\n                          " + _vm._s(nota.item.codigo) + "\n                        ")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Indicadores de Desempenho",
        "align": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(nota.item.titulo) + " ")]), _vm._v(" "), _c('esconde-div', [_vm._v(_vm._s(nota.item.descricao))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_c('p', [_vm._v("Autoaval. (B)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (
          'required|numeric|min_value:1|max_value:8'
        ),
        expression: "\n                                  'required|numeric|min_value:1|max_value:8'\n                                "
      }, {
        name: "model",
        rawName: "v-model",
        value: (nota.notaAutoAvaliacao),
        expression: "nota.notaAutoAvaliacao"
      }],
      attrs: {
        "type": "number",
        "name": 'notaB' + index,
        "id": "notaB",
        "data-vv-as": "Nota",
        "disabled": _vm.habilitaCampoAvaliado
      },
      domProps: {
        "value": (nota.notaAutoAvaliacao)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(nota, "notaAutoAvaliacao", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('notaB' + index)),
        expression: "errors.has('notaB' + index)"
      }],
      staticClass: "error"
    }, [_vm._v("\n                                " + _vm._s(_vm.errors.first('notaB' + index)))])]), _vm._v(" "), _c('div', {
      staticClass: "item"
    }, [_c('p', [_vm._v("Avaliador (C)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (
          'required|numeric|min_value:1|max_value:8'
        ),
        expression: "\n                                  'required|numeric|min_value:1|max_value:8'\n                                "
      }, {
        name: "model",
        rawName: "v-model",
        value: (nota.notaAvaliador),
        expression: "nota.notaAvaliador"
      }],
      attrs: {
        "type": "number",
        "name": 'notaC' + index,
        "id": "notaC",
        "data-vv-as": "Nota",
        "disabled": _vm.habilitaNotasAvaliador
      },
      domProps: {
        "value": (nota.notaAvaliador)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(nota, "notaAvaliador", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('notaC' + index)),
        expression: "errors.has('notaC' + index)"
      }],
      staticClass: "error"
    }, [_vm._v("\n                                " + _vm._s(_vm.errors.first('notaC' + index)))])])])], 1)])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('b', [_vm._v("TOTAL DE PONTOS: ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', [_vm._v("Autoaval. (B)")]), _vm._v("\n                              " + _vm._s(_vm.somaAutoavaliacao) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', [_vm._v("Avaliador (C)")]), _vm._v("\n                              " + _vm._s(_vm.somaAvaliador) + "\n                            ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-lg-4 col-md-4 col-sm-4"
  }, [_c('label', [_vm._v("MÉDIA (M) = (B + C) / 2:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.mediaAvaliacoes))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-4 col-md-4 col-sm-4"
  }, [_c('label', [_vm._v("PONTUAÇÃO FINAL (A + M):")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.pontuacaoFinal))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-4 col-md-4 col-sm-4"
  }, [_c('label', [_vm._v("Data da Avaliação")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dataAvaliacao))])])])])])]), _vm._v(" "), (!_vm.ehRecemEstavel) ? _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Anuência")]), _vm._v(" "), _vm._m(9), _vm._v(" "), (_vm.avaliacao.aceita == true || _vm.avaliacao.aceita == false) ? _c('div', {
    staticClass: "col-lg-offset-2 col-lg-8 col-md-offset-2 col-md-8"
  }, [_c('div', {
    staticClass: "card sub-card sub-card-content"
  }, [_c('div', {
    staticClass: "anuencia"
  }, [_vm._v("\n                    Servidor avaliado\n                    "), _c('span', {
    staticClass: "anuencia-resultado"
  }, [_vm._v(_vm._s(_vm.avaliacao.aceita ? 'CONCORDA' : 'NÃO CONCORDA'))]), _vm._v("\n                    com a pontuação final.\n                  ")])])]) : _c('p')])]) : _vm._e()])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.voltar()
      }
    }
  }), _vm._v(" "), (_vm.mostraFinalizar) ? _c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Entregar",
      "icone": "fa-check fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.valida('finalizar')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mostraSalvar) ? _c('botao', {
    attrs: {
      "estilo": _vm.mostraFinalizar ? 'vazado-verde-dir' : 'cheio-verde-dir',
      "rotulo": "Salvar",
      "icone": "fa-floppy-o fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.valida('salvar')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: (
        'Visual. impres. finalizadas com Concordo ou Discordo'
      ),
      expression: "\n              'Visual. impres. finalizadas com Concordo ou Discordo'\n            ",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "disabled-tooltip"
  }, [(_vm.mostraImprimir) ? _c('botao', {
    attrs: {
      "estilo": _vm.ehAvaliador ? 'vazado-verde-dir' : 'cheio-verde-dir',
      "rotulo": "Imprimir",
      "icone": "imprimir-tabela",
      "disabled": (_vm.avaliacaoFinalizada || _vm.ehAvaliador || _vm.naoFinalizadoComPeriodoEncerrado) ? false : true
    },
    on: {
      "clicado": function($event) {
        return _vm.imprime(_vm.avaliacao.id)
      }
    }
  }) : _vm._e()], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "finalizaModalLabel"
    }
  }, [_vm._v("\n              Finalizar Avaliação\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Você concorda com o resultado da sua avaliação?\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("Funcionário "), _c('small', [_vm._v("(Avaliado)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("Chefe Imediato "), _c('small', [_vm._v("(Avaliador)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("\n                Avaliação de Ficha Funcional "), _c('small', [_vm._v("(Preenchido pelo DEGEPAT)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped table-condensed hidden-xs"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Acima do esperado")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Dentro do esperado")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Parcialmente esperado")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Abaixo do esperado")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "data-title": "Acima do esperado",
      "align": "left"
    }
  }, [_vm._v("\n                          (7-8 pontos)\n                        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-title": "Dentro do esperado",
      "align": "left"
    }
  }, [_vm._v("\n                          (5-6 pontos)\n                        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-title": "Parcialmente esperado",
      "align": "left"
    }
  }, [_vm._v("\n                          (3-4 pontos)\n                        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-title": "Abaixo do esperado",
      "align": "left"
    }
  }, [_vm._v("\n                          (1-2 pontos)\n                        ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-condensed visible-xs"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Acima do esperado")]), _vm._v(" "), _c('td', [_vm._v("(7-8 pontos)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Dentro do esperado")]), _vm._v(" "), _c('td', [_vm._v("(5-6 pontos)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Parcialmente esperado")]), _vm._v(" "), _c('td', [_vm._v("(3-4 pontos)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Abaixo do esperado")]), _vm._v(" "), _c('td', [_vm._v("(1-2 pontos)")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Indicadores de Desempenho")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "135px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('span', [_vm._v("Autoavaliação (B)")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "104px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('span', [_vm._v("Avaliador (C)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("TOTAL DE PONTOS DA AUTOAVALIAÇÃO (B) E DO\n                            AVALIADOR (C):\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Indicadores de Desempenho")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                    Na hipótese de o servidor não concordar com a pontuação\n                    final, poderá negociar com o Avaliador. Essa negociação\n                    das notas deverá ocorrer até o prazo final. Quando as\n                    notas forem definidas, o Avaliado deverá clicar no botão\n                    \"Entregar\" e selecionar dentre as opções “Concordo” ou\n                    “Discordo” e salvar para encerrar a Avaliação. A partir\n                    deste momento as notas não poderão ser alteradas.\n                  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                    Em caso de discordância, o servidor avaliado deverá abrir \n                    processo digital de Recurso de Notas de Avaliação, em até 10 (dez) \n                    dias úteis contados a partir da data do prazo final da avaliação.\n                  ")])])])
}]}

/***/ }),

/***/ "/doR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_declaracoesService__ = __webpack_require__("ijob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_enums_tiposBensService__ = __webpack_require__("zfz5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_dependenciasService__ = __webpack_require__("h5d5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_mesesCompetenciasService__ = __webpack_require__("6Civ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_obtemImpressao__ = __webpack_require__("8QDf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__domain_declaracao__ = __webpack_require__("hVVH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__domain_declaracao_item__ = __webpack_require__("HTYx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__domain_dependencia__ = __webpack_require__("9fBi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__domain_dependencia_renda__ = __webpack_require__("gy/Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_ArrayHelper__ = __webpack_require__("5OEK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_StringHelper__ = __webpack_require__("1pbJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__ = __webpack_require__("+h9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_side_modal__ = __webpack_require__("dLc8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_side_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_side_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_esconde_div__ = __webpack_require__("E20C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_esconde_div___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_esconde_div__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_table_loader__ = __webpack_require__("pKzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_table_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_table_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_moment__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Declaracoes',

  data: function data() {
    return {
      autenticado: {},
      carregando: false,
      carregandoItens: false,
      declaracoes: [],
      declarante: {},
      declaracao: {},
      declaracaoModal: {},
      retificada: {},
      item: {},
      itemModal: {},
      tiposBens: [],
      dependencias: [],
      dependencia: {},
      competencias: [],
      rendaAnualDependenteModal: 0,
      totalCharacter: 0,
      mostraAtualizarRenda: false,
      apiErrors: null,
      navs: [{
        titulo: 'Declaração',
        subtitulo: 'Ano Referência',
        subtDetalhe: 'Ano anterior',
        largura: 900,
        identidade: 'declaracao',
        abreProximo: false,
        aberto: false
      }, {
        titulo: 'Declaração',
        subtitulo: 'Bens e Valores',
        subtDetalhe: 'Nova Declaração',
        largura: 600,
        identidade: 'item',
        abreProximo: false,
        aberto: false
      }]
    };
  },

  computed: {
    declaracoesOrdenadasDistintas: function declaracoesOrdenadasDistintas() {
      if (this.declaracoes.length) {
        var declaracoes = this.declaracoes.sort(function (a, b) {
          if (a.competencia.ano > b.competencia.ano) return -1;
          if (a.competencia.ano < b.competencia.ano) return 1;
          if (a.competencia.mes > b.competencia.mes) return -1;
          if (a.competencia.mes < b.competencia.mes) return 1;
          if (a.numeroRetificacao > b.numeroRetificacao) return -1;
          if (a.numeroRetificacao < b.numeroRetificacao) return 1;
        });
        var declaracoesComCompetenciaId = declaracoes.map(function (declaracao) {
          declaracao.competenciaId = declaracao.competencia.id;
        });
        var distintas = __WEBPACK_IMPORTED_MODULE_15__helpers_ArrayHelper__["a" /* default */].distinctArray(declaracoes, 'competenciaId');

        return distintas;
      }
      var listaComPrimeiraDeclaracao = [this.declaracao];
      listaComPrimeiraDeclaracao[0].competencia = {
        ano: (__WEBPACK_IMPORTED_MODULE_22_moment___default()().year() - 1).toString()
      };

      return listaComPrimeiraDeclaracao;
    },
    competenciasOrdenadas: function competenciasOrdenadas() {
      var competencias = [];
      if (this.competencias.length) {
        competencias = this.competencias.sort(function (a, b) {
          if (a.ano > b.ano) return 1;
          if (a.ano < b.ano) return -1;
          if (a.mes > b.mes) return 1;
          if (a.mes < b.mes) return -1;
        });
      }

      return competencias;
    },
    rendaAnualStatus: function rendaAnualStatus() {
      return this.rendaAnualDependenteModal ? 'alert-success' : 'alert-danger';
    },
    telaEhBigMobile: function telaEhBigMobile() {
      return window.innerWidth > 405 && window.innerWidth < 590;
    }
  },
  methods: {
    imprime: function imprime(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint, mensagem;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = 'declaracoes-bens/' + id + '/impresso';
                _context.prev = 1;
                _context.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__services_obtemImpressao__["a" /* default */])(endpoint);

              case 4:
                _context.next = 11;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context.t0);

                if (mensagem === 'Desbloqueie as pop-ups para este site') {
                  _this.$root.$refs.toastr.w(mensagem, 'Pop-up bloqueada');
                }
                _this.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 6]]);
      }))();
    },
    obtemAnoBase: function obtemAnoBase(competencia) {
      if (competencia) {
        return competencia.mes === 7 ? competencia.ano - 1 + ' Sem.' : competencia.ano - 1;
      }

      return '';
    },
    obtemSituacao: function obtemSituacao(situacao) {
      switch (situacao) {
        case 'FINALIZADA':
          return 'ENTREGUE';
          break;
        case 'EM_BRANCO':
          return 'NÃO ENTREGUE';
          break;
        case 'PENDENTE':
          return 'EM ELABORAÇÃO';
          break;
        case 'RETIFICADA':
          return 'RETIFICADA';
          break;
        case 'RETIFICADORA':
          return 'COM RETIFICAÇÃO';
          break;
        default:
          return 'NÃO INFORMADA';
          break;
      }
    },
    abreModal: function abreModal(identidade) {
      this.$emit('abreModal', identidade);
    },
    fechaModal: function fechaModal(identidade) {
      this.$emit('fechaModal', identidade);
    },
    trataMensagemSucesso: function trataMensagemSucesso(situacao, acao) {
      switch (situacao) {
        case 'PENDENTE':
          this.$root.$refs.toastr.w('Essa declara\xE7\xE3o foi ' + acao + ' mas ainda N\xC3O FOI ENTREGUE', 'Atenção');
          break;
        case 'FINALIZADA':
          this.$root.$refs.toastr.s('Declaração entregue', 'Sucesso');
          break;
        case 'RETIFICADA':
          this.$root.$refs.toastr.s('Declaração retificada', 'Sucesso');
          break;
        default:
          this.$root.$refs.toastr.s('Informa\xE7\xE3o ' + acao, 'Sucesso');
          break;
      }
    },


    // Métodos de apresentação de componentes
    mostraNova: function mostraNova(declaracao) {
      return declaracao.situacao == 'EM_BRANCO';
    },
    mostraEditar: function mostraEditar(declaracao) {
      return declaracao.situacao === 'PENDENTE';
    },
    mostraRetificarVer: function mostraRetificarVer(declaracao) {
      return declaracao.situacao === 'FINALIZADA' && !declaracao.numeroRetificacao;
    },
    mostraVisualizar: function mostraVisualizar(declaracao) {
      return declaracao.situacao == 'RETIFICADA' || declaracao.situacao == 'RETIFICADORA';
    },
    desabilitaEdicaoDasAtrasadas: function desabilitaEdicaoDasAtrasadas(declaracaoItem) {
      return this.declaracao.competencia ? declaracaoItem.competencia.id != this.declaracao.competencia.id : true;
    },
    mostraBotoesDeEdicaoNoSideModal: function mostraBotoesDeEdicaoNoSideModal(declaracao) {
      return declaracao.situacao != 'RETIFICADA' && declaracao.situacao != 'FINALIZADA' && declaracao.situacao != 'RETIFICADORA' ? true : false;
    },
    mostraCopiaAnteriorNoSideModal: function mostraCopiaAnteriorNoSideModal() {
      return this.declaracoesOrdenadasDistintas.length > 1 && this.declaracaoModal.itens.length <= 0 && this.declaracaoModal.situacao == 'EM_BRANCO' ? true : false;
    },
    mostraJustificativaNoSideModal: function mostraJustificativaNoSideModal(declaracao) {
      if (!this.mostraBotoesDeEdicaoNoSideModal(declaracao) && !declaracao.justificativa) return false;
      if (!declaracao.itens.length) return false;
      return true;
    },


    // Métodos da primeira tela
    novo: function novo(declaracao) {
      this.errors.clear();

      this.validaJaDeclarado(declaracao) ? this.$root.$refs.toastr.i('Você já efetuou suas entregas de declaração anual de bens. Obrigado.', 'Atenção') : this.edita(declaracao);
    },
    edita: function edita(declaracao, situacao) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var situacaoAtual;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                situacaoAtual = situacao || declaracao.situacao;

                if (!_this2.bloqueiaEntregaPorData(declaracao, situacaoAtual)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                if (!declaracao.id) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 6;
                return _this2.listaItens(declaracao.id);

              case 6:
                _context2.next = 10;
                break;

              case 8:
                declaracao.index = _this2.declaracoes.indexOf(declaracao);
                _this2.declaracaoModal = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(declaracao));

              case 10:

                _this2.declaracaoModal.dataDeclaracao = __WEBPACK_IMPORTED_MODULE_22_moment___default()().format('YYYY-MM-DD');

                if (!!situacao) {
                  _this2.declaracaoModal.index = _this2.declaracoes.indexOf(declaracao);
                  _this2.corrigeRetificada(_this2.declaracaoModal);
                }

                _this2.navs[0].subtDetalhe = situacao ? 'Retificação ' + _this2.valoraSubdetalheNav0() : _this2.valoraSubdetalheNav0();

                _this2.abreModal('declaracao');

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    visualizaOriginal: function visualizaOriginal(declaracao) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.listaItens(declaracao.idDeclaracaoBensRetificada);

              case 2:

                _this3.navs[0].subtDetalhe = _this3.valoraSubdetalheNav0();

                _this3.abreModal('declaracao');

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    valoraSubdetalheNav0: function valoraSubdetalheNav0() {
      if (this.declaracaoModal.competencia.mes === 7) {
        return this.declaracaoModal.competencia.ano - 1 + ' Semestral';
      }
      return (this.declaracaoModal.competencia.ano - 1).toString();
    },


    // Métodos do modal Declaração
    copiaDeclaracaoAnterior: function copiaDeclaracaoAnterior() {
      var _this4 = this;

      var indexAtual = this.declaracoesOrdenadasDistintas.indexOf(this.declaracao);
      var indexAnterior = indexAtual + 1;
      var declaracaoPassada = this.declaracoesOrdenadasDistintas[indexAnterior];
      var competenciaMes = this.declaracaoModal.competencia.mes;

      this.listaItens(declaracaoPassada.id).then(function () {
        _this4.corrigeCopiaDaAnterior(competenciaMes, indexAtual);
        _this4.declaracaoModal.itens.forEach(function (item) {
          if (_this4.validaRendaDependente(item)) {
            return;
          }
          _this4.editaItem(item);
          __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick().then(function () {
            return _this4.solicitaAtualizarRenda();
          });
        });
      });
    },
    corrigeCopiaDaAnterior: function corrigeCopiaDaAnterior(competenciaMes, index) {
      var _this5 = this;

      var competenciaDesteAno = {};

      if (competenciaMes === 7) {
        competenciaDesteAno = this.competencias.find(function (competencia) {
          return competencia.ano === _this5.declaracaoModal.competencia.ano && competencia.mes === 7;
        });
      } else {
        competenciaDesteAno = this.competencias.find(function (competencia) {
          return competencia.ano === _this5.declaracaoModal.competencia.ano + 1 && competencia.mes === 1;
        });
      }
      this.declaracaoModal.competencia = competenciaDesteAno;
      this.declaracaoModal.dataDeclaracao = __WEBPACK_IMPORTED_MODULE_22_moment___default()().format('YYYY-MM-DD');
      this.declaracaoModal.situacao = 'EM_BRANCO';
      this.declaracaoModal.idDeclaracaoBensRetificada = null;
      this.declaracaoModal.id = null;
      this.declaracaoModal.index = index;
      this.declaracaoModal.numeroRetificacao = 0;
      this.declaracaoModal.itens.map(function (item) {
        return item.id = null;
      });
    },
    corrigeRetificada: function corrigeRetificada(declaracao) {
      declaracao.dataDeclaracao = __WEBPACK_IMPORTED_MODULE_22_moment___default()().format('YYYY-MM-DD');
      declaracao.situacao = 'RETIFICANTE';
      declaracao.numeroRetificacao++;
      declaracao.idDeclaracaoBensRetificada = declaracao.id;
      declaracao.id = null;
      declaracao.itens.map(function (item) {
        return item.id = null;
      });
    },
    salva: function salva(declaracao, situacao) {
      this.declaracao = declaracao;
      this.gerenciaDeclaracao(situacao);
      jQuery('#salvaModal').modal('hide');
      this.limpaModal();
    },
    salvaRetificada: function salvaRetificada(declaracao) {
      this.gerenciaDeclaracao('RETIFICADORA');
      jQuery('#retificaModal').modal('hide');
      this.limpaModal();
    },
    gerenciaDeclaracao: function gerenciaDeclaracao(situacao) {
      var retificante = this.declaracaoModal.situacao === 'RETIFICANTE';
      if (retificante) {
        this.declaracaoModal.situacao = 'RETIFICADORA';
        this.gravaDeclaracao(this.declaracaoModal);
        return;
      }
      this.declaracao.situacao = situacao;
      this.gravaDeclaracao(this.declaracao);
    },
    gravaDeclaracao: function gravaDeclaracao(declaracao) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var acao, _declaracao, index, response, mensagem;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                acao = void 0;

                if (!declaracao.id) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__services_declaracoesService__["a" /* default */].atualiza(declaracao.id, declaracao);

              case 5:
                _this6.incluiEmDeclaracoes(declaracao);
                acao = 'atualizada';
                _context4.next = 16;
                break;

              case 9:
                _declaracao = declaracao, index = _declaracao.index;
                _context4.next = 12;
                return __WEBPACK_IMPORTED_MODULE_6__services_declaracoesService__["a" /* default */].grava(declaracao);

              case 12:
                response = _context4.sent;

                declaracao = response;
                _this6.incluiEmDeclaracoes(declaracao, index);
                acao = 'salva';

              case 16:
                _this6.trataMensagemSucesso(declaracao.situacao, acao);
                _this6.defineNovaDeclaracao();
                _context4.next = 24;
                break;

              case 20:
                _context4.prev = 20;
                _context4.t0 = _context4['catch'](0);
                mensagem = __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context4.t0);

                _this6.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 24:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 20]]);
      }))();
    },
    cancela: function cancela() {
      this.limpaModal();
      this.fechaModal('declaracao');
    },
    limpaModal: function limpaModal() {
      var _this7 = this;

      setTimeout(function () {
        _this7.mostraAtualizarRenda = false;
        _this7.item = new __WEBPACK_IMPORTED_MODULE_12__domain_declaracao_item__["a" /* default */]();
        _this7.declaracaoModal = new __WEBPACK_IMPORTED_MODULE_11__domain_declaracao__["a" /* default */](_this7.declarante);
      }, 600);
    },
    semBens: function semBens(declaracao, rascunho) {
      var _this8 = this;

      if (this.bloqueiaEntregaPorData(declaracao, declaracao.situacao)) return;

      var sentences = [{
        id: 1,
        message: 'Você confirma não possuir bens a serem declarados?',
        bold: false
      }];

      this.$root.$refs.modal.confirm(sentences, {
        yes: function yes() {
          var retificante = declaracao.situacao === 'RETIFICANTE';
          if (retificante) {
            declaracao.situacao = 'RETIFICADORA';
            declaracao.semBens = true;
            declaracao.itens = [];
            _this8.gravaDeclaracao(declaracao);
          } else {
            if (!declaracao.index && declaracao.index !== 0) {
              declaracao.index = _this8.declaracoes.indexOf(declaracao);
            }
            if (declaracao == _this8.declaracao) {
              _this8.declaracao.dataDeclaracao = __WEBPACK_IMPORTED_MODULE_22_moment___default()().format('YYYY-MM-DD');
            }
            if (declaracao == _this8.declaracaoModal) {
              _this8.declaracao = declaracao;
            }
            _this8.declaracao.semBens = true;
            _this8.declaracao.itens = [];
            rascunho ? _this8.gerenciaDeclaracao('PENDENTE') : _this8.gerenciaDeclaracao('FINALIZADA');
          }
        },
        title: 'Sem Bens a Declarar'
      });
    },


    // Métodos do modal Ítem
    novoItem: function novoItem() {
      this.errors.clear();
      this.editaItem(this.item);
    },
    editaItem: function editaItem(item) {
      this.itemModal = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item));
      this.itemModal.index = this.declaracaoModal.itens.indexOf(item);
      this.navs[1].subtDetalhe = this.itemModal.tipo.descricao;
      this.abreModal('item');
    },
    apagaItem: function apagaItem(item) {
      var _this9 = this;

      var sentences = [{
        id: 1,
        message: 'Deseja apagar esse item da sua lista?',
        bold: false
      }];

      this.$root.$refs.modal.confirm(sentences, {
        yes: function yes() {
          _this9.declaracaoModal.itens.splice(_this9.declaracaoModal.itens.indexOf(item), 1);
        },
        title: 'Apagando item'
      });
    },
    incluiItem: function incluiItem() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var index, mensagem;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                index = _this10.itemModal.index;

                if (!_this10.rendaAnualDependenteModal) {
                  _context5.next = 18;
                  break;
                }

                _context5.prev = 2;
                _context5.next = 5;
                return _this10.atualizaRendaDoDependente();

              case 5:
                _context5.next = 7;
                return _this10.obtemDependenciaAtualizada(_this10.dependencia.id);

              case 7:
                _this10.incluiEmDeclaracaoModal(index);
                _this10.$root.$refs.toastr.s('Item incluído', 'Sucesso');
                _context5.next = 16;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5['catch'](2);

                _this10.declaracaoModal.itens.pop(_this10.itemModal);

                mensagem = __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context5.t0);

                _this10.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 16:
                _context5.next = 20;
                break;

              case 18:
                _this10.incluiEmDeclaracaoModal(index);
                _this10.$root.$refs.toastr.s('Item incluído', 'Sucesso');

              case 20:
                _this10.fechaModal('item');
                _this10.limpaModalItem();

              case 22:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this10, [[2, 11]]);
      }))();
    },
    cancelaItem: function cancelaItem() {
      this.limpaModalItem();
      this.fechaModal('item');
    },
    limpaModalItem: function limpaModalItem() {
      var _this11 = this;

      setTimeout(function () {
        _this11.mostraAtualizarRenda = false;
        _this11.rendaAnualDependenteModal = 0;
        _this11.item = new __WEBPACK_IMPORTED_MODULE_12__domain_declaracao_item__["a" /* default */]();
        _this11.itemModal = new __WEBPACK_IMPORTED_MODULE_12__domain_declaracao_item__["a" /* default */]();
      }, 600);
    },
    incluiEmDeclaracaoModal: function incluiEmDeclaracaoModal(index) {
      if (index < 0) {
        if (this.declaracaoModal.semBens) this.declaracaoModal.semBens = false;
        this.declaracaoModal.itens.push(this.itemModal);
      } else {
        this.declaracaoModal.itens[index] = this.itemModal;
      }
    },


    // Métodos dos modais
    semBensModal: function semBensModal() {
      this.semBens(this.declaracaoModal);
      this.fechaModal('declaracao');
    },
    abreLeiModal: function abreLeiModal() {
      jQuery('#leiModal').modal('show');
    },
    abreEnviaModal: function abreEnviaModal(declaracao, idModal) {
      if (this.validaSemBens(declaracao)) {
        this.semBens(declaracao);
        this.fechaModal('declaracao');
        return;
      }
      jQuery(idModal).modal('show');
      this.fechaModal('declaracao');
    },
    abrePeriodoEntregaModal: function abrePeriodoEntregaModal() {
      jQuery('#periodoAberturaModal').modal('show');
    },


    // Métodos de validação
    bloqueiaEntregaPorData: function bloqueiaEntregaPorData(declaracao, situacao) {
      var anoAtual = __WEBPACK_IMPORTED_MODULE_22_moment___default()().year();
      var ehDesseAno = declaracao.competencia.ano === anoAtual;

      if (!ehDesseAno) return false;

      var competenciaAtual = this.competencias.find(function (item) {
        return item.id === declaracao.competenciaId;
      });

      if (!competenciaAtual) {
        this.$root.$refs.toastr.w('Aguarde o período de envio de declaração de bens', 'Atenção');
        return true;
      }

      var inicioLancamento = competenciaAtual.periodos[0].dataInicioLancamento;
      var fimLancamento = competenciaAtual.periodos[0].dataFimLancamento;
      var periodoEstahFechado = !__WEBPACK_IMPORTED_MODULE_22_moment___default()().isBetween(inicioLancamento, fimLancamento);

      var situacaoProibida = situacao === 'PENDENTE' || situacao === 'EM_BRANCO' || situacao === 'RETIFICANTE';

      if (periodoEstahFechado && situacaoProibida) {
        this.$root.$refs.toastr.w('Aguarde a abertura do próximo período de declaração', 'Período Fechado');
        return true;
      }

      return false;
    },
    validaRendaDependente: function validaRendaDependente(item) {
      this.mostraAtualizarRenda = false;
      var dependencia = {};
      var rendas = [];
      if (this.existeDependente(item)) {
        dependencia = item.dependencia;
        if (this.dependenteTemRenda(dependencia)) {
          rendas = dependencia.rendas;
          if (this.rendaEstahAtualizada(rendas)) {
            return true;
          }
        }
        return false;
      }
      return true;
    },
    existeDependente: function existeDependente(item) {
      return item.dependencia ? true : false;
    },
    dependenteTemRenda: function dependenteTemRenda(dependencia) {
      return dependencia.rendas.length > 0 ? true : false;
    },
    rendaEstahAtualizada: function rendaEstahAtualizada(rendas) {
      var anoExercicioDaDeclaracao = this.declaracaoModal.competencia.ano - 1;
      var existeRendaDoExercicio = rendas.find(function (renda) {
        return renda.anoReferencia == anoExercicioDaDeclaracao;
      });
      return existeRendaDoExercicio ? true : false;
    },
    incluiDependente: function incluiDependente(item) {
      if (this.validaRendaDependente(item)) {
        return;
      }
      this.solicitaAtualizarRenda();
    },
    solicitaAtualizarRenda: function solicitaAtualizarRenda() {
      var anoExercicioDaDeclaracao = this.declaracaoModal.competencia.ano - 1;
      this.$root.$refs.toastr.w('Se houver, cadastre a renda do Parceiro Econ\xF4mico\n                do ano de ' + anoExercicioDaDeclaracao, 'Atenção');
      this.mostraAtualizarRenda = true;
    },
    validaJaDeclarado: function validaJaDeclarado(declaracao) {
      var ultimaCompetencia = this.obtemUltimaCompetenciaValida();
      var ehUltimaDeclaracao = declaracao.competencia.id == ultimaCompetencia.id;
      var jaEntregue = declaracao.situacao === 'FINALIZADA' || declaracao.situacao === 'RETIFICADORA';
      var aindaNaoTemCompetenciaDoAnoAtual = this.declaracoesOrdenadasDistintas[0].situacao === 'FINALIZADA' || this.declaracoesOrdenadasDistintas[0].situacao === 'RETIFICADORA';

      return ehUltimaDeclaracao && jaEntregue || aindaNaoTemCompetenciaDoAnoAtual;
    },
    obtemUltimaCompetenciaValida: function obtemUltimaCompetenciaValida() {
      var segundoSemestreAnoAtual = __WEBPACK_IMPORTED_MODULE_22_moment___default()().set({ month: 6, date: 1 });
      var estamosSegundoSemestreAnoAtual = __WEBPACK_IMPORTED_MODULE_22_moment___default()().isAfter(segundoSemestreAnoAtual);
      var indiceUltimaCompetencia = this.competenciasOrdenadas.length - 1;
      var ehCompetenciaSemestral = this.competenciasOrdenadas[indiceUltimaCompetencia].mes === 7;

      if (!estamosSegundoSemestreAnoAtual && ehCompetenciaSemestral) {
        return this.competenciasOrdenadas[indiceUltimaCompetencia - 1];
      }

      return this.competenciasOrdenadas[indiceUltimaCompetencia];
    },
    validaSemBens: function validaSemBens(declaracao) {
      return !declaracao.itens.length ? true : false;
    },
    validaItem: function validaItem() {
      var _this12 = this;

      this.$validator.validateAll().then(function (success) {
        if (success) {
          _this12.incluiItem();
        } else {
          _this12.$root.$refs.toastr.e('Preencha ou corrija os campos em vermelho', 'Atenção');
        }
      });
    },
    validaDeclaracao: function validaDeclaracao(declaracao, idModal) {
      var _this13 = this;

      this.$validator.validateAll().then(function (success) {
        if (success) {
          _this13.abreEnviaModal(declaracao, idModal);
        } else {
          _this13.$root.$refs.toastr.e('Preencha ou corrija o campo de Justificativa', 'Atenção');
        }
      });
    },


    // Métodos de montagem de tela
    montaTelaDeclaracoes: function montaTelaDeclaracoes() {
      var tipo = this.autenticado.tipo === 'CARGO_LIVRE_PROVIMENTO' || this.autenticado.tipo === 'CARGO_ELETIVO' ? 'semestral' : 'anual';

      this.filtraCompetencias(tipo);
      this.listaDeclaracoesPendentes();
      this.defineNovaDeclaracao();
      this.carregando = false;
      this.mostraModalExplicacao();
    },
    filtraCompetencias: function filtraCompetencias(tipoPeriodo) {
      if (tipoPeriodo === 'anual') {
        var filtrado = this.competencias.filter(function (competencia) {
          return competencia.mes === 1;
        });
        this.competencias = filtrado;
      }
    },
    listaDeclaracoesPendentes: function listaDeclaracoesPendentes() {
      var _this14 = this;

      var declaracaoPendente = {};
      var anoAtual = __WEBPACK_IMPORTED_MODULE_22_moment___default()().year();
      var anoInicioAtividade = __WEBPACK_IMPORTED_MODULE_22_moment___default()(this.autenticado.dataInicioAtividade).year();
      var ultimoAnoBase = this.declaracoesOrdenadasDistintas[0].competencia.ano - 1;
      var ultimoMesCompetencia = this.declaracoesOrdenadasDistintas[0].competencia.mes;
      var nuncaDeclarou = !this.declaracoes.length;
      var ativoHaMaisDeUmAno = anoInicioAtividade < anoAtual;

      if (nuncaDeclarou && ativoHaMaisDeUmAno) {
        ultimoAnoBase = anoInicioAtividade - 1;
      }
      var competenciasPendentes = this.listaCompetenciasPendentes(ultimoAnoBase, ultimoMesCompetencia);

      competenciasPendentes.map(function (competenciaCorrente) {
        declaracaoPendente = new __WEBPACK_IMPORTED_MODULE_11__domain_declaracao__["a" /* default */](_this14.declarante);
        declaracaoPendente.competencia = competenciaCorrente;
        declaracaoPendente.dataDeclaracao = null;
        _this14.declaracoes.push(declaracaoPendente);
      });
    },
    listaCompetenciasPendentes: function listaCompetenciasPendentes(ultimoAnoBase, ultimoMesCompetencia) {
      var competenciasPendentes = [];

      var anoAtual = __WEBPACK_IMPORTED_MODULE_22_moment___default()().year();
      var segundoSemestreAnoAtual = __WEBPACK_IMPORTED_MODULE_22_moment___default()().set({ month: 6, date: 1 });
      var estamosSegundoSemestreAnoAtual = __WEBPACK_IMPORTED_MODULE_22_moment___default()().isAfter(segundoSemestreAnoAtual);
      var ultimoAnoMes = String(ultimoAnoBase + 1) + String(ultimoMesCompetencia);

      if (this.competenciasOrdenadas.length) {
        this.competenciasOrdenadas.map(function (competencia) {
          var competenciaAnoMes = String(competencia.ano) + String(competencia.mes);
          var ehUltimoAnoSemestral = competencia.ano === anoAtual && competencia.mes === 7;

          if (competenciaAnoMes > ultimoAnoMes && !ehUltimoAnoSemestral) {
            competenciasPendentes.push(competencia);
          }

          if (ehUltimoAnoSemestral && estamosSegundoSemestreAnoAtual) {
            competenciasPendentes.push(competencia);
          }
        });
      }

      return competenciasPendentes;
    },
    defineNovaDeclaracao: function defineNovaDeclaracao() {
      var declaracoesAtrasadas = this.declaracoesOrdenadasDistintas.filter(function (declaracao) {
        return declaracao.situacao == 'EM_BRANCO' || declaracao.situacao == 'PENDENTE';
      });
      if (declaracoesAtrasadas.length) {
        this.declaracao = declaracoesAtrasadas[declaracoesAtrasadas.length - 1];
      }
    },
    incluiEmDeclaracoes: function incluiEmDeclaracoes(declaracao, index) {
      if (!index && index !== 0) {
        index = this.declaracoes.findIndex(function (element) {
          return element.id === declaracao.id;
        });
      }

      this.$set(this.declaracoes, index, declaracao);
    },


    // Métodos de requisições
    listaDeclaracoes: function listaDeclaracoes() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response, mensagem;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this15.carregando = true;

                _context6.prev = 1;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__services_declaracoesService__["a" /* default */].lista();

              case 4:
                response = _context6.sent;

                if (response && response.content) {
                  _this15.declaracoes = response.content;
                }
                _context6.next = 12;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context6.t0);

                _this15.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 12:
                _context6.prev = 12;

                _this15.carregando = false;
                return _context6.finish(12);

              case 15:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this15, [[1, 8, 12, 15]]);
      }))();
    },
    listaItens: function listaItens(id) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var mensagem;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this16.carregandoItens = true;

                _context7.prev = 1;
                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__services_declaracoesService__["a" /* default */].obtem(id);

              case 4:
                _this16.declaracaoModal = _context7.sent;

                if (!_this16.declaracaoModal.itens) {
                  _this16.declaracaoModal.itens = [];
                }
                _context7.next = 12;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context7.t0);

                _this16.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 12:
                _context7.prev = 12;

                _this16.carregandoItens = false;
                return _context7.finish(12);

              case 15:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this16, [[1, 8, 12, 15]]);
      }))();
    },
    listaTiposBens: function listaTiposBens() {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var tiposBens, mensagem;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__services_enums_tiposBensService__["a" /* default */].lista();

              case 3:
                tiposBens = _context8.sent;

                _this17.tiposBens = tiposBens;
                _context8.next = 11;
                break;

              case 7:
                _context8.prev = 7;
                _context8.t0 = _context8['catch'](0);
                mensagem = __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context8.t0);

                _this17.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 11:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this17, [[0, 7]]);
      }))();
    },
    listaDependencias: function listaDependencias() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var dependencias, mensagem;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__services_dependenciasService__["a" /* default */].lista();

              case 3:
                dependencias = _context9.sent;

                _this18.dependencias = dependencias.content;
                _context9.next = 11;
                break;

              case 7:
                _context9.prev = 7;
                _context9.t0 = _context9['catch'](0);
                mensagem = __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context9.t0);

                _this18.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 11:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this18, [[0, 7]]);
      }))();
    },
    listaCompetencias: function listaCompetencias(evento) {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var competencias, mensagem;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__services_mesesCompetenciasService__["a" /* default */].listaPorEvento(evento);

              case 3:
                competencias = _context10.sent;

                _this19.competencias = competencias.content;
                _context10.next = 11;
                break;

              case 7:
                _context10.prev = 7;
                _context10.t0 = _context10['catch'](0);
                mensagem = __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context10.t0);

                _this19.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 11:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this19, [[0, 7]]);
      }))();
    },
    atualizaRendaDoDependente: function atualizaRendaDoDependente() {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var renda, mensagem;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                renda = new __WEBPACK_IMPORTED_MODULE_14__domain_dependencia_renda__["a" /* default */]();

                renda.valor = _this20.rendaAnualDependenteModal;
                renda.anoReferencia = _this20.declaracaoModal.competencia.ano - 1;
                _this20.dependencia = _this20.itemModal.dependencia;
                _this20.dependencia.dependente.cpf = __WEBPACK_IMPORTED_MODULE_16__helpers_StringHelper__["a" /* default */].limpaFormato(_this20.dependencia.dependente.cpf);
                _this20.dependencia.rendas.unshift(renda);
                _context11.prev = 6;
                _context11.next = 9;
                return __WEBPACK_IMPORTED_MODULE_8__services_dependenciasService__["a" /* default */].atualiza(_this20.dependencia.id, _this20.dependencia);

              case 9:
                _context11.next = 15;
                break;

              case 11:
                _context11.prev = 11;
                _context11.t0 = _context11['catch'](6);
                mensagem = __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context11.t0);

                _this20.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 15:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this20, [[6, 11]]);
      }))();
    },
    obtemDependenciaAtualizada: function obtemDependenciaAtualizada(id) {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var response, dependencias, dependencia, mensagem;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__services_dependenciasService__["a" /* default */].lista();

              case 3:
                response = _context12.sent;
                dependencias = response.content;
                dependencia = dependencias.find(function (item) {
                  return item.id === id;
                });

                _this21.itemModal.dependencia = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dependencia);
                _context12.next = 13;
                break;

              case 9:
                _context12.prev = 9;
                _context12.t0 = _context12['catch'](0);
                mensagem = __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context12.t0);

                _this21.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 13:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this21, [[0, 9]]);
      }))();
    },
    mostraModalExplicacao: function mostraModalExplicacao() {
      if (!sessionStorage.mostraLei) {
        // if (
        //   !this.bloqueiaEntregaPorData(
        //     this.declaracoesOrdenadasDistintas[0],
        //     this.declaracoesOrdenadasDistintas[0].situacao,
        //   )
        // )
        this.abreLeiModal();

        sessionStorage.setItem('mostraLei', true);
      }
    },
    fazRequisicoes: function fazRequisicoes() {
      var _this22 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.listaCompetencias('DECLARACAO_DE_BENS'), this.listaDeclaracoes(), this.listaTiposBens(), this.listaDependencias()]).then(function () {
        return _this22.montaTelaDeclaracoes();
      });
    },
    charCount: function charCount() {
      this.totalCharacter = this.declaracaoModal.justificativa.length;
    }
  },
  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_18__components_botao___default.a,
    SideModal: __WEBPACK_IMPORTED_MODULE_19__components_side_modal___default.a,
    EscondeDiv: __WEBPACK_IMPORTED_MODULE_20__components_esconde_div___default.a,
    TableLoader: __WEBPACK_IMPORTED_MODULE_21__components_table_loader___default.a
  },
  created: function created() {
    this.autenticado = this.$store.state.usuarioLogado.funcionarios[0];
    this.declarante.id = this.autenticado.idPessoa;
    this.declarante.nome = this.autenticado.nome;
    this.item = new __WEBPACK_IMPORTED_MODULE_12__domain_declaracao_item__["a" /* default */]();
    this.itemModal = new __WEBPACK_IMPORTED_MODULE_12__domain_declaracao_item__["a" /* default */]();
    this.declaracao = new __WEBPACK_IMPORTED_MODULE_11__domain_declaracao__["a" /* default */](this.declarante);
    this.declaracaoModal = new __WEBPACK_IMPORTED_MODULE_11__domain_declaracao__["a" /* default */](this.declarante);

    this.fazRequisicoes();
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "/vKb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_card_header__ = __webpack_require__("8KSN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_card_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_card_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_table_loader__ = __webpack_require__("pKzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_table_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_table_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__protocolo_modal__ = __webpack_require__("6/3n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__protocolo_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__protocolo_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__explicacao_modal__ = __webpack_require__("XFWT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__explicacao_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__explicacao_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__regra_dias_pendentes_modal__ = __webpack_require__("WInX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__regra_dias_pendentes_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__regra_dias_pendentes_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__regra_ferias_pendentes_modal__ = __webpack_require__("2qeI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__regra_ferias_pendentes_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__regra_ferias_pendentes_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__side_modal__ = __webpack_require__("fPMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__side_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__side_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__domain_ferias__ = __webpack_require__("9v17");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__domain_ferias_aprovador__ = __webpack_require__("c5jQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_ErrorHelper__ = __webpack_require__("+h9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_support_sample_data_agendamentos_json__ = __webpack_require__("CwU8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_support_sample_data_agendamentos_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__static_support_sample_data_agendamentos_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_obtemImpressao__ = __webpack_require__("8QDf");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Ferias',

  data: function data() {
    return {
      funcionario: this.$store.state.funcionario,
      agendamentos: [],
      feriasAgendadas: [],
      dataInicioAtividade: '',
      uor: {},
      aprovadores: [],
      competencia: {},
      protocolo: '',
      agendamentoId: 0,
      agendaSabado: false,
      agendaDomingoFeriado: false,

      usuarioValido: true,
      carregandoAprovador: false,
      carregando: false,
      escondeAprovador: false
    };
  },


  computed: {
    usuarioAtual: function usuarioAtual() {
      return this.$store.state.funcionario;
    },
    primeiroPeriodoPendente: function primeiroPeriodoPendente() {
      var feriasReverse = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.feriasAgendadas)).reverse();

      var pendente = feriasReverse.find(function (ferias) {
        return ferias.situacao === 'PENDENTE';
      });

      return pendente;
    },
    segundoPeriodoPendente: function segundoPeriodoPendente() {
      var _this = this;

      if (!!this.primeiroPeriodoPendente) {
        var pendente = this.feriasAgendadas.filter(function (ferias) {
          return ferias.id !== _this.primeiroPeriodoPendente.id;
        }).find(function (ferias) {
          return ferias.situacao === 'PENDENTE';
        });

        return pendente;
      }

      return undefined;
    }
  },

  watch: {
    usuarioAtual: function usuarioAtual(novo, anterior) {
      this.editaRegistro(novo);
    }
  },

  methods: {
    // Métodos de input
    agenda: function agenda(identidade, ferias) {
      try {
        this.validaPeriodoDeLancamento();
        this.validaUltimoAgendamento(ferias, this.feriasAgendadas);
        this.validaFeriasJahAgendadas(ferias);
        this.validaDiasEFeriasPendentes(ferias);

        var editavel = true;
        var inicio = this.trataInicioParaModal(ferias, this.feriasAgendadas);

        this.$emit('abreModal', { identidade: identidade, ferias: ferias, inicio: inicio, editavel: editavel });
      } catch (error) {
        if (error.type === 'error') {
          this.$root.$refs.toastr.e(error.message, 'Atenção');
          return;
        }
        if (error.type === 'warning') {
          this.$root.$refs.toastr.w(error.message, 'Atenção');
          return;
        }
        if (error.type === 'info') {
          this.$root.$refs.toastr.i(error.message, 'Obrigado');
          return;
        }
        if (!error.type) {
          this.$root.$refs.toastr.e(error.message, 'Atenção');
          return;
        }
        this.$root.$refs.toastr.e(error.message, 'Atenção');
      }
    },
    visualiza: function visualiza(identidade, ferias) {
      this.validaDiasEFeriasPendentes(ferias);

      var inicio = ferias.inicio,
          protocolo = ferias.protocolo;

      var editavel = false;
      this.protocolo = protocolo;

      this.$emit('abreModal', { identidade: identidade, ferias: ferias, inicio: inicio, editavel: editavel });
    },
    agendaOuVisualiza: function agendaOuVisualiza(identidade, ferias) {
      if (ferias.situacao === 'PENDENTE') {
        this.agenda(identidade, ferias);
        return;
      }

      this.visualiza(identidade, ferias);
      return;
    },
    imprime: function imprime(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint, mensagem;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = 'agendamentos-ferias/' + id + '/protocolo';
                _context.prev = 1;
                _context.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__services_obtemImpressao__["a" /* default */])(endpoint);

              case 4:
                _context.next = 11;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_16__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context.t0);

                if (mensagem === 'Desbloqueie as pop-ups para este site') {
                  _this2.$root.$refs.toastr.w(mensagem, 'Pop-up bloqueada');
                }
                _this2.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 6]]);
      }))();
    },


    // Métodos de validações
    bloqueiaPorTipoFuncionario: function bloqueiaPorTipoFuncionario(tipo) {
      if (tipo !== 'QUADRO_PERMANENTE' && tipo !== 'CARGO_LIVRE_PROVIMENTO' && tipo !== 'CAPEP_CEDIDOS' && tipo !== 'CARGO_ELETIVO') {
        this.$router.push({ name: 'SemAcesso' });
        return true;
      }

      return false;
    },
    validaPeriodoDeLancamento: function validaPeriodoDeLancamento() {
      var _agendamentos$0$perio = this.agendamentos[0].periodo,
          dataInicioLancamento = _agendamentos$0$perio.dataInicioLancamento,
          dataFimLancamento = _agendamentos$0$perio.dataFimLancamento;

      var _dataFimLancamento$sp = dataFimLancamento.split('-'),
          _dataFimLancamento$sp2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_dataFimLancamento$sp, 3),
          ano = _dataFimLancamento$sp2[0],
          mes = _dataFimLancamento$sp2[1],
          dia = _dataFimLancamento$sp2[2];

      var dataFimLancamentoAdicaoDia = new Date(+ano, +mes - 1, +dia + 1);

      var periodoEstahFechado = !__WEBPACK_IMPORTED_MODULE_13_moment___default()().isBetween(dataInicioLancamento, dataFimLancamentoAdicaoDia, 'day', '[]');

      if (periodoEstahFechado) {
        var erro = new Error('Período de agendamento fechado');
        erro.type = 'warning';
        throw erro;
      }
    },
    validaFeriasJahAgendadas: function validaFeriasJahAgendadas(ferias) {
      if (!ferias) {
        var erro = new Error('Você já agendou as suas férias');
        erro.type = 'info';
        throw erro;
      }
    },
    validaUltimoAgendamento: function validaUltimoAgendamento(ferias, feriasAgendadas) {
      var ehSegundoPeriodo = this.segundoPeriodoPendente && ferias.id === this.segundoPeriodoPendente.id;

      if (ehSegundoPeriodo && !this.primeiroPeriodoPendente.inicio) {
        var erro = new Error('Agende as f\xE9rias de ' + (ferias.agendamentoAno - 1) + ' antes');
        erro.type = 'error';
        throw erro;
      }
    },
    validaDiasEFeriasPendentes: function validaDiasEFeriasPendentes(ferias) {
      var temDiasPendentes = this.feriasAgendadas.find(function (ferias) {
        return ferias.diasPendentes;
      });
      var temFeriasPendentes = this.feriasAgendadas.find(function (ferias) {
        return ferias.feriasPendentes;
      });

      if (temDiasPendentes) {
        this.abreRegraDiasPendentes();
      }

      if (temFeriasPendentes) {
        this.abreRegraFeriasPendentes();
      }
    },


    // Métodos de leitura de dados
    gravaData: function gravaData(payload) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var indexAgendamento, indexFerias, id, agendamento, endPoint, agendamentoResponse, protocoloPayload, mensagem;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                indexAgendamento = _this3.agendamentos.findIndex(function (item) {
                  return item.id == payload.agendamentoId;
                });
                indexFerias = _this3.feriasAgendadas.findIndex(function (item) {
                  return item.id == payload.agendamentoId;
                });


                _this3.agendamentos[indexAgendamento].dataInicio = payload.inicio;
                _this3.agendamentos[indexAgendamento].statusAprovacao = 'EM_ANALISE';

                _context2.prev = 4;
                id = _this3.agendamentos[indexAgendamento].id;
                agendamento = _this3.agendamentos[indexAgendamento];
                endPoint = 'agendamentos-ferias/' + id;
                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_18__services_api__["a" /* default */].put(endPoint, agendamento);

              case 10:
                agendamentoResponse = _context2.sent;


                _this3.feriasAgendadas[indexFerias].inicio = agendamentoResponse.dataInicio;
                _this3.feriasAgendadas[indexFerias].situacao = agendamentoResponse.statusAprovacao;
                _this3.feriasAgendadas[indexFerias].protocolo = agendamentoResponse.protocolo.codigo;
                // this.feriasAgendadas[indexFerias].inicio = payload.inicio;
                // this.feriasAgendadas[indexFerias].situacao = 'EM_ANALISE';
                // this.feriasAgendadas[indexFerias].protocolo = 'AFDSA545252G744';

                protocoloPayload = {
                  protocolo: _this3.feriasAgendadas[indexFerias].protocolo,
                  agendamentoId: id
                };

                _this3.abreProtocolo(protocoloPayload);
                _context2.next = 22;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2['catch'](4);
                mensagem = __WEBPACK_IMPORTED_MODULE_16__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context2.t0);

                _this3.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[4, 18]]);
      }))();
    },
    editaRegistro: function editaRegistro(funcionario) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!funcionario) {
                  _context3.next = 9;
                  break;
                }

                if (!_this4.bloqueiaPorTipoFuncionario(funcionario.tipo)) {
                  _context3.next = 4;
                  break;
                }

                _this4.usuarioValido = false;
                return _context3.abrupt('return');

              case 4:

                _this4.listaAgendamentos(funcionario.id);
                _context3.next = 7;
                return _this4.obtemMesCompetencia(funcionario.id);

              case 7:

                if (_this4.competencia.id) {
                  _this4.listaAprovadores(_this4.competencia.id, funcionario.uorId);
                }
                _this4.dataInicioAtividade = funcionario.dataInicioAtividade;

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    listaAgendamentos: function listaAgendamentos(funcionarioId) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var endPoint, agendamentosResponse, agendamentos, agendamentosFuncionarioSelecionado, feriasMapeadas, feriasComProtocolo, mensagem;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.carregando = true;
                _context4.prev = 1;
                endPoint = 'agendamentos-ferias';
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_18__services_api__["a" /* default */].get(endPoint);

              case 5:
                agendamentosResponse = _context4.sent;
                agendamentos = [];


                if (!!agendamentosResponse) {
                  agendamentos = agendamentosResponse.content;
                }

                if (!(!agendamentos || !agendamentos.length)) {
                  _context4.next = 11;
                  break;
                }

                _this5.feriasAgendadas = [];
                return _context4.abrupt('return');

              case 11:
                agendamentosFuncionarioSelecionado = agendamentos.filter(function (agendamento) {
                  return agendamento.periodoAquisitivo.funcionario.id == funcionarioId;
                });

                _this5.agendamentos = agendamentosFuncionarioSelecionado;

                feriasMapeadas = _this5.mapeiaFeriasAgendadas(_this5.agendamentos);
                // const feriasMapeadas = this.mapeiaFeriasAgendadas(agendamentosMock);

                _context4.next = 16;
                return _this5.incluiProtocolos(feriasMapeadas);

              case 16:
                feriasComProtocolo = _context4.sent;

                _this5.feriasAgendadas = feriasComProtocolo;

                _this5.usuarioValido = true;
                _context4.next = 29;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t0 = _context4['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_16__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context4.t0);

                if (!(mensagem === 'Funcionário não localizado ou acesso negado')) {
                  _context4.next = 28;
                  break;
                }

                _this5.$router.push({ name: 'UorNaoParticipante' });
                _this5.usuarioValido = false;
                return _context4.abrupt('return');

              case 28:

                _this5.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 29:
                _context4.prev = 29;

                _this5.carregando = false;
                return _context4.finish(29);

              case 32:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[1, 21, 29, 32]]);
      }))();
    },
    obtemMesCompetencia: function obtemMesCompetencia(funcionarioId) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var endPointCompetencias, competenciaResponse, mensagem;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.carregandoAprovador = true;
                _context5.prev = 1;
                endPointCompetencias = 'agendamentos-ferias/funcionarios/' + funcionarioId + '/competencias';
                _context5.next = 5;
                return __WEBPACK_IMPORTED_MODULE_18__services_api__["a" /* default */].get(endPointCompetencias);

              case 5:
                competenciaResponse = _context5.sent;

                if (competenciaResponse) {
                  _context5.next = 8;
                  break;
                }

                throw new Error();

              case 8:
                if (!(!!competenciaResponse && !competenciaResponse.id)) {
                  _context5.next = 11;
                  break;
                }

                _this6.$root.$refs.toastr.e('Não encontramos os dados do mês que ' + 'compete ao agendamento. Por favor, avise ao DETIC sobre essa mensagem', 'Atenção');

                return _context5.abrupt('return');

              case 11:
                if (!(!!competenciaResponse && !competenciaResponse.acessaAgendamento)) {
                  _context5.next = 15;
                  break;
                }

                _this6.$router.push({ name: 'UorNaoParticipante' });
                _this6.usuarioValido = false;

                return _context5.abrupt('return');

              case 15:

                _this6.competencia = competenciaResponse;
                _this6.agendaSabado = competenciaResponse.agendaSabado;
                _this6.agendaDomingoFeriado = competenciaResponse.agendaDomingoFeriado;
                _context5.next = 31;
                break;

              case 20:
                _context5.prev = 20;
                _context5.t0 = _context5['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_16__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context5.t0);

                if (!(mensagem === 'Funcionário não localizado ou acesso negado')) {
                  _context5.next = 27;
                  break;
                }

                _this6.$router.push({ name: 'UorNaoParticipante' });
                _this6.usuarioValido = false;
                return _context5.abrupt('return');

              case 27:
                if (!(mensagem === 'Agendamento de Férias está fechado para lançamento')) {
                  _context5.next = 30;
                  break;
                }

                _this6.escondeAprovador = true;
                return _context5.abrupt('return');

              case 30:

                _this6.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 31:
                _context5.prev = 31;

                _this6.carregandoAprovador = false;
                return _context5.finish(31);

              case 34:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[1, 20, 31, 34]]);
      }))();
    },
    listaAprovadores: function listaAprovadores(mesCompetencia, uorId) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var endPointResponsaveis, responsaveisResponse, mensagem;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.carregandoAprovador = true;

                _context6.prev = 1;
                endPointResponsaveis = 'agendamentos-ferias/competencias/' + mesCompetencia + '/' + ('unidades-organizacionais/' + uorId + '/responsaveis');
                _context6.next = 5;
                return __WEBPACK_IMPORTED_MODULE_18__services_api__["a" /* default */].get(endPointResponsaveis);

              case 5:
                responsaveisResponse = _context6.sent;

                if (responsaveisResponse.length) {
                  _context6.next = 9;
                  break;
                }

                _this7.aprovadores = [];
                return _context6.abrupt('return');

              case 9:

                _this7.mapeiaAprovadores(responsaveisResponse);
                _context6.next = 16;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_16__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context6.t0);

                _this7.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 16:
                _context6.prev = 16;

                _this7.carregandoAprovador = false;
                return _context6.finish(16);

              case 19:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[1, 12, 16, 19]]);
      }))();
    },
    obtemProtocolo: function obtemProtocolo(agendamentoId) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var endPointAgendamento, agendamentoResponse, mensagem;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                endPointAgendamento = 'agendamentos-ferias/' + agendamentoId;
                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_18__services_api__["a" /* default */].get(endPointAgendamento);

              case 4:
                agendamentoResponse = _context7.sent;
                return _context7.abrupt('return', agendamentoResponse && agendamentoResponse.protocolo);

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7['catch'](0);
                mensagem = __WEBPACK_IMPORTED_MODULE_16__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context7.t0);

                _this8.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 12:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[0, 8]]);
      }))();
    },


    // Métodos handle
    mapeiaFeriasAgendadas: function mapeiaFeriasAgendadas(agendamentos) {
      var feriasMapeadas = agendamentos.reduce(function (result, ferias) {
        if (ferias !== {}) {
          result.push(new __WEBPACK_IMPORTED_MODULE_14__domain_ferias__["a" /* default */](ferias.id, ferias.periodoAquisitivo.id, ferias.dataIninico ? ferias.dataInicio.substr(0, 4) : ferias.periodoAquisitivo.competencia.ano, ferias.periodoAquisitivo.competencia.ano, ferias.dataInicio, ferias.periodoAquisitivo.possuiDiasPendentes, ferias.periodoAquisitivo.possuiFeriasPendentes, ferias.statusAprovacao, ferias.periodo.anoCompetencia, ferias.periodo.mesCompetencia));
        }

        return result;
      }, []);

      return feriasMapeadas;
    },
    mapeiaAprovadores: function mapeiaAprovadores(responsaveisResponse) {
      this.aprovadores = responsaveisResponse.map(function (aprovador) {
        return new __WEBPACK_IMPORTED_MODULE_15__domain_ferias_aprovador__["a" /* default */](aprovador.id = aprovador.funcionarioResponsavel.id, aprovador.nome = aprovador.funcionarioResponsavel.nome, aprovador.registro = aprovador.funcionarioResponsavel.registro, aprovador.cargo = aprovador.funcionarioResponsavel.cargo);
      });
    },
    trataInicioParaModal: function trataInicioParaModal(ferias, feriasAgendadas) {
      var formatoData = 'YYYY-MM-DD';
      var agendamento = this.agendamentos.find(function (agendamento) {
        return agendamento.id === ferias.id;
      });
      var periodo = agendamento.periodo;

      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(periodo.anoCompetencia + '-' + periodo.mesCompetencia + '-01', formatoData).add(2, 'months').format(formatoData);
    },
    incluiProtocolos: function incluiProtocolos(feriasMapeadas) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var feriasComProtocolo, feriasResolvidas;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                feriasComProtocolo = feriasMapeadas.map(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8(ferias) {
                    var protocolo;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            if (!ferias.inicio) {
                              _context8.next = 5;
                              break;
                            }

                            _context8.next = 3;
                            return _this9.obtemProtocolo(ferias.id);

                          case 3:
                            protocolo = _context8.sent;

                            if (protocolo) ferias.protocolo = protocolo.codigo;

                          case 5:
                            return _context8.abrupt('return', ferias);

                          case 6:
                          case 'end':
                            return _context8.stop();
                        }
                      }
                    }, _callee8, _this9);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(feriasComProtocolo);

              case 3:
                feriasResolvidas = _context9.sent;
                return _context9.abrupt('return', feriasResolvidas);

              case 5:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },


    // Outros métodos
    abreProtocolo: function abreProtocolo(_ref2) {
      var protocolo = _ref2.protocolo,
          agendamentoId = _ref2.agendamentoId;

      this.protocolo = protocolo;
      this.agendamentoId = agendamentoId;
      setTimeout(function () {
        jQuery('#protocoloModal').modal('show');
      }, 600);
    },
    abreExplicacaoModal: function abreExplicacaoModal() {
      jQuery('#explicacaoModal').modal('show');
    },
    abreRegraDiasPendentes: function abreRegraDiasPendentes() {
      jQuery('#regraDiasPendentesModal').modal('show');
    },
    abreRegraFeriasPendentes: function abreRegraFeriasPendentes() {
      jQuery('#regraFeriasPendentesModal').modal('show');
    },
    mostraEditar: function mostraEditar(ferias) {
      if (ferias) {
        var naoAgendado = ferias.situacao === 'PENDENTE';

        var naoTemDiasFeriasPendentes = !ferias.diasPendentes && !ferias.feriasPendentes;

        var temDireitoFerias = this.temDireitoFerias(ferias);

        return naoAgendado && naoTemDiasFeriasPendentes && temDireitoFerias;
      }

      return false;
    },
    temDireitoFerias: function temDireitoFerias(ferias) {
      if (ferias) {
        var _usuarioAtual$dataIni = this.usuarioAtual.dataInicioAtividade.split('-'),
            _usuarioAtual$dataIni2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_usuarioAtual$dataIni, 3),
            ano = _usuarioAtual$dataIni2[0],
            mes = _usuarioAtual$dataIni2[1],
            dia = _usuarioAtual$dataIni2[2];

        var dataDireitoFerias = new Date(+ano + 1, +mes - 1, +dia);
        var anoInicioDireito = dataDireitoFerias.getFullYear();
        var mesInicioDireito = dataDireitoFerias.getMonth();

        var dataFerias = new Date(ferias.anoAgendamento, +ferias.mesAgendamento - 1 + 2, 1);
        var anoFerias = dataFerias.getFullYear();
        var mesFerias = dataFerias.getMonth();

        if (anoInicioDireito > anoFerias || anoInicioDireito == anoFerias && mesInicioDireito > mesFerias) {
          return false;
        }

        return true;
      }

      return false;
    },
    mostraVisualizar: function mostraVisualizar(ferias) {
      if (ferias) {
        var agendado = ferias.situacao !== 'PENDENTE';
        var naoTemDiasFeriasPendentes = !ferias.diasPendentes && !ferias.feriasPendentes;

        return agendado && naoTemDiasFeriasPendentes;
      }

      return false;
    },
    mostraDiasFeriasPendentes: function mostraDiasFeriasPendentes(ferias) {
      if (ferias) {
        var temDiasPendentes = ferias.diasPendentes;
        var temFeriasPendentes = ferias.feriasPendentes;

        return temDiasPendentes || temFeriasPendentes;
      }

      return false;
    },
    alternaTooltipDiasFerias: function alternaTooltipDiasFerias(ferias) {
      if (ferias) {
        return ferias.diasPendentes ? 'Dias pendentes' : 'Férias pendentes';
      }
    }
  },

  filters: {
    descricaoStatus: function descricaoStatus(status) {
      var descricao = status;

      switch (status) {
        case 'EM_ANALISE':
          descricao = 'EM ANÁLISE';break;
        case 'SEGUNDA_APROVACAO':
          descricao = 'SEGUNDA APROVAÇÃO';break;
        case 'MARCADA':
          descricao = 'MARCADA/GOZADA';break;
      }

      return descricao;
    }
  },

  created: function created() {
    this.editaRegistro(this.funcionario);
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },


  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_5__components_botao___default.a,
    SideModal: __WEBPACK_IMPORTED_MODULE_12__side_modal___default.a,
    ProtocoloModal: __WEBPACK_IMPORTED_MODULE_8__protocolo_modal___default.a,
    RegraDiasPendentesModal: __WEBPACK_IMPORTED_MODULE_10__regra_dias_pendentes_modal___default.a,
    RegraFeriasPendentesModal: __WEBPACK_IMPORTED_MODULE_11__regra_ferias_pendentes_modal___default.a,
    CardHeader: __WEBPACK_IMPORTED_MODULE_6__components_card_header___default.a,
    ExplicacaoModal: __WEBPACK_IMPORTED_MODULE_9__explicacao_modal___default.a,
    TableLoader: __WEBPACK_IMPORTED_MODULE_7__components_table_loader___default.a
  }
});

/***/ }),

/***/ "0DjR":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("Uu1b")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("2ZXi"),
  /* template */
  __webpack_require__("KDVI"),
  /* scopeId */
  "data-v-1f664b0e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "0Qh0":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("vB7S"),
  /* template */
  __webpack_require__("RxZC"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "0Sf3":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("5x2f")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("ex6t"),
  /* template */
  __webpack_require__("PhpC"),
  /* scopeId */
  "data-v-3ba3f512",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "0xHh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var EstadosCivisService = function () {
  function EstadosCivisService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, EstadosCivisService);

    throw 'Não é possível instanciar EstadosCivisService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(EstadosCivisService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint();
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista() {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }]);

  return EstadosCivisService;
}();

/* harmony default export */ __webpack_exports__["a"] = (EstadosCivisService);


var mergeEndpoint = function mergeEndpoint() {
  return 'estados-civis';
};

/***/ }),

/***/ "1K/T":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pagina-erro', {
    attrs: {
      "titulo": "Desculpe, estamos em manutenção",
      "icone": "fa fa-cog fa-spin",
      "imagemTexto": "centralservidor-logo-texto.png",
      "imagem": "centralservidor-logo.png",
      "texto": "Estamos fora do ar no momento, mas estamos trabalhando nisso.\n\t\tEm breve estaremos operando normalmente."
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "1pbJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var StringHelper = function () {
	function StringHelper() {
		__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, StringHelper);

		throw 'Não é possível instanciar StringHelper';
	}

	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(StringHelper, null, [{
		key: 'limpaFormato',
		value: function limpaFormato(dadoFormatado) {
			var ehRG = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (ehRG && dadoFormatado) {
				var dadoLimpo = dadoFormatado.replace(/[^0-9a-zA-Z]+/g, '');
				return dadoLimpo;
			}
			if (dadoFormatado) {
				var _dadoLimpo = dadoFormatado.replace(/[^\d]+/g, '');
				return _dadoLimpo;
			}
			return null;
		}
	}, {
		key: 'limpaFormatoMonetario',
		value: function limpaFormatoMonetario(dadoFormatado) {
			if (dadoFormatado) {
				var dadoString = dadoFormatado.toString();
				var dadoSemPonto = dadoString.replace(/\.+/g, '');
				var dadoSemVirgula = dadoSemPonto.replace(/,+/g, '.');
				var dadoLimpo = parseFloat(dadoSemVirgula);
				return dadoLimpo;
			}
			return null;
		}
	}, {
		key: 'paraCaixaAlta',
		value: function paraCaixaAlta(frase) {
			if (frase) {
				return frase.toUpperCase();
			}
			return '';
		}
	}, {
		key: 'toUpperCaseInJson',
		value: function toUpperCaseInJson(objeto) {
			var excecao = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

			var maiusculo = function maiusculo(obj) {
				for (var prop in obj) {
					if (typeof obj[prop] === 'string' && !excecao.includes(prop)) {
						obj[prop] = obj[prop].toUpperCase();
					}
					if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj[prop]) === 'object') {
						maiusculo(obj[prop]);
					}
				}
				return obj;
			};
			return maiusculo(objeto);
		}
	}, {
		key: 'verificaCaracterEspecial',
		value: function verificaCaracterEspecial(palavra) {
			var pattern = new RegExp(/[^A-Za-z0-9\-_ªº°.,@() ]/g);
			return palavra ? pattern.test(palavra) : false;
		}
	}, {
		key: 'limpaCaracterEspecial',
		value: function limpaCaracterEspecial(palavra) {
			var result = '';
			result = palavra.replace(/[àáâã]/g, 'a');
			result = result.replace(/[ÀÁÂÃ]/g, 'A');
			result = result.replace(/[èéêẽ]/g, 'e');
			result = result.replace(/[ÈÉÊẼ]/g, 'E');
			result = result.replace(/[ìíîĩ]/g, 'i');
			result = result.replace(/[ÌÍÎĨ]/g, 'I');
			result = result.replace(/[òóôõ]/g, 'o');
			result = result.replace(/[ÒÓÔÕ]/g, 'O');
			result = result.replace(/[ùúûũ]/g, 'u');
			result = result.replace(/[ÙÚÛŨ]/g, 'U');
			result = result.replace(/ç/g, 'c');
			result = result.replace(/Ç/g, 'C');
			result = result.replace(/[^A-Za-z0-9\-_ªº°.,@() ]/g, '');

			return result;
		}
	}]);

	return StringHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (StringHelper);

/***/ }),

/***/ "24L3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_StringHelper__ = __webpack_require__("1pbJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_NullHelper__ = __webpack_require__("2wz9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Contatos',

  data: function data() {
    return {
      cadastrado: this.$store.state.funcionarioCadastrado,
      contato: {
        dddCelular: null,
        dddTelefone: null,
        email: '',
        numeroCelular: null,
        numeroTelefone: null
      },
      apiErrors: null
    };
  },


  computed: {
    telefoneResidencialMasked: function telefoneResidencialMasked() {
      var mask = '';
      if (this.cadastrado && this.cadastrado.pessoa.contato.numeroTelefone) {
        mask = this.cadastrado.pessoa.contato.numeroTelefone.length === 10 ? '#####-####' : '####-####?#';
      }
      return mask;
    },
    ehEmailPrefeitura: function ehEmailPrefeitura() {
      var contatoModelo = this.$store.state.cadastroModelo.pessoa.contato;
      if (contatoModelo && contatoModelo.email) {
        return contatoModelo.email.includes('@santos.sp.gov.br');
      }
      return false;
    },
    situacaoRecad: function situacaoRecad() {
      return this.$store.getters.getSituacaoRecad;
    }
  },

  methods: {
    volta: function volta() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (success) {
          _this.$router.go(-1);
        } else {
          _this.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção');
        }
      });
    },
    avanca: function avanca(cadastrado, proximoLink) {
      var _this2 = this;

      this.$validator.validateAll().then(function (success) {
        if (success) {
          if (proximoLink !== 'Contatos') {
            _this2.formataParaApi(cadastrado);
            _this2.$store.commit('setFuncionarioCadastrado', cadastrado);
            _this2.$router.push({ name: proximoLink });
          }
        } else {
          _this2.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção');
        }
      });
    },
    valoraNulos: function valoraNulos(pessoa) {
      pessoa.contato = __WEBPACK_IMPORTED_MODULE_3__helpers_NullHelper__["a" /* default */].valora(pessoa.contato, this.contato);
    },
    resetaNulos: function resetaNulos(pessoa) {
      pessoa.contato = __WEBPACK_IMPORTED_MODULE_3__helpers_NullHelper__["a" /* default */].reseta(pessoa.contato, this.contato);
    },
    formataParaApi: function formataParaApi(cadastrado) {
      var contato = cadastrado.pessoa.contato;
      if (contato) {
        var limpa = function limpa(numero) {
          return __WEBPACK_IMPORTED_MODULE_2__helpers_StringHelper__["a" /* default */].limpaFormato(numero);
        };
        var numerifica = function numerifica(numero) {
          return numero ? parseInt(numero) : null;
        };

        contato.numeroTelefone = limpa(contato.numeroTelefone);
        contato.numeroTelefone = numerifica(contato.numeroTelefone);
        contato.numeroCelular = limpa(contato.numeroCelular);
        contato.numeroCelular = numerifica(contato.numeroCelular);
        contato.dddTelefone = numerifica(contato.dddTelefone);
        contato.dddCelular = numerifica(contato.dddCelular);

        // Garante que o email não seja vazio ou apenas espaços
        if (contato.email) {
          contato.email = contato.email.trim();
          this.tiraAcentuacao(contato);
        }
      }
      this.resetaNulos(cadastrado.pessoa);
    },
    tiraAcentuacao: function tiraAcentuacao(contato) {
      if (__WEBPACK_IMPORTED_MODULE_2__helpers_StringHelper__["a" /* default */].verificaCaracterEspecial(contato.email)) {
        contato.email = __WEBPACK_IMPORTED_MODULE_2__helpers_StringHelper__["a" /* default */].limpaCaracterEspecial(contato.email);
        this.$root.$refs.toastr.w('A Atualização Cadastral não aceita acentos e cedilhas. A aplicação já fez as correções necessárias.', 'Atenção');
      }
    }
  },

  created: function created() {
    var _this3 = this;

    console.log(this.situacaoRecad);
    this.valoraNulos(this.cadastrado.pessoa);
    this.$eventBus.$on('salvaAvanca', function (nomeComponente) {
      // Validação adicional para garantir que o email não seja nulo antes de permitir avançar
      if (!_this3.ehEmailPrefeitura) {
        var email = _this3.cadastrado.pessoa.contato.email;
        if (!email || email.trim() === '') {
          _this3.$root.$refs.toastr.e('O campo Email é obrigatório', 'Atenção');
          _this3.$router.push({ name: 'Contatos' });
          return;
        }
      }
      _this3.avanca(_this3.cadastrado, nomeComponente);
    });
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off('salvaAvanca');
  },


  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_1__components_botao___default.a
  }
});

/***/ }),

/***/ "26OG":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pagina-erro', {
    attrs: {
      "titulo": "Informação importante",
      "icone": "fa fa-calendar-times-o",
      "imagemTexto": "centralservidor-logo-texto.png",
      "imagem": "centralservidor-logo.png",
      "texto": "Sua secretaria não participará,\n    neste ano, do cadastramento através da Central do Servidor. Informe-se\n    com seu superior direto."
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "2Kst":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("9YD2"),
  /* template */
  __webpack_require__("ltYo"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "2MKL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("QmSG");





var FileHelper = function () {
  function FileHelper() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FileHelper);

    throw 'Não é possível instanciar FileHelper';
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FileHelper, null, [{
    key: 'download',
    value: function download(arquivo, vm) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default()({
        url: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].staticUrl + arquivo,
        methods: 'GET',
        responseType: 'blob'
      }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', arquivo);
        document.body.appendChild(link);
        link.click();
        vm.$root.$refs.toastr.s('O arquivo foi baixado para seu computador.', 'Sucesso');
      }).catch(function (error) {
        if (error == 'Error: Request failed with status code 404') {
          vm.$root.$refs.toastr.e('Arquivo não encontrado, reporte esse erro ao admnistrador do sistema.', 'Atenção');
        } else {
          vm.$root.$refs.toastr.e(error, 'Atenção');
        }
      });
    }
  }]);

  return FileHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (FileHelper);

/***/ }),

/***/ "2RzD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEstados; });
var estados = [{ id: 1, nome: 'Acre' }, { id: 2, nome: 'Alagoas' }, { id: 3, nome: 'Amapá' }, { id: 4, nome: 'Amazonas' }, { id: 5, nome: 'Bahia' }, { id: 6, nome: 'Ceará' }, { id: 7, nome: 'Distrito Federal' }, { id: 8, nome: 'Espírito Santo' }, { id: 9, nome: 'Goiás' }, { id: 10, nome: 'Maranhão' }, { id: 11, nome: 'Mato Grosso' }, { id: 12, nome: 'Mato Grosso do Sul' }, { id: 13, nome: 'Minas Gerais' }, { id: 14, nome: 'Pará' }, { id: 15, nome: 'Paraíba' }, { id: 16, nome: 'Paraná' }, { id: 17, nome: 'Pernambuco' }, { id: 18, nome: 'Piauí' }, { id: 19, nome: 'Rio de Janeiro' }, { id: 20, nome: 'Rio Grande do Norte' }, { id: 21, nome: 'Rio Grande do Sul' }, { id: 22, nome: 'Rondônia' }, { id: 23, nome: 'Roraima' }, { id: 24, nome: 'Santa Catarina' }, { id: 25, nome: 'São Paulo' }, { id: 26, nome: 'Sergipe' }, { id: 27, nome: 'Tocantins' }];

var getEstados = function getEstados() {
  return estados;
};

/***/ }),

/***/ "2VWi":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pagina-erro', {
    attrs: {
      "titulo": "Acesso bloqueado",
      "icone": "fa fa-hand-paper-o",
      "imagemTexto": "centralservidor-logo-texto.png",
      "imagem": "centralservidor-logo.png",
      "texto": "Você não possui acesso a essa página.\n\t\tVerifique suas permissões de acesso com seu superior."
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "2ZXi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_botao__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'registrosModal',

  data: function data() {
    return {
      autenticados: this.$store.state.usuarioLogado.funcionarios,
      funcionario: this.$store.state.funcionario
    };
  },


  computed: {
    carregaAutenticados: function carregaAutenticados() {
      return this.$store.state.usuarioLogado.funcionarios;
    }
  },

  watch: {
    carregaAutenticados: function carregaAutenticados(novo, anterior) {
      this.autenticados = novo;
      this.funcionario = novo[0];
    }
  },

  methods: {
    trocaUsuario: function trocaUsuario(funcionario) {
      this.$store.commit('setFuncionario', funcionario);
    }
  },

  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_0__components_botao___default.a
  }
});

/***/ }),

/***/ "2qeI":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("K1rt"),
  /* template */
  __webpack_require__("LrQo"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "2rAA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('pt-BR');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FaltaLei',
  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_1__components_botao___default.a
  },
  data: function data() {
    return {
      dataSolicitacao: this.dataSolicitada,
      dataFalta: this.dataDaFalta,
      mostraSolicitada: this.mostraDataSolicitada,
      mostraFalta: this.mostraDataFalta,
      config: {
        format: 'L',
        useCurrent: false,
        locale: 'pt-br'
      }
    };
  },

  props: {
    via: {
      type: String,
      required: true
    },
    destino: {
      type: String,
      required: true
    },
    nomeServidor: {
      type: String,
      required: true
    },
    servidor: {
      type: Object,
      required: true
    },
    dataSolicitada: {
      type: [Date, String],
      required: false
    },
    dataDaFalta: {
      type: [Date, String],
      required: false
    },
    mostraDataSolicitada: {
      type: Boolean,
      required: true
    },
    mostraDataFalta: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    entraDataSolicitada: function entraDataSolicitada() {
      var solicitacao = this.trataObjetoOuString(this.dataSolicitacao);
      this.$emit('getDataSolicitada', solicitacao);
    },
    entraDataFalta: function entraDataFalta() {
      var falta = this.trataObjetoOuString(this.dataFalta);
      this.$emit('getDataFalta', falta);
    },
    trataObjetoOuString: function trataObjetoOuString(data) {
      return (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data)) === 'object' ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(data).format('DD/MM/YYYY') : data;
    },
    limpaDataSolicitada: function limpaDataSolicitada() {
      this.dataSolicitacao = new Date();
    },
    limpaDataFalta: function limpaDataFalta() {
      this.dataFalta = new Date();
    }
  },
  filters: {
    extenso: function extenso(data) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(data, 'DD/MM/YYYY').format('LL');
    }
  },
  created: function created() {
    var _this = this;

    this.$parent.$on('enviaDatas', function () {
      _this.entraDataSolicitada();
      _this.entraDataFalta();
    });
  }
});

/***/ }),

/***/ "2wz9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_is__ = __webpack_require__("g4PW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);





var NullHelper = function () {
  function NullHelper() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NullHelper);

    throw 'Não é possível instanciar NullHelper';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(NullHelper, null, [{
    key: 'valora',
    value: function valora(prop, modelo) {
      var copiaModelo = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(modelo));
      return !prop ? copiaModelo : prop;
    }
  }, {
    key: 'reseta',
    value: function reseta(prop, modelo) {
      var propString = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(prop);
      var modeloString = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(modelo);
      var continuaVazio = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_is___default()(propString, modeloString);
      return continuaVazio ? null : prop;
    }
  }]);

  return NullHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (NullHelper);

/***/ }),

/***/ "39rQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_valeAlimentacaoService__ = __webpack_require__("sVKh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_ErrorHelper__ = __webpack_require__("+h9g");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ValeAlimentacao',
  components: { Botao: __WEBPACK_IMPORTED_MODULE_3__components_botao___default.a },
  data: function data() {
    return {
      carregando: true,
      salvando: false,
      imprimindo: false,
      habilitado: false,
      periodoAberto: false,
      competencia: null,
      escolha: null,
      nomeServidor: '',
      empresas: [],
      empresaSelecionada: null,
      empresaOriginal: null,
      modoEscolha: false
    };
  },

  computed: {
    temEscolha: function temEscolha() {
      return Boolean(this.escolha && this.escolha.id);
    },
    tipoEscolha: function tipoEscolha() {
      return this.temEscolha ? this.escolha.tipoEscolha : 'PENDENTE';
    },
    anoCompetencia: function anoCompetencia() {
      return this.competencia ? this.competencia.ano : '—';
    },
    statusLabel: function statusLabel() {
      var labels = {
        PENDENTE: 'PENDENTE',
        CONCLUIDA: 'CONCLUÍDA',
        FINALIZADA: 'FINALIZADA',
        ENVIADA: 'ENVIADA'
      };
      return labels[this.tipoEscolha] || '—';
    },
    badgeLabel: function badgeLabel() {
      var _this = this;

      if (!this.temEscolha) return this.statusLabel;
      if (this.escolha.nomeEmpresa) return this.escolha.nomeEmpresa;

      var empresa = this.empresas.find(function (item) {
        return item.id === _this.empresaSelecionada;
      });
      return empresa ? this.nomeDaEmpresa(empresa) : 'Empresa selecionada';
    },
    statusColor: function statusColor() {
      var cores = {
        PENDENTE: '#d98200',
        CONCLUIDA: '#238b45',
        FINALIZADA: '#2463a8',
        ENVIADA: '#2463a8'
      };
      return cores[this.tipoEscolha] || '#555';
    },
    badgeClass: function badgeClass() {
      return 'badge-status badge-' + this.tipoEscolha.toLowerCase();
    },
    badgeIcon: function badgeIcon() {
      if (this.tipoEscolha === 'PENDENTE') return 'fa fa-clock-o';
      if (this.tipoEscolha === 'CONCLUIDA') return 'fa fa-check-circle-o';
      return 'fa fa-lock';
    },
    statusIconClass: function statusIconClass() {
      return this.badgeIcon;
    },
    somenteConsulta: function somenteConsulta() {
      return this.tipoEscolha === 'FINALIZADA' || this.tipoEscolha === 'ENVIADA';
    },
    podeSalvar: function podeSalvar() {
      if (this.somenteConsulta || !this.empresaSelecionada) return false;
      return !this.temEscolha || this.empresaSelecionada !== this.empresaOriginal;
    },
    dataFimLancamento: function dataFimLancamento() {
      return this.competencia != null ? this.competencia.dataLimiteLancamento : null;
    },
    dataEscolhaFormatada: function dataEscolhaFormatada() {
      if (!this.temEscolha || !this.escolha.dataEscolha) return '—';
      var data = new Date(this.escolha.dataEscolha);
      if (isNaN(data.getTime())) return '—';
      return data.toLocaleString('pt-BR');
    },
    empresasExibidas: function empresasExibidas() {
      var _this2 = this;

      if (!this.temEscolha || this.empresas.some(function (empresa) {
        return empresa.id === _this2.empresaSelecionada;
      })) {
        return this.empresas;
      }
      return [{
        id: this.empresaSelecionada,
        nome: this.escolha.nomeEmpresa,
        temMaterial: false
      }].concat(this.empresas);
    }
  },
  created: function created() {
    this.carregar();
  },

  methods: {
    carregar: function carregar() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var contexto;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.carregando = true;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_valeAlimentacaoService__["a" /* default */].carregarContexto();

              case 4:
                contexto = _context.sent;

                _this3.habilitado = Boolean(contexto && contexto.habilitado);
                _this3.periodoAberto = Boolean(contexto && contexto.periodoAberto);
                _this3.competencia = contexto ? contexto.competencia : null;
                _this3.escolha = contexto ? contexto.escolha : null;
                _this3.nomeServidor = contexto && contexto.nomeServidor ? contexto.nomeServidor : _this3.$store.state.usuarioLogado.nome;

                if (_this3.escolha) {
                  _this3.empresaSelecionada = _this3.escolha.idPessoaJuridicaValeAlimentacao;
                  _this3.empresaOriginal = _this3.empresaSelecionada;
                  _this3.modoEscolha = true;
                } else {
                  _this3.empresaSelecionada = null;
                  _this3.empresaOriginal = null;
                  _this3.modoEscolha = false;
                }

                if (!(_this3.habilitado && _this3.periodoAberto)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 14;
                return __WEBPACK_IMPORTED_MODULE_4__services_valeAlimentacaoService__["a" /* default */].listaEmpresas();

              case 14:
                _this3.empresas = _context.sent;

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](1);

                _this3.$root.$refs.toastr.e(__WEBPACK_IMPORTED_MODULE_5__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context.t0), 'Atenção');

              case 20:
                _context.prev = 20;

                _this3.carregando = false;
                return _context.finish(20);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[1, 17, 20, 23]]);
      }))();
    },
    iniciarEscolha: function iniciarEscolha() {
      this.modoEscolha = true;
    },
    nomeDaEmpresa: function nomeDaEmpresa(empresa) {
      if (empresa.nome) return empresa.nome;
      var pessoaJuridica = empresa.empresa || {};
      return pessoaJuridica.nomeFantasia || pessoaJuridica.nomeAbreviado || 'Empresa ' + empresa.id;
    },
    classeItem: function classeItem(idEmpresa) {
      if (this.empresaSelecionada !== idEmpresa) return '';
      return 'selecionada ' + this.tipoEscolha.toLowerCase();
    },
    formataDataParaMensagem: function formataDataParaMensagem(data) {
      if (!data) return '—';

      var valor = String(data).trim();
      if (!valor) return '—';

      var partes = valor.split('-');
      if (partes.length !== 3) return valor;

      var _partes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(partes, 3),
          ano = _partes[0],
          mes = _partes[1],
          dia = _partes[2];

      if (!ano || !mes || !dia) return valor;

      return dia + '/' + mes + '/' + ano;
    },
    salvar: function salvar() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var dataLimite, dataFormatada, mensagens;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this4.podeSalvar) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                dataLimite = _this4.dataFimLancamento;
                dataFormatada = _this4.formataDataParaMensagem(dataLimite);
                mensagens = [{
                  id: 1,
                  message: 'ATEN\xC7\xC3O: A escolha do vale-alimenta\xE7\xE3o ser\xE1 encerrada em ' + dataFormatada + '. Ap\xF3s essa data, a op\xE7\xE3o escolhida s\xF3 poder\xE1 ser alterada novamente ap\xF3s um ano.',
                  bold: false
                }];


                _this4.$root.$refs.modal.confirm(mensagens, {
                  title: 'Atenção',
                  labelYes: 'OK',
                  showNo: false,
                  yes: function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                      var dados;
                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _this4.salvando = true;
                              _context2.prev = 1;
                              dados = {
                                idPessoaJuridicaValeAlimentacao: _this4.empresaSelecionada,
                                idMesCompetencia: _this4.competencia.id
                              };

                              if (!_this4.temEscolha) {
                                _context2.next = 8;
                                break;
                              }

                              _context2.next = 6;
                              return __WEBPACK_IMPORTED_MODULE_4__services_valeAlimentacaoService__["a" /* default */].atualiza(_this4.escolha.id, dados);

                            case 6:
                              _context2.next = 10;
                              break;

                            case 8:
                              _context2.next = 10;
                              return __WEBPACK_IMPORTED_MODULE_4__services_valeAlimentacaoService__["a" /* default */].salvar(dados);

                            case 10:
                              _context2.next = 12;
                              return _this4.carregar();

                            case 12:
                              _this4.$root.$refs.toastr.s('Escolha salva com sucesso!', 'Sucesso');
                              _context2.next = 18;
                              break;

                            case 15:
                              _context2.prev = 15;
                              _context2.t0 = _context2['catch'](1);

                              _this4.$root.$refs.toastr.e(__WEBPACK_IMPORTED_MODULE_5__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context2.t0), 'Erro ao salvar');

                            case 18:
                              _context2.prev = 18;

                              _this4.salvando = false;
                              return _context2.finish(18);

                            case 21:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this4, [[1, 15, 18, 21]]);
                    }));

                    return function yes() {
                      return _ref.apply(this, arguments);
                    };
                  }()
                });

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    abrirAnexoEmNovaAba: function abrirAnexoEmNovaAba(id) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var arquivo;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__services_valeAlimentacaoService__["a" /* default */].visualizarAnexo(id);

              case 3:
                arquivo = _context4.sent;

                _this5.abrirPdf(arquivo);
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);

                _this5.$root.$refs.toastr.e('Não foi possível carregar o material informativo.', 'Atenção');

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 7]]);
      }))();
    },
    imprimirProtocolo: function imprimirProtocolo() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var arquivo;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this6.temEscolha) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt('return');

              case 2:
                _this6.imprimindo = true;
                _context5.prev = 3;
                _context5.next = 6;
                return __WEBPACK_IMPORTED_MODULE_4__services_valeAlimentacaoService__["a" /* default */].imprimirProtocolo(_this6.escolha.id);

              case 6:
                arquivo = _context5.sent;

                _this6.abrirPdf(arquivo);
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](3);

                _this6.$root.$refs.toastr.e('Não foi possível gerar o protocolo.', 'Atenção');

              case 13:
                _context5.prev = 13;

                _this6.imprimindo = false;
                return _context5.finish(13);

              case 16:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[3, 10, 13, 16]]);
      }))();
    },
    abrirPdf: function abrirPdf(arquivo) {
      var url = URL.createObjectURL(new Blob([arquivo], { type: 'application/pdf' }));
      window.open(url, '_blank');
      window.setTimeout(function () {
        return URL.revokeObjectURL(url);
      }, 60000);
    }
  }
});

/***/ }),

/***/ "3B2p":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "primeira-via"
  }, [_c('impresso', {
    attrs: {
      "via": "1",
      "destino": "DRH",
      "nomeServidor": _vm.nomeFuncionario,
      "servidor": _vm.funcionario,
      "dataSolicitada": _vm.dataSolicitacao,
      "dataDaFalta": _vm.dataFalta,
      "mostraDataSolicitada": _vm.mostraInputSolicitacao,
      "mostraDataFalta": _vm.mostraInputFalta
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "segunda-via"
  }, [_c('impresso', {
    attrs: {
      "via": "2",
      "destino": "Solicitante",
      "nomeServidor": _vm.nomeFuncionario,
      "servidor": _vm.funcionario,
      "dataSolicitada": _vm.dataSolicitacao,
      "dataDaFalta": _vm.dataFalta,
      "mostraDataSolicitada": _vm.mostraInputSolicitacao,
      "mostraDataFalta": _vm.mostraInputFalta
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "43FW":
/***/ (function(module, exports) {

module.exports = "data:image/x-icon;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB90GExICCIzXNS4AAAPcSURBVDjLBcF7TBt1AAfw7+/uegd9P2i7llJGCwz2qGtZBggaHm5zER2ELQZ1/8iMmZlZXKIm6jTjn0UTnU58RhefI4ui2RYHChT+IJnoMhhlONt1gNhBabHdSu/6uOv5+ZBQ7A6qzC4AwIG243jhVAeptLl8FEvvXYuupvlUPul0mg0FMeevqvEExqem0FpfDwBYXA2BAAAv58GBoUZHRmxEoj7N8OmOWGwNckEGRQogDA2VVget2TTDKbnulvqmBcg5mVAcGAAILMwwiY1Ez2om3OmSSzsiczdRusHnkhZrWlIQYgpFFFFDUZGhIO9c1KbemZjLDKsZ7isAIgGAzy5/yEbiy1f900O+k4+fArsBKM2GOW515RJFU3Rao67l09lWiRE1b430oafpMB7x7bHUunwx0n/pAzCg29SJ7JGFa1NNjh0W7umBK9YMpURKR4PIgDINaPgkzh9qiv4T5nOO6uYxa0N1gFLQZ5h8PsukxezY0O1xvHiir799aBqLwa+PrWwyIm7KglPkoF5TwRZK4hnR9sPYiS58fu70MU8wBYVCcZZ6qfsVkSXUu2X/ITIbDFhyjMTKhAZlzkPrS4FuyEN2SpA5AoHKssHgrMUYFZbLdGVDrx56Q6T+XQpvLmY1au/DXfGqErtfIALLgkHWYETCoketSUK9goZeoCEUCOt1bfc3tHetJ7PJaHgxVM5ICtntn//teQhZaTfV0r1P5ILJcgmZrgTmTSpEgirs33If+r8FaGQpHZi93u2fG96RIYWdj3mf+JES2cINHaf52Eu5BafDPZAp0W5VMxKa5nNy+7UUCqUSrtSWIKqgUTC5agxW+4CXqxLsxdZPZMjTBABuh2/tHZy48OtsLji5x+CuefLLb3J8fsOeeU5AbnMeye90BUe8ghrr2i+Npheu1qk8zZ3NTzXYnPYpCgAiLk1ujA8idXO92cV677JHe84qKj3Ifq8C6TOiMu2mSg42vp0R9IPhwNKDv8RnMGcjDACQ5MXBXsb/Z98Shu0ZOQYXvYkvpjUJUVKXCgtBMPdocPZqUDo+witjXDgWNypqKqit9L672e2Nb5LYy6+JIW0/rQ6pwCfV4EQGRkcKK8J90CyDfEpERinBVmQEn9KDXRUhae6B8fFwLB+UGLna0Wk647ycMWjk3efO/zy6/Pvk6HLkvQqeu3DgobZbBUoqHp/6o/ajtUBZR2PLT63bGuQ7h4+clL8Ns9ld+U6m2GStg1Y/oew9epHaUvH+9fBf7tZyT2pX1bYv5BWRgM6TR3s9hcnwjWe1SvU0Z7ZNrx9/fRic6rRc90Dd/ylStJJp1yjPAAAAAElFTkSuQmCC"

/***/ }),

/***/ "4JAb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Avaliador = function Avaliador() {
    var pessoa = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var tipo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var lotacao = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Avaliador);

    this.pessoa = pessoa;
    this.tipo = tipo;
    this.lotacao = lotacao;
};

/* harmony default export */ __webpack_exports__["a"] = (Avaliador);

/***/ }),

/***/ "4a01":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "protocoloModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "protocoloModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [(_vm.protocoloGerado) ? _c('div', {
    staticClass: "row row-field"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Anote ou imprima o seu número.")]), _vm._v(" "), _c('div', {
    staticClass: "espacado",
    staticStyle: {
      "color": "#004f4a"
    }
  }, [_c('h2', [_vm._v("PROTOCOLO")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin-top": "10px",
      "padding-bottom": "10px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.protocoloGerado) + "\n                ")])])]) : _c('div', [_vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.protocoloGerado),
      expression: "protocoloGerado"
    }],
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde",
      "rotulo": "Imprimir",
      "icone": "fa-print",
      "dismiss": "modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.imprime()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Ok",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "protocoloModalLabel"
    }
  }, [_vm._v("\n            Protocolo Gerado\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                O presente "), _c('strong', [_vm._v("protocolo")]), _vm._v(" é um arquivo\n                "), _c('strong', [_vm._v("pessoal")]), _vm._v(". Não é necessário entregar em nenhum\n                setor de Departamento de qualquer Secretaria.\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning espacado",
    staticStyle: {
      "text-align": "center",
      "margin": "30px 30px 15px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Este agendamento é\n                anterior à criação de protocolos. Não existe protocolo para\n                este agendamento.\n              ")])
}]}

/***/ }),

/***/ "4aHL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_rodape__ = __webpack_require__("vN2Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_rodape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_rodape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_botao_ir_para_topo__ = __webpack_require__("NwbQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_botao_ir_para_topo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_botao_ir_para_topo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ajax_intercept__ = __webpack_require__("U3q4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ajax_intercept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_ajax_intercept__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_loader__ = __webpack_require__("tzjS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_barra_navegacao__ = __webpack_require__("hmlq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_barra_navegacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_barra_navegacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_barra_evolucao__ = __webpack_require__("AyCD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_barra_evolucao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_barra_evolucao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_barra_menu__ = __webpack_require__("glyJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_barra_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_barra_menu__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  components: {
    rodape: __WEBPACK_IMPORTED_MODULE_0__components_rodape___default.a,
    BotaoIrParaTopo: __WEBPACK_IMPORTED_MODULE_1__components_botao_ir_para_topo___default.a,
    AjaxIntercept: __WEBPACK_IMPORTED_MODULE_2_vue_ajax_intercept___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_3__components_loader___default.a,
    BarraNavegacao: __WEBPACK_IMPORTED_MODULE_4__components_barra_navegacao___default.a,
    BarraEvolucao: __WEBPACK_IMPORTED_MODULE_5__components_barra_evolucao___default.a,
    BarraMenu: __WEBPACK_IMPORTED_MODULE_6__components_barra_menu___default.a
  },

  data: function data() {
    return {
      routes: this.$router.options.routes,
      carregando: false
    };
  },


  computed: {
    auth: function auth() {
      return this.$root.$data.isAuthenticated;
    },
    usuarioLogado: function usuarioLogado() {
      return this.$store.state.usuarioLogado;
    },
    stepVisible: function stepVisible() {
      return this.$root.$data.isAuthenticated && this.$route.meta.stepNumber > 0;
    },
    number: function number() {
      return this.$route.meta.stepNumber;
    },
    stepName: function stepName() {
      return this.$route.meta.displayName;
    },
    avaliaVisited: function avaliaVisited() {
      return this.$route.meta.avaliaActive;
    },
    declaraVisited: function declaraVisited() {
      return this.$route.meta.declaraActive;
    },
    recadastraVisited: function recadastraVisited() {
      return this.$route.meta.recadastraActive;
    },
    formulariosVisited: function formulariosVisited() {
      return this.$route.meta.formulariosActive;
    },
    feriasVisited: function feriasVisited() {
      return this.$route.meta.feriasActive;
    },
    valeAlimentacaoVisited: function valeAlimentacaoVisited() {
      return this.$route.meta.valeAlimentacaoActive;
    }
  },

  methods: {
    start: function start(param) {
      var _this = this;

      setTimeout(function () {
        if (param.readyState != 4) _this.carregando = true;
      }, 1000);
      return;
    },
    finish: function finish(param) {
      var response = {};
      var message = '';
      var status = param.status,
          responseType = param.responseType,
          timeout = param.timeout;

      // Verifica se é uma requisição de serviço de CEP de várias maneiras

      var isCepRequest =
      // Verifica pelo cabeçalho personalizado
      param.requestHeaders && param.requestHeaders['X-Request-Type'] === 'cep-service' ||
      // Verifica pela URL - ViaCEP
      param.responseURL && param.responseURL.includes('viacep.com.br/ws/') ||
      // Verifica pela URL - BrasilAPI
      param.responseURL && param.responseURL.includes('brasilapi.com.br/api/cep/') ||
      // Verifica pela URL - ApiCEP
      param.responseURL && param.responseURL.includes('apicep.com/file/apicep/');

      // Ignora completamente erros de conexão para requisições de CEP
      if (isCepRequest && (status === 0 || status >= 400)) {
        this.carregando = false;
        return;
      }

      if ((responseType == '' || responseType == 'text') && param.responseText != '') {
        try {
          response = JSON.parse(param.responseText);
          message = response.message ? response.message.toLowerCase() : '';
        } catch (e) {
          // Ignora erros de parsing JSON
        }
      }

      if (status === 200 || status === 201 || status === 204 || status === 400) {
        this.carregando = false;
        return;
      }

      if (status === 401 && message === 'token expirou') {
        this.$root.$refs.toastr.e('Faça login novamente', 'Conexão expirou');
        this.$root.$data.isAuthenticated = false;
        this.$store.commit('setToken', '');
        this.$router.push('/');
        this.carregando = false;
        return;
      }

      if (status === 401 && message === 'autenticação falhou') {
        this.$root.$refs.toastr.e('Usuário ou senha inválidos', 'Atenção');
        this.$root.$data.isAuthenticated = false;
        this.$store.commit('setToken', '');
        this.$router.push('/');
        this.carregando = false;
        return;
      }

      if (status === 401 && message === 'usuário ou senha inválidos') {
        this.$root.$refs.toastr.e('Usuário ou senha inválidos. Se o erro persistir, por favor, abra um SAU.', 'Atenção');
        this.$root.$data.isAuthenticated = false;
        this.$store.commit('setToken', '');
        this.$router.push('/');
        this.carregando = false;
        return;
      }

      if (status === 401) {
        this.$root.$refs.toastr.e(response.message, 'Atenção');
        this.$root.$data.isAuthenticated = false;
        this.$store.commit('setToken', '');
        this.$router.push('/');
        this.carregando = false;
        return;
      }

      if (status === 403) {
        this.$root.$refs.toastr.e('Por favor, contate o administrador', 'Sem acesso');
        this.$router.push({ name: 'SemAcesso' });
        this.carregando = false;
        return;
      }

      if (status === 404 || status === 405) {
        this.carregando = false;
        if (param.responseURL.substr(-24, 13) === '/dependentes/') return;
        this.$root.$refs.toastr.e('Recurso ou página não encontrado', 'Atenção');
        return;
      }

      if (status === 500) {
        var overlay = document.querySelector('.modal-backdrop');
        if (overlay) {
          overlay.remove();
        }
        this.$router.push({ name: 'Manutencao' });
        this.carregando = false;
        return;
      }

      if (status === 503) {
        this.$router.push({ name: 'Manutencao' });
        this.carregando = false;
        return;
      }

      if (status >= 500) {
        this.$root.$refs.toastr.e('Contate o Administrador', 'Problemas no Servidor');
        this.$router.push({ name: 'SemAcesso' });
        this.carregando = false;
        return;
      }

      if (status === 0 && timeout === 0) {
        this.$root.$refs.toastr.w('Verifique sua conexão de rede', 'Computador sem conexão');
        this.carregando = false;
        return;
      }
    }
  },

  mounted: function mounted() {
    this.$root.$refs.toastr.defaultPreventDuplicates = true;
    this.$root.$refs.toastr.defaultPosition = 'toast-top-center';
    // this.$forceUpdate()
  }
});

/***/ }),

/***/ "4rtG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4z+e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "56G/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_barra_menu__ = __webpack_require__("glyJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_barra_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_barra_menu__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'barra-navegacao',

  data: function data() {
    return {
      funcionario: this.$store.state.funcionario,
      autenticados: this.$store.state.usuarioLogado.funcionarios,
      perfis: this.$store.state.usuarioLogado.perfis,
      overlaySuperior: false,
      overlayLateral: false,
      paraBaixoDeclaracao: true,
      paraBaixoRecadastro: true,
      paraBaixoAvaliacao: true,
      paraBaixoFerias: true,
      paraBaixoFormulario: true,
      paraBaixoLinks: true,
      paraBaixoTrocaRegistro: true
    };
  },

  props: {
    autenticado: {
      type: Boolean
    },
    rotas: {
      type: Array,
      required: true
    },
    usuario: {
      type: String,
      required: false
    },
    sshd: {
      type: String,
      required: false
    }
  },
  computed: {
    ehResponsavelAprovador: function ehResponsavelAprovador() {
      if (this.perfis) {
        return this.perfis.includes('APROVADOR_AGENDAMENTO_FERIAS');
      }
      return false;
    },
    registros: function registros() {
      return this.$store.state.usuarioLogado.funcionarios;
    },
    usuarioAtual: function usuarioAtual() {
      return this.$store.state.funcionario;
    },
    permissoes: function permissoes() {
      return this.$store.state.usuarioLogado.perfis;
    }
  },
  watch: {
    registros: function registros(novo, anterior) {
      this.autenticados = novo;
    },
    usuarioAtual: function usuarioAtual(novo, anterior) {
      this.funcionario = novo;
    },
    permissoes: function permissoes(novo, anterior) {
      this.perfis = novo;
    }
  },
  methods: {
    toggleMenuSuperior: function toggleMenuSuperior() {
      var botao = document.querySelector('#btn-menu-superior');
      var largura = botao.clientWidth.toString();
      document.querySelector('#menu-superior').style.width = largura + 'px';
      var offCanvas = document.querySelector('.upper-off-canvas');
      if (offCanvas.classList.contains('fechado')) {
        botao.classList.remove('fechado');
        botao.classList.add('aberto');
        offCanvas.classList.remove('fechado');
        offCanvas.classList.add('aberto');
        this.overlaySuperior = true;
      } else if (offCanvas.classList.contains('aberto')) {
        botao.classList.remove('aberto');
        botao.classList.add('fechado');
        offCanvas.classList.remove('aberto');
        offCanvas.classList.add('fechado');
        this.overlaySuperior = false;
      } else {
        botao.classList.add('aberto');
        offCanvas.classList.add('aberto');
        this.overlaySuperior = true;
      }
      this.limpaSetas();
    },
    toggleMenuLateral: function toggleMenuLateral() {
      var botao = document.querySelector('#btn-menu-lateral');
      var offCanvas = document.querySelector('.off-canvas');
      if (offCanvas.classList.contains('fechado')) {
        botao.classList.remove('fechado');
        botao.classList.add('aberto');
        offCanvas.classList.remove('fechado');
        offCanvas.classList.add('aberto');
        this.overlayLateral = true;
      } else if (offCanvas.classList.contains('aberto')) {
        botao.classList.remove('aberto');
        botao.classList.add('fechado');
        offCanvas.classList.remove('aberto');
        offCanvas.classList.add('fechado');
        this.overlayLateral = false;
      } else {
        botao.classList.add('aberto');
        offCanvas.classList.add('aberto');
        this.overlayLateral = true;
      }
      this.limpaSetas();
    },
    downUp: function downUp(setaParaBaixo) {
      return setaParaBaixo ? 'fa fa-caret-down' : 'fa fa-caret-up';
    },
    limpaSetas: function limpaSetas() {
      this.paraBaixoDeclaracao = true;
      this.paraBaixoAvaliacao = true;
      this.paraBaixoRecadastro = true;
      this.paraBaixoFerias = true;
      this.paraBaixoFormulario = true;
      this.paraBaixoLinks = true;
      this.paraBaixoTrocaRegistro = true;
    },
    trocaRegistro: function trocaRegistro(user) {
      this.funcionario = user;
      this.$store.commit('setFuncionario', user);
    }
  },
  components: {
    BarraMenu: __WEBPACK_IMPORTED_MODULE_0__components_barra_menu___default.a
  }
});

/***/ }),

/***/ "5OEK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);






var ArrayHelper = function () {
    function ArrayHelper() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ArrayHelper);

        throw 'Não é possível instanciar ArrayHelper';
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ArrayHelper, null, [{
        key: 'compareValues',
        value: function compareValues(key) {
            var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'asc';

            return function (a, b) {
                if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                    // property doesn't exist on either object
                    return 0;
                }

                var varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
                var varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

                var comparison = 0;
                if (varA > varB) {
                    comparison = 1;
                } else if (varA < varB) {
                    comparison = -1;
                }
                return order == 'desc' ? comparison * -1 : comparison;
            };
        }
    }, {
        key: 'agrupaArray',
        value: function agrupaArray(array, prop, sum) {
            var agrupado = [];
            array.forEach(function (element) {
                if (!agrupado.find(function (item) {
                    return item[prop] === element[prop];
                })) {
                    var obj = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, prop, element[prop]);
                    agrupado.push(obj);
                }
            });
            agrupado.forEach(function (element) {
                var valores = [];
                valores = array.filter(function (item) {
                    return item[prop] === element[prop];
                });
                valores.reduce(function (prev, item) {
                    return element[sum] = prev + item[sum];
                }, 0);
            });
            return agrupado;
        }
    }, {
        key: 'cloneArray',
        value: function cloneArray(array) {
            var clonados = [];
            array.forEach(function (elemento) {
                var elementoClonado = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(elemento));
                clonados.push(elementoClonado);
            });
            return clonados;
        }
    }, {
        key: 'distinctArray',
        value: function distinctArray(array, atributo) {
            if (typeof atributo != 'string') {
                console.log('Atributo deve ser String e não', typeof atributo === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(atributo));
                return;
            }
            var arrayLimpo = [];
            array.forEach(function (element) {
                if (!arrayLimpo.some(function (item) {
                    return item[atributo] === element[atributo];
                })) {
                    arrayLimpo.push(element);
                }
            });

            return arrayLimpo;
        }
    }, {
        key: 'geraTamanhoLimitado',
        value: function geraTamanhoLimitado(array, prop, tamanho) {
            array.map(function (item) {
                item.limitado = item[prop].substr(0, tamanho);
            });
        }
    }]);

    return ArrayHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (ArrayHelper);

/***/ }),

/***/ "5UK3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ListaEtapas',

  data: function data() {
    return {
      apiErrors: null
    };
  },


  methods: {
    anteriorLink: function anteriorLink() {
      this.$router.go(-1);
    }
  },

  mounted: function mounted() {
    window.scrollTo(0, 0);
  },


  components: {
    botao: __WEBPACK_IMPORTED_MODULE_1__components_botao___default.a
  }
});

/***/ }),

/***/ "5VMd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Endereco = function Endereco() {
    var cep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var logradouro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var bairro = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var municipio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var estado = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var numero = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
    var complemento = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Endereco);

    this._cep = cep;
    this._logradouro = logradouro;
    this._bairro = bairro;
    this._municipio = municipio;
    this._estado = estado;
    this._numero = numero;
    this._complemento = complemento;
};

/* unused harmony default export */ var _unused_webpack_default_export = (Endereco);

/***/ }),

/***/ "5j8y":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pagina-erro', {
    attrs: {
      "titulo": "Página em construção",
      "icone": "fa fa-cog fa-spin",
      "imagemTexto": "centralservidor-logo-texto.png",
      "imagem": "centralservidor-logo.png",
      "texto": "A página que você está tentando acessar não foi construída ainda.\n\t\tVolte mais tarde, por favor."
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "5shf":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("DNAM")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Ufmu"),
  /* template */
  __webpack_require__("Obs4"),
  /* scopeId */
  "data-v-1148c66a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "5x2f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6/3n":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("4rtG")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("LoYH"),
  /* template */
  __webpack_require__("4a01"),
  /* scopeId */
  "data-v-67b2498e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "60R7":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Dados Pessoais\n                "), (_vm.recadastramentos.length > 1) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastro.registro)))]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row row-input"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(this.recadastramentos.length > 1) ? _c('div', {
    staticClass: "col-md-3 col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastro),
      expression: "cadastro"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cadastro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.trocaRegistro(_vm.cadastro.id)
      }]
    }
  }, _vm._l((_vm.recadastramentos), function(recadastramento) {
    return _c('option', {
      key: recadastramento.id,
      domProps: {
        "value": recadastramento
      }
    }, [_vm._v("\n                          " + _vm._s(_vm._f("formataRegistro")(('Registro ' + recadastramento.registro))) + "\n                        ")])
  }), 0)])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('table-loader', {
    attrs: {
      "carregando": _vm.carregando
    }
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "margin-bottom": "2rem"
    }
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-3 col-sm-6 paragrafosPertoDeInput"
  }, [_c('label', {
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.nome),
      expression: "cadastrado.pessoa.nome"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome",
      "id": "nome",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO',
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa, "nome", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3 col-sm-6 paragrafosPertoDeInput"
  }, [_c('label', {
    attrs: {
      "for": "cpf"
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("cpfMask")(_vm.cadastrado.cpf)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3 col-sm-6 paragrafosPertoDeInput"
  }, [_c('field-validation', {
    attrs: {
      "status": _vm.errors,
      "label": "Orientação Sexual",
      "custom-errors": _vm.apiErrors,
      "show-icon": false,
      "field": "orientacaoSexual"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.orientacaoSexual),
      expression: "cadastrado.pessoa.orientacaoSexual"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "orientacaoSexual",
      "data-vv-as": "Orientação Sexual",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa, "orientacaoSexual", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.orientacoesSexuais), function(orientacaoSexual) {
    return _c('option', {
      key: orientacaoSexual.name,
      domProps: {
        "value": orientacaoSexual.name
      }
    }, [_vm._v("\n                        " + _vm._s(_vm._f("tudoMaiusculo")(orientacaoSexual.displayName)) + "\n                      ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3 col-sm-6 paragrafosPertoDeInput"
  }, [_c('field-validation', {
    attrs: {
      "status": _vm.errors,
      "label": "Identidade de Gênero",
      "custom-errors": _vm.apiErrors,
      "show-icon": false,
      "field": "genero"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.genero),
      expression: "cadastrado.pessoa.genero"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "genero",
      "data-vv-as": "Identidade de Gênero",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa, "genero", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.generos), function(genero) {
    return _c('option', {
      key: genero.name,
      domProps: {
        "value": genero.name
      }
    }, [_vm._v("\n                            " + _vm._s(_vm._f("tudoMaiusculo")(genero.displayName)) + "\n                          ")])
  })], 2)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-3"
  }, [(!_vm.cadastrado.lancamentoPermitido) ? _c('div', [_c('campo-calendario', {
    attrs: {
      "disabled": _vm.situacaoRecad === 'CONFIRMADO',
      "rotulo": "Data de Nascimento",
      "nome": "dataNascimento",
      "data-maxima": _vm.dezoitoAnosAtras,
      "validacao": {
        required: true
      }
    },
    model: {
      value: (_vm.cadastrado.pessoa.dataNascimento),
      callback: function($$v) {
        _vm.$set(_vm.cadastrado.pessoa, "dataNascimento", $$v)
      },
      expression: "cadastrado.pessoa.dataNascimento"
    }
  })], 1) : _c('div', [_c('label', {
    attrs: {
      "for": "dataEmissao"
    }
  }, [_vm._v("Data da Emissão")]), _vm._v(" "), _c('p', {
    staticClass: "textoAlinhadoAoInput form-control",
    staticStyle: {
      "background-color": "#eeee",
      "opacity": "1"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.formatarData(_vm.cadastrado.pessoa.dataNascimento)) + "\n                        ")])])]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-3 col-sm-3",
      "label": "Raça/Cor",
      "field": "cor",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.racaCor),
      expression: "cadastrado.pessoa.racaCor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cor",
      "data-vv-as": "Raça/Cor",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa, "racaCor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.cores), function(cor) {
    return _c('option', {
      key: cor.name,
      domProps: {
        "value": cor.name
      }
    }, [_vm._v("\n                          " + _vm._s(_vm._f("tudoMaiusculo")(cor.displayName)) + "\n                        ")])
  })], 2)]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-3 col-sm-3",
      "label": "Estado Civil",
      "field": "estadoCivil",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.estadoCivil),
      expression: "cadastrado.pessoa.estadoCivil"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "estadoCivil",
      "data-vv-as": "Estado Civil",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa, "estadoCivil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.estadosCivis), function(estadoCivil) {
    return _c('option', {
      key: estadoCivil.name,
      domProps: {
        "value": estadoCivil.name
      }
    }, [_vm._v("\n                          " + _vm._s(_vm._f("tudoMaiusculo")(estadoCivil.displayName)) + "\n                        ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-3"
  }, [_c('label', {
    attrs: {
      "for": "grauInstrucao"
    }
  }, [_vm._v("Grau de Escolaridade")]), _vm._v(" "), _c('p', {
    staticClass: "textoAlinhadoAoInput"
  }, [_vm._v("\n                        " + _vm._s(_vm.grauInstrucaoDisplay) + "\n                      ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    directives: [{
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }],
    attrs: {
      "css-class": "col-md-4 col-sm-4",
      "label": "Município de Nascimento",
      "field": "municipioNaturalidade",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.naturalidade.cidade),
      expression: "cadastrado.pessoa.naturalidade.cidade"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:40'),
      expression: "'required|max:40'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "municipioNaturalidade",
      "id": "municipioNaturalidade",
      "data-vv-as": "Município",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.naturalidade.cidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.naturalidade, "cidade", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-4 col-sm-4",
      "label": "Estado de Nascimento",
      "field": "ufNaturalidade",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.naturalidade.uf),
      expression: "cadastrado.pessoa.naturalidade.uf"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.ehBrasil
      }),
      expression: "{ required: ehBrasil }"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ufNaturalidade",
      "data-vv-as": "Estado",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa.naturalidade, "uf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.ufs), function(uf) {
    return _c('option', {
      key: uf.id,
      domProps: {
        "value": uf.sigla
      }
    }, [_vm._v("\n                          " + _vm._s(_vm._f("tudoMaiusculo")(uf.nome)) + "\n                        ")])
  })], 2)]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-4 col-sm-4",
      "label": "Nacionalidade",
      "field": "nacionalidade",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.naturalidade.pais),
      expression: "cadastrado.pessoa.naturalidade.pais"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nacionalidade",
      "data-vv-as": "Nacionalidade",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa.naturalidade, "pais", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.paises), function(pais) {
    return _c('option', {
      key: pais,
      domProps: {
        "value": pais
      }
    }, [_vm._v("\n                          " + _vm._s(pais) + "\n                        ")])
  })], 2)])], 1)])], 1)])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('botao', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right",
      value: ('Desfaz alterações de todas as etapas'),
      expression: "'Desfaz alterações de todas as etapas'",
      modifiers: {
        "right": true
      }
    }],
    attrs: {
      "estilo": "cheio-cinza-esq",
      "rotulo": "Desfazer",
      "icone": "fa-undo"
    },
    on: {
      "clicado": function($event) {
        return _vm.recarregaDados()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Avançar",
      "icone": "avancar",
      "icone-direita": true
    },
    on: {
      "clicado": function($event) {
        return _vm.avanca(_vm.recadastramentos, _vm.ufs, _vm.cadastrado, 'Endereco')
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "margin-bottom": "15px",
      "text-align": "justify"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle fa-lg"
  }), _vm._v("  "), _c('strong', [_vm._v("Atenção:")]), _vm._v(" Para alterações de nome deve ser anexado o CPF atualizado da Receita Federal. Baixar no link: https://servicos.receita.fazenda.gov.br/servicos/cpf/consultasituacao/consultapublica.asp\n              ")])
}]}

/***/ }),

/***/ "6Civ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var MesesCompetenciasService = function () {
  function MesesCompetenciasService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MesesCompetenciasService);

    throw 'Não é possível instanciar MesesCompetenciasService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(MesesCompetenciasService, null, [{
    key: 'obtemPorEventoPorAno',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(evento, anoAtual) {
        var endpoint, params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint();
                params = { 'evento.tipo': evento, ano: anoAtual };
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint, { params: params });

              case 4:
                return _context.abrupt('return', _context.sent);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function obtemPorEventoPorAno(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return obtemPorEventoPorAno;
    }()
  }, {
    key: 'obtemPorEventoPorData',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(idMeCompetencia, evento, dataAtual) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = 'meses-competencias/dataAtual/' + idMeCompetencia + '/' + evento + '/' + dataAtual;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context2.abrupt('return', _context2.sent);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function obtemPorEventoPorData(_x3, _x4, _x5) {
        return _ref2.apply(this, arguments);
      }

      return obtemPorEventoPorData;
    }()
  }, {
    key: 'obtemPorId',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(idMeCompetencia) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                endpoint = mergeEndpoint() + '/' + idMeCompetencia;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context3.abrupt('return', _context3.sent);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function obtemPorId(_x6) {
        return _ref3.apply(this, arguments);
      }

      return obtemPorId;
    }()
  }, {
    key: 'listaPorEvento',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(evento) {
        var endpoint, params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                endpoint = mergeEndpoint();
                params = { 'evento.tipo': evento };
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint, { params: params });

              case 4:
                return _context4.abrupt('return', _context4.sent);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function listaPorEvento(_x7) {
        return _ref4.apply(this, arguments);
      }

      return listaPorEvento;
    }()
  }]);

  return MesesCompetenciasService;
}();

/* harmony default export */ __webpack_exports__["a"] = (MesesCompetenciasService);


var mergeEndpoint = function mergeEndpoint() {
  return 'meses-competencias';
};

/***/ }),

/***/ "6Geg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6SSX":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("APD2")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("RTVR"),
  /* template */
  __webpack_require__("zu1O"),
  /* scopeId */
  "data-v-445dd331",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "6WdY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "IrParaTopo",
    methods: {
        paraTopo: function paraTopo() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        handleScroll: function handleScroll() {
            var element = document.querySelector(".go-to-top");
            if (element.style.right !== "15px") {
                if (window.scrollY > 200) {
                    element.style.right = "20px";
                    setTimeout(function () {
                        element.style.right = "15px";
                    }, 100);
                }
            } else {
                if (window.scrollY < 200) {
                    element.style.right = "20px";
                    setTimeout(function () {
                        element.style.right = "-45px";
                    }, 100);
                }
            }
        }
    },
    created: function created() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed: function destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }
});

/***/ }),

/***/ "6wME":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn",
    class: _vm.estiloBotao,
    attrs: {
      "type": '' ? 'button' : _vm.tipo,
      "data-toggle": _vm.toggle,
      "data-target": _vm.target,
      "data-dismiss": _vm.dismiss,
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.dispara()
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.iconeDireita),
      expression: "!iconeDireita"
    }],
    staticClass: "fa",
    class: _vm.iconeBotao
  }), _vm._v("\n  " + _vm._s(_vm.rotulo) + "\n  "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconeDireita),
      expression: "iconeDireita"
    }],
    staticClass: "fa",
    class: _vm.iconeBotao
  })])
},staticRenderFns: []}

/***/ }),

/***/ "7BIV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_botao__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExplicacaoModal',

  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_0__components_botao___default.a
  }
});

/***/ }),

/***/ "7IAF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Mb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Cadastrado = function Cadastrado() {
  var centroCusto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var competencia = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cpf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var pessoa = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var registro = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var status = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  var tipoFuncionario = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Cadastrado);

  this.centroCusto = centroCusto;
  this.competencia = competencia;
  this.cpf = cpf;
  this.id = id;
  this.pessoa = pessoa;
  this.registro = registro;
  this.status = status;
  this.tipoFuncionario = tipoFuncionario;
};

/* unused harmony default export */ var _unused_webpack_default_export = (Cadastrado);

/***/ }),

/***/ "7pmR":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modal",
      "tabindex": "-1",
      "role": "dialog"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.yes($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.config.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', _vm._l((_vm.sentences), function(sentence) {
    return _c('span', {
      key: sentence.id,
      style: (sentence && sentence.bold ? 'font-weight: bold' : '')
    }, [_vm._v("\n                  " + _vm._s(sentence.message) + "\n                ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.config.showNo !== false) ? _c('botao', {
    attrs: {
      "estilo": "cheio-cinza",
      "icone": "cancela-modal",
      "dismiss": "modal",
      "rotulo": _vm.config.labelNo
    },
    on: {
      "clicado": function($event) {
        return _vm.no()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "icone": "ok-modal",
      "rotulo": _vm.config.labelYes
    },
    on: {
      "clicado": function($event) {
        return _vm.yes()
      }
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Fechar"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),

/***/ "8EMK":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-2 col-md-8"
  }, [_c('div', {
    staticClass: "card card-default card-final"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                " + _vm._s(_vm.titulo) + "\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e()]), _vm._v(" "), (_vm.cadastrado.ultimoProtocolo) ? _c('div', {
    staticClass: "row row-field"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cadastrado.anexos.length === 0 &&
        _vm.cadastrado.validacaoPendente === true
      ),
      expression: "cadastrado.anexos.length === 0 &&\n                  cadastrado.validacaoPendente === true\n                  "
    }]
  }, [_vm._v("\n                  Lembre-se de "), _c('strong', [_vm._v("anexar")]), _vm._v(" seus documentos para\n                  "), _c('strong', [_vm._v("validar")]), _vm._v(" a atualização do seu cadastro.\n                ")]), _vm._v(" "), _c('p', [_vm._v("Anote ou imprima o seu número.")]), _vm._v(" "), _c('div', {
    staticClass: "espacado",
    staticStyle: {
      "color": "#004f4a"
    }
  }, [_c('h2', [_vm._v("PROTOCOLO")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin-top": "10px",
      "padding-bottom": "10px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.cadastrado.ultimoProtocolo.codigo) + "\n                  ")])])]) : _c('div', {
    staticClass: "row row-field"
  }, [_vm._m(1)])])])])])])]), _vm._v(" "), _c('section', {
    staticStyle: {
      "margin": "40px 15px",
      "padding-bottom": "40px"
    },
    attrs: {
      "role": "controller"
    }
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde-lg",
      "rotulo": "Imprimir",
      "icone": "fa-print",
      "disabled": !_vm.cadastrado.ultimoProtocolo
    },
    on: {
      "clicado": function($event) {
        return _vm.imprime(_vm.cadastrado.id, _vm.cadastrado.ultimoProtocolo.id)
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  O presente "), _c('strong', [_vm._v("protocolo")]), _vm._v(" serve apenas para\n                  guarda "), _c('strong', [_vm._v("pessoal")]), _vm._v(", não sendo necessário a\n                  entrega em nenhum setor da Prefeitura de Santos.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning espacado",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Envie sua\n                  atualização cadastral para receber um número de protocolo.\n                ")])
}]}

/***/ }),

/***/ "8Jxu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8KSN":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("/1hM")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("JSRk"),
  /* template */
  __webpack_require__("pmgo"),
  /* scopeId */
  "data-v-2a973207",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "8QDf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("H/Zg");



var _this = this;



var obtemImpressao = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(endpoint, params) {
    var popup, response, blob, url;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            popup = window.open('', '_blank');

            if (popup) {
              _context.next = 3;
              break;
            }

            throw new Error('Desbloqueie as pop-ups para este site');

          case 3:
            _context.prev = 3;
            _context.next = 6;
            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(endpoint, { params: params, responseType: 'blob' });

          case 6:
            response = _context.sent;
            blob = response instanceof Blob ? response : new Blob([response], { type: 'application/pdf' });
            url = window.URL.createObjectURL(blob);


            popup.location.href = url;
            popup.focus();

            setTimeout(function () {
              window.URL.revokeObjectURL(url);
            }, 5 * 60 * 1000);
            _context.next = 18;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context['catch'](3);

            popup.close();
            throw _context.t0;

          case 18:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[3, 14]]);
  }));

  return function obtemImpressao(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = (obtemImpressao);

/***/ }),

/***/ "8ZOQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8ZOn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/brasao-pms.57ad4b3.png";

/***/ }),

/***/ "8il0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_FileHelper__ = __webpack_require__("2MKL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'barra-menu',

  data: function data() {
    return {
      funcionario: this.$store.state.funcionario,
      perfis: this.$store.state.usuarioLogado.perfis
    };
  },

  methods: {
    modalSesc: function modalSesc() {
      jQuery('#modalSesc').modal('show');
    },
    volta: function volta() {
      this.$router.push({ name: 'Home' });
    },
    baixaArquivo: function baixaArquivo(arquivo) {
      __WEBPACK_IMPORTED_MODULE_1__helpers_FileHelper__["a" /* default */].download(arquivo, this);
    }
  },
  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_0__components_botao___default.a
  },
  props: {
    rotas: {
      type: Array,
      required: true
    }
  },
  computed: {
    ehResponsavelAprovador: function ehResponsavelAprovador() {
      if (this.perfis) {
        return this.perfis.includes('APROVADOR_AGENDAMENTO_FERIAS');
      }
      return false;
    },
    declaracaoAtiva: function declaracaoAtiva() {
      if (this.declaracaoVisitada) return 'active';
    },
    avaliacaoAtiva: function avaliacaoAtiva() {
      if (this.avaliacaoVisitada) return 'active';
    },
    recadastramentoAtiva: function recadastramentoAtiva() {
      if (this.recadastramentoVisitada) return 'active';
    },
    formulariosAtiva: function formulariosAtiva() {
      if (this.formulariosVisitada) return 'active';
    },
    feriasAtiva: function feriasAtiva() {
      if (this.feriasVisitada) return 'active';
    },
    usuarioAtual: function usuarioAtual() {
      return this.$store.state.funcionario;
    },
    permissoes: function permissoes() {
      return this.$store.state.usuarioLogado.perfis;
    }
  },
  watch: {
    usuarioAtual: function usuarioAtual(novo, anterior) {
      this.funcionario = novo;
    },
    permissoes: function permissoes(novo, anterior) {
      this.perfis = novo;
    }
  }
});

/***/ }),

/***/ "92WD":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("H7r9")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("jy/c"),
  /* template */
  __webpack_require__("H+Tr"),
  /* scopeId */
  "data-v-a9239cda",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "94Nx":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Jg1t"),
  /* template */
  __webpack_require__("ktDO"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "9NYF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Dependente = function Dependente() {
    var cpf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var dataNascimento = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var nome = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var sexo = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Dependente);

    this.cpf = cpf;
    this.dataNascimento = dataNascimento;
    this.id = id;
    this.nome = nome;
    this.sexo = sexo;
};

/* harmony default export */ __webpack_exports__["a"] = (Dependente);

/***/ }),

/***/ "9RXk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_campo_calendario__ = __webpack_require__("XgyF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_campo_calendario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_campo_calendario__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_table_loader__ = __webpack_require__("pKzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_table_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_table_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_object_hash__ = __webpack_require__("eZXE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_object_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_object_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__domain_cadastrado__ = __webpack_require__("7Mb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelper__ = __webpack_require__("9t/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_ErrorHelper__ = __webpack_require__("+h9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_StringHelper__ = __webpack_require__("1pbJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_recadastramentoService__ = __webpack_require__("e9Zu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_enums_paisesService__ = __webpack_require__("Gq1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_enums_estadosCivisService__ = __webpack_require__("0xHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_enums_grausInstrucoesService__ = __webpack_require__("CgRE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_enums_racasCoresService__ = __webpack_require__("g1YC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services_enderecoService__ = __webpack_require__("bx61");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__services_estadoService__ = __webpack_require__("2RzD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__services_enums_orientacaoSexualService__ = __webpack_require__("oGAn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__services_enums_identidadeGeneroService__ = __webpack_require__("N4eQ");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DadosPessoais',

  data: function data() {
    return {
      carregando: true,
      recadastramentos: [],
      recadMesCompetencia: [],
      // cadastro: {},
      cadastrado: {
        pessoa: {
          genero: '',
          orientacaoSexual: '',
          naturalidade: {
            cidade: '',
            uf: '',
            pais: ''
          },
          dataNascimento: '',
          nome: ''
        }
      },
      ufs: [],
      paises: [],
      cores: [],
      estadosCivis: [],
      grausInstrucoes: [],
      orientacoesSexuais: [],
      generos: [],
      apiErrors: null
    };
  },

  computed: {
    situacaoRecad: function situacaoRecad() {
      return this.$store.getters.getSituacaoRecad;
    },
    ehBrasil: function ehBrasil() {
      return this.cadastrado.pessoa.naturalidade.pais === 'BRASIL' ? true : false;
    },
    grauInstrucaoDisplay: function grauInstrucaoDisplay() {
      var _this = this;

      var graus = this.grausInstrucoes.filter(function (item) {
        return item.name === _this.cadastrado.pessoa.grauInstrucao;
      });
      var grau = function grau(filterResult) {
        return filterResult.length ? filterResult[0].displayName.toUpperCase() : '';
      };
      return grau(graus);
    },
    dezoitoAnosAtras: function dezoitoAnosAtras() {
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(new Date()).add(-18, 'years').format('YYYY-MM-DD');
    }
  },
  methods: {
    avanca: function avanca(recadastramentos, ufs, cadastrado, proximoLink) {
      var _this2 = this;

      // limpeza de espaços em branco
      var grupoEndereco = cadastrado.pessoa.endereco;
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(grupoEndereco).map(function (key, index) {
        if (typeof grupoEndereco[key] === 'string') {
          grupoEndereco[key] = grupoEndereco[key].trim();
        }
      });
      this.$validator.validateAll().then(function (success) {
        var _cadastrado$pessoa = cadastrado.pessoa,
            dataNascimento = _cadastrado$pessoa.dataNascimento,
            naturalidade = _cadastrado$pessoa.naturalidade;


        if (success) {
          if (dataNascimento) {
            cadastrado.pessoa.dataNascimento = __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelper__["a" /* default */].convertPtbrToApiDate(dataNascimento);
            var multiplosRegistros = recadastramentos.length > 1 ? true : false;
            cadastrado.mostraMultiplosRegistros = multiplosRegistros;

            _this2.tiraAcentuacao(naturalidade);
            _this2.setAnexos(cadastrado, _this2.$store.state.cadastroModelo);
            _this2.$store.commit('setEstados', ufs);
            _this2.$store.commit('setFuncionarioCadastrado', cadastrado);
            _this2.$router.push({ name: proximoLink });
            return;
          }
          _this2.$root.$refs.toastr.e('Preencha a Data de Nascimento', 'Atenção');
          return;
        }
        _this2.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção');
      });
    },
    tiraAcentuacao: function tiraAcentuacao(naturalidade) {
      if (__WEBPACK_IMPORTED_MODULE_14__helpers_StringHelper__["a" /* default */].verificaCaracterEspecial(naturalidade.cidade)) {
        naturalidade.cidade = __WEBPACK_IMPORTED_MODULE_14__helpers_StringHelper__["a" /* default */].limpaCaracterEspecial(naturalidade.cidade);
        this.$root.$refs.toastr.w('A Atualização Cadastral não aceita acentos e cedilhas. A aplicação já fez as correções necessárias.', 'Atenção');
      }
    },
    setAnexos: function setAnexos(cadastrado, original) {
      if (!cadastrado.documentosExigidos) cadastrado.documentosExigidos = [];
      if (!original || !original.pessoa) {
        // Evita erro se original ou original.pessoa não existir
        return;
      }
      var nomeOriginal = (original.pessoa.nome || '').trim().toUpperCase();
      var nomeAtual = (cadastrado.pessoa.nome || '').trim().toUpperCase();
      var nome = nomeAtual !== nomeOriginal;

      var dataNascimento = __WEBPACK_IMPORTED_MODULE_10_object_hash___default()(cadastrado.pessoa.dataNascimento) != __WEBPACK_IMPORTED_MODULE_10_object_hash___default()(original.pessoa.dataNascimento) ? true : false;
      var estadoCivil = __WEBPACK_IMPORTED_MODULE_10_object_hash___default()(cadastrado.pessoa.estadoCivil) != __WEBPACK_IMPORTED_MODULE_10_object_hash___default()(original.pessoa.estadoCivil) ? true : false;
      var naturalidade = __WEBPACK_IMPORTED_MODULE_10_object_hash___default()(cadastrado.pessoa.naturalidade) != __WEBPACK_IMPORTED_MODULE_10_object_hash___default()(original.pessoa.naturalidade) ? true : false;
      var documentos = [];

      if (dataNascimento || naturalidade) documentos.push('RG ou Certidão de Nascimento ou Decisão Judicial');
      if (estadoCivil) documentos.push('Certidão de Casamento (a mais recente)');

      if (cadastrado.documentosExigidos) {
        var novosDocumentos = documentos.filter(function (item) {
          return !cadastrado.documentosExigidos.includes(item);
        });
        cadastrado.documentosExigidos = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(cadastrado.documentosExigidos), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(novosDocumentos));
      } else {
        cadastrado.documentosExigidos = [].concat(documentos);
      }
    },
    recarregaDados: function recarregaDados() {
      var vazio = {};
      this.$store.commit('setCadastroModelo', vazio);
      this.listaRecadastramentos();
      this.errors.clear();
    },
    estahVazio: function estahVazio(objeto) {
      for (var key in objeto) {
        if (objeto.hasOwnProperty(key)) return false;
      }
      return true;
    },
    clonaESalvaModelo: function clonaESalvaModelo(cadastrado) {
      var cloneCadastrado = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(cadastrado));
      this.$store.commit('setCadastroModelo', cloneCadastrado);
    },
    obtemEstados: function obtemEstados() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var estadosData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  estadosData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__services_estadoService__["a" /* getEstados */])();

                  _this3.ufs = estadosData.map(function (estado) {
                    return {
                      id: estado.id,
                      nome: estado.nome,
                      sigla: _this3.getSiglaFromNome(estado.nome)
                    };
                  });
                } catch (error) {
                  console.error('Erro ao carregar estados:', error);
                  _this3.emiteAlerta("Erro ao carregar estados");
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getSiglaFromNome: function getSiglaFromNome(nome) {
      var siglas = {
        'Acre': 'AC',
        'Alagoas': 'AL',
        'Amapá': 'AP',
        'Amazonas': 'AM',
        'Bahia': 'BA',
        'Ceará': 'CE',
        'Distrito Federal': 'DF',
        'Espírito Santo': 'ES',
        'Goiás': 'GO',
        'Maranhão': 'MA',
        'Mato Grosso': 'MT',
        'Mato Grosso do Sul': 'MS',
        'Minas Gerais': 'MG',
        'Pará': 'PA',
        'Paraíba': 'PB',
        'Paraná': 'PR',
        'Pernambuco': 'PE',
        'Piauí': 'PI',
        'Rio de Janeiro': 'RJ',
        'Rio Grande do Norte': 'RN',
        'Rio Grande do Sul': 'RS',
        'Rondônia': 'RO',
        'Roraima': 'RR',
        'Santa Catarina': 'SC',
        'São Paulo': 'SP',
        'Sergipe': 'SE',
        'Tocantins': 'TO'
      };
      return siglas[nome] || '';
    },
    listaRecadastramentos: function listaRecadastramentos() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var routeId, userId, response, msg;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                routeId = _this4.$route.params.id;
                userId = routeId || sessionStorage.getItem('userId');

                //const response = await RecadastramentoService.lista();

                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_15__services_recadastramentoService__["a" /* default */].obtemPorId(userId);

              case 5:
                response = _context2.sent;
                _context2.next = 8;
                return response;

              case 8:
                _this4.cadastrado = _context2.sent;

                if (_this4.cadastrado != null || _this4.cadastrado != undefined) {
                  //if (this.recadastramentos && this.recadastramentos.length > 0) {
                  //   this.cadastrado = this.recadastramentos.find(
                  //     item => item.id == userId,
                  //   );

                  //   console.log("Cadastrado: " + this.cadastrado.toString());
                  //   if (!this.cadastrado) {
                  //     this.cadastrado = this.recadastramentos[0];
                  //   }

                  _this4.clonaESalvaModelo(_this4.cadastrado);
                  _this4.$store.commit('setFuncionarioCadastrado', _this4.cadastrado);
                }

                _this4.carregando = false;
                _context2.next = 18;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](0);

                _this4.carregando = false;
                msg = _context2.t0.body && _context2.t0.body.message ? _context2.t0.body.message : _context2.t0.message || 'Erro desconhecido';

                _this4.$root.$refs.toastr.e(msg, 'Atenção');

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 13]]);
      }))();
    },
    trocaRegistro: function trocaRegistro(id) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var cadastradoSelecionado;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                cadastradoSelecionado = _this5.recadastramentos.find(function (item) {
                  return item.id == id;
                });

                if (cadastradoSelecionado) {
                  _context3.next = 4;
                  break;
                }

                _this5.$root.$refs.toastr.e('Registro não encontrado', 'Atenção');
                return _context3.abrupt('return');

              case 4:

                _this5.cadastrado = cadastradoSelecionado;
                _this5.clonaESalvaModelo(_this5.cadastrado);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    listaOrientacaoSexual: function listaOrientacaoSexual() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, arrayResponse;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_22__services_enums_orientacaoSexualService__["a" /* default */].lista();

              case 3:
                response = _context4.sent;
                _context4.next = 6;
                return response;

              case 6:
                arrayResponse = _context4.sent;

                _this6.orientacoesSexuais = arrayResponse.map(function (item) {
                  return {
                    name: item.name.replace(/_/g, " "),
                    displayName: item.displayName
                  };
                });

                _context4.next = 14;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](0);

                _this6.$root.$refs.toastr.e(_context4.t0.body.message, 'Atenção');
                _this6.orientacoesSexuais = [];

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 10]]);
      }))();
    },
    listaGenero: function listaGenero() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response, arrayResponse;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_23__services_enums_identidadeGeneroService__["a" /* default */].lista();

              case 3:
                response = _context5.sent;
                _context5.next = 6;
                return response;

              case 6:
                arrayResponse = _context5.sent;

                _this7.generos = arrayResponse.map(function (item) {
                  return {
                    name: item.name.replace(/_/g, " "),
                    displayName: item.displayName
                  };
                });

                _context5.next = 14;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](0);

                _this7.generos = [];
                _this7.$root.$refs.toastr.e(_context5.t0.body.message, 'Atenção');

              case 14:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[0, 10]]);
      }))();
    },
    listaPaises: function listaPaises() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_16__services_enums_paisesService__["a" /* default */].lista();

              case 3:
                response = _context6.sent;
                _context6.next = 6;
                return response;

              case 6:
                _this8.paises = _context6.sent;
                _context6.next = 12;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6['catch'](0);

                _this8.$root.$refs.toastr.e(_context6.t0.body.message, 'Atenção');

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[0, 9]]);
      }))();
    },
    listaEstadosCivis: function listaEstadosCivis() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response, todosEstadosCivis;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_17__services_enums_estadosCivisService__["a" /* default */].lista();

              case 3:
                response = _context7.sent;
                _context7.next = 6;
                return response;

              case 6:
                todosEstadosCivis = _context7.sent;

                _this9.estadosCivis = todosEstadosCivis.filter(function (item) {
                  return item.name !== 'NAO_INFORMADO';
                });
                _context7.next = 13;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7['catch'](0);

                _this9.$root.$refs.toastr.e(_context7.t0.body.message, 'Atenção');

              case 13:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9, [[0, 10]]);
      }))();
    },
    listaGrausInstrucoes: function listaGrausInstrucoes() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_18__services_enums_grausInstrucoesService__["a" /* default */].lista();

              case 3:
                response = _context8.sent;
                _context8.next = 6;
                return response;

              case 6:
                _this10.grausInstrucoes = _context8.sent;
                _context8.next = 12;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8['catch'](0);

                _this10.$root.$refs.toastr.e(_context8.t0.body.message, 'Atenção');

              case 12:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this10, [[0, 9]]);
      }))();
    },
    listaRacasCores: function listaRacasCores() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_19__services_enums_racasCoresService__["a" /* default */].lista();

              case 3:
                response = _context9.sent;
                _context9.next = 6;
                return response;

              case 6:
                _this11.cores = _context9.sent;
                _context9.next = 12;
                break;

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9['catch'](0);

                _this11.$root.$refs.toastr.e(_context9.t0.body.message, 'Atenção');

              case 12:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this11, [[0, 9]]);
      }))();
    },
    carregaDadosIniciais: function carregaDadosIniciais() {
      try {
        this.listaRecadastramentos();
        this.listaGenero();
        this.listaOrientacaoSexual();
        this.obtemEstados();

        if (typeof this.obtemMunicipiosPor === 'function' && this.parentEstado) {
          this.obtemMunicipiosPor(this.parentEstado);
        }

        if (typeof this.obtemTiposLogradouros === 'function') {
          this.obtemTiposLogradouros();
        }

        if (typeof this.cepMasked === 'function' && this.parentCep) {
          this.enderecoEditado.cep = this.cepMasked(this.parentCep);
        } else if (this.parentCep) {
          this.enderecoEditado.cep = this.formatarCep(this.parentCep);
        }

        this.enderecoEditado.tipoLogradouro = this.parentTipoLogradouro || '';

        if (this.parentLogradouro) {
          this.enderecoEditado.logradouro = this.parentLogradouro.toUpperCase();
        }

        if (this.parentBairro) {
          this.enderecoEditado.bairro = this.parentBairro.toUpperCase();
        }

        this.enderecoEditado.municipio = this.parentMunicipio || '';
        this.enderecoEditado.estado = this.parentEstado || '';
        this.enderecoEditado.numero = this.parentNumero || '';

        if (this.parentComplemento) {
          this.enderecoEditado.complemento = this.parentComplemento.toUpperCase();
        }

        this.enderecoEditado.georreferenciado = this.parentGeorreferenciado || false;
        this.enderecoEditado.inseridoPeloUsuario = this.parentInseridoPeloUsuario || false;
      } catch (error) {
        console.error('Erro ao carregar dados iniciais:', error);
      }
    },
    formatarData: function formatarData(data) {
      if (!data) return '';
      var dataObj = new Date(data);
      return dataObj.toLocaleDateString('pt-BR');
    }
  },
  created: function created() {
    var _this12 = this;

    this.listaPaises();
    this.listaEstadosCivis();
    this.listaGrausInstrucoes();
    this.listaRacasCores();
    this.obtemEstados();
    this.carregaDadosIniciais();

    this.$eventBus.$on('salvaAvanca', function (nomeComponente) {
      _this12.avanca(_this12.recadastramentos, _this12.ufs, _this12.cadastrado, nomeComponente);
    });
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off('salvaAvanca');
  },

  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_5__components_botao___default.a,
    CampoCalendario: __WEBPACK_IMPORTED_MODULE_6__components_campo_calendario___default.a,
    TableLoader: __WEBPACK_IMPORTED_MODULE_7__components_table_loader___default.a
  }
});

/***/ }),

/***/ "9TPg":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "9YD2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__ = __webpack_require__("MPt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'PeriodoEncerrado',
	components: {
		PaginaErro: __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default.a
	}
});

/***/ }),

/***/ "9a4s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);

var Status = {
    RECADASTRAMENTO_PENDENTE: 'RECADASTRAMENTO_PENDENTE',
    NAO_VALIDADO: 'NAO_VALIDADO',
    SEM_VALIDACAO: 'SEM_VALIDACAO',
    COM_VALIDACAO: 'COM_VALIDACAO',
    ALTERADO: 'ALTERADO',
    CONFIRMADO: 'CONFIRMADO',
    VALIDADO: 'VALIDADO',
    PENDENTE_DE_VALIDACAO: 'PENDENTE_DE_VALIDACAO',
    PENDENTE_VALE_TRANSPORTE: 'PENDENTE_VALE_TRANSPORTE',
    ATUALIZADO: 'ATUALIZADO',

    // Método valueOf para obter o valor a partir do nome
    valueOf: function valueOf(name) {
        return this[name];
    },

    // Método values para retornar todos os valores
    values: function values() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this);
    }
};

/* harmony default export */ __webpack_exports__["default"] = (Status);

/***/ }),

/***/ "9cx5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UploadArquivos',

  data: function data() {
    return {
      formData: new FormData(),
      arquivosParaEnviar: [],
      arquivosPainel: [],
      nomeCampoDeEnvio: 'arquivos'
    };
  },


  props: {
    api: {
      required: true,
      type: String
    },
    endPoint: {
      required: true,
      type: String
    },
    arquivos: {
      required: false,
      type: Array
    },
    podeDeletar: {
      required: false,
      type: Boolean,
      default: true
    }
  },

  methods: {
    metodoQueMontaArrayParaEnviar: function metodoQueMontaArrayParaEnviar() {
      var todos = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(listaArquivos.length).keys()).map(function (item) {
        return todos.push(listaArquivos[item]);
      });
    },
    metodoQueMontaFormData: function metodoQueMontaFormData() {
      var _this = this;

      todos.map(function (item) {
        _this.formTeste.append(nomeArquivo, item, item.name);
      });
    },
    voltaEstadoInicial: function voltaEstadoInicial() {
      this.limpaInput();
      this.formData.delete('arquivos');
      if (this.arquivos) this.arquivosPainel = this.arquivos.concat(this.arquivosParaEnviar);
    },
    limpaInput: function limpaInput() {
      document.querySelector('#uploadInput').value = '';
    },
    reiniciaModal: function reiniciaModal() {
      var _this2 = this;

      this.arquivosParaEnviar = [];
      setTimeout(function () {
        _this2.voltaEstadoInicial();
      }, 600);
    },
    incluiArquivos: function incluiArquivos(nomeArquivo, listaArquivos) {
      try {
        this.validaUploadImagens(listaArquivos);
        this.montaParaEnviar(listaArquivos);
        this.mostraArquivos();
        this.limpaInput();
      } catch (error) {
        this.$root.$refs.toastr.e(error.message, 'Atenção');
      }
    },
    validaUploadImagens: function validaUploadImagens(listaArquivos) {
      var _this3 = this;

      var listados = [];
      var todos = [];
      var extensoes = [];
      var naoImagem = [];

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(listaArquivos.length).keys()).map(function (item) {
        return todos.push(listaArquivos[item].name);
      });
      extensoes = todos.map(function (item) {
        return item.substr(-4, 4).toLowerCase();
      });
      naoImagem = extensoes.filter(function (item) {
        return item != '.pdf' && item != '.jpg' && item != '.png' && item != 'jpeg';
      });

      if (!todos.length) {
        this.voltaEstadoInicial();
        throw new Error('Nenhum arquivo foi selecionado');
      }
      if (naoImagem.length > 0) {
        this.voltaEstadoInicial();
        throw new Error('Envie somente imagens com extensões JPG, PNG ou PDF');
      }
      listados = this.arquivosPainel.map(function (item) {
        return item.name;
      });
      todos.map(function (item) {
        if (listados.includes(item)) {
          _this3.voltaEstadoInicial();
          throw new Error('O arquivo "' + item + '" j\xE1 foi enviado. Se necess\xE1rio, apague e envie novamente.');
        }
      });
      todos.map(function (item) {
        if (item.length > 100) {
          _this3.voltaEstadoInicial();
          throw new Error('O nome dos arquivos devem ter menos de 100 caracteres');
        }
      });
    },
    montaParaEnviar: function montaParaEnviar(listaArquivos) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(listaArquivos.length).keys()).map(function (item) {
        return _this4.arquivosParaEnviar.push(listaArquivos[item]);
      });
    },
    mostraArquivos: function mostraArquivos() {
      this.arquivosPainel = this.arquivos.concat(this.arquivosParaEnviar);
    },
    tiraDaLista: function tiraDaLista(arquivo) {
      var index = this.arquivosParaEnviar.indexOf(arquivo);
      this.arquivosParaEnviar.splice(index, 1);
      this.mostraArquivos();
    },
    montaFormData: function montaFormData(nomeArquivo, listaArquivos) {
      var _this5 = this;

      listaArquivos.map(function (item) {
        _this5.formData.append(nomeArquivo, item, item.name);
      });
    },
    salvaArquivo: function salvaArquivo() {
      this.montaFormData(this.nomeCampoDeEnvio, this.arquivosParaEnviar);
      this.upload(this.formData);
    },
    incluiMaisArquivos: function incluiMaisArquivos() {
      var _this6 = this;

      var sentences = [{
        id: 1,
        message: 'Deseja enviar mais algum arquivo?',
        bold: false
      }];

      this.$root.$refs.modal.confirm(sentences, {
        yes: function yes() {
          return;
        },
        no: function no() {
          _this6.$eventBus.$emit('dispensaUploader');
        },
        title: 'Anexos'
      });
    },
    deletaArquivo: function deletaArquivo(arquivo) {
      var _this7 = this;

      if (arquivo.id) {
        var sentences = [{
          id: 1,
          message: 'Deseja excluir esse arquivo da sua lista?',
          bold: false
        }];

        this.$root.$refs.modal.confirm(sentences, {
          yes: function yes() {
            return _this7.delete(arquivo.id);
          },
          title: 'Deletar Arquivo'
        });
        return;
      }
      this.tiraDaLista(arquivo);
    },


    // Requisições
    upload: function upload(formData) {
      var _this8 = this;

      var url = this.api + this.endPoint;
      var token = this.$store.state.token;
      if (formData.getAll('arquivos').length) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, formData, {
          headers: { Authorization: token }
        }).then(function (response) {
          return response.data;
        }).then(function (res) {
          _this8.arquivosPainel = _this8.arquivos.concat(res);
          _this8.arquivosParaEnviar = [];
          _this8.$store.commit('setArquivosRecadastramento', _this8.arquivosPainel);
          _this8.$nextTick(function () {
            return _this8.voltaEstadoInicial();
          });
          _this8.$eventBus.$emit('dispensaUploader');
          _this8.$root.$refs.toastr.s('Arquivo enviado', 'Sucesso');
        }).catch(function (error) {
          return _this8.trataErro(error);
        });
      }
    },
    delete: function _delete(id) {
      var _this9 = this;

      var url = this.api + this.endPoint + '/' + id;
      var token = this.$store.state.token;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(url, {
        headers: { Authorization: token }
      }).then(function (response) {
        var arquivosRestantes = _this9.arquivos.filter(function (item) {
          return item.id !== id;
        });
        _this9.$store.commit('setArquivosRecadastramento', arquivosRestantes);
        _this9.$nextTick(function () {
          return _this9.voltaEstadoInicial();
        });
      }).catch(function (error) {
        return _this9.trataErro(error);
      });
    },
    download: function download(arquivo) {
      var _this10 = this;

      var url = this.api + this.endPoint + '/' + arquivo.id;
      var token = this.$store.state.token;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, {
        headers: { Authorization: token },
        responseType: 'blob'
      }).then(function (response) {
        var resUrl = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = resUrl;
        link.setAttribute('download', arquivo.name);
        document.body.appendChild(link);
        link.click();
      }).catch(function (error) {
        return _this10.trataErro(error);
      });
    },
    trataErro: function trataErro(error) {
      this.voltaEstadoInicial();
      if (error) {
        this.$root.$refs.toastr.e(error.response.data[0].message, 'Atenção');
        return;
      }
      this.$root.$refs.toastr.e('Algo deu errado, por favor nos avise do ocorrido via SAU', 'Atenção');
    }
  },

  created: function created() {
    var _this11 = this;

    if (this.arquivos) this.arquivosPainel = this.arquivos;

    this.$eventBus.$on('limpa-uploads', function () {
      return _this11.reiniciaModal();
    });
    this.$eventBus.$on('salva-arquivos', function () {
      return _this11.salvaArquivo();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off('limpa-uploads');
    this.$eventBus.$off('salva-arquivos');
  }
});

/***/ }),

/***/ "9duw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_botao__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ExplicacaoModal",

  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_0__components_botao___default.a
  }
});

/***/ }),

/***/ "9eSt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var AvaliadorEstagioProbatorioService = function () {
  function AvaliadorEstagioProbatorioService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AvaliadorEstagioProbatorioService);

    throw 'Não é possível instanciar AvaliadorEstagioProbatorioService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AvaliadorEstagioProbatorioService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id, idMes) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint(id, idMes);
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }]);

  return AvaliadorEstagioProbatorioService;
}();

/* harmony default export */ __webpack_exports__["a"] = (AvaliadorEstagioProbatorioService);


var mergeEndpoint = function mergeEndpoint(id, idMes) {
  return 'avaliacoes-estagio-probatorio/avaliadores/' + id + '/competencias/' + idMes + '/totais';
};

/***/ }),

/***/ "9fBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Dependencia = function Dependencia() {
    var declarante = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var dependente = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var grau = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var rendas = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Dependencia);

    this.declarante = declarante;
    this.dependente = dependente;
    this.grau = grau;
    this.id = id;
    this.rendas = rendas;
};

/* harmony default export */ __webpack_exports__["a"] = (Dependencia);

/***/ }),

/***/ "9nt4":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "dropzone"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "multiple": "",
      "id": "uploadInput",
      "name": _vm.nomeCampoDeEnvio,
      "accept": "image/*,.pdf"
    },
    on: {
      "change": function($event) {
        _vm.incluiArquivos($event.target.name, $event.target.files);
        _vm.fileCount = $event.target.files.length;
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.arquivosPainel), function(arquivo) {
    return _c('tr', {
      key: arquivo.name
    }, [_c('td', {
      staticClass: "esquerda"
    }, [_c('span', [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!arquivo.id),
        expression: "!arquivo.id"
      }],
      staticClass: "fa fa-times fa-lg icone-lista arquivo-nao-enviado",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (arquivo.id),
        expression: "arquivo.id"
      }],
      staticClass: "fa fa-check fa-lg icone-lista arquivo-enviado",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" \n        ")])]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(arquivo.name) + "\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "direita"
    }, [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.podeDeletar),
        expression: "podeDeletar"
      }],
      staticClass: "icone-lista botao-direita tira-da-lista",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletaArquivo(arquivo)
        }
      }
    }, [_vm._m(1, true)]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (arquivo.id),
        expression: "arquivo.id"
      }],
      staticClass: "icone-lista botao-direita download-arquivo",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.download(arquivo)
        }
      }
    }, [_vm._m(2, true)])])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("\n        Arraste e solte seu arquivo aqui"), _c('br'), _vm._v("\n        ou"), _c('br'), _vm._v("\n        Clique para selecionar"), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-address-card fa-3x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-cloud-download fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),

/***/ "9t/u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




var DateHelper = function () {
    function DateHelper() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DateHelper);

        throw 'Não é possível instanciar DateHelper';
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DateHelper, [{
        key: 'dataPorExtenso',


        /**
         * @param string data Data no formato ##/##/####
         */
        value: function dataPorExtenso(data) {
            return data.split('/')[0] + '/' + this.mesPorExtenso(data.split('/')[1]) + '/' + data.split('/')[2];
        }

        /**
         * @param int mes Mês de 1 a 12
         */

    }, {
        key: 'mesPorExtenso',
        value: function mesPorExtenso(mes) {
            var meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
            return meses[mes - 1];
        }
    }], [{
        key: 'convertDateToNumber',
        value: function convertDateToNumber(dataPtbr) {
            var dataApi = __WEBPACK_IMPORTED_MODULE_2_moment___default()(dataPtbr, 'DD/MM/YYYY').format('MMM DD, YYYY');
            dataApi = __WEBPACK_IMPORTED_MODULE_2_moment___default()(dataApi).valueOf();
            return dataApi;
        }
    }, {
        key: 'convertNumberToDate',
        value: function convertNumberToDate(numero) {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(numero).format("DD/MMM/YYYY");
        }
    }, {
        key: 'convertDateToPtbr',
        value: function convertDateToPtbr(date) {
            var testDateApi = /\d{4}-\d{2}-\d{2}/;
            return testDateApi.test(date) ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, 'YYYY-MM-DD').format('DD/MM/YYYY') : date;
        }
    }, {
        key: 'convertDateToApiDate',
        value: function convertDateToApiDate(date) {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
    }, {
        key: 'convertPtbrToApiDate',
        value: function convertPtbrToApiDate(dataPtbr) {
            var testDatePtbr = /\d{2}\/\d{2}\/\d{4}/;
            return testDatePtbr.test(dataPtbr) ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(dataPtbr, 'DD/MM/YYYY').format('YYYY-MM-DD') : dataPtbr;
        }
    }, {
        key: 'tempoPorExtenso',
        value: function tempoPorExtenso(anos, meses, dias) {
            var frase = '';
            var anosPalavra = '';
            var mesesPalavra = '';
            var diasPalavra = '';

            if (!anos) {
                anos = anosPalavra = '';
            } else if (anos === 1) {
                anosPalavra = ' ano ';
            } else {
                anosPalavra = ' anos ';
            }

            if (!meses) {
                meses = mesesPalavra = '';
            } else if (meses === 1) {
                mesesPalavra = ' mês ';
            } else {
                mesesPalavra = ' meses ';
            }

            if (!dias) {
                dias = diasPalavra = '';
            } else if (dias === 1) {
                diasPalavra = ' dia ';
            } else {
                diasPalavra = ' dias ';
            }

            frase = anos + anosPalavra + meses + mesesPalavra + dias + diasPalavra;

            return frase;
        }
    }]);

    return DateHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (DateHelper);

/***/ }),

/***/ "9v17":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Ferias = function Ferias() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var periodoAquisitivoId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var agendamentoAno = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var periodo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var inicio = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var diasPendentes = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var feriasPendentes = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var situacao = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'PENDENTE';
  var anoAgendamento = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
  var mesAgendamento = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 0;
  var protocolo = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : '';

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Ferias);

  this.id = id;
  this.periodoAquisitivoId = periodoAquisitivoId;
  this.agendamentoAno = agendamentoAno;
  this.periodo = periodo;
  this.inicio = inicio;
  this.diasPendentes = diasPendentes;
  this.feriasPendentes = feriasPendentes;
  this.situacao = situacao;
  this.anoAgendamento = anoAgendamento;
  this.mesAgendamento = mesAgendamento;
  this.protocolo = protocolo;
};

/* harmony default export */ __webpack_exports__["a"] = (Ferias);

/***/ }),

/***/ "A0xF":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "A3/Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validaRecadastramento */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validaRecadastramentoPorId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_mesesCompetenciasService__ = __webpack_require__("6Civ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_recadastramentoService__ = __webpack_require__("e9Zu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ErrorHelper__ = __webpack_require__("+h9g");



var _this = this;





var validaRecadastramento = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(next, app) {
    var recadastramentos, existeRecadastramento, hoje, algumPeriodoAtivo;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return obtemMesCompetenciaRecad(app);

          case 2:
            recadastramentos = _context.sent;
            existeRecadastramento = !!recadastramentos.length;

            if (existeRecadastramento) {
              _context.next = 6;
              break;
            }

            return _context.abrupt('return', false);

          case 6:
            hoje = new Date();
            algumPeriodoAtivo = recadastramentos.some(function (recad) {
              if (!recad.periodos || !recad.periodos.length) return false;

              return recad.periodos.some(function (periodo) {
                var dataInicio = new Date(periodo.dataInicioLancamento + 'T00:00:00');
                var dataFim = new Date(periodo.dataFimLancamento + 'T23:59:59');
                return hoje >= dataInicio && hoje <= dataFim;
              });
            });
            return _context.abrupt('return', algumPeriodoAtivo);

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function validaRecadastramento(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var validaRecadastramentoPorId = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(recadId, app) {
    var recad, mesCompetencia, hoje, algumPeriodoAtivo;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3__services_recadastramentoService__["a" /* default */].obtemPorId(recadId);

          case 2:
            recad = _context2.sent;
            _context2.next = 5;
            return __WEBPACK_IMPORTED_MODULE_2__services_mesesCompetenciasService__["a" /* default */].obtemPorId(recad.competencia.id);

          case 5:
            mesCompetencia = _context2.sent;
            hoje = new Date();
            algumPeriodoAtivo = mesCompetencia.periodos && mesCompetencia.periodos.length ? mesCompetencia.periodos.some(function (periodo) {
              var dataInicio = new Date(periodo.dataInicioLancamento + 'T00:00:00');
              var dataFim = new Date(periodo.dataFimLancamento + 'T23:59:59');
              return hoje >= dataInicio && hoje <= dataFim;
            }) : false;
            return _context2.abrupt('return', algumPeriodoAtivo);

          case 9:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function validaRecadastramentoPorId(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var obtemMesCompetenciaRecad = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(app) {
    var recads, mensagem;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2__services_mesesCompetenciasService__["a" /* default */].listaPorEvento('ATUALIZACAO_CADASTRAL');

          case 3:
            recads = _context3.sent;
            return _context3.abrupt('return', recads.content || []);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3['catch'](0);
            mensagem = __WEBPACK_IMPORTED_MODULE_4__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context3.t0);

            if (app && app.$root && app.$root.$refs && app.$root.$refs.toastr) {
              app.$root.$refs.toastr.e(mensagem, 'Atenção');
            }
            return _context3.abrupt('return', []);

          case 12:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[0, 7]]);
  }));

  return function obtemMesCompetenciaRecad(_x5) {
    return _ref3.apply(this, arguments);
  };
}();

// Exporta ambas


/* unused harmony default export */ var _unused_webpack_default_export = (validaRecadastramento);

/***/ }),

/***/ "APD2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ASZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var AvaliacoesEstagioProbatorioService = function () {
  function AvaliacoesEstagioProbatorioService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AvaliacoesEstagioProbatorioService);

    throw 'Não é possível instanciar AvaliacoesEstagioProbatorioService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AvaliacoesEstagioProbatorioService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint(id);
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista(_x) {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }]);

  return AvaliacoesEstagioProbatorioService;
}();

AvaliacoesEstagioProbatorioService.id = null;
/* harmony default export */ __webpack_exports__["a"] = (AvaliacoesEstagioProbatorioService);


var mergeEndpoint = function mergeEndpoint(id) {
  return 'avaliacoes-estagio-probatorio/avaliados/' + id + '/avaliacoes-estagio-probatorio/competencias';
};

/***/ }),

/***/ "AeWN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AyCD":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("PHgq")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("NYl2"),
  /* template */
  __webpack_require__("Wbmx"),
  /* scopeId */
  "data-v-cb9b8ee4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "B6Ps":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "impresso"
  }, [_c('div', {
    staticClass: "cabecalho"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__("8ZOn"),
      "alt": "Logo prefeitura"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "via"
  }, [_c('b', [_vm._v(_vm._s((_vm.via + "ª VIA")))]), _vm._v("\n      " + _vm._s((" - " + _vm.destino)) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "data-cabecalho"
  }, [_c('div', {
    staticClass: "nesta"
  }, [_vm._v("NESTA")]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v("\n      Santos,\n      "), (_vm.mostraSolicitada) ? _c('span', [_c('date-picker', {
    staticClass: "form-control data-texto",
    attrs: {
      "name": "dataSolicitacao",
      "id": "dataSolicitacao",
      "config": _vm.config
    },
    model: {
      value: (_vm.dataSolicitacao),
      callback: function($$v) {
        _vm.dataSolicitacao = $$v
      },
      expression: "dataSolicitacao"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm._f("extenso")(_vm.dataSolicitacao)))])])]), _vm._v(" "), _c('div', {
    staticClass: "corpo"
  }, [_vm._v("\n    " + _vm._s(_vm.nomeServidor) + ", registro nº " + _vm._s(_vm.servidor.registroFormatado) + ", ocupante\n    do(a) " + _vm._s(_vm.servidor.cargoPrincipal) + ", lotado(a) na\n    " + _vm._s(_vm.servidor.siglaUnidadeOrganizacional) + ", faltará no serviço no dia\n    "), (_vm.mostraFalta) ? _c('span', [_c('date-picker', {
    staticClass: "form-control data-texto",
    attrs: {
      "name": "dataFalta",
      "id": "dataFalta",
      "config": _vm.config
    },
    model: {
      value: (_vm.dataFalta),
      callback: function($$v) {
        _vm.dataFalta = $$v
      },
      expression: "dataFalta"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm._f("extenso")(_vm.dataFalta)))]), _vm._v("\n    , vindo pelo presente solicitar o ABONO da falta, de acordo com a lei nº\n    4.623/84, de 12 de junho de 1984.\n  ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "rodape"
  }, [_vm._v("COSUPRI - SEAD/029")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titulo"
  }, [_c('h1', [_vm._v("PREFEITURA DE SANTOS")]), _vm._v(" "), _c('h2', [_vm._v("Abono de falta - Lei Nº 4.623/84")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "despacho"
  }, [_vm._v("\n    DESPACHO: _________________________________\n    "), _c('br'), _vm._v("____________________________________________ "), _c('br'), _vm._v("Em\n    _________/_________/_____________\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assinaturas"
  }, [_c('div', {
    staticClass: "funcionario"
  }, [_c('div', {
    staticClass: "linha"
  }, [_vm._v("___________________________________________")]), _vm._v(" "), _c('div', {
    staticClass: "inscricao"
  }, [_vm._v("Assinatura do funcionário")])]), _vm._v(" "), _c('div', {
    staticClass: "chefe"
  }, [_c('div', {
    staticClass: "linha"
  }, [_vm._v("VISTO: ____________________________________")]), _vm._v(" "), _c('div', {
    staticClass: "inscricao"
  }, [_vm._v("\n        (Assinatura e carimbo)\n        "), _c('br'), _vm._v("CHEFE DA UNIDADE\n      ")])])])
}]}

/***/ }),

/***/ "BkkY":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("8Jxu")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("VE/E"),
  /* template */
  __webpack_require__("giWo"),
  /* scopeId */
  "data-v-19ef9608",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "C6qM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var AvaliacaoEstagioProbatorio = function AvaliacaoEstagioProbatorio() {
    var avaliado = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var avaliador = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var segundoAvaliador = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var competencia = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var notas = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AvaliacaoEstagioProbatorio);

    this.avaliado = avaliado;
    this.avaliador = avaliador;
    this.segundoAvaliador = segundoAvaliador;
    this.competencia = competencia;
    this.notas = notas;
};

/* harmony default export */ __webpack_exports__["a"] = (AvaliacaoEstagioProbatorio);

/***/ }),

/***/ "CAtd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Caaj":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.valida($event)
      }
    }
  }, [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('card-header', {
    attrs: {
      "titulo": "Formulário de Falta lei"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm hidden-xs"
  }, [_c('impresso', {
    attrs: {
      "via": "1",
      "destino": "DRH",
      "nomeServidor": _vm.nomeFuncionario,
      "servidor": _vm.funcionario,
      "dataSolicitada": new Date(),
      "dataDaFalta": new Date(),
      "mostraDataSolicitada": true,
      "mostraDataFalta": true
    },
    on: {
      "getDataSolicitada": _vm.pegaSolicitada,
      "getDataFalta": _vm.pegaFalta
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 footer-controller-inner"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Imprimir",
      "icone": "fa fa-print",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.valida()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.anteriorLink()
      }
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller hidden-md hidden-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.anteriorLink()
      }
    }
  }), _vm._v(" "), (!_vm.telaEhMobile) ? _c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Imprimir",
      "icone": "fa fa-print",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.valida()
      }
    }
  }) : _vm._e()], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('p', [_vm._v("\n                    O formulário de "), _c('strong', [_vm._v("Falta Lei")]), _vm._v(" não pode ser\n                    impresso via celular. Acesse essa tela em um\n                    "), _c('strong', [_vm._v("desktop")]), _vm._v(" ou "), _c('strong', [_vm._v("notebook")]), _vm._v(" para\n                    imprimi-lo sem problemas.\n                  ")])])])
}]}

/***/ }),

/***/ "Catl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CgRE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var GrausInstrucoesService = function () {
  function GrausInstrucoesService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, GrausInstrucoesService);

    throw 'Não é possível instanciar GrausInstrucoesService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(GrausInstrucoesService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint();
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista() {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }]);

  return GrausInstrucoesService;
}();

/* harmony default export */ __webpack_exports__["a"] = (GrausInstrucoesService);


var mergeEndpoint = function mergeEndpoint() {
  return 'graus-instrucoes';
};

/***/ }),

/***/ "CmI8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_botao__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SideModal',

  props: {
    tit: {
      required: true,
      type: String,
      value: ''
    },
    subtit: {
      required: false,
      type: String,
      value: ''
    },
    subtDetl: {
      required: false,
      type: String,
      value: ''
    },
    larg: {
      required: false,
      type: Number,
      value: 600
    },
    id: {
      required: true,
      type: String,
      value: ''
    },
    abreMaisUm: {
      required: false,
      type: Boolean,
      value: false
    },
    aberto: {
      required: true,
      type: Boolean,
      value: false
    }
  },
  methods: {
    largString: function largString(larg) {
      return larg + 'px';
    },
    largCalc: function largCalc(larg) {
      // soma para esconder o box-shadow
      var calc = larg + 30;
      return '-' + calc + 'px';
    },
    abre: function abre(id) {
      document.querySelector('#' + id).style.right = '0px';
    },
    abreOutro: function abreOutro() {
      this.$emit('abreFromChild');
    },
    fecha: function fecha(id) {
      document.querySelector('#' + id).style.width = this.largString(this.larg);
      document.querySelector('#' + id).style.right = this.largCalc(this.larg);
      this.$emit('fechou');
    },
    fechaFromParent: function fechaFromParent(id, larg) {
      document.querySelector('#' + id).style.right = this.largCalc(larg);
    },
    expande: function expande(id, larg) {
      document.querySelector('#' + id).style.width = this.largString(larg);
      this.abre(id);
    },
    contrai: function contrai(id, larg) {
      document.querySelector('#' + id).style.width = this.largString(larg);
      this.$emit('largura', larg);
    }
  },
  components: {
    botao: __WEBPACK_IMPORTED_MODULE_0__components_botao___default.a
  },
  created: function created() {
    var _this = this;

    this.$parent.$on('mostra', function (id) {
      return _this.abre(id);
    });
    this.$parent.$on('esconde', function (prop) {
      return _this.fechaFromParent(prop.identidade, prop.largura);
    });
    this.$parent.$on('mostraMais', function (prop) {
      return _this.expande(prop.id, prop.larg);
    });
    this.$parent.$on('escondeMais', function (prop) {
      return _this.contrai(prop.identidade, prop.largura);
    });
  },
  mounted: function mounted() {
    document.querySelector('#' + this.id).style.width = this.largString(this.larg);
    document.querySelector('#' + this.id).style.right = this.largCalc(this.larg);
  }
});

/***/ }),

/***/ "CwU8":
/***/ (function(module, exports) {

module.exports = [{"id":1623,"periodo":{"id":67,"dataFimLancamento":"2020-12-30","dataFimReferencia":"2020-12-30","dataInicioLancamento":"2020-06-19","dataInicioReferencia":"2020-04-06","dataLimiteLancamento":"2020-09-30","lancamentoPermitido":true},"periodoAquisitivo":{"id":1623,"competencia":{"id":110,"evento":"PERIODO_AQUISITIVO_FERIAS","ano":2020,"mes":0,"periodos":[],"nomeMes":null},"possuiDiasPendentes":false,"possuiFeriasPendentes":false,"dataAlteracao":null,"funcionario":{"id":9290,"registro":"30.867-6","nome":"CARLOS HENRIQUE BORGES FORTES WIMMER ","unidadeOrganizacional":{"id":310,"sigla":"SEMAPRO"},"cargo":"TÉCNICO DE INFORMÁTICA","nivelEspecial":null,"nivelSalarial":"J"}},"dataInicio":null,"dataAgendamento":null,"statusAprovacao":"PENDENTE","dataAprovacao":null,"protocolo":null,"responsavelAprovacao":null},{"id":1624,"periodo":{"id":67,"dataFimLancamento":"2020-12-30","dataFimReferencia":"2020-12-30","dataInicioLancamento":"2020-06-19","dataInicioReferencia":"2020-04-06","dataLimiteLancamento":"2020-09-30","lancamentoPermitido":true},"periodoAquisitivo":{"id":1624,"competencia":{"id":107,"evento":"PERIODO_AQUISITIVO_FERIAS","ano":2021,"mes":0,"periodos":[],"nomeMes":null},"possuiDiasPendentes":false,"possuiFeriasPendentes":false,"dataAlteracao":null,"funcionario":{"id":9290,"registro":"30.867-6","nome":"CARLOS HENRIQUE BORGES FORTES WIMMER ","unidadeOrganizacional":{"id":310,"sigla":"SEMAPRO"},"cargo":"TÉCNICO DE INFORMÁTICA","nivelEspecial":null,"nivelSalarial":"J"}},"dataInicio":null,"dataAgendamento":null,"statusAprovacao":"PENDENTE","dataAprovacao":null,"protocolo":null,"responsavelAprovacao":null}]

/***/ }),

/***/ "DNAM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DUKk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      iconeData: this.icone
    };
  },

  props: {
    tipo: {
      required: false,
      default: "button",
      type: String
    },
    estilo: {
      required: true,
      type: String
    },
    rotulo: {
      required: false,
      default: "",
      type: String
    },
    icone: {
      required: false,
      default: "",
      type: String
    },
    toggle: {
      required: false,
      default: "",
      type: String
    },
    target: {
      required: false,
      default: "",
      type: String
    },
    dismiss: {
      required: false,
      default: "",
      type: String
    },
    iconeDireita: {
      required: false,
      default: false,
      type: Boolean
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  methods: {
    dispara: function dispara() {
      var _this = this;

      if (this.disabled) return;
      this.iconeData = "carregando";
      setTimeout(function () {
        _this.iconeData = _this.icone;
      }, 1000);
      this.$emit("clicado");
      document.querySelector(".btn").blur();
    }
  },
  computed: {
    estiloBotao: function estiloBotao() {
      if (this.estilo == "vazado-verde") return "btn-primary";
      if (this.estilo == "cheio-verde") return "btn-primary side-btn-primary";
      if (this.estilo == "vazado-cinza") return "btn-default";
      if (this.estilo == "cheio-cinza") return "btn-default side-btn-default";
      if (this.estilo == "vazado-verde-dir") return "btn-primary btn-next";
      if (this.estilo == "cheio-verde-dir") return "btn-primary side-btn-primary btn-next";
      if (this.estilo == "vazado-cinza-dir") return "btn-default btn-next";
      if (this.estilo == "vazado-verde-esq") return "btn-primary btn-previous";
      if (this.estilo == "vazado-cinza-esq") return "btn-default btn-previous";
      if (this.estilo == "cheio-cinza-esq") return "btn-default side-btn-default btn-previous";
      if (this.estilo == "cheio-verde-esq") return "btn-primary side-btn-primary btn-previous";
      if (this.estilo == "vazado-laranja-esq") return "btn-warning btn-previous";
      if (this.estilo == "vazado-verde-sm") return "btn-primary btn-sm";
      if (this.estilo == "vazado-cinza-sm") return "btn-default btn-sm";
      if (this.estilo == "vazado-laranja-sm") return "btn-warning btn-sm";
      if (this.estilo == "vazado-vermelho-sm") return "btn-danger btn-sm";
      if (this.estilo == "vazado-verde-lg") return "btn-primary btn-subscribe btn-lg";
      if (this.estilo == "cheio-verde-lg") return "btn-primary side-btn-primary btn-subscribe btn-lg";
      if (this.estilo == "vazado-verde-inline") return "btn-primary btn-inline";else return "btn-primary";
    },
    iconeBotao: function iconeBotao() {
      if (this.iconeData == "ok-modal") return "fa-check";
      if (this.iconeData == "cancela-modal") return "fa-ban";
      if (this.iconeData == "novo-modal") return "fa-file-o";
      if (this.iconeData == "mais") return "fa-plus";
      if (this.iconeData == "salvar") return "fa-floppy-o";
      if (this.iconeData == "apagar") return "fa-eraser";
      if (this.iconeData == "exclui-tabela") return "fa-trash fa-lg";
      if (this.iconeData == "editar-tabela") return "fa-pencil fa-lg";
      if (this.iconeData == "imprimir-tabela") return "fa fa-print fa-lg";
      if (this.iconeData == "voltar") return "fa-caret-left fa-lg";
      if (this.iconeData == "avancar") return "fa-caret-right fa-lg";
      if (this.iconeData == "buscar") return "fa-search";
      if (this.iconeData == "visualizar") return "fa-eye fa-lg";
      if (this.iconeData == "carregando") return "fa-spinner fa-pulse";else return this.iconeData;
    }
  }
});

/***/ }),

/***/ "DjVM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var DependenteRecad = function DependenteRecad() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var nome = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var dataNascimento = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var tipo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { descricao: '' };
  var sexo = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DependenteRecad);

  this.id = id;
  this.nome = nome;
  this.dataNascimento = dataNascimento;
  this.tipo = tipo;
  this.sexo = sexo;
};

/* harmony default export */ __webpack_exports__["a"] = (DependenteRecad);

/***/ }),

/***/ "E20C":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("YydT")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("SGrW"),
  /* template */
  __webpack_require__("r65U"),
  /* scopeId */
  "data-v-78997fb6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "F6RG":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pagina-erro', {
    attrs: {
      "titulo": "Atualização Cadastral Encerrada",
      "icone": "fa fa-hourglass-end",
      "imagemTexto": "centralservidor-logo-texto.png",
      "imagem": "centralservidor-logo.png",
      "texto": "O período de atualização cadastral se encerrou.\n\t\tCaso ainda precise atualizar seus dados, dirija-se ao DEGEPAT."
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "FP3a":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("7IAF")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("XQ5R"),
  /* template */
  __webpack_require__("rD6O"),
  /* scopeId */
  "data-v-74f55920",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "GQcT":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("vSKJ")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("I3MW"),
  /* template */
  __webpack_require__("7pmR"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Gkx4":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("fXuD"),
  /* template */
  __webpack_require__("Caaj"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Gq1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var PaisesService = function () {
  function PaisesService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PaisesService);

    throw 'Não é possível instanciar PaisesService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(PaisesService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint();
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista() {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }]);

  return PaisesService;
}();

/* harmony default export */ __webpack_exports__["a"] = (PaisesService);

var mergeEndpoint = function mergeEndpoint() {
  return 'paises';
};

/***/ }),

/***/ "H+Tr":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('encerramento-modal'), _vm._v(" "), _c('section', {
    attrs: {
      "role": "side-modal"
    }
  }, [_c('side-modal', {
    attrs: {
      "sides": _vm.navs
    },
    on: {
      "cancela": function($event) {
        return _vm.cancela()
      }
    }
  }, [_c('template', {
    slot: _vm.navs[0].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "CPF",
      "field": "cpf",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:11'),
      expression: "'required|min:11'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.cpf),
      expression: "dependenteModal.cpf"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cpf",
      "id": "cpf",
      "data-vv-as": "CPF"
    },
    domProps: {
      "value": (_vm.dependenteModal.cpf)
    },
    on: {
      "change": function($event) {
        return _vm.verificaCpf($event.target.value)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenteModal, "cpf", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.telaEhMobile) ? _c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Data de Nascimento",
      "field": "dataNascimento",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.dataNascimento),
      expression: "dependenteModal.dataNascimento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "dataNascimento",
      "id": "dataNascimento",
      "data-vv-as": "Data de Nascimento"
    },
    domProps: {
      "value": (_vm.dependenteModal.dataNascimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenteModal, "dataNascimento", $event.target.value)
      }
    }
  })]) : _c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Data de Nascimento",
      "field": "dataNascimento",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataNascimento",
      "id": "dataNascimento",
      "config": _vm.config,
      "data-vv-as": "Data de Nascimento"
    },
    model: {
      value: (_vm.dependenteModal.dataNascimento),
      callback: function($$v) {
        _vm.$set(_vm.dependenteModal, "dataNascimento", $$v)
      },
      expression: "dependenteModal.dataNascimento"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-12 col-sm-12",
      "label": "Nome",
      "field": "nome",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.nome),
      expression: "dependenteModal.nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:50'),
      expression: "'required|max:50'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome",
      "id": "nome",
      "autofocus": "autofocus",
      "data-vv-as": "Nome"
    },
    domProps: {
      "value": (_vm.dependenteModal.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenteModal, "nome", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), (_vm.validacaoMaeSeAutenticadoMasculinoEDependenteFilha()) ? _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-12 col-sm-12",
      "label": "Nome da Mãe da filha do servidor",
      "field": "mae",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.mae),
      expression: "dependenteModal.mae"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:50'),
      expression: "'required|max:50'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "mae",
      "id": "mae",
      "autofocus": "autofocus",
      "data-vv-as": "Nome da Mãe"
    },
    domProps: {
      "value": (_vm.dependenteModal.mae)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenteModal, "mae", $event.target.value)
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Vínculo familiar",
      "field": "parentesco",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [(!_vm.dependenteModal.id) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.tipoDependenteId),
      expression: "dependenteModal.tipoDependenteId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "parentesco",
      "data-vv-as": "Parentesco",
      "disabled": !_vm.podeAlterar(_vm.dependenteModal)
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dependenteModal, "tipoDependenteId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.alteraParentesco]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.tiposDependencia), function(tipo) {
    return _c('option', {
      key: tipo.id,
      domProps: {
        "value": tipo.id
      }
    }, [_vm._v("\n                      " + _vm._s(tipo.nome) + "\n                    ")])
  })], 2) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.tipoDependenteNome),
      expression: "dependenteModal.tipoDependenteNome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autofocus": "autofocus",
      "disabled": true,
      "readonly": true
    },
    domProps: {
      "value": (_vm.dependenteModal.tipoDependenteNome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenteModal, "tipoDependenteNome", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Sexo",
      "field": "sexo",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.sexo),
      expression: "dependenteModal.sexo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "sexo",
      "id": "sexo",
      "data-vv-as": "Sexo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dependenteModal, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.sexos), function(sexo) {
    return _c('option', {
      key: _vm.sexos.indexOf(sexo),
      domProps: {
        "value": sexo.name
      }
    }, [_vm._v("\n                      " + _vm._s(_vm._f("tudoMaiusculo")(sexo.displayName)) + "\n                    ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [(_vm.dependenteEhTipoEsposo()) ? _c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Tem alteração de estado civil?",
      "field": "alteracaoEstadoCivil",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.alteracaoEstadoCivil),
      expression: "dependenteModal.alteracaoEstadoCivil"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "alteracaoEstadoCivil",
      "name": "alteracaoEstadoCivil"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dependenteModal, "alteracaoEstadoCivil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("NÃO")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("SIM")])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [(_vm.validacaoMaeSeAutenticadoMasculinoEDependenteFilha()) ? _c('p', {
    staticClass: "col-md-12 col-sm-12"
  }, [_vm._v("\n                  * Para dependente FILHA/ENTEADA/TUTELADA de servidor de sexo masculino o preenchimento do nome da mãe é obrigatório.\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.podeAlterar(_vm.dependenteModal) && _vm.dependenteEhTipoEsposo()) ? _c('div', {
    staticClass: "row row-field"
  }, [_c('p', {
    staticClass: "col-md-12 col-sm-12"
  }, [_vm._v("\n                  Caso seja inclusão de dependente que altere o estado civil do(a) servidor(a), envie quaisquer documentos\n                  referentes ao novo estado civil, seja certidão de casamento ou declaração de união estável.\n                  Fornecer documentos oficiais do(a) cônjuge que contenham Data de nascimento e CPF.\n                ")])]) : _vm._e(), _vm._v(" "), (!_vm.podeAlterar(_vm.dependenteModal) && _vm.dependenteEhTipoEsposo()) ? _c('div', {
    staticClass: "row row-field"
  }, [_c('p', {
    staticClass: "col-md-12 col-sm-12"
  }, [_vm._v("\n                  Caso haja alteração de estado civil, envie quaisquer documentos referentes ao novo estado civil, seja certidão\n                  de casamento (ou a certidão de casamento com a averbação do divórcio), declaração de união estável, certidão de óbito\n                  do cônjuge. Fornecer documentos oficiais do(a) cônjuge (ou ex-cônjuge), que contenham Data de nascimento e CPF.\n                ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-xs-12 form-group",
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_c('label', [_vm._v("Anexos")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 form-group",
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_c('label', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                      Anexar comprovantes\n                      "), _c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "id": "comprovantes",
      "multiple": "",
      "hidden": ""
    },
    on: {
      "change": _vm.anexarArquivo
    }
  })])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "padding": "0 15px"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dependenteModal.anexos), function(anexo, index) {
    return _c('tr', {
      key: index,
      attrs: {
        "value": anexo
      }
    }, [_c('td', [_vm._v(_vm._s(anexo.nomeArquivo))]), _vm._v(" "), _c('td', {
      staticClass: "td-btns td-btns-alone"
    }, [_c('botao', {
      attrs: {
        "tipo": "button",
        "estilo": "vazado-vermelho-sm",
        "icone": "exclui-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.excluiAnexo(anexo)
        }
      }
    })], 1)])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancela()
      }
    }
  }), _vm._v(" "), (_vm.podeSalvar(_vm.dependenteModal)) ? _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Salvar",
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.valida()
      }
    }
  }) : _vm._e()], 1)])], 2)], 1), _vm._v(" "), _c('section', {
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Selecione o registro funcional",
      "field": "funcionariosAutenticado",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionarioId),
      expression: "funcionarioId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "funcionarios-autenticado",
      "name": "funcionarios-autenticado",
      "disabled": _vm.autenticado.funcionarios.length == 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.funcionarioId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.autenticado.funcionarios), function(funcionario) {
    return _c('option', {
      key: funcionario.id,
      domProps: {
        "value": funcionario.id
      }
    }, [_vm._v("\n              " + _vm._s(funcionario.tipo) + " - " + _vm._s(funcionario.registroFormatado) + "\n            ")])
  }), 0)])], 1), _vm._v(" "), (!_vm.funcionarioId) ? _c('div', {
    staticClass: "row row-field"
  }, [_c('p', {
    staticClass: "col-md-12 col-sm-12 alert alert-info"
  }, [_vm._v("\n          Selecione o registro funcional para carregar os dependentes.\n        ")])]) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.temDependentesSemCpf) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Há dependentes sem o cpf cadastrado.\n                ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('table-loader', {
    attrs: {
      "carregando": _vm.carregando
    }
  }, [(_vm.dependentes.length == 0) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Não há dependentes\n                      cadastrados.\n                    ")]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs hidden-sm"
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs hidden-sm"
  }, [_vm._v("Data Nascimento")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs hidden-sm"
  }, [_vm._v("Parentesco")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs hidden-sm"
  }, [_vm._v("Dependente IR")]), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dependentesOrdenados), function(dependente) {
    return _c('tr', {
      key: _vm.dependentes.indexOf(dependente)
    }, [_c('td', [_vm._v("\n                            " + _vm._s(dependente.nome) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs hidden-sm"
    }, [_vm._v("\n                            " + _vm._s(dependente.sexo) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs hidden-sm"
    }, [_vm._v("\n                            " + _vm._s(_vm._f("formataData")(dependente.dataNascimento)) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs hidden-sm"
    }, [_vm._v("\n                            " + _vm._s(dependente.tipoDependenteNome) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                            " + _vm._s(_vm._f("cpfMask")(dependente.cpf)) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs hidden-sm"
    }, [_vm._v("\n                            " + _vm._s(_vm._f("simNao")(dependente.dependenteIR)) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticClass: "td-btns"
    }, [_c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Editar'),
        expression: "'Editar'",
        modifiers: {
          "right": true
        }
      }],
      attrs: {
        "tipo": "button",
        "estilo": "vazado-cinza-sm",
        "icone": "editar-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.edita(dependente)
        }
      }
    }), _vm._v(" "), (_vm.podeExcluir(dependente)) ? _c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Apagar'),
        expression: "'Apagar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "tipo": "button",
        "estilo": "vazado-vermelho-sm",
        "icone": "exclui-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.exclui(dependente)
        }
      }
    }) : _vm._e()], 1)])
  }), 0)]), _vm._v(" "), (!_vm.carregando) ? _c('div', {
    staticClass: "col-md-12 col-xs-12 footer-controller-inner",
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.podeImprimirProtocolo) ? _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde",
      "rotulo": "Imprimir protocolo",
      "icone": "fa-print",
      "dismiss": "modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.imprimeProtocolo()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde-dir",
      "rotulo": "Novo",
      "icone": "novo-modal",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.novo()
      }
    }
  })], 1) : _vm._e()])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('p', [_c('strong', [_vm._v("Estado civil do servidor: ")]), _vm._v(" " + _vm._s(_vm.pessoaAutenticada.estadoCivil) + "\n        ")])]), _vm._v(" "), _vm._m(1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('small', [_vm._v("\n                    Atualização do Quadro Familiar, com inclusão do CPF, por exigência do e-Social.\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 aviso-inicial"
  }, [_c('p', [_vm._v("\n            “O Recadastramento só pode ser concluído após todos os CPFs do quadro familiar serem informados.\n            Exclusão do familiar (por óbito ou divórcio), bem como alteração de dependentes para fins de\n            imposto de renda, só serão requeridos por e-mail: dependentes@santos.sp.gov.br. Dúvidas serão\n            esclarecidas apenas pelo e-mail: secar@santos.sp.gov.br.”\n          ")])])])
}]}

/***/ }),

/***/ "H/Zg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_store__ = __webpack_require__("YtJ0");





var api = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].apiUrl });

var setConfig = function setConfig(config) {
  var token = __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].state.token;

  if (token) config.headers.common.Authorization = token;

  return config;
};

var handleError = function handleError(error) {
  if (!error || !error.response) return;

  var isActionUnauthorized = error.response.status === 401;

  if (isActionUnauthorized) {}

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
};

var getRejectedError = function getRejectedError(error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
};
var getResponse = function getResponse(response) {
  return response && response.data;
};

api.interceptors.request.use(setConfig, getRejectedError);
api.interceptors.response.use(getResponse, handleError);

/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),

/***/ "H5fW":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.autenticados), function(autenticado) {
    return _c('div', {
      key: autenticado.id
    }, [_c('div', {
      staticClass: "card card-default"
    }, [_c('div', {
      staticClass: "card-content"
    }, [_c('h4', [_vm._v("\n                  Meus Dados\n                  "), (_vm.autenticados.length > 1) ? _c('span', [_vm._v("- " + _vm._s(autenticado.registroFormatado))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-lg-6 col-md-6 col-sm-6"
    }, [_c('label', [_vm._v("Nome:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.usuarioLogado.nome))])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
    }, [_c('label', [_vm._v("Registro:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(autenticado.registroFormatado))])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
    }, [_c('label', [_vm._v("Cargo:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(autenticado.cargoPrincipal))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-lg-6 col-md-6 col-sm-6"
    }, [_c('label', [_vm._v("Unidade Organizacional:")]), _vm._v(" "), _c('p', [_vm._v("\n                      " + _vm._s(((autenticado.siglaUnidadeOrganizacional) + " - " + (autenticado.unidadeOrganizacional))) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
    }, [_c('label', [_vm._v("Início das atividades:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("formataData")(autenticado.dataInicioAtividade)))])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
    }, [_c('label', [_vm._v("Centro de Custo:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(autenticado.centroCustoFormatado))])])])])])])
  }), 0)])])])])
},staticRenderFns: []}

/***/ }),

/***/ "H7r9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HJFU":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.telaEhMobile) ? _c('field-validation', {
    attrs: {
      "label": _vm.rotulo,
      "field": _vm.nome,
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    staticClass: "form-control sem-espaco-dir",
    attrs: {
      "type": "date",
      "name": _vm.nome,
      "id": _vm.nome,
      "data-vv-as": _vm.rotulo,
      "v-validate": _vm.validacao,
      "max": _vm.dataMaxima,
      "min": _vm.dataMinima,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.valorDaData
    },
    on: {
      "input": function($event) {
        return _vm.valorDoInput($event.target.value)
      }
    }
  })]) : _c('field-validation', {
    attrs: {
      "label": _vm.rotulo,
      "field": _vm.nome,
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validacao),
      expression: "validacao"
    }],
    class: {
      'disabled': _vm.disabled
    },
    attrs: {
      "name": _vm.nome,
      "id": _vm.nome,
      "config": _vm.config,
      "data-vv-as": _vm.rotulo,
      "value": _vm.valorDaData
    },
    on: {
      "input": function($event) {
        return _vm.valorDoInput($event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "HTYx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Item = function Item() {
    var dependencia = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var tipo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var valor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var descricao = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var heranca = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Item);

    this.dependencia = dependencia;
    this.tipo = tipo;
    this.valor = valor;
    this.descricao = descricao;
    this.heranca = heranca;
};

/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),

/***/ "I/bL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Avaliacao = function Avaliacao() {
    var avaliado = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var avaliador = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var uorAvaliador = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var competencia = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var notas = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Avaliacao);

    this.avaliado = avaliado;
    this.avaliador = avaliador;
    this.competencia = competencia;
    this.uorAvaliador = uorAvaliador;
    this.notas = notas;
};

/* harmony default export */ __webpack_exports__["a"] = (Avaliacao);

/***/ }),

/***/ "I3MW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_botao__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Modal',
  data: function data() {
    return {
      sentences: [],
      config: {}
    };
  },

  methods: {
    confirm: function confirm(sentences) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.sentences = sentences;
      config.title = config.title ? config.title : 'Alerta';
      config.labelYes = config.labelYes ? config.labelYes : 'Sim';
      config.labelNo = config.labelNo ? config.labelNo : 'Não';
      config.showNo = config.showNo !== undefined ? config.showNo : true;

      this.config = config;

      jQuery('#modal').modal({
        backdrop: config.showNo === false ? 'static' : true,
        keyboard: config.showNo === false ? false : true,
        show: true
      });
    },
    yes: function yes() {
      jQuery('#modal').modal('hide');
      if (this.config.yes) {
        this.config.yes();
      }
    },
    no: function no() {
      if (this.config.no) {
        this.config.no();
      }
    }
  },
  components: {
    botao: __WEBPACK_IMPORTED_MODULE_0__components_botao___default.a
  }
});

/***/ }),

/***/ "I7CV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IBCJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_PeriodoAtualHelper__ = __webpack_require__("Yjkh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ArrayHelper__ = __webpack_require__("5OEK");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Avaliados',

  data: function data() {
    return {
      apiErrors: null,
      funcionarioId: this.$route.params.idAvaliador,
      periodos: []
    };
  },


  computed: {
    periodosOrdenados: function periodosOrdenados() {
      this.periodos.forEach(function (periodo) {
        return periodo.nomeAvaliado = periodo.avaliado.pessoa.nome;
      });

      return this.periodos.sort(__WEBPACK_IMPORTED_MODULE_2__helpers_ArrayHelper__["a" /* default */].compareValues('nomeAvaliado'));
    }
  },

  methods: {
    situacaoAtual: function situacaoAtual(periodo) {
      var _periodo$competencia$ = periodo.competencia.periodos[0],
          dataInicioLancamento = _periodo$competencia$.dataInicioLancamento,
          dataFimLancamento = _periodo$competencia$.dataFimLancamento;


      var estahDentroDoPeriodo = __WEBPACK_IMPORTED_MODULE_1__helpers_PeriodoAtualHelper__["a" /* default */].validaPeriodo(dataInicioLancamento, dataFimLancamento);
      var naoAceitouNemRecusou = periodo.aceita == null;
      var naoEstahEmEstagioProbatorio = periodo.mediaEstagioProbatorio == 0;

      return estahDentroDoPeriodo && naoAceitouNemRecusou && naoEstahEmEstagioProbatorio;
    },
    mostraNota: function mostraNota(periodo) {
      if (periodo.mediaEstagioProbatorio > 0) {
        return periodo.mediaEstagioProbatorio;
      }
      if (periodo.avaliado.id == this.funcionarioId) {
        return periodo.totalAutoavaliacao;
      }
      return periodo.totalAvaliador;
    },
    situacaoPendente: function situacaoPendente(periodo, atributoQueMuda) {
      if (periodo.mediaEstagioProbatorio > 0) {
        return atributoQueMuda === 'class' ? '' : 'vazado-cinza-sm';
      }
      if (periodo.avaliado.id == this.funcionarioId && periodo.totalAutoavaliacao == 0) {
        return atributoQueMuda === 'class' ? 'situacao-pendente' : 'vazado-laranja-sm';
      }
      if (periodo.avaliado.id != this.funcionarioId && periodo.totalAvaliador == 0) {
        return atributoQueMuda === 'class' ? 'situacao-pendente' : 'vazado-laranja-sm';
      }
      return atributoQueMuda === 'class' ? '' : 'vazado-cinza-sm';
    },
    editaAvaliacao: function editaAvaliacao(avaliadoId) {
      this.$router.push({
        name: 'DetalhaAvaliacao',
        params: { idAvaliador: this.funcionarioId, idAvaliado: avaliadoId }
      });
    },
    volta: function volta() {
      this.$router.push({ name: 'Avaliacao' });
    }
  },

  created: function created() {
    this.periodos = JSON.parse(sessionStorage.getItem('periodos'));
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },


  components: {
    botao: __WEBPACK_IMPORTED_MODULE_0__components_botao___default.a
  }
});

/***/ }),

/***/ "IBjx":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("CAtd")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("IByX"),
  /* template */
  __webpack_require__("3B2p"),
  /* scopeId */
  "data-v-b3218d0a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "IByX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__impresso__ = __webpack_require__("kmnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__impresso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__impresso__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      funcionario: {},
      nomeFuncionario: '',
      dataFalta: '',
      dataSolicitacao: '',
      mostraInputSolicitacao: false,
      mostraInputFalta: false
    };
  },

  methods: {
    obtemDatasEFuncionario: function obtemDatasEFuncionario() {
      var indexFuncionario = this.$route.params.index;
      var diaFaltoso = this.$route.params.diaFalta;
      var mesFaltoso = this.$route.params.mesFalta;
      var anoFaltoso = this.$route.params.anoFalta;
      var diaSolicitado = this.$route.params.diaSolicitacao;
      var mesSolicitado = this.$route.params.mesSolicitacao;
      var anoSolicitado = this.$route.params.anoSolicitacao;

      this.funcionario = this.$store.state.usuarioLogado.funcionarios[indexFuncionario];
      this.nomeFuncionario = this.$store.state.usuarioLogado.nome;
      this.dataFalta = diaFaltoso + '/' + mesFaltoso + '/' + anoFaltoso;
      this.dataSolicitacao = diaSolicitado + '/' + mesSolicitado + '/' + anoSolicitado;
    }
  },
  created: function created() {
    this.obtemDatasEFuncionario();
  },
  mounted: function mounted() {
    window.print();
    this.$router.go(-1);
  },

  components: {
    Impresso: __WEBPACK_IMPORTED_MODULE_0__impresso___default.a
  }
});

/***/ }),

/***/ "IOhd":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "explicacaoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "explicacaoModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Entendi",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Endereço\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v(_vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e(), _vm._v(" \n                "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cadastrado.pessoa.recebeValeTransporte),
      expression: "cadastrado.pessoa.recebeValeTransporte"
    }]
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.abreExplicacaoModal()
      }
    }
  }, [_vm._v("(Como editar meu endereço?)")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "content"
    }
  }, [(_vm.cadastrado.lancamentoPermitido) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "cep"
    }
  }, [_vm._v("CEP")]), _vm._v(" "), _c('p', [_vm._v("\n                          " + _vm._s(_vm._f("formataCep")(_vm.cadastrado.pessoa.endereco.cep)) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "logradouro"
    }
  }, [_vm._v("Logradouro")]), _vm._v(" "), _c('p', [_vm._v("\n                          " + _vm._s(_vm.cadastrado.pessoa.endereco.tipoLogradouro +
    ' ' +
    _vm.cadastrado.pessoa.endereco.logradouro) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 hidden-xs"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "numero"
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cadastrado.pessoa.endereco.numero))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row visible-xs-12 hidden-sm hidden-md hidden-lg"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "numero-xs"
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cadastrado.pessoa.endereco.numero))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "complemento-xs"
    }
  }, [_vm._v("Complem.")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cadastrado.pessoa.endereco.complemento))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 hidden-xs"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Complemento")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cadastrado.pessoa.endereco.complemento))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('p', {
    staticClass: "textoAlinhadoAoInput"
  }, [_vm._v("\n                          " + _vm._s(_vm.cadastrado.pessoa.endereco.bairro) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Município")]), _vm._v(" "), _c('p', {
    staticClass: "textoAlinhadoAoInput"
  }, [_vm._v("\n                          " + _vm._s(_vm.cadastrado.pessoa.endereco.cidade) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "proprio"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('p', {
    staticClass: "textoAlinhadoAoInput"
  }, [_vm._v("\n                          " + _vm._s(_vm.cadastrado.pessoa.endereco.uf) + "\n                        ")])])])])]) : _c('div', {
    staticClass: "row"
  }, [_c('pms-endereco', {
    ref: "enderecoComponente",
    attrs: {
      "api": _vm.$root.$data.apiEnderecoUrl,
      "apiUrl": _vm.$root.$data.apiUrl,
      "parentCep": _vm.cadastrado.pessoa.endereco.cep,
      "parentTipoLogradouro": _vm.cadastrado.pessoa.endereco.tipoLogradouro,
      "parentLogradouro": _vm.cadastrado.pessoa.endereco.logradouro,
      "parentBairro": _vm.cadastrado.pessoa.endereco.bairro,
      "parentMunicipio": _vm.cadastrado.pessoa.endereco.cidade,
      "parentEstado": _vm.cadastrado.pessoa.endereco.uf,
      "parentNumero": _vm.cadastrado.pessoa.endereco.numero,
      "parentComplemento": _vm.cadastrado.pessoa.endereco.complemento,
      "parentGeorreferenciado": _vm.cadastrado.pessoa.endereco.georreferenciado,
      "parentInseridoPeloUsuario": _vm.cadastrado.pessoa.endereco.inseridoPeloUsuario,
      "disabled": !_vm.enderecoEditavel
    },
    on: {
      "submitEndereco": _vm.gravaPessoaEndereco
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.volta()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Avançar",
      "icone": "avancar",
      "icone-direita": true
    },
    on: {
      "clicado": function($event) {
        return _vm.avanca('Contatos')
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "explicacaoModalLabel"
    }
  }, [_vm._v("\n              Regra de Edição de Endereço\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Para servidores com "), _c('strong', [_vm._v("vale transporte")]), _vm._v(" ativo, as alterações serão validadas pela Seção de Controle de Cestas Básicas e Vale Transporte – "), _c('strong', [_vm._v("SEVALE")]), _vm._v(".\n                ")])])])])
}]}

/***/ }),

/***/ "IYHZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'impresso'
});

/***/ }),

/***/ "IbFM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_FileHelper__ = __webpack_require__("2MKL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_valeAlimentacaoService__ = __webpack_require__("sVKh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'barra-menu',

  data: function data() {
    return {
      funcionario: this.$store.state.funcionario,
      perfis: this.$store.state.usuarioLogado.perfis,
      valeAlimentacaoHabilitado: false
    };
  },

  methods: {
    verificaValeAlimentacao: function verificaValeAlimentacao() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.$store.state.token) {
                  _context.next = 3;
                  break;
                }

                _this.valeAlimentacaoHabilitado = false;
                return _context.abrupt('return');

              case 3:
                _context.prev = 3;
                _context.t0 = Boolean;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4__services_valeAlimentacaoService__["a" /* default */].verificarHabilitacao();

              case 7:
                _context.t1 = _context.sent;
                _this.valeAlimentacaoHabilitado = (0, _context.t0)(_context.t1);
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t2 = _context['catch'](3);

                _this.valeAlimentacaoHabilitado = false;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 11]]);
      }))();
    },
    modalSesc: function modalSesc() {
      jQuery('#modalSesc').modal('show');
    },
    baixaArquivo: function baixaArquivo(arquivo) {
      __WEBPACK_IMPORTED_MODULE_3__helpers_FileHelper__["a" /* default */].download(arquivo, this);
    }
  },
  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_2__components_botao___default.a
  },
  props: {
    rotas: {
      type: Array,
      required: true
    },
    declaracaoVisitada: {
      type: Boolean,
      required: false
    },
    avaliacaoVisitada: {
      type: Boolean,
      required: false
    },
    recadastramentoVisitada: {
      type: Boolean,
      required: false
    },
    formulariosVisitada: {
      type: Boolean,
      required: false
    },
    feriasVisitada: {
      type: Boolean,
      required: false
    },
    valeAlimentacaoVisitada: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    ehResponsavelAprovador: function ehResponsavelAprovador() {
      if (this.perfis) {
        return this.perfis.includes('APROVADOR_AGENDAMENTO_FERIAS');
      }
      return false;
    },
    declaracaoAtiva: function declaracaoAtiva() {
      if (this.declaracaoVisitada) return 'active';
    },
    avaliacaoAtiva: function avaliacaoAtiva() {
      if (this.avaliacaoVisitada) return 'active';
    },
    recadastramentoAtiva: function recadastramentoAtiva() {
      if (this.recadastramentoVisitada) return 'active';
    },
    formulariosAtiva: function formulariosAtiva() {
      if (this.formulariosVisitada) return 'active';
    },
    feriasAtiva: function feriasAtiva() {
      if (this.feriasVisitada) return 'active';
    },
    valeAlimentacaoAtiva: function valeAlimentacaoAtiva() {
      if (this.valeAlimentacaoVisitada) return 'active';
    },
    usuarioAtual: function usuarioAtual() {
      return this.$store.state.funcionario;
    },
    permissoes: function permissoes() {
      return this.$store.state.usuarioLogado.perfis;
    },
    tokenAtual: function tokenAtual() {
      return this.$store.state.token;
    }
  },
  watch: {
    usuarioAtual: function usuarioAtual(novo, anterior) {
      this.funcionario = novo;
      this.verificaValeAlimentacao();
    },
    permissoes: function permissoes(novo, anterior) {
      this.perfis = novo;
      this.verificaValeAlimentacao();
    },
    tokenAtual: function tokenAtual() {
      this.verificaValeAlimentacao();
    }
  },
  created: function created() {
    this.verificaValeAlimentacao();
  }
});

/***/ }),

/***/ "JJBI":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.usuarioValido) ? _c('div', [_c('protocolo-modal', {
    attrs: {
      "protocoloGerado": _vm.protocolo,
      "agendamentoId": _vm.agendamentoId
    },
    on: {
      "imprimeProtocolo": _vm.imprime
    }
  }), _vm._v(" "), _c('explicacao-modal'), _vm._v(" "), _c('regra-dias-pendentes-modal'), _vm._v(" "), _c('regra-ferias-pendentes-modal'), _vm._v(" "), _c('side-modal', {
    attrs: {
      "inicioAtividade": _vm.dataInicioAtividade,
      "inicioSabado": _vm.agendaSabado,
      "inicioDomingoFeriado": _vm.agendaDomingoFeriado
    },
    on: {
      "agendaData": _vm.gravaData,
      "mostraProtocolo": _vm.abreProtocolo
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(0), _vm._v(" "), _c('section', [_c('table-loader', {
    attrs: {
      "carregando": _vm.carregandoAprovador
    }
  }, [(_vm.escondeAprovador) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Sistema fechado para atualização. \n                    Agendamentos poderão ser solicitados a partir do dia 05.\n                  ")]) : (_vm.aprovadores && !_vm.aprovadores.length) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Você não tem\n                    aprovador cadastrado. Relate esse problema ao seu chefe ou\n                    superior.\n                  ")]) : _vm._l((_vm.aprovadores), function(aprovador) {
    return _c('div', {
      key: aprovador.id,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-lg-5 col-md-5 col-sm-5"
    }, [_c('label', [_vm._v("Nome:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(aprovador.nome))])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
    }, [_c('label', [_vm._v("Registro:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(aprovador.registro))])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-lg-4 col-md-4 col-sm-4"
    }, [_c('label', [_vm._v("Cargo:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(aprovador.cargo))])])])
  })], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('card-header', {
    attrs: {
      "titulo": ("Agendamento de Férias " + (_vm.feriasAgendadas.length &&
                    _vm.feriasAgendadas[0].periodo)),
      "subtitulo": "(Como funciona o agendamento?)"
    },
    on: {
      "abreModal": _vm.abreExplicacaoModal
    }
  }), _vm._v(" "), _c('section', [_c('table-loader', {
    attrs: {
      "carregando": _vm.carregando
    }
  }, [(_vm.feriasAgendadas && !_vm.feriasAgendadas.length) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Você ainda não\n                    tem período de férias para agendar.\n                  ")]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Exercício")]), _vm._v(" "), _c('th', [_vm._v("Data de Início")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs hidden-xxs"
  }, [_vm._v("Dias Pendentes")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs hidden-xxs"
  }, [_vm._v("Férias Pendentes")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xxs"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.feriasAgendadas), function(ferias) {
    return _c('tr', {
      key: ferias.id,
      class: ferias.situacao === 'PENDENTE' ?
        'situacao-pendente' :
        ''
    }, [_c('td', [_vm._v(_vm._s(ferias.periodo))]), _vm._v(" "), (ferias.inicio) ? _c('td', [_vm._v("\n                          " + _vm._s(_vm._f("formataData")(ferias.inicio)) + "\n                        ")]) : _c('td', [_c('i', {
      staticClass: "fa fa-ellipsis-h fa-lg",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs hidden-xxs"
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "width": "107px"
      }
    }, [_vm._v("\n                            " + _vm._s(ferias.diasPendentes ? 'SIM' : 'NÃO') + "\n                          ")])]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs hidden-xxs"
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "width": "107px"
      }
    }, [_vm._v("\n                            " + _vm._s(ferias.feriasPendentes ? 'SIM' : 'NÃO') + "\n                          ")])]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xxs"
    }, [_vm._v("\n                          " + _vm._s(_vm._f("descricaoStatus")(ferias.situacao)) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "td-btns td-btns-alone",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('div', [_c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mostraEditar(ferias)),
        expression: "mostraEditar(ferias)"
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Editar'),
        expression: "'Editar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": 'vazado-laranja-sm',
        "icone": "editar-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.agenda('agendamento', ferias)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mostraVisualizar(ferias)),
        expression: "mostraVisualizar(ferias)"
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Visualizar'),
        expression: "'Visualizar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar"
      },
      on: {
        "clicado": function($event) {
          return _vm.visualiza('agendamento', ferias)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mostraDiasFeriasPendentes(ferias)),
        expression: "mostraDiasFeriasPendentes(ferias)"
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: (
          _vm.alternaTooltipDiasFerias(ferias)
        ),
        expression: "\n                                alternaTooltipDiasFerias(ferias)\n                              ",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-vermelho-sm",
        "icone": "fa-exclamation-triangle"
      },
      on: {
        "clicado": function($event) {
          return _vm.agendaOuVisualiza('agendamento', ferias)
        }
      }
    })], 1)])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 footer-controller-inner"
  }, [_c('botao', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraEditar(_vm.primeiroPeriodoPendente)),
      expression: "mostraEditar(primeiroPeriodoPendente)"
    }],
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Agendar",
      "icone": "fa-calendar-check-o",
      "toggle": "",
      "target": "",
      "disabled": !_vm.feriasAgendadas.length
    },
    on: {
      "clicado": function($event) {
        return _vm.agenda('agendamento', _vm.primeiroPeriodoPendente)
      }
    }
  })], 1)])], 1)], 1)])])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("Chefe Imediato "), _c('small', [_vm._v("(Aprovador)")])])
}]}

/***/ }),

/***/ "JSRk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CardHeader',

  data: function data() {
    return {
      autenticados: this.$store.state.usuarioLogado.funcionarios,
      funcionario: this.$store.state.funcionario
    };
  },


  props: {
    titulo: {
      required: true,
      type: String
    },
    subtitulo: {
      required: false,
      type: String,
      default: ''
    }
  },

  computed: {
    usuarioAtual: function usuarioAtual() {
      return this.$store.state.funcionario;
    }
  },

  watch: {
    usuarioAtual: function usuarioAtual(novo, anterior) {
      this.funcionario = novo;
    }
  },

  methods: {
    abreModal: function abreModal() {
      this.$emit('abreModal');
    },
    trocaUsuario: function trocaUsuario(funcionario) {
      this.$store.commit('setFuncionario', funcionario);
    }
  }
});

/***/ }),

/***/ "Jg1t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ArrayHelper__ = __webpack_require__("5OEK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AvaliadosEstagioProbatorio',

  data: function data() {
    return {
      apiErrors: null,
      funcionarioId: this.$route.params.idAvaliador,
      periodos: []
    };
  },


  computed: {
    periodosOrdenados: function periodosOrdenados() {
      this.periodos.forEach(function (periodo) {
        return periodo.nomeAvaliado = periodo.avaliado.pessoa.nome;
      });

      return this.periodos.sort(__WEBPACK_IMPORTED_MODULE_1__helpers_ArrayHelper__["a" /* default */].compareValues('nomeAvaliado'));
    }
  },

  methods: {
    situacaoAtual: function situacaoAtual(periodo) {
      var _periodo$competencia$ = periodo.competencia.periodos[0],
          dataInicioLancamento = _periodo$competencia$.dataInicioLancamento,
          dataFimLancamento = _periodo$competencia$.dataFimLancamento;


      var estahDentroDoPeriodo = __WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date()).isBetween(dataInicioLancamento, dataFimLancamento, 'day', '[]');

      var naoAceitouNemRecusou = periodo.aceita == null;

      return estahDentroDoPeriodo && naoAceitouNemRecusou;
    },
    mostraNota: function mostraNota(periodo) {
      if (periodo.avaliador.id == this.funcionarioId) {
        return periodo.totalAvaliador;
      }
      if (periodo.segundoAvaliador.id == this.funcionarioId) {
        return periodo.totalSegundoAvaliador;
      }
    },
    situacaoPendente: function situacaoPendente(periodo, atributoQueMuda) {
      var emAndamento = this.situacaoAtual(periodo);

      if (emAndamento) {
        return atributoQueMuda === 'class' ? 'situacao-pendente' : 'vazado-laranja-sm';
      }
      return atributoQueMuda === 'class' ? '' : 'vazado-cinza-sm';
    },
    editaAvaliacao: function editaAvaliacao(avaliadoId) {
      this.$router.push({
        name: 'DetalhaAvaliacaoEstagioProbatorio',
        params: { idAvaliador: this.funcionarioId, idAvaliado: avaliadoId }
      });
    },
    volta: function volta() {
      this.$router.push({ name: 'AvaliacaoEstagioProbatorio' });
    }
  },

  created: function created() {
    var _this = this;

    this.periodos = JSON.parse(sessionStorage.getItem('periodosEstagioProbatorio'));
    this.periodos = this.periodos.filter(function (periodo) {
      return periodo.avaliado.id === _this.funcionarioId || periodo.avaliador.id === _this.funcionarioId || periodo.segundoAvaliador.id === _this.funcionarioId;
    });
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },


  components: {
    botao: __WEBPACK_IMPORTED_MODULE_0__components_botao___default.a
  }
});

/***/ }),

/***/ "K1rt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_botao__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExplicacaoModal',

  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_0__components_botao___default.a
  }
});

/***/ }),

/***/ "KDVI":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "registrosModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "registrosModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "5px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "registros"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionario),
      expression: "funcionario"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.funcionario = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.trocaUsuario(_vm.funcionario)
      }]
    }
  }, _vm._l((_vm.autenticados), function(autenticado) {
    return _c('option', {
      key: autenticado.id,
      domProps: {
        "value": autenticado
      }
    }, [_vm._v("\n                    " + _vm._s('Registro ' + autenticado.registroFormatado) + "\n                  ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Esse Registro",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "registrosModalLabel"
    }
  }, [_vm._v("\n            Escolha seu registro\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row row-field"
  }, [_c('p', [_vm._v("\n                Você possui mais de um registro. Sempre que quiser, você pode\n                trocar de usuário no menu à direita, em \"Trocar Registro\".\n              ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Qual registro deseja usar agora?")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-user-circle-o fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),

/***/ "Kg44":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var recadTiposDependentesService = function () {
  function recadTiposDependentesService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, recadTiposDependentesService);

    throw 'Não é possível instanciar recadTiposDependentesService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(recadTiposDependentesService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint();
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista() {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }]);

  return recadTiposDependentesService;
}();

/* harmony default export */ __webpack_exports__["a"] = (recadTiposDependentesService);


var mergeEndpoint = function mergeEndpoint() {
  return 'recadastramento-servidores/tipos-dependentes';
};

/***/ }),

/***/ "Kw2F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LaCu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DateHelper__ = __webpack_require__("9t/u");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      config: {
        format: 'L',
        useCurrent: false,
        locale: 'pt-br',
        maxDate: this.dataMaxima,
        minDate: this.dataMinima,
        ignoreReadonly: false
      },
      apiErrors: null
    };
  },

  props: {
    value: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).format('YYYY-MM-DD'),
      required: false
    },
    rotulo: {
      type: String,
      required: true
    },
    nome: {
      type: String,
      required: true
    },
    valor: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).format('YYYY-MM-DD'),
      required: false
    },
    dataMaxima: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).format('YYYY-MM-DD'),
      required: false
    },
    dataMinima: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).add(-100, 'years').format('YYYY-MM-DD'),
      required: false
    },
    validacao: {
      type: Object,
      default: {},
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    telaEhMobile: function telaEhMobile() {
      return window.innerWidth <= 768;
    },
    valorDaData: function valorDaData() {
      var data = null;
      if (this.value) {
        if (this.telaEhMobile) {
          data = this.value;
          return data;
        }
        data = __WEBPACK_IMPORTED_MODULE_1__helpers_DateHelper__["a" /* default */].convertDateToPtbr(this.value);
        return data;
      }
      return data;
    }
  },
  methods: {
    valorDoInput: function valorDoInput(event) {
      if (!this.disabled) {
        this.$emit('input', event);
      }
    }
  },
  watch: {
    disabled: {
      immediate: true,
      handler: function handler(newVal) {
        var _this = this;

        if (newVal) {
          this.$nextTick(function () {
            var input = _this.$el.querySelector('input');
            if (input) {
              input.setAttribute('readonly', 'readonly');
            }
          });
        }
      }
    }
  }
});

/***/ }),

/***/ "LaJZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var AvaliadorService = function () {
  function AvaliadorService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AvaliadorService);

    throw 'Não é possível instanciar AvaliadorService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AvaliadorService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id, idMes) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint(id, idMes);
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }]);

  return AvaliadorService;
}();

/* harmony default export */ __webpack_exports__["a"] = (AvaliadorService);


var mergeEndpoint = function mergeEndpoint(id, idMes) {
  return 'avaliacoes-periodicas/avaliadores/' + id + '/competencias/' + idMes + '/totais';
};

/***/ }),

/***/ "LlmX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_side_modal__ = __webpack_require__("dLc8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_side_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_side_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_object_hash__ = __webpack_require__("eZXE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_object_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_object_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_ArrayHelper__ = __webpack_require__("5OEK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_DateHelper__ = __webpack_require__("9t/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelper__ = __webpack_require__("1pbJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_NullHelper__ = __webpack_require__("2wz9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__domain_dependenteRecad_DependenteRecad__ = __webpack_require__("DjVM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_enums_recadTiposDependentesService__ = __webpack_require__("Kg44");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Filiacao',

  data: function data() {
    return {
      cadastrado: this.$store.state.funcionarioCadastrado,
      graus: [],
      dependente: {
        tipo: {
          descricao: ''
        }
      },
      dependentes: [],
      dependenteModal: {
        tipo: {
          descricao: ''
        },
        sexo: ''
      },
      sexos: [{
        displayName: 'Masculino',
        name: 'M'
      }, {
        displayName: 'Feminino',
        name: 'F'
      }],
      navs: [{
        titulo: 'Atualização Cadastral',
        subtitulo: 'Dependente',
        subtDetalhe: 'Novo Dependente',
        largura: 600,
        identidade: 'dependente',
        abreProximo: false,
        aberto: false
      }],
      config: {
        format: 'L',
        useCurrent: false,
        locale: 'pt-br',
        maxDate: __WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date()),
        minDate: __WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date()).add(-100, 'years')
      },
      filiacao: {
        mae: '',
        pai: ''
      },
      apiErrors: null
    };
  },


  computed: {
    dependenteIr: function dependenteIr() {
      return this.dependenteModal.dependenteIR ? 'SIM' : 'NÃO';
    },
    dependenteSexo: function dependenteSexo() {
      return this.dependenteModal.sexo === 'F' ? 'FEMININO' : 'MASCULINO';
    },
    telaEhMobile: function telaEhMobile() {
      return window.innerWidth <= 768;
    },
    situacaoRecad: function situacaoRecad() {
      return this.$store.getters.getSituacaoRecad;
    }
  },

  methods: {
    abreModal: function abreModal(identidade) {
      this.$emit('abreModal', identidade);
    },
    fechaModal: function fechaModal(identidade) {
      this.$emit('fechaModal', identidade);
    },
    abreExplicacaoModal: function abreExplicacaoModal() {
      jQuery('#explicacaoModal').modal('show');
    },

    // Função para validar CPF
    validaCPF: function validaCPF(cpf) {
      // Remove caracteres não numéricos
      cpf = cpf.replace(/\D/g, '');

      // Verifica se tem 11 dígitos
      if (cpf.length !== 11) return false;

      // Verifica se todos os dígitos são iguais
      if (/^(\d)\1+$/.test(cpf)) return false;

      // Validação do primeiro dígito verificador
      var soma = 0;
      for (var i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i);
      }
      var resto = 11 - soma % 11;
      var dv1 = resto > 9 ? 0 : resto;

      // Validação do segundo dígito verificador
      soma = 0;
      for (var _i = 0; _i < 10; _i++) {
        soma += parseInt(cpf.charAt(_i)) * (11 - _i);
      }
      resto = 11 - soma % 11;
      var dv2 = resto > 9 ? 0 : resto;

      // Verifica se os dígitos verificadores estão corretos
      return parseInt(cpf.charAt(9)) === dv1 && parseInt(cpf.charAt(10)) === dv2;
    },
    novo: function novo() {
      this.navs[0].subtDetalhe = 'Novo Dependente';
      this.abreModal('dependente');
      this.errors.clear();
    },
    valida: function valida(dependente) {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (success) {
          // Validação adicional do CPF
          if (!_this.validaCPF(dependente.cpfDependente)) {
            _this.$root.$refs.toastr.e('CPF inválido. Por favor, verifique o número informado.', 'Atenção');
            return;
          }

          if (_this.procuraMesmoNome(dependente)) {
            _this.$root.$refs.toastr.e('Esse dependente já está cadastrado', 'Atenção');
            return;
          }
          _this.tiraAcentuacaoDependente(dependente);
          _this.salva(dependente);
          return;
        }
        _this.$root.$refs.toastr.e('Preencha ou corrija os campos em vermelho', 'Atenção');
      });
    },
    procuraMesmoNome: function procuraMesmoNome(dependente) {
      if (dependente.index === undefined) {
        return this.cadastrado.pessoa.dependentes.some(function (item) {
          return item.nome === dependente.nome;
        });
      }
      return false;
    },
    edita: function edita(dependente) {
      this.navs[0].subtDetalhe = dependente.nome;

      dependente.index = this.cadastrado.pessoa.dependentes.indexOf(dependente);
      this.dependenteModal = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(dependente));
      if (!this.telaEhMobile) {
        this.dependenteModal.dataNascimento = __WEBPACK_IMPORTED_MODULE_11__helpers_DateHelper__["a" /* default */].convertDateToPtbr(this.dependenteModal.dataNascimento);
      }
      this.abreModal('dependente');
    },
    exclui: function exclui(dependente) {
      var _this2 = this;

      var sentences = [{
        id: 1,
        message: 'A exclusão do dependente é apenas em caso de falecimento. Tem certeza que deseja excluir?',
        bold: false
      }];

      this.$root.$refs.modal.confirm(sentences, {
        yes: function yes() {
          _this2.cadastrado.pessoa.dependentes.splice(_this2.cadastrado.pessoa.dependentes.indexOf(dependente), 1);
          _this2.$store.commit('setFuncionarioCadastrado', _this2.cadastrado);

          // Atualizar o status para COM_VALIDACAO quando um dependente é excluído
          // Importar o Status
          var Status = __webpack_require__("9a4s").default;

          // Alteração em dependentes sempre exige validação
          //this.cadastrado.status = Status.COM_VALIDACAO;

          // Atualizar o status no store
          //this.$store.dispatch('updateSituacaoRecad', Status.COM_VALIDACAO);

          _this2.$root.$refs.toastr.s('Dependente excluído', 'Sucesso');
        },
        title: 'Deletar Dependente'
      });
    },
    salva: function salva(dependente) {
      this.dependente = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(dependente));
      if (!this.telaEhMobile) {
        this.dependente.dataNascimento = __WEBPACK_IMPORTED_MODULE_11__helpers_DateHelper__["a" /* default */].convertPtbrToApiDate(this.dependente.dataNascimento);
      }
      var indice = this.dependente.index;
      if (indice >= 0) {
        this.cadastrado.pessoa.dependentes[indice] = this.dependente;
        this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
        this.$root.$refs.toastr.s('Dependente atualizado', 'Sucesso');
        this.fechaModal('dependente');
        this.limpaModal();
      } else {
        this.cadastrado.pessoa.dependentes.push(this.dependente);
        this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
        this.$root.$refs.toastr.s('Novo dependente incluso', 'Sucesso');
        this.fechaModal('dependente');
        this.limpaModal();
      }
    },
    cancela: function cancela() {
      this.fechaModal('dependente');
      this.limpaModal();
    },
    limpaModal: function limpaModal() {
      var _this3 = this;

      setTimeout(function () {
        _this3.dependenteModal = new __WEBPACK_IMPORTED_MODULE_14__domain_dependenteRecad_DependenteRecad__["a" /* default */]();
      }, 600);
    },
    mostraNomeExibicao: function mostraNomeExibicao(valor, lista) {
      if (valor) {
        return lista.find(function (data) {
          return data.name == valor;
        }).displayName;
      }
    },
    solicitaConfirmacao: function solicitaConfirmacao(cadastrado, proximoLink, referencia) {
      var _this4 = this;

      var sentences = [{
        id: 1,
        message: 'Identificamos que o ' + referencia + ' est\xE1 em branco. Deseja manter dessa forma?',
        bold: false
      }];

      this.$root.$refs.modal.confirm(sentences, {
        yes: function yes() {
          referencia === 'nome da mãe' ? cadastrado.nomeMaeNulo = true : cadastrado.nomePaiNulo = true;
          _this4.preparaGravaMuda(cadastrado, proximoLink);
        },
        title: 'Confirmar campo em branco'
      });
    },
    preparaGravaMuda: function preparaGravaMuda(cadastrado, proximoLink) {
      this.tiraAcentuacao(cadastrado.pessoa.filiacao, cadastrado.pessoa.dependentes);
      this.resetaNulos(cadastrado.pessoa);
      this.setAnexos(cadastrado, this.$store.state.cadastroModelo);
      this.$store.commit('setFuncionarioCadastrado', cadastrado);
      this.$router.push({ name: proximoLink });
    },
    tiraAcentuacao: function tiraAcentuacao(filiacao) {
      var _this5 = this;

      var camposFiliacao = [filiacao.mae, filiacao.pai];
      var indexFiliacao = 0;

      camposFiliacao.map(function (element) {
        if (__WEBPACK_IMPORTED_MODULE_12__helpers_StringHelper__["a" /* default */].verificaCaracterEspecial(element)) {
          camposFiliacao[indexFiliacao] = __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelper__["a" /* default */].limpaCaracterEspecial(element);
          _this5.$root.$refs.toastr.w('A Atualização Cadastral não aceita acentos e cedilhas. A aplicação já fez as correções necessárias.', 'Atenção');
        }
        indexFiliacao++;
      });
      this.cadastrado.pessoa.filiacao.mae = camposFiliacao[0];
      this.cadastrado.pessoa.filiacao.pai = camposFiliacao[1];
    },
    tiraAcentuacaoDependente: function tiraAcentuacaoDependente(dependente) {
      if (__WEBPACK_IMPORTED_MODULE_12__helpers_StringHelper__["a" /* default */].verificaCaracterEspecial(dependente.nome)) {
        dependente.nome = __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelper__["a" /* default */].limpaCaracterEspecial(dependente.nome);
        this.$root.$refs.toastr.w('A Atualização Cadastral não aceita acentos e cedilhas. A aplicação já fez as correções necessárias.', 'Atenção');
      }
    },
    setAnexos: function setAnexos(cadastrado, original) {
      var filiacao = __WEBPACK_IMPORTED_MODULE_9_object_hash___default()(cadastrado.pessoa.filiacao) != __WEBPACK_IMPORTED_MODULE_9_object_hash___default()(original.pessoa.filiacao) ? true : false;
      var dependentes = __WEBPACK_IMPORTED_MODULE_9_object_hash___default()(cadastrado.pessoa.dependentes) != __WEBPACK_IMPORTED_MODULE_9_object_hash___default()(original.pessoa.dependentes) ? true : false;
      var documentos = [];

      if (filiacao) documentos.push('RG ou Certidão de Nascimento ou Decisão Judicial');

      if (dependentes) {
        // Verificar cada dependente alterado ou adicionado
        var novos = cadastrado.pessoa.dependentes.filter(function (dep) {
          return !original.pessoa.dependentes.some(function (origDep) {
            return origDep.id === dep.id && __WEBPACK_IMPORTED_MODULE_9_object_hash___default()(origDep) === __WEBPACK_IMPORTED_MODULE_9_object_hash___default()(dep);
          });
        });

        // Conjunto para evitar documentos duplicados
        var docsExigidos = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a();

        novos.forEach(function (dep) {
          var tipoDesc = dep.tipo.descricao.toUpperCase();

          if (tipoDesc.includes('COMPANHEIRO') || tipoDesc.includes('COMPANHEIRA')) {
            docsExigidos.add('Escritura de União Estável');
          } else if (tipoDesc.includes('ESPOSO') || tipoDesc.includes('ESPOSA')) {
            docsExigidos.add('Certidão de Casamento Averbada');
          } else {
            docsExigidos.add('Certidão de Nascimento ou de Óbito do parente');
          }
        });

        // Adicionar os documentos sem duplicatas
        documentos = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(documentos), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(docsExigidos));
      }

      if (cadastrado.documentosExigidos) {
        var novosDocumentos = documentos.filter(function (item) {
          return !cadastrado.documentosExigidos.includes(item);
        });
        cadastrado.documentosExigidos = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(cadastrado.documentosExigidos), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(novosDocumentos));
      } else {
        cadastrado.documentosExigidos = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(documentos));
      }
    },
    volta: function volta() {
      this.$router.go(-1);
    },
    avanca: function avanca(cadastrado, proximoLink) {
      if (!cadastrado.pessoa.filiacao.mae) {
        if (!cadastrado.nomeMaeNulo) {
          this.solicitaConfirmacao(cadastrado, proximoLink, 'nome da mãe');
          return;
        }
      } else {
        cadastrado.nomeMaeNulo = false;
      }
      if (!cadastrado.pessoa.filiacao.pai) {
        if (!cadastrado.nomePaiNulo) {
          this.solicitaConfirmacao(cadastrado, proximoLink, 'nome do pai');
          return;
        }
      } else {
        cadastrado.nomePaiNulo = false;
      }
      this.preparaGravaMuda(cadastrado, proximoLink);
    },
    valoraNulos: function valoraNulos(pessoa) {
      pessoa.filiacao = __WEBPACK_IMPORTED_MODULE_13__helpers_NullHelper__["a" /* default */].valora(pessoa.filiacao, this.filiacao);
    },
    resetaNulos: function resetaNulos(pessoa) {
      pessoa.filiacao = __WEBPACK_IMPORTED_MODULE_13__helpers_NullHelper__["a" /* default */].reseta(pessoa.filiacao, this.filiacao);
    },
    listaTiposDependentes: function listaTiposDependentes() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_15__services_enums_recadTiposDependentesService__["a" /* default */].lista();

              case 3:
                response = _context.sent;
                _context.next = 6;
                return response;

              case 6:
                _this6.graus = _context.sent;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this6.$root.$refs.toastr.e(_context.t0.body.message, 'Atenção');

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6, [[0, 9]]);
      }))();
    }
  },

  created: function created() {
    var _this7 = this;

    console.log(this.situacaoRecad);
    this.valoraNulos(this.cadastrado.pessoa);
    this.listaTiposDependentes();

    // Adicionar regra de validação personalizada para CPF
    this.$validator.extend('cpf_valido', {
      getMessage: function getMessage(field) {
        return 'O CPF informado não é válido.';
      },
      validate: function validate(value) {
        return _this7.validaCPF(value);
      }
    });

    this.$eventBus.$on('salvaAvanca', function (nomeComponente) {
      _this7.avanca(_this7.cadastrado, nomeComponente);
    });
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off('salvaAvanca');
  },

  filters: {
    formatarCPF: function formatarCPF(cpf) {
      if (!cpf) return '';
      // Remove caracteres não numéricos
      cpf = cpf.replace(/\D/g, '');
      // Aplica a máscara
      return cpf.replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    }
  },
  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_6__components_botao___default.a,
    SideModal: __WEBPACK_IMPORTED_MODULE_7__components_side_modal___default.a
  }
});

/***/ }),

/***/ "LoYH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_botao__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProtocoloModal',

  props: {
    protocoloGerado: {
      required: false,
      type: String
    },
    agendamentoId: {
      required: true,
      type: Number
    }
  },

  methods: {
    imprime: function imprime() {
      this.$emit('imprimeProtocolo', this.agendamentoId);
    }
  },

  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_0__components_botao___default.a
  }
});

/***/ }),

/***/ "LrQo":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "regraFeriasPendentesModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "regraFeriasPendentesModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Ciente",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "regraFeriasPendentesModalLabel"
    }
  }, [_vm._v("\n            Férias Anteriores Pendentes\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', [_vm._v("Você tem férias pendentes de exercícios anteriores!")]), _vm._v(" "), _c('p', [_vm._v("\n                Conforme § 3º do artigo 172 da Lei nº 4623/84, é proibida a\n                acumulação de férias pelo máximo de dois anos consecutivos.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                Para regularizar sua situação é necessário enviar memorando\n                por e-mail para o endereço\n                "), _c('a', {
    attrs: {
      "href": "mailto:ferias@santos.sp.gov.br"
    }
  }, [_vm._v("\n                  ferias@santos.sp.gov.br ")]), _vm._v(", até o 3º dia útil do mês anterior ao do início das férias.\n              ")])])])])
}]}

/***/ }),

/***/ "M93x":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("xJD8"),
  /* template */
  __webpack_require__("dm3l"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "MKaz":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("5UK3"),
  /* template */
  __webpack_require__("vWEU"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "MPt9":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("RpBN")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("mhWi"),
  /* template */
  __webpack_require__("W3+9"),
  /* scopeId */
  "data-v-a1fe8224",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Mp9a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MuUL":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group has-feedback",
    class: [_vm.problems ? 'has-error' : '', _vm.cssClass]
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.label),
      expression: "label"
    }],
    staticClass: "control-label",
    attrs: {
      "for": _vm.field
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.problems && _vm.label && _vm.showIcon),
      expression: "problems && label && showIcon"
    }],
    staticClass: "glyphicon glyphicon-remove form-control-feedback",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.problems),
      expression: "problems"
    }],
    staticClass: "help-block"
  }, _vm._l((_vm.problems), function(problem) {
    return _c('p', {
      key: _vm.problems.indexOf(problem)
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.problems.length > 1),
        expression: "problems.length > 1"
      }],
      staticClass: "fa fa-exclamation",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n        " + _vm._s(problem) + "\n      ")])
  }), 0)], 2)
},staticRenderFns: []}

/***/ }),

/***/ "N2/l":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "L7",
      "xmlns": "https://www.w3.org/2000/svg",
      "xmlns:xlink": "https://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 100 100",
      "enable-background": "new 0 0 100 100",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3\n          c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "attributeType": "XML",
      "type": "rotate",
      "dur": "2s",
      "from": "0 50 50",
      "to": "360 50 50",
      "repeatCount": "indefinite"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7\n          c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "attributeType": "XML",
      "type": "rotate",
      "dur": "1s",
      "from": "0 50 50",
      "to": "-360 50 50",
      "repeatCount": "indefinite"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5\n          L82,35.7z"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "attributeType": "XML",
      "type": "rotate",
      "dur": "2s",
      "from": "0 50 50",
      "to": "360 50 50",
      "repeatCount": "indefinite"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ "N4eQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var IdentidadeGeneroService = function () {
  function IdentidadeGeneroService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, IdentidadeGeneroService);

    throw 'Não é possível instanciar IdentidadeGeneroService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(IdentidadeGeneroService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint();
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista() {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }]);

  return IdentidadeGeneroService;
}();

/* harmony default export */ __webpack_exports__["a"] = (IdentidadeGeneroService);


var mergeEndpoint = function mergeEndpoint() {
  return 'identidades-generos';
};

/***/ }),

/***/ "N9Gh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var PeriodosService = function () {
  function PeriodosService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PeriodosService);

    throw 'Não é possível instanciar PeriodosService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(PeriodosService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id, idMes) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint(id, idMes);
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }, {
    key: 'obtemDoFuncionario',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id, idMes) {
        var endpoint, params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = mergeEndpoint(id, idMes);
                params = { idAvaliado: id };
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint, { params: params });

              case 4:
                return _context2.abrupt('return', _context2.sent);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function obtemDoFuncionario(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return obtemDoFuncionario;
    }()
  }]);

  return PeriodosService;
}();

/* harmony default export */ __webpack_exports__["a"] = (PeriodosService);


var mergeEndpoint = function mergeEndpoint(id, idMes) {
  return 'avaliacoes-periodicas/avaliador/' + id + '/competencias/' + idMes + '/avaliacoes-periodicas';
};

/***/ }),

/***/ "NGiz":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "side-modal"
    }
  }, [_c('side-modal', {
    attrs: {
      "sides": _vm.navs
    },
    on: {
      "cancela": function($event) {
        return _vm.cancela()
      }
    }
  }, [_c('template', {
    slot: _vm.navs[0].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('field-validation', {
    attrs: {
      "label": "Estado",
      "field": "estadoModal",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.estado),
      expression: "enderecoEditado.estado"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "estadoModal",
      "data-vv-as": "Estado"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.enderecoEditado, "estado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.estados), function(estado) {
    return _c('option', {
      key: estado.id,
      domProps: {
        "value": estado.sigla
      },
      on: {
        "change": function($event) {
          return _vm.obtemMunicipios(_vm.enderecoEditado.estado, 'modal')
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm._f("tudoMaiusculo")(estado.nome)) + "\n                      ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('field-validation', {
    attrs: {
      "label": "Município",
      "field": "municipioModal",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.municipio),
      expression: "enderecoEditado.municipio"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "municipioModal",
      "data-vv-as": "Município"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.enderecoEditado, "municipio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.limpaModal()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.municipios), function(municipio) {
    return _c('option', {
      key: municipio.id,
      domProps: {
        "value": municipio.id
      }
    }, [_vm._v("\n                        " + _vm._s(municipio.nome) + "\n                      ")])
  })], 2)])], 1)]), _vm._v(" "), (_vm.mostraLista) ? _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Logradouro")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoLista),
      expression: "enderecoLista"
    }],
    staticClass: "form-control",
    attrs: {
      "size": _vm.enderecos.length > 10 ? 10 : _vm.enderecos.length + 1
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.enderecoLista = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.valoraLista()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("\n                        Selecione o seu logradouro ou refine sua busca\n                      ")]), _vm._v(" "), _vm._l((_vm.enderecos), function(endereco) {
    return _c('option', {
      key: _vm.enderecos.indexOf(endereco),
      domProps: {
        "value": endereco
      },
      on: {
        "dblclick": function($event) {
          return _vm.inclui()
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm._f("tudoMaiusculo")(((endereco.logradouro.tipo) + " " + (endereco.logradouro.nome) + " - " + (endereco.bairro.nome) + " - " + (_vm.cepMasked(endereco.cep))))) + "\n                      ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('botao', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "estilo": "vazado-verde-dir",
      "rotulo": "Ok",
      "icone": "fa-check fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.inclui()
      }
    }
  }), _vm._v(" "), _c('botao', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "estilo": "vazado-cinza-dir",
      "rotulo": "Limpar",
      "icone": "fa-eraser fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.montaModal()
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.logradouroInvalido),
      expression: "logradouroInvalido"
    }],
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "tipoLogradouro"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.tipoLogradouro),
      expression: "enderecoEditado.tipoLogradouro"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tipoLogradouro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.enderecoEditado, "tipoLogradouro", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.tiposLogradouros), function(tipoLogradouro) {
    return _c('option', {
      key: tipoLogradouro.id,
      domProps: {
        "value": tipoLogradouro.descricao
      }
    }, [_vm._v("\n                          " + _vm._s(tipoLogradouro.descricao) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "logradouroModal"
    }
  }, [_vm._v("Logradouro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.logradouro),
      expression: "enderecoEditado.logradouro"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "logradouroModal",
      "id": "logradouroModal"
    },
    domProps: {
      "value": (_vm.enderecoEditado.logradouro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "logradouro", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('field-validation', {
    attrs: {
      "label": "CEP",
      "field": "cepModal",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##.###-###'),
      expression: "'##.###-###'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.cep),
      expression: "enderecoEditado.cep"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cepModal",
      "id": "cepModal",
      "data-vv-as": "CEP"
    },
    domProps: {
      "value": (_vm.enderecoEditado.cep)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "cep", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('field-validation', {
    attrs: {
      "label": "Bairro",
      "field": "bairroModal",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.bairro),
      expression: "enderecoEditado.bairro"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "bairroModal",
      "id": "bairroModal",
      "data-vv-as": "Bairro"
    },
    domProps: {
      "value": (_vm.enderecoEditado.bairro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "bairro", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-xs-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('field-validation', {
    attrs: {
      "label": "Número",
      "field": "numeroModal",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('######'),
      expression: "'######'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.numero),
      expression: "enderecoEditado.numero"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "numeroModal",
      "id": "numeroModal",
      "data-vv-as": "Número"
    },
    domProps: {
      "value": (_vm.enderecoEditado.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "numero", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-2"
  }, [_c('div', {
    staticClass: "checkbox-default"
  }, [_c('label', {
    attrs: {
      "for": "semNumeroModal"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.semNumero),
      expression: "semNumero"
    }],
    attrs: {
      "type": "checkbox",
      "name": "semNumeroModal",
      "id": "semNumeroModal",
      "tabindex": "-1"
    },
    domProps: {
      "checked": Array.isArray(_vm.semNumero) ? _vm._i(_vm.semNumero, null) > -1 : (_vm.semNumero)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.semNumero,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.semNumero = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.semNumero = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.semNumero = $$c
        }
      }, function($event) {
        return _vm.zeraNumero('#numeroModal')
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "complementoModal"
    }
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.complemento),
      expression: "enderecoEditado.complemento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "complementoModal",
      "value": "",
      "id": "complementoModal"
    },
    domProps: {
      "value": (_vm.enderecoEditado.complemento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "complemento", $event.target.value)
      }
    }
  })])])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancela()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": _vm.logradouroInvalido ? 'Incluir' : 'Selecionar',
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.inclui()
      }
    }
  })], 1)])], 2)], 1), _vm._v(" "), _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "cep"
    }
  }, [_vm._v("CEP  ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.cep),
      expression: "enderecoEditado.cep"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##.###-###'),
      expression: "'##.###-###'"
    }],
    staticClass: "form-control",
    class: _vm.errorInputCep,
    attrs: {
      "type": "text",
      "name": "cep",
      "value": "",
      "id": "cep",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.enderecoEditado.cep)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.enderecoEditado.cep ? _vm.busca(_vm.enderecoEditado.cep) : _vm.buscaAbreModal(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "cep", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('botao', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right",
      value: ('Busca endereço'),
      expression: "'Busca endereço'",
      modifiers: {
        "right": true
      }
    }],
    staticStyle: {
      "height": "34px",
      "font-size": "12px",
      "margin-bottom": "0"
    },
    attrs: {
      "estilo": "vazado-verde-dir",
      "rotulo": "",
      "icone": "fa-search fa-lg",
      "disabled": _vm.disabled
    },
    on: {
      "clicado": function($event) {
        return _vm.busca(_vm.enderecoEditado.cep)
      }
    }
  })], 1)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cep')),
      expression: "errors.has('cep')"
    }],
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errors.first('cep')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    directives: [{
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }],
    attrs: {
      "css-class": "col-sm-3",
      "label": "Tipo",
      "field": "tipoLogradouro",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.tipoLogradouro),
      expression: "enderecoEditado.tipoLogradouro"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tipoLogradouro",
      "data-vv-as": "Tipo",
      "disabled": _vm.disabled
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.enderecoEditado, "tipoLogradouro", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.tiposLogradouros), function(tipoLogradouro) {
    return _c('option', {
      key: tipoLogradouro.id,
      domProps: {
        "value": tipoLogradouro.descricao
      }
    }, [_vm._v("\n              " + _vm._s(tipoLogradouro.descricao) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-6",
      "label": "Logradouro",
      "field": "logradouro",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.logradouro),
      expression: "enderecoEditado.logradouro"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:40'),
      expression: "'required|max:40'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "logradouro",
      "id": "logradouro",
      "data-vv-as": "Logradouro",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.enderecoEditado.logradouro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "logradouro", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field visible-xs-12 hidden-sm hidden-md hidden-lg"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-xs-5",
      "label": "Número",
      "field": "numero-xs",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('#######'),
      expression: "'#######'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.numero),
      expression: "enderecoEditado.numero"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "numero-xs",
      "id": "numero-xs",
      "data-vv-as": "Número",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.enderecoEditado.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "numero", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('div', {
    staticClass: "checkbox-default"
  }, [_c('label', {
    attrs: {
      "for": "semNumero-xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.semNumero),
      expression: "semNumero"
    }],
    attrs: {
      "type": "checkbox",
      "name": "semNumero-xs",
      "id": "semNumero-xs",
      "tabindex": "-1",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": Array.isArray(_vm.semNumero) ? _vm._i(_vm.semNumero, null) > -1 : (_vm.semNumero)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.semNumero,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.semNumero = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.semNumero = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.semNumero = $$c
        }
      }, function($event) {
        return _vm.zeraNumero('#numero-xs')
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "complemento-xs"
    }
  }, [_vm._v("Complem.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.complemento),
      expression: "enderecoEditado.complemento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "complemento-xs",
      "value": "",
      "id": "complemento-xs",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.enderecoEditado.complemento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "complemento", $event.target.value)
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-sm-3 hidden-xs",
      "label": "Complemento",
      "field": "complemento",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.complemento),
      expression: "enderecoEditado.complemento"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:15'),
      expression: "'max:15'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "complemento",
      "id": "complemento",
      "data-vv-as": "Complemento",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.enderecoEditado.complemento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "complemento", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-3",
      "label": "Bairro",
      "field": "bairro",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.bairro),
      expression: "enderecoEditado.bairro"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:20'),
      expression: "'required|max:20'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "bairro",
      "id": "bairro",
      "data-vv-as": "Bairro",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.enderecoEditado.bairro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "bairro", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-2 hidden-xs",
      "label": "Número",
      "field": "numero",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('#######'),
      expression: "'#######'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.numero),
      expression: "enderecoEditado.numero"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "numero",
      "id": "numero",
      "data-vv-as": "Número",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.enderecoEditado.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "numero", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 hidden-xs"
  }, [_c('div', {
    staticClass: "checkbox-default"
  }, [_c('label', {
    attrs: {
      "for": "semNumero"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.semNumero),
      expression: "semNumero"
    }],
    attrs: {
      "type": "checkbox",
      "name": "semNumero",
      "id": "semNumero",
      "tabindex": "-1",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": Array.isArray(_vm.semNumero) ? _vm._i(_vm.semNumero, null) > -1 : (_vm.semNumero)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.semNumero,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.semNumero = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.semNumero = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.semNumero = $$c
        }
      }, function($event) {
        return _vm.zeraNumero('#numero')
      }]
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-4 col-sm-4",
      "label": "Estado",
      "field": "estado",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.estado),
      expression: "enderecoEditado.estado"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "estado",
      "data-vv-as": "Estado",
      "disabled": _vm.disabled
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.enderecoEditado, "estado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.obtemMunicipios(_vm.enderecoEditado.estado, 'formulario')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.estados), function(estado) {
    return _c('option', {
      key: estado.id,
      domProps: {
        "value": estado.sigla
      }
    }, [_vm._v("\n              " + _vm._s(_vm._f("tudoMaiusculo")(estado.nome)) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-4 col-sm-4",
      "label": "Município",
      "field": "municipio",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.municipio),
      expression: "enderecoEditado.municipio"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "municipio",
      "data-vv-as": "Município",
      "disabled": _vm.disabled || !_vm.dadosCarregados
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.enderecoEditado, "municipio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.municipios), function(municipio) {
    return _c('option', {
      key: municipio.id,
      domProps: {
        "value": municipio.nome
      }
    }, [_vm._v("\n              " + _vm._s(municipio.nome) + "\n            ")])
  })], 2)])], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_less__ = __webpack_require__("ydoK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_toastr__ = __webpack_require__("/3l7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_auto_progress__ = __webpack_require__("AmOw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_auto_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_auto_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modal__ = __webpack_require__("GQcT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_field_validation__ = __webpack_require__("mGlk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_field_validation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_field_validation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_pt_BR__ = __webpack_require__("RAMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_pt_BR___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_pt_BR__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_bootstrap_datetimepicker__ = __webpack_require__("fv+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_v_mask__ = __webpack_require__("1I9z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_v_money__ = __webpack_require__("9VIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__filters_filters__ = __webpack_require__("V1NV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_directive_tooltip__ = __webpack_require__("h/Ox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_directive_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_directive_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__directives_semAcentos__ = __webpack_require__("unEG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__("I7CV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





















window.jQuery = __webpack_require__("7t+N");
__webpack_require__("gNGx");


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_bootstrap_datetimepicker___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_v_mask__["a" /* default */]);
//Vue.directive('sem-acentos', semAcentos);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('sem-acentos', {
  bind: function bind(el, binding, vnode) {
    var aplicar = function aplicar(elemento) {
      elemento.addEventListener('input', function (e) {
        var valor = e.target.value;

        var limpo = valor.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9\s]/g, '');

        if (valor !== limpo) {
          e.target.value = limpo;

          // 🔥 atualiza o v-model
          if (binding.expression) {
            vnode.context[binding.expression] = limpo;
          }

          elemento.dispatchEvent(new Event('input'));
        }
      });
    };

    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
      aplicar(el);
    } else {
      el.querySelectorAll('input, textarea').forEach(aplicar);
    }
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_v_money___default.a, { decimal: ',', thousands: '.', precision: 2 });
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_directive_tooltip___default.a, {
  delay: 100,
  class: 'tooltip-custom',
  triggers: ['hover']
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_the_mask__["TheMask"]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_10__components_field_validation___default.a.locale(__WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_pt_BR___default.a, 'pt_BR');
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('field-validation', __WEBPACK_IMPORTED_MODULE_10__components_field_validation___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$eventBus = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__vuex_store__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */],
  template: '<div><App/><modal ref="modal" /><toastr ref="toastr" /><auto-progress /></div>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a, modal: __WEBPACK_IMPORTED_MODULE_9__components_modal___default.a, toastr: __WEBPACK_IMPORTED_MODULE_7_vue_toastr___default.a, autoProgress: __WEBPACK_IMPORTED_MODULE_8_vue_auto_progress___default.a }
});

/***/ }),

/***/ "NV+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NVOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_botao__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EncerramentoModal",

  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_0__components_botao___default.a
  }
});

/***/ }),

/***/ "NVyW":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "footer",
    attrs: {
      "role": "footer",
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container",
    on: {
      "click": function($event) {
        return _vm.mostraRodape()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3 hidden-xs info-content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', [_vm._v("PROBLEMAS")]), _vm._v(" "), _c('p', [_vm._v("\n          Abra um SAU para"), _c('br'), _vm._v("solucionar seu problema."), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/sau"
    }
  }, [_vm._v("\n            egov.santos.sp.gov.br/sau\n          ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3 hidden-xs info-content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', [_vm._v("DEGEPAT")]), _vm._v(" "), _c('p', [_vm._v("\n          Rua QUINZE DE NOVEMBRO, 108"), _c('br'), _vm._v("\n          Centro - Santos/SP"), _c('br'), _vm._v("\n          CEP 11010-150"), _c('br'), _vm._v("\n          Tel. (13) 3213-7166"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:degepat@santos.sp.gov.br"
    }
  }, [_vm._v("\n            degepat@santos.sp.gov.br\n          ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3 hidden-xs info-content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', [_vm._v("CONTROLADORIA")]), _vm._v(" "), _c('p', [_vm._v("\n          Paço Municipal"), _c('br'), _vm._v("\n          Praça Visconde de Mauá, s/n"), _c('br'), _vm._v("\n          3º andar, sala 302"), _c('br'), _vm._v("\n          Cep 11010-900"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:declaracaodebens@santos.sp.gov.br"
    }
  }, [_vm._v("\n            declaracaodebens@santos.sp.gov.br\n          ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-xs-6 visible-xs info-content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', [_vm._v("PROBLEMAS")]), _vm._v(" "), _c('p', [_vm._v("\n            Abra um SAU para"), _c('br'), _vm._v("solucionar seu problema."), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/sau"
    }
  }, [_vm._v("\n              egov.santos.sp.gov.br/sau\n            ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-xs-6 visible-xs info-content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', [_vm._v("DEGEPAT")]), _vm._v(" "), _c('p', [_vm._v("\n            Rua Riachuelo, 104"), _c('br'), _vm._v("\n            Centro - Santos/SP"), _c('br'), _vm._v("\n            Cep 11010-020"), _c('br'), _vm._v("\n            Tel. (13) 3213-7166"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:degepat@santos.sp.gov.br"
    }
  }, [_vm._v("\n              degepat@santos.sp.gov.br\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 visible-xs info-content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', [_vm._v("IPREV")]), _vm._v(" "), _c('p', [_vm._v("\n            Rua Dr. Assis Corrêa, 20"), _c('br'), _vm._v("\n            Gonzaga - Santos/SP"), _c('br'), _vm._v("\n            Cep 11055-310"), _c('br'), _vm._v("\n            Tel. (13) 3202-9099"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:degepat@santos.sp.gov.br"
    }
  }, [_vm._v("\n              iprev@santos.sp.gov.br\n            ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n        Prefeitura de Santos - Secretaria de Gestão (SEGES) - Departamento de\n        Gestão de Tecnologia da Informação e Comunicação (DETIC) - Versão:\n        3.0.0 - 2019\n      ")])])
}]}

/***/ }),

/***/ "NYl2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'barra-evolucao',

    props: {
        stepOne: { type: Number, required: false },
        stepTwo: { type: Number, required: false },
        stepThree: { type: Number, required: false },
        stepFour: { type: Number, required: false },
        stepFive: { type: Number, required: false },
        stepSix: { type: Number, required: false },
        stepSeven: { type: Number, required: false },
        textOne: { type: Number, required: false },
        textTwo: { type: Number, required: false },
        textThree: { type: Number, required: false },
        textFour: { type: Number, required: false },
        textFive: { type: Number, required: false },
        textSix: { type: Number, required: false },
        textSeven: { type: Number, required: false },
        contentName: { type: String, required: false },
        contentNumber: { type: Number, required: false }
    },
    computed: {
        one: function one() {
            if (this.stepOne >= '1') return 'step-done';
        },
        two: function two() {
            if (this.stepTwo >= '2') return 'step-done';
        },
        three: function three() {
            if (this.stepThree >= '3') return 'step-done';
        },
        four: function four() {
            if (this.stepFour >= '4') return 'step-done';
        },
        five: function five() {
            if (this.stepFive >= '5') return 'step-done';
        },
        six: function six() {
            if (this.stepSix >= '6') return 'step-done';
        },
        seven: function seven() {
            if (this.stepSeven >= '7') return 'step-done';
        },
        tOne: function tOne() {
            if (this.textOne >= '1') return 'text-done';
        },
        tTwo: function tTwo() {
            if (this.textTwo >= '2') return 'text-done';
        },
        tThree: function tThree() {
            if (this.textThree >= '3') return 'text-done';
        },
        tFour: function tFour() {
            if (this.textFour >= '4') return 'text-done';
        },
        tFive: function tFive() {
            if (this.textFive >= '5') return 'text-done';
        },
        tSix: function tSix() {
            if (this.textSix >= '6') return 'text-done';
        },
        tSeven: function tSeven() {
            if (this.textSeven >= '7') return 'text-done';
        }
    },
    methods: {
        emiteSalva: function emiteSalva(nomeComponente) {
            if (nomeComponente == 'DadosPessoais') {
                var id = sessionStorage.getItem('userId'); // Recupera o ID da sessão
                if (id) {
                    this.$router.push({ name: nomeComponente, params: { id: id } });
                    // this.$eventBus.$emit('salvaAvanca', { id, nomeComponente });
                } else {
                    console.error('Nenhum ID encontrado na sessão');
                }
            } else {
                this.$router.push({ name: nomeComponente });
                //this.$eventBus.$emit('salvaAvanca', nomeComponente)
            }
        },
        emiteSalvaMobile: function emiteSalvaMobile(direcao, step) {
            console.log('Dire\xE7\xE3o: ' + direcao + '; Step: ' + step);
            switch (step) {
                case 1:
                    this.emiteSalva('Endereco');
                    break;
                case 2:
                    direcao === 'esquerda' ? this.emiteSalva('DadosPessoais') : this.emiteSalva('Contatos');
                    break;
                case 3:
                    direcao === 'esquerda' ? this.emiteSalva('Endereco') : this.emiteSalva('Documentacao');
                    break;
                case 4:
                    direcao === 'esquerda' ? this.emiteSalva('Contatos') : this.emiteSalva('Filiacao');
                    break;
                case 5:
                    direcao === 'esquerda' ? this.emiteSalva('Documentacao') : this.emiteSalva('Envio');
                    break;
                case 6:
                    direcao === 'esquerda' ? this.emiteSalva('Filiacao') : this.emiteSalva('Fim');
                    break;
                case 7:
                    this.emiteSalva('Envio');
                    break;
                default:
                    break;
            }
        }
    },
    created: function created() {},
    destroyed: function destroyed() {}
});

/***/ }),

/***/ "NwbQ":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("pUc1")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("6WdY"),
  /* template */
  __webpack_require__("dPOl"),
  /* scopeId */
  "data-v-296c43d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "OHw6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_card_header__ = __webpack_require__("8KSN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_card_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_card_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_table_loader__ = __webpack_require__("pKzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_table_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_table_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_avaliacoesEstagioProbatorioService__ = __webpack_require__("ASZ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_avaliadorEstagioProbatorioService__ = __webpack_require__("9eSt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_periodosEstagioProbatorioService__ = __webpack_require__("V1H8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_ErrorHelper__ = __webpack_require__("+h9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AvaliacaoEstagioProbatorio',

  data: function data() {
    return {
      apiErrors: null,
      funcionario: this.$store.state.funcionario,
      carregando: false,
      anosAvaliados: [],
      periodos: [],
      anos: [],
      periodoAvaliacaoAnoAtual: {},
      avaliador: {}
    };
  },

  computed: {
    avaliacoesOrdenadas: function avaliacoesOrdenadas() {
      return this.anosAvaliados.sort(function (a, b) {
        return b.ano - a.ano || a.mes - b.mes;
      });
    },
    ehAvaliador: function ehAvaliador() {
      return this.avaliador ? this.avaliador.totalPendente != null : false;
    },
    usuarioAtual: function usuarioAtual() {
      return this.$store.state.funcionario;
    }
  },
  watch: {
    usuarioAtual: function usuarioAtual(novo, anterior) {
      this.funcionario = novo;
      this.editaRegistro(this.funcionario.id);
    }
  },
  methods: {
    statusDaLinhaDaTabela: function statusDaLinhaDaTabela(avaliacao) {
      var _avaliacao$periodos$ = avaliacao.periodos[0],
          dataInicioLancamento = _avaliacao$periodos$.dataInicioLancamento,
          dataFimLancamento = _avaliacao$periodos$.dataFimLancamento;
      var aceita = avaliacao.aceita;


      return this.validaEhEditavel(avaliacao, dataInicioLancamento, dataFimLancamento) ? 'situacao-pendente' : '';
    },
    statusDaAvaliacao: function statusDaAvaliacao(avaliacao) {
      var _avaliacao$periodos$2 = avaliacao.periodos[0],
          dataInicioLancamento = _avaliacao$periodos$2.dataInicioLancamento,
          dataFimLancamento = _avaliacao$periodos$2.dataFimLancamento;


      var ehEditavel = this.validaEhEditavel(avaliacao, dataInicioLancamento, dataFimLancamento);

      var periodoAindaNaoAbriu = new Date() < new Date(dataInicioLancamento);
      if (avaliacao.idAvaliacaoAvaliador == null && avaliacao.idAvaliador == this.usuarioAtual.id) return '-';
      if (ehEditavel) return 'EM ANDAMENTO';
      if (periodoAindaNaoAbriu) return 'INDISPONÍVEL';
      return 'FINALIZADA';
    },
    quantidadeDeAvaliacoesPorAvaliador: function quantidadeDeAvaliacoesPorAvaliador(avaliacao) {
      var _avaliacao$periodos$3 = avaliacao.periodos[0],
          dataInicioLancamento = _avaliacao$periodos$3.dataInicioLancamento,
          dataFimLancamento = _avaliacao$periodos$3.dataFimLancamento;


      return this.situacaoAvaliacoesPendentes(dataInicioLancamento, dataFimLancamento, avaliacao) ? avaliacao.totalPendente : 'NENHUM';
    },
    statusDoBotao: function statusDoBotao(avaliacao) {
      var _avaliacao$periodos$4 = avaliacao.periodos[0],
          dataInicioLancamento = _avaliacao$periodos$4.dataInicioLancamento,
          dataFimLancamento = _avaliacao$periodos$4.dataFimLancamento;
      var aceita = avaliacao.aceita;


      return this.validaEhEditavel(avaliacao, dataInicioLancamento, dataFimLancamento) && aceita == null ? 'vazado-laranja-sm' : 'vazado-cinza-sm';
    },
    condicionalDoBotaoDeAvaliador: function condicionalDoBotaoDeAvaliador(avaliacao) {
      var _avaliacao$periodos$5 = avaliacao.periodos[0],
          dataInicioLancamento = _avaliacao$periodos$5.dataInicioLancamento,
          dataFimLancamento = _avaliacao$periodos$5.dataFimLancamento;


      return this.validaEhEditavel(avaliacao, dataInicioLancamento, dataFimLancamento);
    },
    condicionalDoBotaoComum: function condicionalDoBotaoComum(avaliacao, status) {
      var _avaliacao$periodos$6 = avaliacao.periodos[0],
          dataInicioLancamento = _avaliacao$periodos$6.dataInicioLancamento,
          dataFimLancamento = _avaliacao$periodos$6.dataFimLancamento;


      var ehEditavel = this.validaEhEditavel(avaliacao, dataInicioLancamento, dataFimLancamento);

      if (status) {
        return ehEditavel;
      }

      return !ehEditavel;
    },
    validaEhEditavel: function validaEhEditavel(avaliacao, dataInicial, dataFinal) {
      var aceita = avaliacao.aceita;


      if (dataInicial && dataFinal) {
        var periodoAberto = __WEBPACK_IMPORTED_MODULE_11_moment___default()(new Date()).isBetween(dataInicial, dataFinal, 'day', '[]');
        var naoHaAceite = aceita == null;
        var avaliadoresPendentes = avaliacao.totalPendente > 0;

        return periodoAberto && naoHaAceite;
      }

      return false;
    },
    validaPeriodoAindaNaoAbriu: function validaPeriodoAindaNaoAbriu(avaliacao) {
      var dataInicioLancamento = avaliacao.periodos[0].dataInicioLancamento;


      var periodoAindaNaoAbriu = new Date() < new Date(dataInicioLancamento);

      if (periodoAindaNaoAbriu) {
        var erro = new Error('O período de avaliação ainda não está aberto');
        erro.type = 'warning';
        throw erro;
      }
    },
    situacaoAvaliacoesPendentes: function situacaoAvaliacoesPendentes(dataInicial, dataFinal, avaliacao) {
      if (dataInicial && dataFinal && avaliacao) {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(new Date()).isBetween(dataInicial, dataFinal, 'day', '[]') && avaliacao.totalPendente > 0;
      }
      return false;
    },
    apagaDuplicatas: function apagaDuplicatas(array) {
      var arrayLimpo = [];
      array.forEach(function (element) {
        if (!arrayLimpo.some(function (item) {
          return item.id === element.id;
        })) {
          arrayLimpo.push(element);
        }
      });

      return arrayLimpo;
    },
    editaRegistro: function editaRegistro(funcionarioId) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var anosAvaliados, mensagem;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.carregando = true;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__services_avaliacoesEstagioProbatorioService__["a" /* default */].lista(funcionarioId);

              case 4:
                anosAvaliados = _context.sent;

                if (anosAvaliados.length) {
                  _context.next = 9;
                  break;
                }

                _this.anosAvaliados = anosAvaliados;
                _this.carregando = false;
                return _context.abrupt('return');

              case 9:
                _context.next = 11;
                return _this.obtemAnosAvaliadosComTotalPendente(anosAvaliados);

              case 11:
                _this.anosAvaliados = _context.sent;

                _this.periodoAvaliacaoAnoAtual = _this.avaliacoesOrdenadas[0];

                _this.obtemContagemAvaliados(funcionarioId, _this.periodoAvaliacaoAnoAtual.id);
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_10__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context.t0);

                _this.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 20:
                _context.prev = 20;

                _this.carregando = false;
                return _context.finish(20);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 16, 20, 23]]);
      }))();
    },
    obtemContagemAvaliados: function obtemContagemAvaliados(funcionarioId, idMes) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var avaliador, mensagem;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.carregando = true;

                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_avaliadorEstagioProbatorioService__["a" /* default */].lista(funcionarioId, idMes);

              case 4:
                avaliador = _context2.sent;


                _this2.avaliador = avaliador;
                _context2.next = 15;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_10__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context2.t0);

                if (!(mensagem === 'Recurso não encontrado')) {
                  _context2.next = 14;
                  break;
                }

                _this2.avaliador.totalPendente = null;
                return _context2.abrupt('return');

              case 14:
                _this2.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 15:
                _context2.prev = 15;

                _this2.carregando = false;
                return _context2.finish(15);

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 8, 15, 18]]);
      }))();
    },
    obtemAnosAvaliadosComTotalPendente: function obtemAnosAvaliadosComTotalPendente(anosAvaliados) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var anos, anosAvaliadosAgrupados, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, ano, total;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                anos = [];
                anosAvaliadosAgrupados = _this3.apagaDuplicatas(anosAvaliados);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 5;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(anosAvaliadosAgrupados);

              case 7:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 17;
                  break;
                }

                ano = _step.value;
                _context3.next = 11;
                return __WEBPACK_IMPORTED_MODULE_8__services_avaliadorEstagioProbatorioService__["a" /* default */].lista(_this3.funcionario.id, ano.id);

              case 11:
                total = _context3.sent;

                ano.totalPendente = total.totalPendente;
                anos.push(ano);

              case 14:
                _iteratorNormalCompletion = true;
                _context3.next = 7;
                break;

              case 17:
                _context3.next = 23;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3['catch'](5);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 23:
                _context3.prev = 23;
                _context3.prev = 24;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 26:
                _context3.prev = 26;

                if (!_didIteratorError) {
                  _context3.next = 29;
                  break;
                }

                throw _iteratorError;

              case 29:
                return _context3.finish(26);

              case 30:
                return _context3.finish(23);

              case 31:
                return _context3.abrupt('return', anos);

              case 32:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[5, 19, 23, 31], [24,, 26, 30]]);
      }))();
    },
    editaAvaliacao: function editaAvaliacao(id, avaliacao) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var periodos, mensagem;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.validaPeriodoAindaNaoAbriu(avaliacao);

                _context4.next = 4;
                return _this4.obtemPeriodos(id, avaliacao);

              case 4:
                periodos = _context4.sent;

                if (!_this4.usuarioAtualEhAvaliador(periodos)) {
                  _context4.next = 8;
                  break;
                }

                _this4.redirecionaParaAvaliados();
                return _context4.abrupt('return');

              case 8:
                _this4.redirecionaParaDetalheAvaliacao(id);

                _context4.next = 18;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](0);
                mensagem = __WEBPACK_IMPORTED_MODULE_10__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context4.t0);

                if (!(_context4.t0.type === 'warning')) {
                  _context4.next = 17;
                  break;
                }

                _this4.$root.$refs.toastr.w(mensagem, 'Atenção');
                return _context4.abrupt('return');

              case 17:

                _this4.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 18:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 11]]);
      }))();
    },
    obtemPeriodos: function obtemPeriodos(id, avaliacao) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var periodos;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__services_periodosEstagioProbatorioService__["a" /* default */].lista(id, avaliacao.id);

              case 2:
                periodos = _context5.sent;

                _this5.periodos = periodos;
                sessionStorage.setItem('periodosEstagioProbatorio', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this5.periodos));
                return _context5.abrupt('return', periodos);

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    usuarioAtualEhAvaliador: function usuarioAtualEhAvaliador(periodos) {
      var _this6 = this;

      var avaliador = periodos.find(function (periodo) {
        return periodo.avaliado.id !== _this6.funcionario.id && (periodo.avaliador.id === _this6.funcionario.id || periodo.segundoAvaliador.id === _this6.funcionario.id);
      });

      return avaliador != null;
    },
    redirecionaParaAvaliados: function redirecionaParaAvaliados() {
      this.$router.push({
        name: 'AvaliadosEstagioProbatorio',
        params: { idAvaliador: this.funcionario.id }
      });
    },
    redirecionaParaDetalheAvaliacao: function redirecionaParaDetalheAvaliacao(id) {
      this.$router.push({
        name: 'DetalhaAvaliacaoEstagioProbatorio',
        params: {
          idAvaliador: this.funcionario.id,
          idAvaliado: id
        }
      });
    }
  },
  created: function created() {
    this.editaRegistro(this.funcionario.id);
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_4__components_botao___default.a,
    CardHeader: __WEBPACK_IMPORTED_MODULE_5__components_card_header___default.a,
    TableLoader: __WEBPACK_IMPORTED_MODULE_6__components_table_loader___default.a
  }
});

/***/ }),

/***/ "Obs4":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.carregando) ? _c('div', {
    staticClass: "text-center p-4"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-2x"
  }), _vm._v(" Carregando registros...\n  ")]) : [(!_vm.estahVazio(_vm.registros)) ? _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Atualização Cadastral por ano e mês")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.registros), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.anoCompetencia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.mesCompetencia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.situacao))]), _vm._v(" "), _c('td', [_c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Visualizar'),
        expression: "'Visualizar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar"
      },
      on: {
        "clicado": function($event) {
          return _vm.visualizar(item.id)
        }
      }
    })], 1)])
  }), 0)])])])])])])])]) : _c('pagina-erro', {
    attrs: {
      "titulo": "Atualização Cadastral Encerrada",
      "icone": "fa fa-hourglass-end",
      "imagemTexto": "centralservidor-logo-texto.png",
      "imagem": "centralservidor-logo.png",
      "texto": "O período de atualização cadastral se encerrou. Caso ainda precise atualizar seus dados, dirija-se ao DEGEPAT."
    }
  })]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ano")]), _vm._v(" "), _c('th', [_vm._v("Mês")]), _vm._v(" "), _c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])])
}]}

/***/ }),

/***/ "OhKN":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("anPr")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("8il0"),
  /* template */
  __webpack_require__("Tce3"),
  /* scopeId */
  "data-v-3326f377",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Onna":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Avaliados")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.periodosOrdenados), function(periodo) {
    return _c('tr', {
      key: periodo.id,
      class: _vm.situacaoPendente(periodo, 'class')
    }, [_c('td', [_vm._v(_vm._s(periodo.avaliado.pessoa.nome))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.mostraNota(periodo)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                        " + _vm._s(_vm.situacaoAtual(periodo) ?
      'EM ANDAMENTO' :
      'FINALIZADA') + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "td-btns td-btns-alone"
    }, [_c('botao', {
      attrs: {
        "estilo": _vm.situacaoPendente(periodo, 'estilo'),
        "icone": _vm.situacaoAtual(periodo) ?
          'editar-tabela' :
          'visualizar'
      },
      on: {
        "clicado": function($event) {
          return _vm.editaAvaliacao(periodo.avaliado.id)
        }
      }
    })], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 footer-controller-inner"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.volta()
      }
    }
  })], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Notas Atribuídas")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v(" ")])])])
}]}

/***/ }),

/***/ "P/VR":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('card-header', {
    attrs: {
      "titulo": "Avaliações Periódicas de Desempenho"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraMensagemDeSemAvaliacao),
      expression: "mostraMensagemDeSemAvaliacao"
    }],
    staticClass: "alert alert-danger",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle fa-lg"
  }), _vm._v("\n                    Caso não veja sua avaliação do ano de\n                  " + _vm._s(_vm.anoDaAvaliacaoAtual) + ", favor entrar em contato com o\n                  telefone 3213-7166 (DEGEPAT).\n                ")]), _vm._v(" "), _c('table-loader', {
    attrs: {
      "carregando": _vm.carregando
    }
  }, [(_vm.anosAvaliados.length == 0) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Ainda não foram\n                    geradas avaliações para o seu registro.\n                  ")]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Ano da Avaliação")]), _vm._v(" "), (_vm.ehAvaliador) ? _c('th', [_vm._v("Minha Avaliação")]) : _c('th', [_vm._v("Avaliação")]), _vm._v(" "), (_vm.ehAvaliador) ? _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("\n                          Avaliados Pendentes\n                        ")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.avaliacoesOrdenadas), function(avaliacao) {
    return _c('tr', {
      key: avaliacao.id,
      class: _vm.statusDaLinhaDaTabela(avaliacao)
    }, [_c('td', [_vm._v(_vm._s(avaliacao.ano))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusDaAvaliacao(avaliacao)) + "\n                        ")]), _vm._v(" "), (_vm.ehAvaliador) ? _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                          " + _vm._s(_vm.quantidadeDeAvaliacoesPorAvaliador(avaliacao)) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "td-btns td-btns-alone"
    }, [(_vm.ehAvaliador) ? _c('div', [_c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          _vm.condicionalDoBotaoDeAvaliador(avaliacao)
        ),
        expression: "\n                                condicionalDoBotaoDeAvaliador(avaliacao)\n                              "
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Editar'),
        expression: "'Editar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": _vm.statusDoBotao(avaliacao),
        "icone": "editar-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.editaAvaliacao(_vm.funcionario.id, avaliacao)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          !_vm.condicionalDoBotaoDeAvaliador(avaliacao)
        ),
        expression: "\n                                !condicionalDoBotaoDeAvaliador(avaliacao)\n                              "
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Visualizar'),
        expression: "'Visualizar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar"
      },
      on: {
        "clicado": function($event) {
          return _vm.editaAvaliacao(_vm.funcionario.id, avaliacao)
        }
      }
    })], 1) : _c('div', [_c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          _vm.condicionalDoBotaoComum(avaliacao, true)
        ),
        expression: "\n                                condicionalDoBotaoComum(avaliacao, true)\n                              "
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Editar'),
        expression: "'Editar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": _vm.statusDoBotao(avaliacao),
        "icone": "editar-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.editaAvaliacao(_vm.funcionario.id, avaliacao)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          _vm.condicionalDoBotaoComum(avaliacao, false)
        ),
        expression: "\n                                condicionalDoBotaoComum(avaliacao, false)\n                              "
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Visualizar'),
        expression: "'Visualizar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar"
      },
      on: {
        "clicado": function($event) {
          return _vm.editaAvaliacao(_vm.funcionario.id, avaliacao)
        }
      }
    })], 1)])])
  }), 0)])])], 1)], 1)])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ "PHgq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PPzv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__side_modal_vue__ = __webpack_require__("xyKs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__side_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__side_modal_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SideHome',

  props: {
    sides: {
      required: true,
      type: Array,
      default: [{
        titulo: 'Título',
        subtitulo: '',
        subtDetalhe: '',
        largura: 600,
        identidade: '',
        abreProximo: false,
        aberto: false
      }]
    }
  },
  data: function data() {
    return {
      largMinima: 0
    };
  },

  components: {
    'side-modal': __WEBPACK_IMPORTED_MODULE_0__side_modal_vue___default.a
  },
  methods: {
    minima: function minima(larg) {
      this.larguraMinima = larg + 50;
    },
    comparaSidesAbre: function comparaSidesAbre(side) {
      var _this = this;

      var largMinima = side.largura;
      var largAtual = 0;

      this.sides.reverse();
      this.sides.forEach(function (item) {
        largAtual = document.querySelector('#' + item.identidade).clientWidth;
        if (item.aberto && largAtual <= largMinima) {
          largMinima += 50;
          var prop = { id: item.identidade, larg: largMinima };
          _this.$emit('mostraMais', prop);
        }
      });
      this.sides.reverse();
    },
    comparaSidesFecha: function comparaSidesFecha(side) {
      var _this2 = this;

      var largAtual = 0;
      var largResult = 0;

      var abertos = this.sides.filter(function (item) {
        return item.aberto === true;
      });
      abertos.reverse();
      this.$emit('escondeMais', abertos[0]);
      abertos.splice(0, 1);

      abertos.forEach(function (item) {
        largAtual = document.querySelector('#' + item.identidade).clientWidth;

        if (item.largura !== largAtual && item.largura < largAtual) {
          _this2.largMinima > item.largura ? largResult = _this2.largMinima : largResult = item.largura;
          var prop = { id: item.identidade, larg: largResult };
          _this2.$emit('escondeMais', prop);
        } else {
          _this2.largMinima = item.largura + 50;
        }
      });
    },
    abreSide: function abreSide(side) {
      var index = this.sides.indexOf(side);
      if (index > 0) {
        this.comparaSidesAbre(side);
      }
      side.aberto = true;
      this.$emit('mostra', side.identidade);
    },
    fechaSide: function fechaSide(side) {
      this.$emit('esconde', side);
      this.fechaFromChild(side);
    },
    fechaFromChild: function fechaFromChild(side) {
      side.aberto = false;
      var index = this.sides.indexOf(side);
      if (index > 0) {
        this.comparaSidesFecha(side);
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.sides.forEach(function (side) {
      if (window.innerWidth < side.largura) side.largura = window.innerWidth;
    });
    this.$parent.$on('abreModal', function (identidade) {
      var index = _this3.sides.findIndex(function (item) {
        return item.identidade === identidade;
      });
      _this3.abreSide(_this3.sides[index]);
    });
    this.$parent.$on('fechaModal', function (identidade) {
      var index = _this3.sides.findIndex(function (item) {
        return item.identidade === identidade;
      });
      _this3.fechaSide(_this3.sides[index]);
    });
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "PhhY":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "side-modal"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aberto),
      expression: "aberto"
    }],
    attrs: {
      "id": "overlay"
    },
    on: {
      "click": function($event) {
        return _vm.fecha(_vm.id)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "side",
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "side-content"
  }, [_c('div', {
    staticClass: "side-header"
  }, [_c('div', {
    staticClass: "side-close",
    attrs: {
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.fecha(_vm.id)
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "side-title",
    attrs: {
      "id": (_vm.id + "-label")
    }
  }, [_vm._v(_vm._s(_vm.tit))])]), _vm._v(" "), _c('div', {
    staticClass: "side-subtitle",
    attrs: {
      "id": (_vm.id + "-sublabel")
    }
  }, [_vm._v(_vm._s(_vm.subtit) + "\n                "), _c('p', [_vm._v(_vm._s(_vm.subtDetl))])]), _vm._v(" "), _vm._t("default")], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-close-circle"
  }, [_c('div', {
    staticClass: "side-close-x"
  }, [_c('div', {
    staticClass: "side-close-x1"
  }), _vm._v(" "), _c('div', {
    staticClass: "side-close-x2"
  })])])
}]}

/***/ }),

/***/ "PhpC":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "finalizaModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "finalizaModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal",
      "dismiss": "modal"
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde",
      "rotulo": "Não",
      "icone": "fa-times fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.discorda()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Sim",
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.concorda()
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-lg-4 col-md-4 col-sm-4"
  }, [_c('label', [_vm._v("Nome:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.avaliado.pessoa.nome))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-1 col-md-1 col-sm-1"
  }, [_c('label', [_vm._v("Registro:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.avaliado.registroFormatado))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-2 col-md-2 col-sm-2"
  }, [_c('label', [_vm._v("Cargo:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.avaliado.cargoPrincipal))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
  }, [_c('label', [_vm._v("Período Avaliado:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.peridoAvaliacao))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-2 col-md-2 col-sm-2"
  }, [_c('label', [_vm._v("Número da Avaliação:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.numeroSequenciaAvaliacao))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(3), _vm._v(" "), (_vm.avaliacao.avaliador) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-lg-5 col-md-5 col-sm-5"
  }, [_c('label', [_vm._v("Nome:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.avaliador.pessoa.nome))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
  }, [_c('label', [_vm._v("Registro:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.avaliador.registroFormatado))])])]) : _c('div', {
    staticClass: "row"
  }, [_vm._m(4)])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(5), _vm._v(" "), (_vm.avaliacao.segundoAvaliador) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-lg-5 col-md-5 col-sm-5"
  }, [_c('label', [_vm._v("Nome:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.segundoAvaliador.pessoa.nome))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
  }, [_c('label', [_vm._v("Registro:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.segundoAvaliador.registroFormatado))])])]) : _c('div', {
    staticClass: "row"
  }, [_vm._m(6)])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(7), _vm._v(" "), _c('div', [_c('b', [_vm._v("Deduções ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-condensed hidden-xs"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "data-title": "Atrasos",
      "align": "left"
    }
  }, [_vm._v("\n                        (1 ponto por atraso)\n                      ")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-title": "Faltas",
      "align": "left"
    }
  }, [_vm._v("\n                        (3 pontos por falta)\n                      ")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-title": "Repreensões",
      "align": "left"
    }
  }, [_vm._v("\n                        (5 pontos por Repreensão)\n                      ")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-title": "Suspensões",
      "align": "left"
    }
  }, [_vm._v("\n                        (10 pontos por Suspensão)\n                      ")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-title": "Pontuação (A)",
      "align": "left"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.avaliacao.notaFichaFuncional) + "\n                      ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-condensed visible-xs"
  }, [_c('tbody', [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('tr', [_vm._m(13), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.avaliacao.notaFichaFuncional))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-3 col-xs-6"
  }, [_c('label', [_vm._v("Atrasos:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeAtrasos))]), _vm._v(" "), _c('label', [_vm._v("Deduções:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeDeducoesAtrasos))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-3 col-xs-6"
  }, [_c('label', [_vm._v("Faltas:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeFaltas))]), _vm._v(" "), _c('label', [_vm._v("Deduções:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeDeducoesFaltas))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-3 col-xs-6"
  }, [_c('label', [_vm._v("Repreensões:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeRepreensoes))]), _vm._v(" "), _c('label', [_vm._v("Deduções:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeDeducoesRepreensoes))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-3 col-xs-6"
  }, [_c('label', [_vm._v("Suspensões:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeSuspensoes))]), _vm._v(" "), _c('label', [_vm._v("Deduções:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeDeducoesSuspensoes))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-lg-5 col-md-5 col-sm-5"
  }, [_c('label', [_vm._v("Quantidade de horas cursadas pelo servidor:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.quantidadeHorasCursadas))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
  }, [_c('label', [_vm._v("PONTUAÇÃO (B):")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.avaliacao.notaHorasCursadas))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Avaliação de Desempenho")]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Parâmetros ")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-condensed hidden-xs"
  }, [_vm._m(16), _vm._v(" "), _c('tbody', _vm._l((_vm.notasOrdenadas), function(nota, index) {
    return _c('tr', {
      key: nota.id,
      class: {
        'has-error': _vm.errors.has('name' + index)
      }
    }, [_c('td', {
      attrs: {
        "data-title": "",
        "align": "left"
      }
    }, [_vm._v("\n                          " + _vm._s(nota.item.codigo) + "\n                        ")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Indicadores de Desempenho",
        "align": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(nota.item.titulo) + " ")]), _vm._v(" "), _c('esconde-div', [_vm._v(_vm._s(nota.item.descricao))])], 1), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Avaliador 1 (C)",
        "align": "left"
      }
    }, [(_vm.habilitaNotasPrimeiroAvaliador) ? _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (
          'required|numeric|min_value:1|max_value:10'
        ),
        expression: "\n                              'required|numeric|min_value:1|max_value:10'\n                            "
      }, {
        name: "model",
        rawName: "v-model",
        value: (nota.notaAvaliador),
        expression: "nota.notaAvaliador"
      }],
      attrs: {
        "type": "text",
        "size": "3",
        "name": 'notaC' + index,
        "id": 'notaC' + index,
        "data-vv-as": "Nota"
      },
      domProps: {
        "value": (nota.notaAvaliador)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(nota, "notaAvaliador", $event.target.value)
        }
      }
    }) : _c('span', [_vm._v(_vm._s(nota.notaAvaliador))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('notaC' + index)),
        expression: "errors.has('notaC' + index)"
      }],
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.errors.first('notaC' + index)))])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Avaliador 2 (D)",
        "align": "left"
      }
    }, [(_vm.habilitaNotasSegundoAvaliador) ? _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (
          'required|numeric|min_value:1|max_value:10'
        ),
        expression: "\n                              'required|numeric|min_value:1|max_value:10'\n                            "
      }, {
        name: "model",
        rawName: "v-model",
        value: (nota.notaSegundoAvaliador),
        expression: "nota.notaSegundoAvaliador"
      }],
      attrs: {
        "type": "text",
        "size": "3",
        "name": 'notaD' + index,
        "id": 'notaD' + index,
        "data-vv-as": "Nota"
      },
      domProps: {
        "value": (nota.notaSegundoAvaliador)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(nota, "notaSegundoAvaliador", $event.target.value)
        }
      }
    }) : _c('span', [_vm._v(_vm._s(nota.notaSegundoAvaliador))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('notaD' + index)),
        expression: "errors.has('notaD' + index)"
      }],
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.errors.first('notaD' + index)))])])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td'), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "12px"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.somaPrimeiroAvaliador) + "\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "12px"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.somaSegundoAvaliador) + "\n                        ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-condensed visible-xs"
  }, [_vm._m(18), _vm._v(" "), _c('tbody', _vm._l((_vm.notasOrdenadas), function(nota, index) {
    return _c('tr', {
      key: nota.id,
      class: {
        'has-error': _vm.errors.has('name' + index)
      }
    }, [_c('td', {
      attrs: {
        "data-title": "",
        "align": "left"
      }
    }, [_vm._v("\n                          " + _vm._s(nota.item.codigo) + "\n                        ")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Indicadores de Desempenho",
        "align": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(nota.item.titulo) + " ")]), _vm._v(" "), _c('esconde-div', [_vm._v(_vm._s(nota.item.descricao))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_c('p', [_vm._v("Avaliador (C)")]), _vm._v(" "), (_vm.habilitaNotasPrimeiroAvaliador) ? _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (
          'required|numeric|min_value:1|max_value:10'
        ),
        expression: "\n                                  'required|numeric|min_value:1|max_value:10'\n                                "
      }, {
        name: "model",
        rawName: "v-model",
        value: (nota.notaAvaliador),
        expression: "nota.notaAvaliador"
      }],
      attrs: {
        "type": "number",
        "name": 'notaC' + index,
        "id": "notaC",
        "data-vv-as": "Nota"
      },
      domProps: {
        "value": (nota.notaAvaliador)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(nota, "notaAvaliador", $event.target.value)
        }
      }
    }) : _c('span', [_vm._v(_vm._s(nota.notaAvaliador))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('notaC' + index)),
        expression: "errors.has('notaC' + index)"
      }],
      staticClass: "error"
    }, [_vm._v("\n                                " + _vm._s(_vm.errors.first('notaC' + index)))])]), _vm._v(" "), _c('div', {
      staticClass: "item"
    }, [_c('p', [_vm._v("Avaliador (D)")]), _vm._v(" "), (_vm.habilitaNotasSegundoAvaliador) ? _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (
          'required|numeric|min_value:1|max_value:10'
        ),
        expression: "\n                                  'required|numeric|min_value:1|max_value:10'\n                                "
      }, {
        name: "model",
        rawName: "v-model",
        value: (nota.notaSegundoAvaliador),
        expression: "nota.notaSegundoAvaliador"
      }],
      attrs: {
        "type": "number",
        "name": 'notaD' + index,
        "id": "notaC",
        "data-vv-as": "Nota"
      },
      domProps: {
        "value": (nota.notaSegundoAvaliador)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(nota, "notaSegundoAvaliador", $event.target.value)
        }
      }
    }) : _c('span', [_vm._v(_vm._s(nota.notaSegundoAvaliador))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('notaD' + index)),
        expression: "errors.has('notaD' + index)"
      }],
      staticClass: "error"
    }, [_vm._v("\n                                " + _vm._s(_vm.errors.first('notaD' + index)))])])])], 1)])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('b', [_vm._v("TOTAL DE PONTOS: ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', [_vm._v("Avaliador (C)")]), _vm._v("\n                              " + _vm._s(_vm.somaPrimeiroAvaliador) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', [_vm._v("Avaliador (D)")]), _vm._v("\n                              " + _vm._s(_vm.somaSegundoAvaliador) + "\n                            ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-lg-4 col-md-4 col-sm-4"
  }, [_c('label', [_vm._v("MÉDIA (M) = (C + D) /2:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.mediaAvaliacoes))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-4 col-md-4 col-sm-4"
  }, [_c('label', [_vm._v("PONTUAÇÃO FINAL (A + B + M):")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.pontuacaoFinal))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-4 col-md-4 col-sm-4"
  }, [_c('label', [_vm._v("Data da Avaliação")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dataAvaliacao))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Ciência do Servidor Avaliado")]), _vm._v(" "), _vm._m(19), _vm._v(" "), (_vm.avaliacao.aceita == true || _vm.avaliacao.aceita == false) ? _c('div', {
    staticClass: "col-lg-offset-2 col-lg-8 col-md-offset-2 col-md-8"
  }, [_c('div', {
    staticClass: "card sub-card sub-card-content"
  }, [_c('div', {
    staticClass: "anuencia"
  }, [_vm._v("\n                    Servidor avaliado\n                    "), _c('span', {
    staticClass: "anuencia-resultado"
  }, [_vm._v(_vm._s(_vm.avaliacao.aceita ? 'CONCORDA' : 'NÃO CONCORDA'))]), _vm._v("\n                    com a pontuação final.\n                  ")])])]) : _c('p')])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.voltar()
      }
    }
  }), _vm._v(" "), (_vm.mostraFinalizar) ? _c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Anuência",
      "icone": "fa-check fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.valida('finalizar')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mostraSalvar) ? _c('botao', {
    attrs: {
      "estilo": _vm.mostraFinalizar ? 'vazado-verde-dir' : 'cheio-verde-dir',
      "rotulo": "Salvar",
      "icone": "fa-floppy-o fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.valida('salvar')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: (
        'Visual. impres. finalizadas com Concordo ou Discordo'
      ),
      expression: "\n              'Visual. impres. finalizadas com Concordo ou Discordo'\n            ",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "disabled-tooltip"
  }, [(_vm.mostraImprimir) ? _c('botao', {
    attrs: {
      "estilo": _vm.ehAvaliador ? 'vazado-verde-dir' : 'cheio-verde-dir',
      "rotulo": "Imprimir",
      "icone": "imprimir-tabela",
      "disabled": (_vm.avaliacaoFinalizada || _vm.ehAvaliador || _vm.naoFinalizadoComPeriodoEncerrado) ? false : true
    },
    on: {
      "clicado": function($event) {
        return _vm.imprime(_vm.avaliacao.id)
      }
    }
  }) : _vm._e()], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "finalizaModalLabel"
    }
  }, [_vm._v("\n              Finalizar Avaliação\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Você concorda com o resultado da sua avaliação?\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("Funcionário "), _c('small', [_vm._v("(Avaliado)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("Chefe Imediato "), _c('small', [_vm._v("(Avaliador 1)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group col-lg-5 col-md-5 col-sm-5"
  }, [_c('p', [_vm._v("Não existe avaliador cadastrado!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("Chefe Imediato "), _c('small', [_vm._v("(Avaliador 2)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group col-lg-5 col-md-5 col-sm-5"
  }, [_c('p', [_vm._v("Não existe avaliador cadastrado!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("\n                Avaliação de Ficha Funcional "), _c('small', [_vm._v("(Preenchido pelo DEGEPAT)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Atrasos")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Faltas")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Repreensões")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Suspensões")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Pontuação (A)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Atrasos")]), _vm._v(" "), _c('td', [_vm._v("(1 ponto por atraso)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Faltas")]), _vm._v(" "), _c('td', [_vm._v("(3 pontos por falta)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Repreensões")]), _vm._v(" "), _c('td', [_vm._v("(5 pontos por Repreensão)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Suspensões")]), _vm._v(" "), _c('td', [_vm._v("(10 pontos por Suspensão)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Pontuação (A)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("\n                Formação continuada "), _c('small', [_vm._v("(Preenchido pelo DEGEPAT)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped table-condensed hidden-xs"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Plenamente Insatisfatório")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Insatisfatório")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Regular")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Satisfatório")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Plenamente Satisfatório")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "data-title": "Plenamente Insatisfatório",
      "align": "left"
    }
  }, [_vm._v("\n                          (1-2 pontos)\n                        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-title": "Insatisfatório",
      "align": "left"
    }
  }, [_vm._v("\n                          (3-4 pontos)\n                        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-title": "Regular",
      "align": "left"
    }
  }, [_vm._v("\n                          (5-6 pontos)\n                        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-title": "Satisfatório",
      "align": "left"
    }
  }, [_vm._v("\n                          (7-8 pontos)\n                        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-title": "Plenamente Satisfatório",
      "align": "left"
    }
  }, [_vm._v("\n                          (9-10 pontos)\n                        ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-condensed visible-xs"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Plenamente Insatisfatório")]), _vm._v(" "), _c('td', [_vm._v("(1-2 pontos)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Insatisfatório")]), _vm._v(" "), _c('td', [_vm._v("(3-4 pontos)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Regular")]), _vm._v(" "), _c('td', [_vm._v("(5-6 pontos)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Satisfatório")]), _vm._v(" "), _c('td', [_vm._v("(7-8 pontos)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Plenamente Satisfatório")]), _vm._v(" "), _c('td', [_vm._v("(9-10 pontos)")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "135px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('span', [_vm._v("Avaliador 1 (C)")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "135px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('span', [_vm._v("Avaliador 2 (D)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("TOTAL DE PONTOS DO AVALIADOR (C) E DO AVALIADOR 2 (D):\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_c('span', [_vm._v("Indicadores de Desempenho")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                    Em caso de discordância, o servidor avaliado deverá abrir processo digital \n                    de Recurso de Notas de Avaliação, em até 10 (dez) \n                    dias úteis contados a partir da ciência da nota.\n                  ")])])])
}]}

/***/ }),

/***/ "PvXa":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./LogoPMS.png": "e78A",
	"./LogoXs.jpg": "ZDE/",
	"./SshdLogo.png": "y0j6",
	"./brasao-pms.png": "8ZOn",
	"./centralservidor-logo-texto.png": "VQf9",
	"./centralservidor-logo.png": "d1MV",
	"./favicon.ico": "43FW",
	"./ico-contagem.png": "lIAz",
	"./ico-ferias.png": "u1pV",
	"./ico-holerites.png": "9TPg",
	"./ico-ocorrencias.png": "A0xF",
	"./ico-previdenciario.png": "mLKy",
	"./textura-papel-reciclado.jpg": "v6Um"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";

/***/ }),

/***/ "QkBs":
/***/ (function(module, exports) {

module.exports = [{"id":1,"periodoAquisitivo":2021,"registro":"12.445-2","nome":"José Agripino Amarantes dos Anjos","lotacao":"SEMAPRO","dataInicioFerias":"2021-04-11","statusAprovacao":"APROVADA"},{"id":2,"periodoAquisitivo":2020,"registro":"23.945-2","nome":"Maria Galdino Siqueira","lotacao":"SEMAPRO","dataInicioFerias":"2021-07-19","statusAprovacao":"REPROVADA"},{"id":8,"periodoAquisitivo":2021,"registro":"44.733-2","nome":"Albânia Velasquez Paparrazzi","lotacao":"SEPAI","dataInicioFerias":null,"statusAprovacao":"PENDENTE"},{"id":9,"periodoAquisitivo":2020,"registro":"19.449-8","nome":"Cícero de Andrade de Oliveira","lotacao":"SEPAI","dataInicioFerias":"2020-12-22","statusAprovacao":"EM_ANALISE"},{"id":12,"periodoAquisitivo":2020,"registro":"23.945-2","nome":"Maria Galdino Siqueira","lotacao":"SEMAPRO","dataInicioFerias":null,"statusAprovacao":"PENDENTE"},{"id":5,"periodoAquisitivo":2020,"registro":"19.449-8","nome":"Márcio de Andrade de Oliveira","lotacao":"SEPAI","dataInicioFerias":"2020-12-22","statusAprovacao":"EM_ANALISE"},{"id":7,"periodoAquisitivo":2020,"registro":"14.569-8","nome":"Maria Magalhães Santouro","lotacao":"SEMAPRO","dataInicioFerias":"2021-10-12","statusAprovacao":"EM_ANALISE"}]

/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("ufme");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__env__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_store__ = __webpack_require__("YtJ0");



/* harmony default export */ __webpack_exports__["a"] = ({
  sistema: {
    nome: 'Central do Servidor',
    sigla: 'Central',
    descricao: 'Tudo para o servidor num só lugar.'
  },

  isAuthenticated: !!__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.token,
  publicPath: __WEBPACK_IMPORTED_MODULE_0__env___default.a.publicPath,
  apiUrl: __WEBPACK_IMPORTED_MODULE_0__env___default.a.apiUrl,
  apiEnderecoUrl: __WEBPACK_IMPORTED_MODULE_0__env___default.a.apiEnderecoUrl,
  staticUrl: __WEBPACK_IMPORTED_MODULE_0__env___default.a.staticUrl
});

/***/ }),

/***/ "R583":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "conteudo"
    }
  }, [_c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "problemaAcessoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "problemaAcessoModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal",
      "dismiss": "modal"
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Abrir SAU",
      "icone": "fa-external-link"
    },
    on: {
      "clicado": function($event) {
        return _vm.abreSau()
      }
    }
  })], 1)])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('section', {
    attrs: {
      "role": "login"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-offset-1 col-md-5 col-lg-offset-2 col-lg-4",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "card card-banner",
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "container container-login"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.valida($event)
      }
    }
  }, [_c('div', {
    staticClass: "container container-input container-input-text"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("SSHD")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8|max:8'),
      expression: "'required|min:8|max:8'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.username),
      expression: "usuario.username"
    }],
    staticClass: "form-control-credential",
    class: _vm.errorInputUsername,
    attrs: {
      "type": "text",
      "name": "username",
      "data-vv-as": "SSHD",
      "value": "",
      "id": "username",
      "placeholder": "sshd",
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.usuario.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errors.first('username')))])])]), _vm._v(" "), _c('div', {
    staticClass: "container container-input container-input-text",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Senha")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.password),
      expression: "usuario.password"
    }],
    staticClass: "form-control-credential",
    class: _vm.errorInputPassword,
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": "senha",
      "data-vv-as": "Senha"
    },
    domProps: {
      "value": (_vm.usuario.password)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkCapsLock($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-addon-right",
    on: {
      "click": function($event) {
        return _vm.mostraSenha()
      }
    }
  }, [(_vm.senhaVisivel) ? _c('i', {
    staticClass: "fa fa-eye-slash fa-lg"
  }) : _c('i', {
    staticClass: "fa fa-eye fa-lg"
  })])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])]), _vm._v(" "), _vm._m(7)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-5 col-lg-6"
  }, [_c('div', {
    staticClass: "card card-default",
    attrs: {
      "id": "login-description"
    }
  }, [_c('h3', [_vm._v("Links Informativos")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h3', [_vm._v("Adição de documento")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', [_vm._v("\n              Clique para acessar:\n              "), _c('div', {
    staticClass: "contain-link"
  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('declaracao-ausencia.doc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Declaração de Comparecimento\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('ANEXO I - O.S. 001-2022-GPM - VERBA TRANSPORTE - SOLICITAÇÃO.doc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Verba Transporte - Solicitação\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('ANEXO II - O.S. 001-2022-GPM - VERBA TRANSPORTE - DESCRIÇÃO DE CONSUMO.xls')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Verba Transporte - Descrição De Consumo\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('manual-ferias.pdf')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Manual do Agendamento de Férias\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('manual-de-procedimentos.pdf')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Manual de Procedimentos DEGEPAT\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('manual-de-especificacoes-tecnicas-de-epi.pdf')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Manual de Especificações Técnicas de EPI\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('cartilha_capep.pdf')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cartilha de Informações da CAPEP\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('artemis_consignado.pdf')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Manual do Sistema Artemis Versão Mobile\n                      (Consignado)\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('documento_basico_e_orientativo_sobre_pgr.pdf')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Documento Básico e Orientativo sobre PGR\n                      ")])])])])])]), _vm._v(" "), _c('h3', [_vm._v("Esqueceu sua Senha?")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('p')])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "problemaAcessoModalLabel"
    }
  }, [_vm._v("\n              Problemas de Acesso\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Você digitou suas credenciais com algum erro por 3 vezes\n                  seguidas.\n                ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Por favor,\n                  "), _c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/sau/",
      "target": "blank"
    }
  }, [_vm._v("\n                    abra um SAU")]), _vm._v("\n                  contando-nos que está com problema de acesso e faremos os\n                  ajustes necessários.\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "banner"
    }
  }, [_c('div', {
    staticClass: "page-header-bg logo-login hidden-xs",
    attrs: {
      "id": "header-bg-login"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-input",
    staticStyle: {
      "font-size": "26px",
      "font-weight": "bold",
      "padding-top": "7px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "58px",
      "vertical-align": "bottom"
    },
    attrs: {
      "src": __webpack_require__("y0j6"),
      "alt": "Logotipo SSHD"
    }
  }), _vm._v("\n                SSHD\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-input"
  }, [_vm._v("\n                Entre com sua conta da prefeitura\n                "), _c('br'), _vm._v("para acessar o sistema\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-addon"
  }, [_c('i', {
    staticClass: "fa fa-user fa-fw fa-lg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock fa-fw fa-lg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-input"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                    Login\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n              Clique para acessar:\n              "), _c('div', {
    staticClass: "contain-link"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-usd",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Holerite\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/legis/documents/55",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Estatuto\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://app.pmsantos.lecom.com.br/bpm",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                    Processos Digitais\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Informe IR\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/sigm_web_adm_sistema",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-stethoscope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                     Perícia Médica\n                  ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://entrega.santos.sp.gov.br",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Entrega\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=pdymO6b7jCg&feature=youtu.be",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube-play",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Manual Entrega\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/websshd",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Trocar Senha\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('p', [_vm._v("Para redefinição e geração de uma nova senha temporária, procure o "), _c('strong', [_vm._v("Gestor de SSHD/Senhas")]), _vm._v(" de sua Unidade.")]), _vm._v(" "), _c('strong', [_vm._v("Suporte técnico:")]), _vm._v(" (13) 3213-2755\n              ")])])
}]}

/***/ }),

/***/ "RLyq":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("ottn"),
  /* template */
  __webpack_require__("F6RG"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "RTVR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_card_header__ = __webpack_require__("8KSN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_card_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_card_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_table_loader__ = __webpack_require__("pKzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_table_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_table_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_support_sample_data_feriasAgendadas__ = __webpack_require__("QkBs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_support_sample_data_feriasAgendadas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_support_sample_data_feriasAgendadas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_support_sample_data_maisFeriasAgendadas__ = __webpack_require__("dC5d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_support_sample_data_maisFeriasAgendadas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_support_sample_data_maisFeriasAgendadas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_ferias_agendamento__ = __webpack_require__("sXEj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_DateHelper_js__ = __webpack_require__("9t/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_ErrorHelper__ = __webpack_require__("+h9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_obtemImpressao__ = __webpack_require__("8QDf");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Aprovacao',

  data: function data() {
    return {
      apiErrors: null,
      carregando: true,
      funcionario: {},
      periodoAquisitivo: '',
      agendamentos: [],
      agendamentosDaApi: [],
      statusDefault: 'APROVADA,REPROVADA,EM_ANALISE,PENDENTE,MARCADA,SEGUNDA_APROVACAO',
      resultadoDaBusca: [],
      filter: {
        uor: '',
        status: ''
      },
      comboStatus: [],
      comboUors: [],
      paginacao: {
        ultimo: false,
        numero: 0
      }
    };
  },

  filters: {
    descricaoStatus: function descricaoStatus(status) {
      var descricao = status;

      switch (status) {
        case 'EM_ANALISE':
          descricao = 'EM ANÁLISE';break;
        case 'SEGUNDA_APROVACAO':
          descricao = 'SEGUNDA APROVAÇÃO';break;
        case 'MARCADA':
          descricao = 'MARCADA/GOZADA';break;
      }

      return descricao;
    }
  },
  computed: {
    temMultiplasUors: function temMultiplasUors() {
      return this.comboUors && this.comboUors.length > 1;
    },
    temMultiplosAnos: function temMultiplosAnos() {
      var anos = this.agendamentos.map(function (item) {
        return item.ano;
      }).filter(function (item, index, array) {
        return array.indexOf(item) === index;
      });

      return anos && anos.length > 1;
    },
    usuarioAtual: function usuarioAtual() {
      return this.$store.state.funcionario;
    },
    usuarioLogado: function usuarioLogado() {
      return this.$store.state.usuarioLogado;
    }
  },
  watch: {
    usuarioAtual: function usuarioAtual(novo, anterior) {
      this.funcionario = novo;
      this.listaAgendamentosNaTela(novo);
    }
  },
  methods: {
    desabilitaAprovacaoOuReprovacao: function desabilitaAprovacaoOuReprovacao(ferias) {
      var esperandoDuplaAprovacao = ferias.statusAprovacao === 'SEGUNDA_APROVACAO' && (ferias.idFuncionarioResponsavel == this.funcionario.id || ferias.idFuncionarioResponsavelSegundo == this.funcionario.id);

      return ferias.statusAprovacao === 'APROVADA' || ferias.statusAprovacao === 'PENDENTE' || ferias.statusAprovacao === 'REPROVADA' || ferias.statusAprovacao === 'MARCADA' || esperandoDuplaAprovacao;
    },


    // Métodos de input
    imprime: function imprime(funcionarioId, filter) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endPoint, uor, status, params, mensagem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endPoint = 'agendamentos-ferias/relatorio';
                uor = filter.uor, status = filter.status;
                params = {
                  idFuncionarioResponsavel: funcionarioId,
                  idUnidadeOrganizacional: uor && uor.id,
                  status: status ? status.name : _this.statusDefault
                };
                _context.prev = 3;
                _context.next = 6;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__services_obtemImpressao__["a" /* default */])(endPoint, params);

              case 6:
                _context.next = 13;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](3);
                mensagem = __WEBPACK_IMPORTED_MODULE_10__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context.t0);

                if (mensagem === 'Desbloqueie as pop-ups para este site') {
                  _this.$root.$refs.toastr.w(mensagem, 'Pop-up bloqueada');
                }
                _this.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 8]]);
      }))();
    },
    reprovar: function reprovar(ferias) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var bloqueiaPorDataLancamento, reprovaTodas, mensagemTodas, mensagemSimples, sentences;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.bloqueiaPorDataLancamento();

              case 2:
                bloqueiaPorDataLancamento = _context3.sent;

                if (!bloqueiaPorDataLancamento) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt('return');

              case 5:
                reprovaTodas = _this2.validaReprovaAnteriorEPosterior(ferias);
                mensagemTodas = 'Para evitar conflitos de reagendamento, n\xE3o aprovar as f\xE9rias de ' + (ferias.ano + ' reprovar\xE1, automaticamente, as f\xE9rias de ') + (ferias.ano + 1 + '. Deseja reprovar o agendamento escolhido?');
                mensagemSimples = 'Deseja reprovar a data escolhida pelo servidor?';
                sentences = [{
                  id: 1,
                  message: reprovaTodas ? mensagemTodas : mensagemSimples,
                  bold: true
                }];


                _this2.$root.$refs.modal.confirm(sentences, {
                  yes: function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                      var agendamento, agendamentoParaEnvio, response;
                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              agendamento = _this2.agendamentosDaApi.find(function (agendamento) {
                                return agendamento.id === ferias.id;
                              });
                              agendamentoParaEnvio = _this2.mapeiaAgendamentoParaEnvio(agendamento, 'REPROVADA');
                              _context2.next = 4;
                              return _this2.gravaStatusEscolhido(agendamentoParaEnvio, _this2.funcionario.id);

                            case 4:
                              response = _context2.sent;


                              _this2.buscaFeriasAgendadas(_this2.funcionario, _this2.filter);

                            case 6:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this2);
                    }));

                    return function yes() {
                      return _ref.apply(this, arguments);
                    };
                  }(),
                  title: 'Reprovar Agendamento'
                });

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    aprovar: function aprovar(ferias) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var bloqueiaPorDataLancamento, mensagem, sentences;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this3.bloqueiaPorDataLancamento();

              case 2:
                bloqueiaPorDataLancamento = _context5.sent;

                if (!bloqueiaPorDataLancamento) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt('return');

              case 5:
                mensagem = 'Deseja aprovar a data escolhida pelo servidor?';


                if (ferias.possuiDiasPendentes) {
                  mensagem = "Este servidor possui dias pendentes que devem ser gozados antes do " + "gozo das próximas férias regulares. Deseja prosseguir com a aprovação?";
                }

                sentences = [{
                  id: 1,
                  message: mensagem,
                  bold: true
                }];


                _this3.$root.$refs.modal.confirm(sentences, {
                  yes: function () {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
                      var agendamento, agendamentoParaEnvio, response;
                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              agendamento = _this3.agendamentosDaApi.find(function (agendamento) {
                                return agendamento.id === ferias.id;
                              });
                              agendamentoParaEnvio = _this3.mapeiaAgendamentoParaEnvio(agendamento, 'APROVADA');
                              _context4.next = 4;
                              return _this3.gravaStatusEscolhido(agendamentoParaEnvio, _this3.funcionario.id);

                            case 4:
                              response = _context4.sent;


                              _this3.atualizaFeriasNaTela(ferias, response);

                            case 6:
                            case 'end':
                              return _context4.stop();
                          }
                        }
                      }, _callee4, _this3);
                    }));

                    return function yes() {
                      return _ref2.apply(this, arguments);
                    };
                  }(),
                  title: 'Aprovar Agendamento'
                });

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this3);
      }))();
    },
    listaMaisResultados: function listaMaisResultados(funcionario, filter) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var uor, status, pagina, params, botaoMaisResultados;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                uor = filter.uor, status = filter.status;
                pagina = _this4.paginacao.numero + 1;
                params = {
                  idFuncionarioResponsavel: funcionario.id,
                  idUnidadeOrganizacional: uor && uor.id,
                  status: status ? status.name : _this4.statusDefault,
                  page: pagina,
                  size: 50
                };
                _context6.next = 5;
                return _this4.listaAgendamentos(funcionario, params, 'mais resultados');

              case 5:
                botaoMaisResultados = document.querySelector('#mais-resultados');

                botaoMaisResultados && botaoMaisResultados.scrollIntoView({ behavior: 'smooth' });

              case 7:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this4);
      }))();
    },
    buscaFeriasAgendadas: function buscaFeriasAgendadas(funcionario, filter) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var uor, status, params;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this5.carregando = true;

                uor = filter.uor, status = filter.status;
                params = {
                  idFuncionarioResponsavel: funcionario.id,
                  idUnidadeOrganizacional: uor && uor.id,
                  status: status ? status.name : _this5.statusDefault,
                  size: 50
                };
                _context7.next = 5;
                return _this5.listaAgendamentos(funcionario, params, 'filtrados');

              case 5:

                _this5.carregando = false;

              case 6:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this5);
      }))();
    },


    // Métodos de validações
    verificaSeEhAprovador: function verificaSeEhAprovador() {
      if (this.usuarioLogado.perfis) {
        return this.usuarioLogado.perfis.includes('APROVADOR_AGENDAMENTO_FERIAS');
      }

      return false;
    },
    bloqueiaSeNaoEhAprovador: function bloqueiaSeNaoEhAprovador() {
      var ehResponsavelAprovador = this.verificaSeEhAprovador();

      if (!ehResponsavelAprovador) {
        this.$router.push({ name: 'SemAcesso' });
        return true;
      }

      return false;
    },
    bloqueiaPorDataLancamento: function bloqueiaPorDataLancamento() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var endPointPeriodos, response, periodoEstahFechado;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                endPointPeriodos = 'agendamentos-ferias/funcionarios/' + _this6.funcionario.id + '/competencias';
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].get(endPointPeriodos);

              case 3:
                response = _context8.sent;
                periodoEstahFechado = !__WEBPACK_IMPORTED_MODULE_11_moment___default()().isBetween(response.periodos[0].dataInicioLancamento, response.periodos[0].dataFimLancamento, 'day', '[]');

                if (!periodoEstahFechado) {
                  _context8.next = 8;
                  break;
                }

                _this6.$root.$refs.toastr.w('Período de aprovação de férias fechado', 'Atenção');
                return _context8.abrupt('return', true);

              case 8:
                return _context8.abrupt('return', false);

              case 9:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this6);
      }))();
    },


    // Métodos de requisição
    listaAgendamentos: function listaAgendamentos(funcionario, parametros, tipoDeResultado) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var endPoint, queryParams, response, agendamentosMapeados, agendamentosOrdenados;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                endPoint = 'agendamentos-ferias';
                queryParams = { params: parametros };
                _context9.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].get(endPoint, queryParams);

              case 5:
                response = _context9.sent;
                agendamentosMapeados = _this7.mapeiaAgendamentos(response.content);
                agendamentosOrdenados = _this7.ordenaFeriasListadas(agendamentosMapeados);


                if (tipoDeResultado === 'mais resultados') {
                  _this7.agendamentos = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this7.agendamentos), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(agendamentosOrdenados));
                  _this7.agendamentosDaApi = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this7.agendamentosDaApi), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.content));
                } else {
                  _this7.agendamentosDaApi = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.content));
                  _this7.agendamentos = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(agendamentosOrdenados));
                }

                _this7.paginacao.ultimo = response.last;
                _this7.paginacao.numero = response.number;
                _context9.next = 17;
                break;

              case 13:
                _context9.prev = 13;
                _context9.t0 = _context9['catch'](0);

                _this7.$root.$refs.toastr.e(_context9.t0.data[0].message, 'Atenção');
                _this7.carregando = false;

              case 17:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this7, [[0, 13]]);
      }))();
    },
    listaStatus: function listaStatus() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var endPoint, situacoes, situacoesOrdenadas;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                endPoint = 'agendamentos-ferias/status-aprovacoes';
                _context10.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].get(endPoint);

              case 3:
                situacoes = _context10.sent;
                situacoesOrdenadas = _this8.ordenaStatus(situacoes);


                _this8.comboStatus = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(situacoesOrdenadas));

              case 6:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this8);
      }))();
    },
    obtemMesCompetencia: function obtemMesCompetencia(funcionarioId) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var endPointCompetencias, competencia, message;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                endPointCompetencias = 'agendamentos-ferias/funcionarios/' + funcionarioId + '/competencias';
                _context11.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].get(endPointCompetencias);

              case 4:
                competencia = _context11.sent;

                if (competencia.id) {
                  _context11.next = 8;
                  break;
                }

                _this9.$root.$refs.toastr.e('Não encontramos os dados do mês que ' + 'compete ao agendamento. Por favor, avise ao DETIC sobre essa mensagem', 'Atenção');

                return _context11.abrupt('return');

              case 8:
                if (competencia.acessaAgendamento) {
                  _context11.next = 12;
                  break;
                }

                _this9.$router.push({ name: 'UorNaoParticipante' });
                _this9.usuarioValido = false;

                return _context11.abrupt('return');

              case 12:

                _this9.periodoAquisitivo = competencia.ano;

                return _context11.abrupt('return', competencia);

              case 16:
                _context11.prev = 16;
                _context11.t0 = _context11['catch'](0);
                message = _context11.t0.data[0].message;

                if (!(message === 'Funcionário não localizado ou acesso negado')) {
                  _context11.next = 23;
                  break;
                }

                _this9.$router.push({ name: 'UorNaoParticipante' });
                _this9.usuarioValido = false;
                throw _context11.t0;

              case 23:
                if (!(message === 'Agendamento de Férias está fechado para lançamento')) {
                  _context11.next = 28;
                  break;
                }

                _this9.carregandoAprovador = false;
                _this9.escondeAprovador = true;
                _this9.$router.push({ name: 'PeriodoEncerrado' });
                throw _context11.t0;

              case 28:

                _this9.$root.$refs.toastr.e(message, 'Atenção');

              case 29:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this9, [[0, 16]]);
      }))();
    },
    listaUors: function listaUors(funcionarioId) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var competencia, endPoint, uors, uorsOrdenadas;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return _this10.obtemMesCompetencia(funcionarioId);

              case 3:
                competencia = _context12.sent;
                endPoint = '/agendamentos-ferias/funcionarios/' + funcionarioId + ('/competencias/' + competencia.id + '/unidades-organizacionais');
                _context12.next = 7;
                return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].get(endPoint);

              case 7:
                uors = _context12.sent;
                uorsOrdenadas = _this10.ordenaUors(uors);


                _this10.comboUors = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(uorsOrdenadas));
                _context12.next = 15;
                break;

              case 12:
                _context12.prev = 12;
                _context12.t0 = _context12['catch'](0);

                _this10.$root.$refs.toastr.e(_context12.t0.data[0].message, 'Atenção');

              case 15:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this10, [[0, 12]]);
      }))();
    },
    gravaStatusEscolhido: function gravaStatusEscolhido(agendamento, funcionarioId) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var endPoint, queryParams, response, mensagem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                endPoint = 'agendamentos-ferias/' + agendamento.id;
                queryParams = {
                  params: {
                    idFuncionarioResponsavel: funcionarioId
                  }
                };
                _context13.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].put(endPoint, agendamento, queryParams);

              case 5:
                response = _context13.sent;
                mensagem = '';


                if (response.statusAprovacao === 'SEGUNDA_APROVACAO') {
                  mensagem = 'É necessário mais uma aprovação para este funcionário';
                } else if (agendamento.statusAprovacao === 'APROVADA') {
                  mensagem = 'Aprovação registrada';
                } else {
                  mensagem = 'Reprovação registrada';
                }

                _this11.$root.$refs.toastr.s(mensagem, 'Sucesso');

                return _context13.abrupt('return', response);

              case 12:
                _context13.prev = 12;
                _context13.t0 = _context13['catch'](0);

                _this11.$root.$refs.toastr.e(_context13.t0.data[0].message, 'Atenção');

              case 15:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this11, [[0, 12]]);
      }))();
    },


    // Outros métodos
    listaAgendamentosNaTela: function listaAgendamentosNaTela(funcionario) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!_this12.bloqueiaSeNaoEhAprovador()) {
                  _context14.next = 2;
                  break;
                }

                return _context14.abrupt('return');

              case 2:

                _this12.carregando = true;

                params = {
                  idFuncionarioResponsavel: funcionario.id,
                  status: _this12.statusDefault,
                  size: 50
                };
                _context14.next = 6;
                return _this12.listaAgendamentos(funcionario, params, 'primeira tela');

              case 6:

                _this12.carregando = false;

              case 7:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this12);
      }))();
    },
    mapeiaAgendamentos: function mapeiaAgendamentos(agendamentos) {
      var feriasMapeadas = [];

      agendamentos.map(function (agendamento) {
        var ferias = new __WEBPACK_IMPORTED_MODULE_8__domain_ferias_agendamento__["a" /* default */](agendamento.id, agendamento.periodoAquisitivo.funcionario.nome, agendamento.periodoAquisitivo.possuiDiasPendentes, agendamento.periodoAquisitivo.funcionario.unidadeOrganizacional.sigla, agendamento.periodoAquisitivo.competencia.ano, agendamento.dataInicio, agendamento.statusAprovacao, agendamento.responsavelAprovacao ? agendamento.responsavelAprovacao.funcionarioResponsavel.id : null, agendamento.responsavelSegundoAprovador ? agendamento.responsavelSegundoAprovador.funcionarioResponsavel.id : null);

        feriasMapeadas.push(ferias);
      });

      return feriasMapeadas;
    },
    mapeiaAgendamentoParaEnvio: function mapeiaAgendamentoParaEnvio(agendamento, status) {
      var mapeado = { periodo: {}, periodoAquisitivo: {} };

      mapeado.id = agendamento.id;
      mapeado.periodo.id = agendamento.periodo.id;
      mapeado.periodoAquisitivo.id = agendamento.periodoAquisitivo.id;
      mapeado.dataInicio = agendamento.dataInicio;
      mapeado.dataAgendamento = agendamento.dataAgendamento;
      mapeado.statusAprovacao = status;
      mapeado.dataAprovacao = null;
      mapeado.responsavelAprovacao = null;

      return mapeado;
    },
    ordenaFeriasListadas: function ordenaFeriasListadas(agendamentos) {
      if (agendamentos.length) {
        var agendamentosOrdenados = agendamentos.sort(function (a, b) {
          if (a.nome > b.nome) return 1;
          if (a.nome < b.nome) return -1;
          if (a.id > b.id) return 1;
          if (a.id < b.id) return -1;
        });

        return agendamentosOrdenados;
      }

      return agendamentos;
    },
    ordenaStatus: function ordenaStatus(situacoes) {
      if (situacoes.length) {
        var situacoesOrdenados = situacoes.sort(function (a, b) {
          if (a.name > b.name) return 1;
          if (a.name < b.name) return -1;
        });

        return situacoesOrdenados;
      }

      return situacoes;
    },
    ordenaUors: function ordenaUors(uors) {
      if (uors.length) {
        var uorsOrdenados = uors.sort(function (a, b) {
          if (a.sigla > b.sigla) return 1;
          if (a.sigla < b.sigla) return -1;
        });

        return uorsOrdenados;
      }

      return uors;
    },
    limpa: function limpa() {
      this.filter.uor = '';
      this.filter.status = '';
      this.buscaFeriasAgendadas(this.funcionario, this.filter);
    },
    mostraAvisoBloqueadoPorData: function mostraAvisoBloqueadoPorData() {
      if (!sessionStorage.mostraForaDataAprovacao && this.bloqueiaPorDataLancamento()) {
        sessionStorage.setItem('mostraForaDataAprovacao', true);
      }
    },
    atualizaFeriasNaTela: function atualizaFeriasNaTela(ferias, response) {
      var index = this.agendamentos.indexOf(ferias);
      var agendamento = this.agendamentos[index];

      agendamento.statusAprovacao = response.statusAprovacao;
      agendamento.idFuncionarioResponsavel = response.responsavelAprovacao ? response.responsavelAprovacao.funcionarioResponsavel.id : null;
      agendamento.idFuncionarioResponsavelSegundo = response.responsavelSegundoAprovador ? response.responsavelSegundoAprovador.funcionarioResponsavel.id : null;
    },
    validaReprovaAnteriorEPosterior: function validaReprovaAnteriorEPosterior(ferias) {
      var anoAtual = __WEBPACK_IMPORTED_MODULE_11_moment___default()().year();

      var posteriorAprovada = this.agendamentos.find(function (item) {
        return item.nome === ferias.nome && item.ano === ferias.ano + 1 && (item.statusAprovacao === 'EM_ANALISE' || item.statusAprovacao === 'APROVADA');
      });

      if (ferias.ano === anoAtual && posteriorAprovada) return true;

      return false;
    }
  },
  created: function created() {
    this.funcionario = this.$store.state.funcionario;
    this.mostraAvisoBloqueadoPorData();
    this.listaAgendamentosNaTela(this.funcionario);
    this.listaUors(this.funcionario.id);
    this.listaStatus();
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_3__components_botao___default.a,
    CardHeader: __WEBPACK_IMPORTED_MODULE_4__components_card_header___default.a,
    TableLoader: __WEBPACK_IMPORTED_MODULE_5__components_table_loader___default.a
  }
});

/***/ }),

/***/ "Rg0L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = limparTexto;
// src/utils/text.js

function limparTexto(valor) {
  if (!valor) return '';

  return valor.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // remove acentos
  .replace(/[^a-zA-Z0-9\s]/g, '').toUpperCase(); // remove pontuação
}

/***/ }),

/***/ "RpBN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RxZC":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pagina-erro', {
    attrs: {
      "titulo": "Página não encontrada",
      "icone": "fa fa-eye-slash",
      "imagemTexto": "centralservidor-logo-texto.png",
      "imagem": "centralservidor-logo.png",
      "texto": "A página que você esta tentando acessar não foi encontrada.\n\t\tPor favor, verifique o link digitado ou entre em contato\n\t\tcom o administrador."
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "SGrW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            mostra: false
        };
    },


    props: {
        estilo: {
            required: false,
            default: "",
            type: String
        },
        iconeMostra: {
            required: false,
            default: "",
            type: String
        },
        iconeEsconde: {
            required: false,
            default: "",
            type: String
        }

    },
    methods: {},
    computed: {
        iconeBotaoMostra: function iconeBotaoMostra() {
            if (this.iconeMostra == 'interrogacao') return 'fa-question-circle-o';
            if (this.iconeMostra == 'seta-abaixo') return 'fa-chevron-circle-down';else return this.icone;
        },
        iconeBotaoEsconde: function iconeBotaoEsconde() {
            if (this.iconeEsconde == 'interrogacao') return 'fa-question-circle-o';
            if (this.iconeEsconde == 'seta-acima') return 'fa-chevron-circle-up';else return this.icone;
        }
    }
});

/***/ }),

/***/ "SMiL":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("DUKk"),
  /* template */
  __webpack_require__("6wME"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "TQeL":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, _vm._l((_vm.sides), function(side) {
    return _c('side-modal', {
      key: side.identidade,
      attrs: {
        "tit": side.titulo,
        "subtit": side.subtitulo,
        "subtDetl": side.subtDetalhe,
        "larg": side.largura,
        "id": side.identidade,
        "abreMaisUm": side.abreProximo,
        "aberto": side.aberto
      },
      on: {
        "fechou": function($event) {
          return _vm.fechaFromChild(side)
        },
        "abreFromChild": function($event) {
          _vm.abreSide(_vm.sides[_vm.sides.indexOf(side) + 1])
        },
        "largura": _vm.minima
      }
    }, [_vm._t(side.identidade)], 2)
  }), 1)
},staticRenderFns: []}

/***/ }),

/***/ "Tce3":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "menu"
    }
  }, [_c('div', [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_vm._m(1), _vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://form.jotform.com/241063912551652"
    }
  }, [_vm._v("https://form.jotform.com/241063912551652")]), _c('p'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p'), _vm._m(5), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('manual_mis_sesc.pdf')
      }
    }
  }, [_vm._v("Acessar Manual")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('descontados-mes.pdf')
      }
    }
  }, [_vm._v("Acessar lista")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.volta()
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modalSescLabel"
    }
  }, [_vm._v("\n            Credenciamento Prefeitura de Santos - SESC\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                Olá!"), _c('br'), _c('br'), _vm._v("\n\n                Esta ação de Credenciamento do Sesc é exclusiva para os servidores ativos\n                Municipal de Santos e ficará disponível para preenchimento a partir das\n                10h30 do 1º dia útil do mês (exceto segundas-feiras), por 48 horas, ou até\n                atingir o limite permitido no contrato, a saber, 300 inscrições/mês.\n                "), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Para acessar o link do formulário, faz-se necessário “atualizar os dados de\n                  navegação”,")]), _vm._v("\n                limpando o histórico de seu navegador, preferindo computadores ou notebook.\n                "), _c('br'), _c('br'), _vm._v("\n                Após o período de preenchimento, os dados serão validados pela Prefeitura Municipal de Santos,\n                a qual procederá com "), _c('strong', [_vm._v("desconto único anual")]), _vm._v(" na folha de pagamento no valor\n                de R$40,00 (quarenta reais), referente ao credenciamento do titular.\n                "), _c('br'), _c('br'), _vm._v("\n                Para ativar sua credencial MIS digital, você receberá um SMS recomendando a instalação do\n                aplicativo “Credencial Sesc SP” (iOS ou Android). Desta forma é OBRIGATÓRIO informar seu\n                número de celular e aceitar o recebimento de SMS durante o preenchimento deste formulário.\n                Lembramos que a credencial MIS tem validade de 1 (um) ano, com abrangência no estado de\n                São Paulo e não cria vínculo com o Sesc, assim como não concede os mesmos benefícios\n                oferecidos aos trabalhadores do Comércio de Bens, Serviços e Turismo.\n                "), _c('br'), _c('br'), _vm._v("Para iniciarmos o processo de credenciamento MIS, tenha em\n                mãos seus documentos pessoais (RG, CPF e uma foto).\n\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br'), _vm._v("\n                Importante! "), _c('br'), _c('br'), _vm._v("\n                O não preenchimento dos dados, assim como o preenchimento incompleto,\n                serão considerados como inconsistência cadastral.\n                "), _c('br'), _vm._v("\n                Caso o limite de 300 (trezentas) inscrições/mês seja alcançado no prazo de 48 horas, o servidor\n                deverá aguardar o próximo período para inscrever-se novamente, por não haver lista de espera.\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Link do formulário eletrônico de inscrição para credenciamento dos servidores da\n                  Prefeitura Municipal de Santos:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Acesso:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Manual para cadastramento no sistema do SESC, contendo perguntas e respostas\n                  frequentes:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("\n                  Lista contendo Nome e Registro dos servidores contemplados no último mês (os quais\n                  deverão AGUARDAR desconto na folha de pagamento, bem como contato do SESC através\n                  de SMS para efetivação do credenciamento no App Credencial Sesc SP, podendo baixar\n                  desde já):\n                ")])])
}]}

/***/ }),

/***/ "Tci9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_store__ = __webpack_require__("YtJ0");


var trataToken = function trataToken(token) {
  var tokenData = token.split('.');
  var decoded = atob(tokenData[1]);
  var tokenJson = JSON.parse(decoded);

  return tokenJson;
};

var obtemPrimeiroNome = function obtemPrimeiroNome(nomeCompleto) {
  if (nomeCompleto) {
    var arrayNome = nomeCompleto.split(' ');
    var primeiroNome = arrayNome[0].toLowerCase();
    var primeiraLetraMaiuscula = primeiroNome.charAt(0).toUpperCase() + primeiroNome.slice(1);

    return primeiraLetraMaiuscula;
  }
  return '';
};

var obtemUsuarioLogado = function obtemUsuarioLogado(token) {
  var usuarioLogado = {};

  var _trataToken = trataToken(token),
      sub = _trataToken.sub,
      fullname = _trataToken.fullname,
      roles = _trataToken.roles;

  usuarioLogado.sshd = sub;
  usuarioLogado.nome = fullname;
  usuarioLogado.perfis = roles;
  usuarioLogado.primeiroNome = obtemPrimeiroNome(fullname);
  __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */].commit('setUsuarioLogado', usuarioLogado);
};

/* harmony default export */ __webpack_exports__["a"] = (obtemUsuarioLogado);

/***/ }),

/***/ "U9pR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__ = __webpack_require__("MPt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Construcao',
	components: {
		PaginaErro: __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default.a
	}
});

/***/ }),

/***/ "UAGg":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "encerramentoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "encerramentoModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Entendi",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "encerramentoModalLabel"
    }
  }, [_vm._v("\n            Atualização  do CPF do Familiar\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 aviso-inicial"
  }, [_vm._v("\n              \"Conforme portaria 06/2022-SEGES, o recadastramento encerrou dia 05/08/2022.\n              Excepcionalmente, será permitido que os servidores atualizem os dados até 23:59 do dia 07/08/2022\"\n            ")])])])
}]}

/***/ }),

/***/ "Ufmu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_recadastramentoService__ = __webpack_require__("e9Zu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pagina_erro__ = __webpack_require__("MPt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pagina_erro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pagina_erro__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MesCompetenciaOrdenado',

  data: function data() {
    return {
      registros: [],
      carregando: true
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.carregarRegistros();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    carregarRegistros: function carregarRegistros() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var teste;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.carregando = true;
                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__services_recadastramentoService__["a" /* default */].listaPorAno();

              case 4:
                teste = _context2.sent;
                _context2.next = 7;
                return teste;

              case 7:
                _this2.registros = _context2.sent;

                if (_this2.estahVazio(_this2.registros)) {
                  // Lógica para lidar com registros vazios, se necessário
                }

                if (_this2.registros.length > 0) {
                  _this2.$store.dispatch('updateSituacaoRecad', _this2.registros[0].situacao);
                }

                _this2.carregando = false;
                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](1);

                _this2.carregando = false;
                _this2.$root.$refs.toastr.e(_context2.t0.message, 'Atenção');

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 13]]);
      }))();
    },
    visualizar: function visualizar(id) {
      if (id) {
        sessionStorage.setItem('userId', id);
        this.$router.push({ name: 'DadosPessoais', params: { id: id } });
      } else {
        console.error('ID inválido');
      }
      // this.$router.push({ name: 'DadosPessoais', params: { id: id } });
    },
    estahVazio: function estahVazio(objeto) {
      for (var key in objeto) {
        if (objeto.hasOwnProperty(key)) return false;
      }
      return true;
    },
    volta: function volta() {
      this.$router.push({ name: 'OutraRota' });
    }
  },
  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_3__components_botao___default.a,
    PaginaErro: __WEBPACK_IMPORTED_MODULE_4__components_pagina_erro___default.a
  }
});

/***/ }),

/***/ "Ufsi":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "load-smooth",
      "mode": "out-in"
    }
  }, [(_vm.carregando) ? _c('div', {
    key: "antes"
  }, [_c('h2', {
    staticClass: "carregando"
  }, [_vm._v("Carregando...")])]) : _c('div', {
    key: "depois"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "UmM+":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "menu"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalSesc",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "modalSescLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_vm._m(1), _vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                Caso o limite de 300 (trezentas) inscrições/mês seja alcançado no prazo de 48 horas, o servidor\n                deverá aguardar o próximo período para inscrever-se novamente, por não haver lista de espera.\n              ")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._m(4), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(5), _vm._m(6), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('Manual_MIS_7.0.pdf')
      }
    }
  }, [_vm._v("Acessar Manual")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('descontados-mes.pdf')
      }
    }
  }, [_vm._v("Acessar lista")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "OK",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    class: _vm.declaracaoAtiva,
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Declarações")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'DeclaracaoBens'
      }
    }
  }, [_vm._v("Declaração de Bens")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dependente'
      }
    }
  }, [_vm._v("Parceiro Econômico")])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    class: _vm.avaliacaoAtiva,
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Avaliações")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Avaliacao'
      }
    }
  }, [_vm._v("Avaliação Periódica")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'AvaliacaoEstagioProbatorio'
      }
    }
  }, [_vm._v("Estágio Probatório")])], 1)])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-toggle",
    class: _vm.recadastramentoAtiva,
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Atualização Cadastral")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'MesCompetenciaOrdenado'
      }
    }
  }, [_vm._v("Dados Pessoais")])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    class: _vm.feriasAtiva,
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Férias")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Ferias'
      }
    }
  }, [_vm._v("Agendamento de Férias\n                ")])], 1), _vm._v(" "), (_vm.ehResponsavelAprovador) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Aprovacao'
      }
    }
  }, [_vm._v("\n                  Aprovação de Férias\n                ")])], 1) : _vm._e()])]), _vm._v(" "), (_vm.valeAlimentacaoHabilitado) ? _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    class: _vm.valeAlimentacaoAtiva,
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Vale-Alimentação")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ValeAlimentacao'
      }
    }
  }, [_vm._v("Escolha do Vale-Alimentação\n                ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    class: _vm.formulariosAtiva,
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Formulários")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'FaltaLei'
      }
    }
  }, [_vm._v("Falta Lei")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'DeclaracaoInclusaoImpostoRenda'
      }
    }
  }, [_vm._v("Declaração de Inclusão IR")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'DeclaracaoExclusaoImpostoRenda'
      }
    }
  }, [_vm._v("Declaração de Exclusao IR")])], 1)])]), _vm._v(" "), _vm._m(8)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modalSescLabel"
    }
  }, [_vm._v("\n            Credenciamento Prefeitura de Santos - SESC\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                Olá!"), _c('br'), _c('br'), _vm._v("\n\n                Esta ação de Credenciamento do Sesc é exclusiva para os servidores ativos da Prefeitura\n                Municipal de Santos e ficará disponível para preenchimento a partir das 10h30 do 1º dia útil do\n                mês (exceto segundas-feiras), por 48 horas, ou até atingir o limite permitido no contrato, a saber,\n                300 inscrições/mês.\n                "), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Para acessar o link do formulário, faz-se necessário “atualizar os dados de navegação”,\n                ")]), _vm._v("\n                limpando o histórico de seu navegador, preferindo computadores ou notebook.\n                "), _c('br'), _c('br'), _vm._v("\n                Após o período de preenchimento, os dados serão validados pela Prefeitura Municipal de Santos,\n                a qual procederá com "), _c('strong', [_vm._v("desconto único anual")]), _vm._v(" na folha de pagamento no valor\n                de R$40,00 (quarenta reais), referente ao credenciamento do titular.\n                "), _c('br'), _c('br'), _vm._v("\n                Para ativar sua credencial MIS digital, você receberá um SMS recomendando a instalação do\n                aplicativo “Credencial Sesc SP” (iOS ou Android). Desta forma é OBRIGATÓRIO informar seu\n                número de celular e aceitar o recebimento de SMS durante o preenchimento deste formulário.\n                Lembramos que a credencial MIS tem validade de 1 (um) ano, com abrangência no estado de\n                São Paulo e não cria vínculo com o Sesc, assim como não concede os mesmos benefícios\n                oferecidos aos trabalhadores do Comércio de Bens, Serviços e Turismo.\n                "), _c('br'), _c('br'), _vm._v("\n                Para iniciarmos o processo de credenciamento MIS, tenha em mãos seus documentos pessoais\n                (RG, CPF e uma foto).\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br'), _vm._v("Importante! "), _c('br'), _c('br'), _vm._v("\n                O não preenchimento dos dados, assim como o preenchimento incompleto, serão considerados\n                como inconsistência cadastral.\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("\n                  Link do formulário eletrônico de inscrição para credenciamento dos servidores da\n                  Prefeitura Municipal de Santos:\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Acesso:")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://form.jotform.com/241063912551652"
    }
  }, [_vm._v("https://form.jotform.com/241063912551652")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Manual para cadastramento no sistema do SESC, contendo perguntas e respostas\n                  frequentes:\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br'), _vm._v(" "), _c('strong', [_vm._v("\n                  Lista contendo Nome e Registro dos servidores contemplados no último mês (os quais\n                  deverão AGUARDAR desconto na folha de pagamento, bem como contato do SESC através\n                  de SMS para efetivação do credenciamento no App Credencial Sesc SP, podendo baixar\n                  desde já):\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Links")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/jornada",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Jornada\n                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/jornada/downloads/manual.pdf",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-book",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Manual\n                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/jornada/downloads/formularios.docx",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Anexo Único\n                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://entrega.santos.sp.gov.br",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Entrega\n                ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://webmail.santos.sp.gov.br",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   WebMail\n                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/sigm_web_adm_sistema",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-stethoscope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Perícia Médica\n                ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-usd",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Holerite\n                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-paw",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Informe de Rendimentos\n                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Contagem de Tempo\n                ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/legis/documents/55",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Estatuto\n                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.santos.sp.gov.br/portal/servidor",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Portal do Servidor\n                ")])])])])
}]}

/***/ }),

/***/ "Uu1b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V1H8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var PeriodosAvaliacaoEstagioProbatorioService = function () {
  function PeriodosAvaliacaoEstagioProbatorioService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PeriodosAvaliacaoEstagioProbatorioService);

    throw 'Não é possível instanciar PeriodosAvaliacaoEstagioProbatorioService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(PeriodosAvaliacaoEstagioProbatorioService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id, idMes) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint(id, idMes);
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }, {
    key: 'obtemDoFuncionario',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id, idMes) {
        var endpoint, params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = mergeEndpoint(id, idMes);
                params = { idAvaliado: id };
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint, { params: params });

              case 4:
                return _context2.abrupt('return', _context2.sent);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function obtemDoFuncionario(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return obtemDoFuncionario;
    }()
  }]);

  return PeriodosAvaliacaoEstagioProbatorioService;
}();

/* harmony default export */ __webpack_exports__["a"] = (PeriodosAvaliacaoEstagioProbatorioService);


var mergeEndpoint = function mergeEndpoint(id, idMes) {
  return 'avaliacoes-estagio-probatorio/avaliador/' + id + '/competencias/' + idMes + '/avaliacoes-estagio-probatorio';
};

/***/ }),

/***/ "V1NV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_store__ = __webpack_require__("YtJ0");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('simNao', function (valor) {
    return valor === true ? 'Sim' : 'Não';
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('cpfMask', function (cpf) {
    if (cpf && cpf.length < 14) {
        return cpf.slice(0, 3) + '.' + cpf.slice(3, 6) + '.' + cpf.slice(6, 9) + '-' + cpf.slice(9);
    } else {
        return cpf;
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('monetarioMask', function (valor) {
    if (valor) {
        var str = valor.toString();
        if (!str.match(/[,.]/)) {
            // Exemplo 3000
            str = str + '00';
        }
        if (str.charAt(str.length - 2) == '.') {
            // Exemplo 3000.0
            str = str + '0';
        }
        if (str.match(/[,.]/)) {
            // Exemplo 3000.00
            str = str.replace(/[\D]+/g, '');
        }
        var formatado = str.replace(/([0-9]{2})$/g, ",$1");
        if (formatado.length > 9) {
            return formatado.replace(/([0-9]{3})([0-9]{3}),([0-9]{2})$/g, ".$1.$2,$3");
        }
        if (formatado.length > 6) {
            return formatado.replace(/([0-9]{3}),([0-9]{2})$/g, ".$1,$2");
        } else {
            return formatado;
        }
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formataData', function (valor) {
    if (valor) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(String(valor)).format('DD/MM/YYYY');
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('grauParentescoFilter', function (valor) {
    if (valor) {
        var graus = __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].state.graus;
        var grau = graus.find(function (grau) {
            return grau.name == valor;
        });
        return grau ? grau.displayName.toUpperCase() : 'Não encontrado';
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formataRegistro', function (valor) {
    if (!!valor) {
        var str = valor.toString();
        return str.replace(/([0-9]{2})([0-9]{3})([0-9]{1})/, '$1.$2-$3');
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formataCep', function (valor) {
    if (!!valor) {
        var str = valor.toString();
        return str.replace(/([0-9]{2})([0-9]{3})([0-9]{3})/, '$1.$2-$3');
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('tudoMaiusculo', function (valor) {
    if (!!valor) {
        return valor.toUpperCase();
    }
});

/***/ }),

/***/ "VE/E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_campo_calendario__ = __webpack_require__("XgyF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_campo_calendario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_campo_calendario__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_StringHelper__ = __webpack_require__("1pbJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_DateHelper__ = __webpack_require__("9t/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_NullHelper__ = __webpack_require__("2wz9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_object_hash__ = __webpack_require__("eZXE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_object_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_object_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_estadoService__ = __webpack_require__("2RzD");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Documentacao',

  data: function data() {
    return {
      cadastrado: this.$store.state.funcionarioCadastrado,
      //ufs: this.$store.state.estados,
      ufs: [],
      categorias: [{ id: 1, codigo: 'A' }, { id: 2, codigo: 'AB' }, { id: 3, codigo: 'AC' }, { id: 4, codigo: 'AD' }, { id: 5, codigo: 'AE' }, { id: 6, codigo: 'B' }, { id: 7, codigo: 'C' }, { id: 8, codigo: 'D' }, { id: 9, codigo: 'E' }],
      apiErrors: null,
      cnh: {
        numero: 0,
        categoria: '',
        validade: ''
      },
      orgaoClasse: {
        descricao: '',
        numero: ''
      },
      rg: {
        dataEmissao: '',
        numero: '',
        orgaoEmissor: '',
        uf: ''
      },
      tituloEleitor: {
        numero: 0,
        secao: 0,
        zona: 0
      },
      X: {
        pattern: /[0-9A-Z]/
      }
    };
  },


  computed: {
    situacaoRecad: function situacaoRecad() {
      return this.$store.getters.getSituacaoRecad;
    },
    temRg: function temRg() {
      return this.cadastrado.pessoa.rg.numero ? true : false;
    },
    temTituloEleitoral: function temTituloEleitoral() {
      return this.cadastrado.pessoa.tituloEleitor.numero ? true : false;
    },
    temOrgaoClasse: function temOrgaoClasse() {
      if (this.cadastrado.pessoa.orgaoClasse) {
        return this.cadastrado.pessoa.orgaoClasse.descricao ? true : false;
      }
      return false;
    },
    daquiADezAnos: function daquiADezAnos() {
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()(new Date()).add(10, 'years').format('YYYY-MM-DD');
    }
  },

  methods: {
    obtemEstados: function obtemEstados() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var estadosData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  estadosData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__services_estadoService__["a" /* getEstados */])();

                  _this.ufs = estadosData.map(function (estado) {
                    return {
                      id: estado.id,
                      nome: estado.nome,
                      sigla: _this.getSiglaFromNome(estado.nome)
                    };
                  });
                } catch (error) {
                  console.error('Erro ao carregar estados:', error);
                  _this.emiteAlerta("Erro ao carregar estados");
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getSiglaFromNome: function getSiglaFromNome(nome) {
      var siglas = {
        'Acre': 'AC',
        'Alagoas': 'AL',
        'Amapá': 'AP',
        'Amazonas': 'AM',
        'Bahia': 'BA',
        'Ceará': 'CE',
        'Distrito Federal': 'DF',
        'Espírito Santo': 'ES',
        'Goiás': 'GO',
        'Maranhão': 'MA',
        'Mato Grosso': 'MT',
        'Mato Grosso do Sul': 'MS',
        'Minas Gerais': 'MG',
        'Pará': 'PA',
        'Paraíba': 'PB',
        'Paraná': 'PR',
        'Pernambuco': 'PE',
        'Piauí': 'PI',
        'Rio de Janeiro': 'RJ',
        'Rio Grande do Norte': 'RN',
        'Rio Grande do Sul': 'RS',
        'Rondônia': 'RO',
        'Roraima': 'RR',
        'Santa Catarina': 'SC',
        'São Paulo': 'SP',
        'Sergipe': 'SE',
        'Tocantins': 'TO'
      };
      return siglas[nome] || '';
    },
    volta: function volta() {
      var _this2 = this;

      this.$validator.validateAll().then(function (success) {
        if (success) {
          if (_this2.validaDatas(_this2.cadastrado)) {
            _this2.$router.go(-1);
            return;
          }
          _this2.$root.$refs.toastr.e('Preencha as datas necessárias', 'Atenção');
          return;
        }
        _this2.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção');
      });
    },
    avanca: function avanca(cadastrado, proximoLink) {
      var _this3 = this;

      this.$validator.validateAll().then(function (success) {
        if (success) {
          // Só implementa o avanca() se for para outra tela
          if (proximoLink !== 'Documentacao') {
            if (_this3.validaDatas(cadastrado)) {
              _this3.formataParaApi(cadastrado);
              _this3.setAnexos(cadastrado, _this3.$store.state.cadastroModelo);
              _this3.$store.commit('setFuncionarioCadastrado', cadastrado);
              _this3.$router.push({ name: proximoLink });
              return;
            }
            _this3.$root.$refs.toastr.e('Preencha as datas necessárias', 'Atenção');
            return;
          }
          return;
        }
        _this3.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção');
      });
    },
    zeraDataEmissao: function zeraDataEmissao() {
      this.cadastrado.pessoa.rg.dataEmissao = null;
    },
    limitaRgInput: function limitaRgInput(event) {
      // Limita a entrada a apenas números e no máximo 11 dígitos
      var valor = event.target.value;
      var apenasNumeros = valor.replace(/[^0-9xX]/g, '').toUpperCase();
      if (apenasNumeros.length > 11) {
        this.cadastrado.pessoa.rg.numero = apenasNumeros.substring(0, 11);
      }
    },
    removeMascaraRg: function removeMascaraRg() {
      // Remove a máscara quando o campo recebe foco
      if (!this.cadastrado.pessoa.rg.numero) return;
      var apenasNumeros = String(this.cadastrado.pessoa.rg.numero).replace(/[^0-9xX]/g, '').toUpperCase();
      this.cadastrado.pessoa.rg.numero = apenasNumeros;
    },
    aplicaMascaraRg: function aplicaMascaraRg() {
      // Aplica a máscara quando o campo perde o foco
      var numero = String(this.cadastrado.pessoa.rg.numero || '').replace(/[^0-9xX]/g, '').toUpperCase();
      if (!numero) return;

      var tamanho = numero.length;

      if (tamanho === 11) {
        // Aplica máscara de CPF: 000.000.000-00
        this.cadastrado.pessoa.rg.numero = numero.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
      } else if (tamanho === 8 || tamanho === 9) {
        // Aplica máscara de RG padrão
        if (tamanho === 9) {
          // RG com 9 dígitos: 00.000.000-0
          this.cadastrado.pessoa.rg.numero = numero.replace(/^(\d{2})(\d{3})(\d{3})([\dxX]{1})$/, '$1.$2.$3-$4');
        } else {
          // RG com 8 dígitos: 00.000.000
          this.cadastrado.pessoa.rg.numero = numero.replace(/^(\d{2})(\d{3})(\d{3})$/, '$1.$2.$3');
        }
      }
      // Se tiver outro tamanho, mantém sem máscara
    },
    validaDatas: function validaDatas(cadastrado) {
      var _cadastrado$pessoa = cadastrado.pessoa,
          motorista = _cadastrado$pessoa.motorista,
          cnh = _cadastrado$pessoa.cnh,
          rg = _cadastrado$pessoa.rg;

      var dataCnhValida = !motorista || cnh.validade;
      var dataRgValida = !rg.numero || rg.dataEmissao;

      return dataCnhValida && dataRgValida;
    },
    valoraNulos: function valoraNulos(pessoa) {
      pessoa.cnh = __WEBPACK_IMPORTED_MODULE_9__helpers_NullHelper__["a" /* default */].valora(pessoa.cnh, this.cnh);
      pessoa.orgaoClasse = __WEBPACK_IMPORTED_MODULE_9__helpers_NullHelper__["a" /* default */].valora(pessoa.orgaoClasse, this.orgaoClasse);
      pessoa.rg = __WEBPACK_IMPORTED_MODULE_9__helpers_NullHelper__["a" /* default */].valora(pessoa.rg, this.rg);
      pessoa.tituloEleitor = __WEBPACK_IMPORTED_MODULE_9__helpers_NullHelper__["a" /* default */].valora(pessoa.tituloEleitor, this.tituloEleitor);
    },
    resetaNulos: function resetaNulos(pessoa) {
      pessoa.cnh = __WEBPACK_IMPORTED_MODULE_9__helpers_NullHelper__["a" /* default */].reseta(pessoa.cnh, this.cnh);
      pessoa.orgaoClasse = __WEBPACK_IMPORTED_MODULE_9__helpers_NullHelper__["a" /* default */].reseta(pessoa.orgaoClasse, this.orgaoClasse);
      pessoa.rg = __WEBPACK_IMPORTED_MODULE_9__helpers_NullHelper__["a" /* default */].reseta(pessoa.rg, this.rg);
      pessoa.tituloEleitor = __WEBPACK_IMPORTED_MODULE_9__helpers_NullHelper__["a" /* default */].reseta(pessoa.tituloEleitor, this.tituloEleitor);
    },
    formataParaApi: function formataParaApi(cadastrado) {
      var _cadastrado$pessoa2 = cadastrado.pessoa,
          rg = _cadastrado$pessoa2.rg,
          tituloEleitor = _cadastrado$pessoa2.tituloEleitor,
          cnh = _cadastrado$pessoa2.cnh,
          pisPasep = _cadastrado$pessoa2.pisPasep,
          orgaoClasse = _cadastrado$pessoa2.orgaoClasse;

      var limpa = function limpa(numero) {
        return __WEBPACK_IMPORTED_MODULE_7__helpers_StringHelper__["a" /* default */].limpaFormato(numero);
      };
      var limpaRg = function limpaRg(rg) {
        return __WEBPACK_IMPORTED_MODULE_7__helpers_StringHelper__["a" /* default */].limpaFormato(rg, true);
      };
      var numerifica = function numerifica(numero) {
        return parseInt(numero);
      };
      var dataParaPtbr = function dataParaPtbr(data) {
        return __WEBPACK_IMPORTED_MODULE_8__helpers_DateHelper__["a" /* default */].convertPtbrToApiDate(data);
      };

      rg.numero = limpaRg(rg.numero);
      rg.dataEmissao = dataParaPtbr(rg.dataEmissao);
      tituloEleitor.numero = limpa(tituloEleitor.numero);
      tituloEleitor.numero = numerifica(tituloEleitor.numero);
      tituloEleitor.zona = numerifica(tituloEleitor.zona);
      tituloEleitor.secao = numerifica(tituloEleitor.secao);
      cnh.numero = numerifica(cnh.numero);
      cnh.validade = dataParaPtbr(cnh.validade);

      // Corrigindo o problema do PIS/PASEP
      if (pisPasep) {
        pisPasep = limpa(pisPasep);
        cadastrado.pessoa.pisPasep = numerifica(pisPasep);
      } else {
        cadastrado.pessoa.pisPasep = null;
      }

      this.tiraAcentuacao(rg, orgaoClasse);
      this.resetaNulos(cadastrado.pessoa);
    },
    tiraAcentuacao: function tiraAcentuacao(rg, orgaoClasse) {
      var _this4 = this;

      if (orgaoClasse) {
        var camposOrgao = [orgaoClasse.descricao, orgaoClasse.numero];
        var indexOrgao = 0;

        camposOrgao.map(function (element) {
          if (__WEBPACK_IMPORTED_MODULE_7__helpers_StringHelper__["a" /* default */].verificaCaracterEspecial(element)) {
            camposOrgao[indexOrgao] = __WEBPACK_IMPORTED_MODULE_7__helpers_StringHelper__["a" /* default */].limpaCaracterEspecial(element);
            _this4.$root.$refs.toastr.w('A Atualização Cadastral não aceita acentos e cedilhas. A aplicação já fez as correções necessárias.', 'Atenção');
          }
          indexOrgao++;
        });
        this.cadastrado.pessoa.orgaoClasse.descricao = camposOrgao[0];
        this.cadastrado.pessoa.orgaoClasse.numero = camposOrgao[1];
      }

      if (__WEBPACK_IMPORTED_MODULE_7__helpers_StringHelper__["a" /* default */].verificaCaracterEspecial(rg.orgaoEmissor)) {
        rg.orgaoEmissor = __WEBPACK_IMPORTED_MODULE_7__helpers_StringHelper__["a" /* default */].limpaCaracterEspecial(rg.orgaoEmissor);
        this.$root.$refs.toastr.w('A Atualização Cadastral não aceita acentos e cedilhas. A aplicação já fez as correções necessárias.', 'Atenção');
      }
    },
    normalizaEndereco: function normalizaEndereco(endereco) {
      if (!endereco) return null;

      return {
        cep: endereco.cep || '',
        tipoLogradouro: endereco.tipoLogradouro || '',
        logradouro: endereco.logradouro || '',
        numero: endereco.numero || 0,
        complemento: endereco.complemento || '',
        bairro: endereco.bairro || '',
        cidade: endereco.cidade || '',
        uf: endereco.uf || ''
      };
    },
    normalizaContato: function normalizaContato(contato) {
      if (!contato) return null;

      return {
        dddTelefone: contato.dddTelefone ? parseInt(contato.dddTelefone) : null,
        numeroTelefone: contato.numeroTelefone ? String(contato.numeroTelefone).replace(/\D/g, '') : null,
        dddCelular: contato.dddCelular ? parseInt(contato.dddCelular) : null,
        numeroCelular: contato.numeroCelular ? String(contato.numeroCelular).replace(/\D/g, '') : null,
        email: contato.email || ''
      };
    },
    normalizaDocumentos: function normalizaDocumentos(pessoa) {
      if (!pessoa) return null;

      // Cria cópias para normalizar
      var pessoaNormalizada = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(pessoa));

      // Normaliza RG
      if (pessoaNormalizada.rg) {
        pessoaNormalizada.rg = {
          numero: String(pessoaNormalizada.rg.numero || '').replace(/\D/g, ''),
          dataEmissao: pessoaNormalizada.rg.dataEmissao,
          orgaoEmissor: pessoaNormalizada.rg.orgaoEmissor || '',
          uf: pessoaNormalizada.rg.uf || ''
        };
      }

      // Normaliza Título de Eleitor
      if (pessoaNormalizada.tituloEleitor) {
        pessoaNormalizada.tituloEleitor = {
          numero: parseInt(String(pessoaNormalizada.tituloEleitor.numero || '').replace(/\D/g, '')) || 0,
          zona: parseInt(pessoaNormalizada.tituloEleitor.zona || 0),
          secao: parseInt(pessoaNormalizada.tituloEleitor.secao || 0)
        };
      }

      // Normaliza PIS/PASEP
      if (pessoaNormalizada.pisPasep) {
        pessoaNormalizada.pisPasep = parseInt(String(pessoaNormalizada.pisPasep).replace(/\D/g, '')) || 0;
      }

      // Normaliza Órgão de Classe
      if (pessoaNormalizada.orgaoClasse) {
        pessoaNormalizada.orgaoClasse = {
          descricao: pessoaNormalizada.orgaoClasse.descricao || '',
          numero: pessoaNormalizada.orgaoClasse.numero || ''
        };
      }

      // Normaliza CNH
      if (pessoaNormalizada.cnh) {
        pessoaNormalizada.cnh = {
          numero: parseInt(String(pessoaNormalizada.cnh.numero || '').replace(/\D/g, '')) || 0,
          categoria: pessoaNormalizada.cnh.categoria || '',
          validade: pessoaNormalizada.cnh.validade
        };
      }

      return pessoaNormalizada;
    },
    setAnexos: function setAnexos(cadastrado, original) {
      // Normaliza os dados antes de comparar
      var pessoaNormalizada = this.normalizaDocumentos(cadastrado.pessoa);
      var originalNormalizada = this.normalizaDocumentos(original.pessoa);

      var rg = __WEBPACK_IMPORTED_MODULE_11_object_hash___default()(pessoaNormalizada.rg) != __WEBPACK_IMPORTED_MODULE_11_object_hash___default()(originalNormalizada.rg) ? true : false;
      var tituloEleitor = __WEBPACK_IMPORTED_MODULE_11_object_hash___default()(pessoaNormalizada.tituloEleitor) != __WEBPACK_IMPORTED_MODULE_11_object_hash___default()(originalNormalizada.tituloEleitor) ? true : false;
      var pisPasep = __WEBPACK_IMPORTED_MODULE_11_object_hash___default()(pessoaNormalizada.pisPasep) != __WEBPACK_IMPORTED_MODULE_11_object_hash___default()(originalNormalizada.pisPasep) ? true : false;
      var orgaoClasse = __WEBPACK_IMPORTED_MODULE_11_object_hash___default()(pessoaNormalizada.orgaoClasse) != __WEBPACK_IMPORTED_MODULE_11_object_hash___default()(originalNormalizada.orgaoClasse) ? true : false;
      var cnh = __WEBPACK_IMPORTED_MODULE_11_object_hash___default()(pessoaNormalizada.cnh) != __WEBPACK_IMPORTED_MODULE_11_object_hash___default()(originalNormalizada.cnh) ? true : false;

      var documentos = [];

      if (rg) documentos.push('RG (caso ainda não estiver anexado)');
      if (tituloEleitor) documentos.push('Título de Eleitor');
      if (pisPasep) documentos.push('PIS/PASEP');
      if (orgaoClasse) documentos.push('Documento oficial do Conselho de Classe');
      if (cnh) documentos.push('Carteira de Habilitação');

      if (cadastrado.documentosExigidos) {
        var novosDocumentos = documentos.filter(function (item) {
          return !cadastrado.documentosExigidos.includes(item);
        });
        cadastrado.documentosExigidos = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(cadastrado.documentosExigidos), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(novosDocumentos));
      } else {
        cadastrado.documentosExigidos = [].concat(documentos);
      }
    },
    formatarData: function formatarData(data) {
      if (!data) return '';
      var dataObj = new Date(data);
      return dataObj.toLocaleDateString('pt-BR'); // Formato dd/mm/yyyy
    }
  },

  created: function created() {
    var _this5 = this;

    this.obtemEstados();
    this.valoraNulos(this.cadastrado.pessoa);
    this.$eventBus.$on('salvaAvanca', function (nomeComponente) {
      _this5.avanca(_this5.cadastrado, nomeComponente);
    });
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
    // Aplica a máscara do RG ao carregar a tela (para exibição correta mesmo sem edição)
    this.aplicaMascaraRg();
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off('salvaAvanca');
  },


  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_5__components_botao___default.a,
    CampoCalendario: __WEBPACK_IMPORTED_MODULE_6__components_campo_calendario___default.a
  }
});

/***/ }),

/***/ "VQf9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/centralservidor-logo-texto.a730e5c.png";

/***/ }),

/***/ "VdY4":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ "Vyv6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return avisaAntesDeTokenExpirar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return forcaLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cancelaAvisosEFechar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_store__ = __webpack_require__("YtJ0");


var avisaEm30 = void 0;
var avisaEm10 = void 0;
var fechaApp = void 0;

var avisaAntesDeTokenExpirar = function avisaAntesDeTokenExpirar(app) {
  var faltam30 = 1770000;
  var faltam10 = 1790000;

  avisaEm30 = setTimeout(function () {
    app.$refs.toastr.w('Salve suas alterações, a sessão vai expirar em 30 segundos', 'Sessão vai expirar');
  }, faltam30);

  avisaEm10 = setTimeout(function () {
    app.$refs.toastr.w('Salve suas alterações, a sessão vai expirar em 10 segundos', 'Sessão vai expirar');
  }, faltam10);
};

var forcaLogout = function forcaLogout(router) {
  var app = router.app;
  var expirou = 1800000;

  fechaApp = setTimeout(function () {
    app.isAuthenticated = false;
    __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */].commit('setToken', '');
    __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */].commit('setAutenticados', []);
    __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */].commit('setFuncionario', {});
    document.querySelector('.upper-off-canvas').classList.remove('fechado');
    document.querySelector('.off-canvas').classList.remove('fechado');
    router.push({ path: '/' });
  }, expirou);
};

var cancelaAvisosEFechar = function cancelaAvisosEFechar(app) {
  app.$root.$refs.toastr.removeByType('success');
  app.$root.$refs.toastr.removeByType('warning');
  app.$root.$refs.toastr.removeByType('error');
  clearTimeout(avisaEm30);
  clearTimeout(avisaEm10);
  clearTimeout(fechaApp);
};

/***/ }),

/***/ "W3+9":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "canvas"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "title-content"
  }, [_c('div', {
    staticClass: "title-icon"
  }, [_c('i', {
    class: _vm.icone,
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title-text"
  }, [_c('h4', [_vm._v(_vm._s(_vm.titulo))])]), _vm._v(" "), _c('div', {
    staticClass: "title-logo"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.logoComTexto),
      expression: "logoComTexto"
    }],
    attrs: {
      "src": __webpack_require__("PvXa")("./" + _vm.imagemTexto)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.logoComTexto),
      expression: "!logoComTexto"
    }],
    attrs: {
      "src": __webpack_require__("PvXa")("./" + _vm.imagem)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.texto) + " ")])]), _vm._v(" "), _vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ "W8LH":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('card-header', {
    attrs: {
      "titulo": "Avaliações de Estágios Probatórios"
    }
  }), _vm._v(" "), _c('div', [_c('table-loader', {
    attrs: {
      "carregando": _vm.carregando
    }
  }, [(_vm.anosAvaliados.length == 0) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Ainda não foram\n                    geradas avaliações para o seu registro.\n                  ")]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Avaliação")]), _vm._v(" "), (_vm.ehAvaliador) ? _c('th', [_vm._v("Minha Avaliação")]) : _c('th', [_vm._v("Avaliação")]), _vm._v(" "), (_vm.ehAvaliador) ? _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("\n                          Avaliados Pendentes\n                        ")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.avaliacoesOrdenadas), function(avaliacao) {
    return _c('tr', {
      key: avaliacao.id,
      class: _vm.statusDaLinhaDaTabela(avaliacao)
    }, [_c('td', [_vm._v(_vm._s(avaliacao.mes + '/' + avaliacao.ano))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusDaAvaliacao(avaliacao)) + "\n                        ")]), _vm._v(" "), (_vm.ehAvaliador) ? _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                          " + _vm._s(_vm.quantidadeDeAvaliacoesPorAvaliador(avaliacao)) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "td-btns td-btns-alone"
    }, [(_vm.ehAvaliador) ? _c('div', [_c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          _vm.condicionalDoBotaoDeAvaliador(avaliacao)
        ),
        expression: "\n                                condicionalDoBotaoDeAvaliador(avaliacao)\n                              "
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Editar'),
        expression: "'Editar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": _vm.statusDoBotao(avaliacao),
        "icone": "editar-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.editaAvaliacao(_vm.funcionario.id, avaliacao)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          !_vm.condicionalDoBotaoDeAvaliador(avaliacao)
        ),
        expression: "\n                                !condicionalDoBotaoDeAvaliador(avaliacao)\n                              "
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Visualizar'),
        expression: "'Visualizar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar"
      },
      on: {
        "clicado": function($event) {
          return _vm.editaAvaliacao(_vm.funcionario.id, avaliacao)
        }
      }
    })], 1) : _c('div', [_c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          _vm.condicionalDoBotaoComum(avaliacao, true)
        ),
        expression: "\n                                condicionalDoBotaoComum(avaliacao, true)\n                              "
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Editar'),
        expression: "'Editar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": _vm.statusDoBotao(avaliacao),
        "icone": "editar-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.editaAvaliacao(_vm.funcionario.id, avaliacao)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          _vm.condicionalDoBotaoComum(avaliacao, false)
        ),
        expression: "\n                                condicionalDoBotaoComum(avaliacao, false)\n                              "
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Visualizar'),
        expression: "'Visualizar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar"
      },
      on: {
        "clicado": function($event) {
          return _vm.editaAvaliacao(_vm.funcionario.id, avaliacao)
        }
      }
    })], 1)])])
  }), 0)])])], 1)], 1)])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ "WCqJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__ = __webpack_require__("MPt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Manutencao',
	components: {
		PaginaErro: __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default.a
	}
});

/***/ }),

/***/ "WD1U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var PessoaFisicaService = function () {
  function PessoaFisicaService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PessoaFisicaService);

    throw 'Não é possível instanciar PessoaFisicaService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(PessoaFisicaService, null, [{
    key: 'obtemAutenticada',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint('autenticada');
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function obtemAutenticada() {
        return _ref.apply(this, arguments);
      }

      return obtemAutenticada;
    }()
  }]);

  return PessoaFisicaService;
}();

/* harmony default export */ __webpack_exports__["a"] = (PessoaFisicaService);


var mergeEndpoint = function mergeEndpoint(value) {
  return 'pessoas-fisicas/' + (value || '');
};

/***/ }),

/***/ "WInX":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("mWIn")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("7BIV"),
  /* template */
  __webpack_require__("gI/F"),
  /* scopeId */
  "data-v-57c4b24a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "WUBI":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "side-modal"
    }
  }, [_c('side-modal', {
    attrs: {
      "sides": _vm.navs
    }
  }, [_c('template', {
    slot: _vm.navs[0].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 hidden-others"
  }, [_c('p', {
    staticStyle: {
      "margin": "0 15px 5px",
      "font-size": "16px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Pendências:")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0 15px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4 form-group"
  }, [_c('label', [_vm._v("Dias")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ferias.diasPendentes ? 'SIM' : 'NÃO'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 form-group"
  }, [_c('label', [_vm._v("Férias")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ferias.feriasPendentes ? 'SIM' : 'NÃO'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 form-group"
  }, [_c('label', [_vm._v("Aprovação")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.ferias.situacao === 'EM_ANALISE' ?
    'EM ANÁLISE' :
    _vm.ferias.situacao) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "font-size": "1.6rem"
    }
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-calendar",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('strong', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_vm._v("\n                    Data de início:\n                  ")]), _vm._v(" "), _c('span', [_vm._v("\n                    " + _vm._s(_vm.escolhidoDia) + "/" + _vm._s(_vm.escolhidoMes) + "/" + _vm._s(_vm.escolhidoAno) + "\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "id": "calendar"
    }
  }, [_c('p', {
    staticClass: "hidden-xxs",
    staticStyle: {
      "font-size": "1.6rem"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Data de início: ")]), _vm._v(" "), _c('span', [_vm._v("\n                  " + _vm._s(_vm.escolhidoDia) + " de " + _vm._s(_vm.escolhidoMesFull) + " de\n                  " + _vm._s(_vm.escolhidoAno) + "\n                ")])]), _vm._v(" "), _c('section', [_c('header', {
    staticClass: "calendar-header"
  }, [_c('div', {
    class: _vm.mostraHeaderMudaMes,
    on: {
      "click": function($event) {
        return _vm.toggleMonths()
      }
    }
  }, [_c('span', {
    staticClass: "hidden-xxs"
  }, [_vm._v(_vm._s(_vm.calendarioMesFull))]), _vm._v(" "), _c('span', {
    staticClass: "hidden-others"
  }, [_vm._v(_vm._s(_vm.calendarioMesLess))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraSetaMudaMes),
      expression: "mostraSetaMudaMes"
    }],
    staticClass: "fa fa-chevron-down chevron-header",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.mostraHeaderMudaAno,
    on: {
      "click": function($event) {
        return _vm.toggleYears()
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraSetaMudaAno),
      expression: "mostraSetaMudaAno"
    }],
    staticClass: "fa fa-chevron-down chevron-header",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                    " + _vm._s(_vm.calendarioAno) + "\n                  ")])]), _vm._v(" "), _c('main', {
    staticClass: "calendar-body"
  }, [_c('div', {
    staticClass: "chevron-month"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraSetaMudaMesAnterior),
      expression: "mostraSetaMudaMesAnterior"
    }],
    staticClass: "chevron-action",
    on: {
      "click": function($event) {
        return _vm.montaCalendario('subtracao')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "calendar"
  }, [_c('div', {
    staticClass: "calendar-month"
  }, _vm._l((_vm.meses), function(mes) {
    return _c('button', {
      key: mes,
      class: _vm.mudaCorDoMesAno('mes', mes),
      on: {
        "click": function($event) {
          return _vm.marcaMesAno('mes', mes)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(mes) + "\n                      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "calendar-year"
  }, _vm._l((_vm.anos), function(ano) {
    return _c('button', {
      key: ano,
      class: _vm.mudaCorDoMesAno('ano', ano),
      staticStyle: {
        "font-size": "2.4rem"
      },
      on: {
        "click": function($event) {
          return _vm.marcaMesAno('ano', ano)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(ano) + "\n                      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "day-header",
    class: _vm.coloreSabDomHeader,
    staticStyle: {
      "cursor": "default"
    }
  }, [_vm._v("\n                      D\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "day-header",
    class: _vm.coloreSegASexHeader,
    staticStyle: {
      "cursor": "default"
    }
  }, [_vm._v("\n                      S\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "day-header",
    class: _vm.coloreSegASexHeader,
    staticStyle: {
      "cursor": "default"
    }
  }, [_vm._v("\n                      T\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "day-header",
    class: _vm.coloreSegASexHeader,
    staticStyle: {
      "cursor": "default"
    }
  }, [_vm._v("\n                      Q\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "day-header",
    class: _vm.coloreSegASexHeader,
    staticStyle: {
      "cursor": "default"
    }
  }, [_vm._v("\n                      Q\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "day-header",
    class: _vm.coloreSegASexHeader,
    staticStyle: {
      "cursor": "default"
    }
  }, [_vm._v("\n                      S\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "day-header",
    class: _vm.coloreSabDomHeader,
    staticStyle: {
      "cursor": "default"
    }
  }, [_vm._v("\n                      S\n                    ")]), _vm._v(" "), _vm._l((_vm.dias), function(dia, index) {
    return _c('button', {
      key: dia.numero,
      class: _vm.mudaCorDoDia(dia),
      style: (index === 0 && ("grid-column-start: " + (dia.semana + 1))),
      on: {
        "click": function($event) {
          return _vm.marcaDia(dia)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(dia.numero) + "\n                    ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "chevron-month"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraSetaMudaMesPosterior),
      expression: "mostraSetaMudaMesPosterior"
    }],
    staticClass: "chevron-action",
    on: {
      "click": function($event) {
        return _vm.montaCalendario('soma')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancela()
      }
    }
  }), _vm._v(" "), (_vm.ehEditavel) ? _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "icone": "ok-modal",
      "rotulo": "Salvar",
      "disabled": _vm.salvarDesabilitado
    },
    on: {
      "clicado": function($event) {
        return _vm.salva()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('botao', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.ehEditavel),
      expression: "!ehEditavel"
    }],
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "icone": "fa-file-text-o",
      "rotulo": "Protocolo"
    },
    on: {
      "clicado": function($event) {
        return _vm.chamaProtocolo()
      }
    }
  })], 1)])], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "Wbmx":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "banner"
    }
  }, [_c('div', {
    staticClass: "page-header-bg header-bg-cadastro hidden-xs",
    attrs: {
      "id": "barra"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "785px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 container-step",
    attrs: {
      "id": "container-step"
    }
  }, [_c('div', {
    staticClass: "col-md-1 step",
    class: _vm.one,
    on: {
      "click": function($event) {
        return _vm.emiteSalva('DadosPessoais')
      }
    }
  }, [_c('div', {
    staticClass: "center-step",
    class: _vm.one
  }), _vm._v(" "), _c('div', {
    staticClass: "text-step",
    class: _vm.tOne,
    attrs: {
      "id": "text-step1"
    }
  }, [_vm._v("Pessoal")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 inter-step",
    class: _vm.two
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 step",
    class: _vm.two,
    on: {
      "click": function($event) {
        return _vm.emiteSalva('Endereco')
      }
    }
  }, [_c('div', {
    staticClass: "center-step",
    class: _vm.two
  }), _vm._v(" "), _c('div', {
    staticClass: "text-step",
    class: _vm.tTwo,
    attrs: {
      "id": "text-step2"
    }
  }, [_vm._v("Endereço")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 inter-step",
    class: _vm.three
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 step",
    class: _vm.three,
    on: {
      "click": function($event) {
        return _vm.emiteSalva('Contatos')
      }
    }
  }, [_c('div', {
    staticClass: "center-step",
    class: _vm.three
  }), _vm._v(" "), _c('div', {
    staticClass: "text-step",
    class: _vm.tThree,
    attrs: {
      "id": "text-step3"
    }
  }, [_vm._v("Contatos")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 inter-step",
    class: _vm.four
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 step",
    class: _vm.four,
    on: {
      "click": function($event) {
        return _vm.emiteSalva('Documentacao')
      }
    }
  }, [_c('div', {
    staticClass: "center-step",
    class: _vm.four
  }), _vm._v(" "), _c('div', {
    staticClass: "text-step",
    class: _vm.tFour,
    attrs: {
      "id": "text-step4"
    }
  }, [_vm._v("Documentos")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 inter-step",
    class: _vm.five
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 step",
    class: _vm.five,
    on: {
      "click": function($event) {
        return _vm.emiteSalva('Filiacao')
      }
    }
  }, [_c('div', {
    staticClass: "center-step",
    class: _vm.five
  }), _vm._v(" "), _c('div', {
    staticClass: "text-step",
    class: _vm.tFive,
    attrs: {
      "id": "text-step4"
    }
  }, [_vm._v("Família")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 inter-step",
    class: _vm.six
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 step",
    class: _vm.six,
    on: {
      "click": function($event) {
        return _vm.emiteSalva('Envio')
      }
    }
  }, [_c('div', {
    staticClass: "center-step",
    class: _vm.six
  }), _vm._v(" "), _c('div', {
    staticClass: "text-step",
    class: _vm.tSix,
    attrs: {
      "id": "text-step6"
    }
  }, [_vm._v("Envio")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 inter-step",
    class: _vm.seven
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 step step-end",
    class: _vm.seven,
    attrs: {
      "id": "bola"
    },
    on: {
      "click": function($event) {
        return _vm.emiteSalva('Fim')
      }
    }
  }, [_c('div', {
    staticClass: "center-step center-step-end"
  }), _vm._v(" "), _c('div', {
    staticClass: "thumbs-up-step",
    class: _vm.tSeven
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up",
    attrs: {
      "aria-hidden": "false"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-header-bg header-bg-cadastro header-bg-cadastro-sm-xs visible-xs"
  }, [_c('div', {
    staticClass: "container container-xs"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contentNumber != 1),
      expression: "contentNumber != 1"
    }],
    staticClass: "chevron-left",
    on: {
      "click": function($event) {
        return _vm.emiteSalvaMobile('esquerda', _vm.contentNumber)
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "container-step container-step-sm-xs"
  }, [_c('div', {
    staticClass: "col-xs-1 step step-done"
  }, [_c('div', {
    staticClass: "center-step step-done"
  }, [_c('div', {
    staticClass: "text-number-xs"
  }, [_vm._v(_vm._s(_vm.contentNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-11 text-done text-done-xs"
  }, [_vm._v(_vm._s(_vm.contentName))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contentNumber != 7),
      expression: "contentNumber != 7"
    }],
    staticClass: "chevron-right",
    on: {
      "click": function($event) {
        return _vm.emiteSalvaMobile('direita', _vm.contentNumber)
      }
    }
  }, [_vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),

/***/ "Wbwb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__obtemUsuarioLogado__ = __webpack_require__("Tci9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_FileHelper__ = __webpack_require__("2MKL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__("H/Zg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',

  data: function data() {
    return {
      usuario: {
        username: '',
        password: ''
      },
      senhaVisivel: false,
      errosDeAcesso: 0
    };
  },

  methods: {
    getCredentials: function getCredentials() {
      var buffer = new Buffer(this.usuario.username.toUpperCase() + ':' + this.usuario.password);
      return buffer.toString('base64');
    },
    valida: function valida() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (success) {
          _this.acessa();
          return;
        }
        _this.$root.$refs.toastr.e('Favor informar os campos de usuário e senha', 'Atenção');
      });
    },
    acessa: function acessa() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].post('login', null, {
        headers: {
          Authorization: 'Basic ' + this.getCredentials()
        }
      }).then(function (response) {
        // Limpa SessionStorage se for outro usuário
        _this2.limpaSessionStorage();
        _this2.$store.commit('setToken', 'Bearer ' + response.token);

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__obtemUsuarioLogado__["a" /* default */])(_this2.token);
        _this2.$root.$data.isAuthenticated = true;

        _this2.$root.$refs.toastr.s('Login efetuado', 'Sucesso');

        _this2.$router.push({ name: 'Home' });
        sessionStorage.removeItem('errosDeAcesso');
      }, function (error) {
        _this2.contaErrosDeAcesso();
        if (_this2.errosDeAcesso >= 3) {
          jQuery('#problemaAcessoModal').modal('show');
        }
      });
    },
    limpaSessionStorage: function limpaSessionStorage() {
      var usuarioAtual = this.usuario.username.toUpperCase();
      var dadosSessionStorage = JSON.parse(sessionStorage.getItem('vuex'));
      if (dadosSessionStorage) {
        var usuarioAnterior = dadosSessionStorage.usuarioLogado.sshd;
        if (usuarioAtual !== usuarioAnterior) {
          this.$store.commit('setCadastroModelo', {});
          this.$store.commit('setFuncionarioCadastrado', {});
        }
      }
    },
    checkCapsLock: function checkCapsLock(event) {
      if (event.getModifierState('CapsLock')) {
        this.$root.$refs.toastr.w('A tecla CAPS LOCK está clicada', 'Atenção');
      }
    },
    mostraSenha: function mostraSenha() {
      var campoSenha = document.querySelector('#password');
      var status = campoSenha.type;
      this.senhaVisivel = !this.senhaVisivel;
      campoSenha.type = status === 'password' ? 'text' : 'password';
    },
    contaErrosDeAcesso: function contaErrosDeAcesso() {
      if (sessionStorage.errosDeAcesso) {
        this.errosDeAcesso = sessionStorage.errosDeAcesso;
      }
      this.errosDeAcesso++;
      sessionStorage.setItem('errosDeAcesso', this.errosDeAcesso);
    },
    abreSau: function abreSau() {
      window.open('https://egov.santos.sp.gov.br/sau/', '_blank');
      jQuery('#problemaAcessoModal').modal('hide');
    },
    baixaArquivo: function baixaArquivo(arquivo) {
      __WEBPACK_IMPORTED_MODULE_2__helpers_FileHelper__["a" /* default */].download(arquivo, this);
    }
  },
  computed: {
    token: function token() {
      return this.$store.state.token;
    },
    errorInputUsername: function errorInputUsername() {
      if (this.errors.has('username')) return 'form-control-credential-error';
    },
    errorInputPassword: function errorInputPassword() {
      if (this.errors.has('password')) return 'form-control-credential-error';
    }
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_0__components_botao___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("EuP9").Buffer))

/***/ }),

/***/ "X/AL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Anexo = function Anexo() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var nomeArquivo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var conteudo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Anexo);

  this.id = id;
  this.nomeArquivo = nomeArquivo;
  this.data = data, this.conteudo = conteudo;
};

/* harmony default export */ __webpack_exports__["a"] = (Anexo);

/***/ }),

/***/ "X2Lp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_tokenExpirado__ = __webpack_require__("Vyv6");



/* harmony default export */ __webpack_exports__["a"] = ({
  logout: function logout(app, next) {
    var sentences = [{
      id: 1,
      message: 'Deseja realmente sair do sistema?',
      bold: false
    }];

    app.$refs.modal.confirm(sentences, {
      yes: function yes() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__router_tokenExpirado__["c" /* cancelaAvisosEFechar */])(app);
        app.isAuthenticated = false;
        __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */].commit('setToken', '');
        __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */].commit('setAutenticados', []);
        __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */].commit('setFuncionario', {});
        next({ path: '/' });
        document.querySelector('.upper-off-canvas').classList.remove('fechado');
        document.querySelector('.off-canvas').classList.remove('fechado');
      },
      no: function no() {
        next({ path: '/' });
      },
      title: 'Saindo do Sistema'
    });
  }
});

/***/ }),

/***/ "XFWT":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("jUxG")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("9duw"),
  /* template */
  __webpack_require__("vzcd"),
  /* scopeId */
  "data-v-67f9ac32",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "XHEd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XN6+":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("xxzF"),
  /* template */
  __webpack_require__("H5fW"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "XQ5R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__registros_modal__ = __webpack_require__("0DjR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__registros_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__registros_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listaFuncionariosLogados__ = __webpack_require__("ZGkd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_support_sample_data_usuarioLogado__ = __webpack_require__("Z4Us");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_support_sample_data_usuarioLogado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_support_sample_data_usuarioLogado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_ErrorHelper__ = __webpack_require__("+h9g");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home',

  data: function data() {
    return {
      apiErrors: null,
      rotas: [],
      favoritosDoLogado: {},
      autenticados: this.$store.state.usuarioLogado.funcionarios,
      niveisUors: []
    };
  },

  computed: {
    funcionariosLogados: function funcionariosLogados() {
      return this.$store.state.usuarioLogado.funcionarios;
    }
  },
  watch: {
    funcionariosLogados: function funcionariosLogados(novo, antigo) {
      this.autenticados = novo;
    }
  },
  methods: {
    obtemFavoritosLogado: function obtemFavoritosLogado() {
      var sshdLogado = this.$store.state.usuarioLogado.sshd;
      var favoritos = JSON.parse(localStorage.getItem('clicados'));
      this.favoritosDoLogado = favoritos.find(function (item) {
        return item.sshd === sshdLogado;
      });
    },
    listaClicados: function listaClicados() {
      // this.rotas = this.favoritosDoLogado.links.slice(0, 4);
      var links = this.favoritosDoLogado.links.filter(function (rota) {
        return rota.name !== 'DependenteCpf';
      });
      this.rotas = links.slice(0, 4);
    },
    listaGraus: function listaGraus() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var graus;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__services_api__["a" /* default */].get('graus-parentescos');

              case 3:
                graus = _context.sent;


                _this.$store.commit('setGraus', graus);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                (function (error) {
                  var mensagem = __WEBPACK_IMPORTED_MODULE_7__helpers_ErrorHelper__["a" /* default */].trataMensagem(error);
                  _this.$root.$refs.toastr.e(mensagem, 'Atenção');
                });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    registraAutenticados: function registraAutenticados(autenticados) {
      this.$store.commit('setAutenticados', autenticados);
      this.$store.commit('setFuncionario', autenticados[0]);
      this.autenticados = autenticados;
    },
    mostraModalExplicacao: function mostraModalExplicacao() {
      if (this.favoritosDoLogado.links[0].cliques === 1) jQuery('#bemVindoModal').modal('show');
    },
    mostraModalRegistros: function mostraModalRegistros() {
      if (this.autenticados && this.autenticados.length > 1) jQuery('#registrosModal').modal('show');
    },
    fazRequisicoes: function fazRequisicoes() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.autenticados) {
                  _context2.next = 5;
                  break;
                }

                _this2.listaGraus();
                _context2.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__listaFuncionariosLogados__["a" /* default */])(_this2);

              case 4:
                _this2.mostraModalRegistros();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  created: function created() {
    this.obtemFavoritosLogado();
    this.listaClicados();
    this.fazRequisicoes();
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_2__components_botao___default.a,
    RegistrosModal: __WEBPACK_IMPORTED_MODULE_3__registros_modal___default.a
  }
});

/***/ }),

/***/ "XR3h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XdQw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__ = __webpack_require__("MPt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'SemAcesso',
	components: {
		PaginaErro: __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default.a
	}
});

/***/ }),

/***/ "XgyF":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("ikHu")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("LaCu"),
  /* template */
  __webpack_require__("HJFU"),
  /* scopeId */
  "data-v-62b78b1c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Y2k2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y651":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YQgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_card_header__ = __webpack_require__("8KSN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_card_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_card_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_table_loader__ = __webpack_require__("pKzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_table_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_table_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_avaliacoesService__ = __webpack_require__("tSzk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_avaliadorService__ = __webpack_require__("LaJZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_periodosService__ = __webpack_require__("N9Gh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_PeriodoAtualHelper__ = __webpack_require__("Yjkh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_ErrorHelper__ = __webpack_require__("+h9g");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Avaliacao',

  data: function data() {
    return {
      apiErrors: null,
      funcionario: this.$store.state.funcionario,
      carregando: false,
      anosAvaliados: [],
      periodos: [],
      anos: [],
      periodoAvaliacaoAnoAtual: {},
      avaliacaoAtualDoAvaliado: {},
      avaliador: {}
    };
  },

  computed: {
    anoDaAvaliacaoAtual: function anoDaAvaliacaoAtual() {
      return new Date().getFullYear() - 1;
    },
    avaliacoesOrdenadas: function avaliacoesOrdenadas() {
      return this.anosAvaliados.sort(function (a, b) {
        return b.ano - a.ano;
      });
    },
    mostraMensagemDeSemAvaliacao: function mostraMensagemDeSemAvaliacao() {
      var _this = this;

      return !this.anosAvaliados.some(function (competencia) {
        return competencia.ano === _this.anoDaAvaliacaoAtual;
      }) && this.anosAvaliados.length > 0 && this.validaEhEditavel(this.periodoAvaliacaoAnoAtual.dataInicioLancamento, this.periodoAvaliacaoAnoAtual.dataFimLancamento);
    },
    ehAvaliador: function ehAvaliador() {
      return this.avaliador ? this.avaliador.totalPendente != null : false;
    },
    usuarioAtual: function usuarioAtual() {
      return this.$store.state.funcionario;
    }
  },
  watch: {
    usuarioAtual: function usuarioAtual(novo, anterior) {
      this.funcionario = novo;
      this.editaRegistro(this.funcionario.id);
    }
  },
  methods: {
    statusDaLinhaDaTabela: function statusDaLinhaDaTabela(avaliacao) {
      var _avaliacao$periodos$ = avaliacao.periodos[0],
          dataInicioLancamento = _avaliacao$periodos$.dataInicioLancamento,
          dataFimLancamento = _avaliacao$periodos$.dataFimLancamento;
      var totalAutoavaliacao = this.avaliacaoAtualDoAvaliado.totalAutoavaliacao;


      return this.validaEhEditavel(dataInicioLancamento, dataFimLancamento) && totalAutoavaliacao === 0 ? 'situacao-pendente' : '';
    },
    statusDaAvaliacao: function statusDaAvaliacao(avaliacao) {
      var _avaliacao$periodos$2 = avaliacao.periodos[0],
          dataInicioLancamento = _avaliacao$periodos$2.dataInicioLancamento,
          dataFimLancamento = _avaliacao$periodos$2.dataFimLancamento;
      var naoExiste = this.avaliacaoAtualDoAvaliado.naoExiste;


      var ehEditavel = this.validaEhEditavel(dataInicioLancamento, dataFimLancamento);
      var avaliacaoNaoExiste = ehEditavel && naoExiste;
      var periodoAindaNaoAbriu = new Date() < new Date(dataInicioLancamento);

      if (ehEditavel) return 'EM ANDAMENTO';
      if (avaliacaoNaoExiste) return 'SEM AUTOAVALIAÇÃO';
      if (periodoAindaNaoAbriu) return 'INDISPONÍVEL';
      return 'FINALIZADA';
    },
    quantidadeDeAvaliacoesPorAvaliador: function quantidadeDeAvaliacoesPorAvaliador(avaliacao) {
      var _avaliacao$periodos$3 = avaliacao.periodos[0],
          dataInicioLancamento = _avaliacao$periodos$3.dataInicioLancamento,
          dataFimLancamento = _avaliacao$periodos$3.dataFimLancamento;


      return this.situacaoAvaliacoesPendentes(dataInicioLancamento, dataFimLancamento, this.avaliador) ? this.avaliador.totalPendente : 'NENHUM';
    },
    statusDoBotao: function statusDoBotao(avaliacao) {
      var _avaliacao$periodos$4 = avaliacao.periodos[0],
          dataInicioLancamento = _avaliacao$periodos$4.dataInicioLancamento,
          dataFimLancamento = _avaliacao$periodos$4.dataFimLancamento;
      var totalAutoavaliacao = this.avaliacaoAtualDoAvaliado.totalAutoavaliacao;


      return this.validaEhEditavel(dataInicioLancamento, dataFimLancamento) && totalAutoavaliacao === 0 ? 'vazado-laranja-sm' : 'vazado-cinza-sm';
    },
    condicionalDoBotaoDeAvaliador: function condicionalDoBotaoDeAvaliador(avaliacao) {
      var _avaliacao$periodos$5 = avaliacao.periodos[0],
          dataInicioLancamento = _avaliacao$periodos$5.dataInicioLancamento,
          dataFimLancamento = _avaliacao$periodos$5.dataFimLancamento;


      return this.validaEhEditavel(dataInicioLancamento, dataFimLancamento);
    },
    condicionalDoBotaoComum: function condicionalDoBotaoComum(avaliacao, status) {
      var _avaliacao$periodos$6 = avaliacao.periodos[0],
          dataInicioLancamento = _avaliacao$periodos$6.dataInicioLancamento,
          dataFimLancamento = _avaliacao$periodos$6.dataFimLancamento;
      var _avaliacaoAtualDoAval = this.avaliacaoAtualDoAvaliado,
          aceita = _avaliacaoAtualDoAval.aceita,
          mediaEstagioProbatorio = _avaliacaoAtualDoAval.mediaEstagioProbatorio;


      var ehEditavel = this.validaEhEditavel(dataInicioLancamento, dataFimLancamento);

      if (status) {
        return ehEditavel;
      }

      return !ehEditavel;
    },
    validaEhEditavel: function validaEhEditavel(dataInicial, dataFinal) {
      var _avaliacaoAtualDoAval2 = this.avaliacaoAtualDoAvaliado,
          aceita = _avaliacaoAtualDoAval2.aceita,
          mediaEstagioProbatorio = _avaliacaoAtualDoAval2.mediaEstagioProbatorio;


      if (dataInicial && dataFinal) {
        return __WEBPACK_IMPORTED_MODULE_9__helpers_PeriodoAtualHelper__["a" /* default */].validaPeriodo(dataInicial, dataFinal) && aceita === null && mediaEstagioProbatorio === 0;
      }
      return false;
    },
    validaPeriodoAindaNaoAbriu: function validaPeriodoAindaNaoAbriu(avaliacao) {
      var dataInicioLancamento = avaliacao.periodos[0].dataInicioLancamento;


      var periodoAindaNaoAbriu = new Date() < new Date(dataInicioLancamento);

      if (periodoAindaNaoAbriu) {
        var erro = new Error('O período de avaliação ainda não está aberto');
        erro.type = 'warning';
        throw erro;
      }
    },
    situacaoAvaliacoesPendentes: function situacaoAvaliacoesPendentes(dataInicial, dataFinal, avaliador) {
      if (dataInicial && dataFinal && avaliador) {
        return __WEBPACK_IMPORTED_MODULE_9__helpers_PeriodoAtualHelper__["a" /* default */].validaPeriodo(dataInicial, dataFinal) && avaliador.totalPendente > 0;
      }
      return false;
    },
    apagaDuplicatas: function apagaDuplicatas(array) {
      var arrayLimpo = [];
      array.forEach(function (element) {
        if (!arrayLimpo.some(function (item) {
          return item.id === element.id;
        })) {
          arrayLimpo.push(element);
        }
      });

      return arrayLimpo;
    },
    editaRegistro: function editaRegistro(funcionarioId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var anosAvaliados, mensagem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.carregando = true;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__services_avaliacoesService__["a" /* default */].lista(funcionarioId);

              case 4:
                anosAvaliados = _context.sent;

                if (anosAvaliados.length) {
                  _context.next = 9;
                  break;
                }

                _this2.anosAvaliados = anosAvaliados;
                _this2.carregando = false;
                return _context.abrupt('return');

              case 9:
                _this2.anosAvaliados = _this2.apagaDuplicatas(anosAvaliados);
                _this2.periodoAvaliacaoAnoAtual = _this2.avaliacoesOrdenadas[0];
                _this2.obtemUltimaAvaliacaoDoLogado(funcionarioId, _this2.periodoAvaliacaoAnoAtual.id);
                _this2.obtemContagemAvaliados(funcionarioId, _this2.periodoAvaliacaoAnoAtual.id);
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_10__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context.t0);

                _this2.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 19:
                _context.prev = 19;

                _this2.carregando = false;
                return _context.finish(19);

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 15, 19, 22]]);
      }))();
    },
    obtemUltimaAvaliacaoDoLogado: function obtemUltimaAvaliacaoDoLogado(funcionarioId, idMes) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var avaliacao, mensagem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__services_periodosService__["a" /* default */].obtemDoFuncionario(funcionarioId, idMes);

              case 3:
                avaliacao = _context2.sent;

                if (avaliacao.length) {
                  _context2.next = 7;
                  break;
                }

                _this3.avaliacaoAtualDoAvaliado = {
                  totalAutoavaliacao: 100,
                  mediaEstagioProbatorio: 0,
                  aceita: true,
                  naoExiste: true
                };
                return _context2.abrupt('return');

              case 7:
                _this3.avaliacaoAtualDoAvaliado = avaliacao[0];
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);
                mensagem = __WEBPACK_IMPORTED_MODULE_10__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context2.t0);

                _this3.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 10]]);
      }))();
    },
    obtemContagemAvaliados: function obtemContagemAvaliados(funcionarioId, idMes) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var avaliador, mensagem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.carregando = true;

                _context3.prev = 1;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__services_avaliadorService__["a" /* default */].lista(funcionarioId, idMes);

              case 4:
                avaliador = _context3.sent;

                _this4.avaliador = avaliador;
                _context3.next = 15;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_10__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context3.t0);

                if (!(mensagem === 'Recurso não encontrado')) {
                  _context3.next = 14;
                  break;
                }

                _this4.avaliador.totalPendente = null;
                return _context3.abrupt('return');

              case 14:
                _this4.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 15:
                _context3.prev = 15;

                _this4.carregando = false;
                return _context3.finish(15);

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[1, 8, 15, 18]]);
      }))();
    },
    editaAvaliacao: function editaAvaliacao(id, avaliacao) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var periodos, mensagem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this5.validaPeriodoAindaNaoAbriu(avaliacao);

                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_periodosService__["a" /* default */].lista(id, avaliacao.id);

              case 4:
                periodos = _context4.sent;

                _this5.periodos = periodos;
                sessionStorage.setItem('periodos', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this5.periodos));

                if (!(_this5.periodos.length === 1 && !_this5.avaliacaoAtualDoAvaliado.naoExiste)) {
                  _context4.next = 10;
                  break;
                }

                _this5.$router.push({
                  name: 'DetalhaAvaliacao',
                  params: {
                    idAvaliador: _this5.funcionario.id,
                    idAvaliado: id
                  }
                });

                return _context4.abrupt('return');

              case 10:

                _this5.$router.push({
                  name: 'Avaliados',
                  params: { idAvaliador: _this5.funcionario.id }
                });
                _context4.next = 20;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4['catch'](0);
                mensagem = __WEBPACK_IMPORTED_MODULE_10__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context4.t0);

                if (!(_context4.t0.type === 'warning')) {
                  _context4.next = 19;
                  break;
                }

                _this5.$root.$refs.toastr.w(mensagem, 'Atenção');
                return _context4.abrupt('return');

              case 19:

                _this5.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 20:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 13]]);
      }))();
    }
  },
  created: function created() {
    this.editaRegistro(this.funcionario.id);
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_3__components_botao___default.a,
    CardHeader: __WEBPACK_IMPORTED_MODULE_4__components_card_header___default.a,
    TableLoader: __WEBPACK_IMPORTED_MODULE_5__components_table_loader___default.a
  }
});

/***/ }),

/***/ "YUax":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "explicacaoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "explicacaoModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Entendi",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "side-modal"
    }
  }, [_c('side-modal', {
    attrs: {
      "sides": _vm.navs
    },
    on: {
      "cancela": function($event) {
        return _vm.cancela()
      }
    }
  }, [_c('template', {
    slot: _vm.navs[0].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('article', [_c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dependenteModal.nome))])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "dataNascimento"
    }
  }, [_vm._v("Data de Nascimento")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dependenteModal.dataNascimento))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "sexo"
    }
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dependenteSexo))])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "tipo"
    }
  }, [_vm._v("Parentesco")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dependenteModal.tipo.descricao))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "dependeteIr"
    }
  }, [_vm._v("Dependente IR")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dependenteIr))])])])]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-12 col-sm-12",
      "label": "Nome",
      "field": "nome",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.nome),
      expression: "dependenteModal.nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:45'),
      expression: "'required|max:45'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome",
      "id": "nome",
      "data-vv-as": "Nome",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.dependenteModal.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenteModal, "nome", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [(_vm.telaEhMobile) ? _c('field-validation', {
    attrs: {
      "css-class": "col-sm-6",
      "label": "Data de Nascimento",
      "field": "dataNascimento",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.dataNascimento),
      expression: "dependenteModal.dataNascimento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "dataNascimento",
      "id": "dataNascimento",
      "data-vv-as": "Data de Nascimento",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.dependenteModal.dataNascimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenteModal, "dataNascimento", $event.target.value)
      }
    }
  })]) : _c('field-validation', {
    attrs: {
      "css-class": "col-sm-6",
      "label": "Data de Nascimento",
      "field": "dataNascimento",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataNascimento",
      "id": "dataNascimento",
      "config": _vm.config,
      "data-vv-as": "Data de Nascimento",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    model: {
      value: (_vm.dependenteModal.dataNascimento),
      callback: function($$v) {
        _vm.$set(_vm.dependenteModal, "dataNascimento", $$v)
      },
      expression: "dependenteModal.dataNascimento"
    }
  })], 1), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Sexo",
      "field": "sexo",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.sexo),
      expression: "dependenteModal.sexo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "sexo",
      "id": "sexo",
      "data-vv-as": "Sexo",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dependenteModal, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.sexos), function(sexo) {
    return _c('option', {
      key: sexo.name,
      domProps: {
        "value": sexo.name
      }
    }, [_vm._v("\n                      " + _vm._s(sexo.displayName.toUpperCase()) + "\n                    ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Parentesco",
      "field": "parentesco",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.tipo),
      expression: "dependenteModal.tipo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "parentesco",
      "data-vv-as": "Parentesco",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dependenteModal, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.graus), function(grau) {
    return _c('option', {
      key: grau.id,
      domProps: {
        "value": grau
      }
    }, [_vm._v("\n                      " + _vm._s(grau.descricao) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "dependeteIr"
    }
  }, [_vm._v("Dependente IR")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.dependenteIR),
      expression: "dependenteModal.dependenteIR"
    }],
    staticClass: "toggle-switch",
    attrs: {
      "type": "checkbox",
      "id": "dependenteIr",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "checked": Array.isArray(_vm.dependenteModal.dependenteIR) ? _vm._i(_vm.dependenteModal.dependenteIR, null) > -1 : (_vm.dependenteModal.dependenteIR)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.dependenteModal.dependenteIR,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dependenteModal, "dependenteIR", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dependenteModal, "dependenteIR", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dependenteModal, "dependenteIR", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.dependenteModal.dependenteIR ? 'Sim' : 'Não'))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "CPF",
      "field": "cpf",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenteModal.cpfDependente),
      expression: "dependenteModal.cpfDependente"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        cpf_valido: true
      }),
      expression: "{ required: true, cpf_valido: true }"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cpf",
      "id": "cpf",
      "data-vv-as": "CPF",
      "placeholder": "Digite o CPF",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.dependenteModal.cpfDependente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenteModal, "cpfDependente", $event.target.value)
      }
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancela()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Salvar",
      "icone": "ok-modal",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "clicado": function($event) {
        return _vm.valida(_vm.dependenteModal)
      }
    }
  })], 1)])], 2)], 1), _vm._v(" "), _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Filiação\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.avanca(_vm.cadastrado, 'Envio')
      }
    }
  }, [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-sm-6",
      "label": "Nome da Mãe",
      "field": "nomeMae",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.filiacao.mae),
      expression: "cadastrado.pessoa.filiacao.mae"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:45'),
      expression: "'max:45'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nomeMae",
      "id": "nomeMae",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO',
      "data-vv-as": "Nome da Mãe"
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.filiacao.mae)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.filiacao, "mae", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-6",
      "label": "Nome do Pai",
      "field": "nomePai",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.filiacao.pai),
      expression: "cadastrado.pessoa.filiacao.pai"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:45'),
      expression: "'max:45'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nomePai",
      "id": "nomePai",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO',
      "data-vv-as": "Nome do Pai"
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.filiacao.pai)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.filiacao, "pai", $event.target.value)
      }
    }
  })])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Quadro Familiar \n                "), _c('small', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.abreExplicacaoModal()
      }
    }
  }, [_vm._v("(Regra de edição de dependentes)")])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [(_vm.cadastrado.pessoa.dependentes.length == 0) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center",
      "cursor": "pointer"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Para incluir um\n                  dependente clique em NOVO.\n                ")]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.cadastrado.pessoa.dependentes), function(dependente) {
    return _c('tr', {
      key: dependente.id
    }, [_c('td', [_vm._v(_vm._s(_vm._f("tudoMaiusculo")(dependente.nome)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatarCPF")(dependente.cpfDependente)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs hidden-sm"
    }, [_vm._v("\n                        " + _vm._s(_vm._f("formataData")(dependente.dataNascimento)) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                        " + _vm._s(_vm._f("tudoMaiusculo")(dependente.tipo.descricao)) + "\n                      ")]), _vm._v(" "), _c('td', [_c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Visualizar'),
        expression: "'Visualizar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "tipo": "button",
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar"
      },
      on: {
        "clicado": function($event) {
          return _vm.edita(dependente)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Editar'),
        expression: "'Editar'",
        modifiers: {
          "right": true
        }
      }],
      attrs: {
        "tipo": "button",
        "estilo": "vazado-cinza-sm",
        "icone": "editar-tabela",
        "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
      },
      on: {
        "clicado": function($event) {
          return _vm.edita(dependente)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Apagar'),
        expression: "'Apagar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "tipo": "button",
        "estilo": "vazado-vermelho-sm",
        "icone": "exclui-tabela",
        "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
      },
      on: {
        "clicado": function($event) {
          return _vm.exclui(dependente)
        }
      }
    })], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 footer-controller-inner"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde-dir",
      "rotulo": "Novo",
      "icone": "novo-modal",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "clicado": function($event) {
        return _vm.novo()
      }
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.volta()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde-dir",
      "rotulo": "Avançar",
      "icone": "avancar",
      "icone-direita": true,
      "id": "vai"
    },
    on: {
      "clicado": function($event) {
        return _vm.avanca(_vm.cadastrado, 'Envio')
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "explicacaoModalLabel"
    }
  }, [_vm._v("\n              Regra de Edição de Dependentes\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Para alterações referentes à dependentes do Imposto de Renda, é obrigatório anexar os formulários\n                  correspondentes.\n                  Os mesmos estão disponíveis na Central do Servidor, na aba "), _c('strong', [_vm._v("FORMULÁRIOS")]), _vm._v(".\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "margin-bottom": "15px",
      "text-align": "justify"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle fa-lg"
  }), _vm._v("  "), _c('strong', [_vm._v("Atenção:")]), _vm._v(" Para alterações referentes à dependentes do Imposto de Renda, é obrigatório anexar os formulários correspondentes. Os mesmos estão disponíveis na Central do Servidor, na aba "), _c('strong', [_vm._v("FORMULÁRIOS")]), _vm._v(".\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("CPF")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs hidden-sm"
  }, [_vm._v("Data de Nascimento")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Grau de Parentesco")]), _vm._v(" "), _c('th', [_vm._v(" ")])])])
}]}

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Site__ = __webpack_require__("mWGn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Site___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Site__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Impresso__ = __webpack_require__("xyqo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Impresso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Impresso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_login__ = __webpack_require__("jT7l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_nao_encontrado__ = __webpack_require__("0Qh0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_nao_encontrado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_nao_encontrado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_credenciamento_sesc__ = __webpack_require__("OhKN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_credenciamento_sesc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_credenciamento_sesc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_sem_acesso__ = __webpack_require__("bu/5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_sem_acesso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_sem_acesso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_uor_nao_participante__ = __webpack_require__("v0od");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_uor_nao_participante___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_uor_nao_participante__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_manutencao__ = __webpack_require__("lonj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_manutencao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_manutencao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_construcao__ = __webpack_require__("x/Th");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_construcao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_construcao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_recadastramento_encerrado__ = __webpack_require__("RLyq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_recadastramento_encerrado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_recadastramento_encerrado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_dependente_cpf_encerrado__ = __webpack_require__("y2Rf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_dependente_cpf_encerrado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_dependente_cpf_encerrado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_conta__ = __webpack_require__("XN6+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_conta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_conta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_sair__ = __webpack_require__("X2Lp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_faq__ = __webpack_require__("MKaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_faq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_faq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_home__ = __webpack_require__("FP3a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_dependente__ = __webpack_require__("sJIn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_dependente___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_dependente__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_dependente_cpf__ = __webpack_require__("92WD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_dependente_cpf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_dependente_cpf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_declaracao__ = __webpack_require__("mhA2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_declaracao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_declaracao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_avaliacao__ = __webpack_require__("f19i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_avaliacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__pages_avaliacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_avaliacao_detalha_avaliacao__ = __webpack_require__("w1KV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_avaliacao_detalha_avaliacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__pages_avaliacao_detalha_avaliacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_avaliacao_avaliados__ = __webpack_require__("v5Jx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_avaliacao_avaliados___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__pages_avaliacao_avaliados__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_avaliacao_estagio_probatorio__ = __webpack_require__("fK6S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_avaliacao_estagio_probatorio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__pages_avaliacao_estagio_probatorio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_avaliacao_estagio_probatorio_detalha_avaliacao__ = __webpack_require__("0Sf3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_avaliacao_estagio_probatorio_detalha_avaliacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__pages_avaliacao_estagio_probatorio_detalha_avaliacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_avaliacao_estagio_probatorio_avaliados__ = __webpack_require__("94Nx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_avaliacao_estagio_probatorio_avaliados___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__pages_avaliacao_estagio_probatorio_avaliados__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_recadastramento_dados_pessoais__ = __webpack_require__("hzvd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_recadastramento_dados_pessoais___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__pages_recadastramento_dados_pessoais__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_recadastramento_endereco__ = __webpack_require__("soYb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_recadastramento_endereco___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__pages_recadastramento_endereco__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_recadastramento_contatos__ = __webpack_require__("x00c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_recadastramento_contatos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__pages_recadastramento_contatos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_recadastramento_documentacao__ = __webpack_require__("BkkY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_recadastramento_documentacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__pages_recadastramento_documentacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_recadastramento_filiacao__ = __webpack_require__("h6wb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_recadastramento_filiacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__pages_recadastramento_filiacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_recadastramento_envio__ = __webpack_require__("dWeg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_recadastramento_envio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__pages_recadastramento_envio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_recadastramento_fim__ = __webpack_require__("pVN0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_recadastramento_fim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__pages_recadastramento_fim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_ferias_agendamento__ = __webpack_require__("nva8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_ferias_agendamento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__pages_ferias_agendamento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_ferias_aprovacao__ = __webpack_require__("6SSX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_ferias_aprovacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__pages_ferias_aprovacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_falta_lei__ = __webpack_require__("Gkx4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_falta_lei___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__pages_falta_lei__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_falta_lei_pagina_impresso__ = __webpack_require__("IBjx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_falta_lei_pagina_impresso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__pages_falta_lei_pagina_impresso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__favoritos__ = __webpack_require__("x1eA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__tokenExpirado__ = __webpack_require__("Vyv6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__validaRecadastramento__ = __webpack_require__("A3/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__validaPeriodoRecadastramentoFamiliar__ = __webpack_require__("cZEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_periodo_encerrado__ = __webpack_require__("2Kst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_periodo_encerrado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__pages_periodo_encerrado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_recadastramento_mes_competencia_ordenado_index_vue__ = __webpack_require__("5shf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_recadastramento_mes_competencia_ordenado_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__pages_recadastramento_mes_competencia_ordenado_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__pages_vale_alimentacao_index_vue__ = __webpack_require__("qPY7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__pages_vale_alimentacao_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__pages_vale_alimentacao_index_vue__);



var _this = this;


















































__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  mode: 'history',
  base: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].publicPath,
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_6__Site___default.a,
    children: [{
      path: '',
      name: 'Login',
      component: __WEBPACK_IMPORTED_MODULE_8__pages_login___default.a,
      meta: {
        requiresAuth: false
      }
    }, {
      path: 'sem-acesso',
      name: 'SemAcesso',
      component: __WEBPACK_IMPORTED_MODULE_11__pages_sem_acesso___default.a,
      meta: {
        requiresAuth: false
      }
    }, {
      path: 'periodo-encerrado',
      name: 'PeriodoEncerrado',
      component: __WEBPACK_IMPORTED_MODULE_45__pages_periodo_encerrado___default.a,
      meta: {
        requiresAuth: false
      }
    }, {
      path: 'uor-nao-participante',
      name: 'UorNaoParticipante',
      component: __WEBPACK_IMPORTED_MODULE_12__pages_uor_nao_participante___default.a,
      meta: {
        requiresAuth: false
      }
    }, {
      path: 'manutencao',
      name: 'Manutencao',
      component: __WEBPACK_IMPORTED_MODULE_13__pages_manutencao___default.a,
      meta: {
        requiresAuth: false
      }
    }, {
      path: 'construcao',
      name: 'Construcao',
      component: __WEBPACK_IMPORTED_MODULE_14__pages_construcao___default.a,
      meta: {
        requiresAuth: false
      }
    }, {
      path: 'sair',
      name: 'Sair',
      component: __WEBPACK_IMPORTED_MODULE_18__pages_sair__["a" /* default */].default
    }, {
      path: 'conta',
      name: 'Conta',
      component: __WEBPACK_IMPORTED_MODULE_17__pages_conta___default.a
    }, {
      path: 'faq',
      name: 'Faq',
      component: __WEBPACK_IMPORTED_MODULE_19__pages_faq___default.a,
      meta: {
        declaraActive: true
      }
    }, {
      path: 'home',
      name: 'Home',
      component: __WEBPACK_IMPORTED_MODULE_20__pages_home___default.a
    }, {
      path: 'avaliacao',
      name: 'Avaliacao',
      component: __WEBPACK_IMPORTED_MODULE_24__pages_avaliacao___default.a,
      meta: {
        avaliaActive: true,
        contavel: true,
        titulo: 'Avaliação Periódica',
        imagem: 'ico-contagem.png',
        texto: 'Faça sua avaliação periódica e veja as conclusões do seu avaliador.'
      }
    }, {
      path: 'avaliacaoEstagioProbatorio',
      name: 'AvaliacaoEstagioProbatorio',
      component: __WEBPACK_IMPORTED_MODULE_27__pages_avaliacao_estagio_probatorio___default.a,
      meta: {
        avaliaActive: true,
        contavel: true,
        titulo: 'Estágio Probatório',
        imagem: 'ico-contagem.png',
        texto: 'Faça sua avaliação de estágio probatório e veja as conclusões do seu avaliador.'
      }
    }, {
      path: 'declaracao',
      name: 'DeclaracaoBens',
      component: __WEBPACK_IMPORTED_MODULE_23__pages_declaracao___default.a,
      meta: {
        declaraActive: true,
        contavel: true,
        titulo: 'Declaração de Bens',
        imagem: 'ico-holerites.png',
        texto: 'Declare seus bens conforme previsto no Decreto Municipal nº 7.517/2016 .'
      }
    }, {
      path: 'dependente_economico',
      name: 'Dependente',
      component: __WEBPACK_IMPORTED_MODULE_21__pages_dependente___default.a,
      meta: {
        declaraActive: true,
        contavel: true,
        titulo: 'Parceiro Econômico',
        imagem: 'ico-holerites.png',
        texto: 'Inclua parceiros (dependente econômico) que partilhem bens de sua declaração.'
      }
    }, {
      path: 'avaliacao/avaliados/:idAvaliador',
      name: 'Avaliados',
      component: __WEBPACK_IMPORTED_MODULE_26__pages_avaliacao_avaliados___default.a,
      meta: {
        avaliaActive: true
      }
    }, {
      path: 'avaliacao_estagio_probatorio/avaliados/:idAvaliador',
      name: 'AvaliadosEstagioProbatorio',
      component: __WEBPACK_IMPORTED_MODULE_29__pages_avaliacao_estagio_probatorio_avaliados___default.a,
      meta: {
        avaliaActive: true
      }
    }, {
      path: 'avaliacao/detalha_avaliacao/:idAvaliador/:idAvaliado',
      name: 'DetalhaAvaliacao',
      component: __WEBPACK_IMPORTED_MODULE_25__pages_avaliacao_detalha_avaliacao___default.a,
      meta: {
        avaliaActive: true
      }
    }, {
      path: 'avaliacao_estagio_probatorio/detalha_avaliacao/:idAvaliador/:idAvaliado',
      name: 'DetalhaAvaliacaoEstagioProbatorio',
      component: __WEBPACK_IMPORTED_MODULE_28__pages_avaliacao_estagio_probatorio_detalha_avaliacao___default.a,
      meta: {
        avaliaActive: true
      }
    }, {
      path: 'recadastramento/mes-competencia-ordenado',
      name: 'MesCompetenciaOrdenado',
      component: __WEBPACK_IMPORTED_MODULE_46__pages_recadastramento_mes_competencia_ordenado_index_vue___default.a,
      meta: {
        title: 'Dados Pessoais',
        requiresAuth: true
      }
    }, {
      path: 'recadastramento/dados_pessoais/index.vue/:id',
      name: 'DadosPessoais',
      component: __WEBPACK_IMPORTED_MODULE_30__pages_recadastramento_dados_pessoais___default.a,
      meta: {
        requiresAuth: true,
        stepNumber: 1
      },
      beforeEnter: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
          var periodoId, isRecadastra;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!__WEBPACK_IMPORTED_MODULE_4__vuex_store__["a" /* default */].state.token) {
                    _context.next = 7;
                    break;
                  }

                  periodoId = to.params.id || sessionStorage.getItem('userId'); // query parameters

                  if (!periodoId) {
                    _context.next = 7;
                    break;
                  }

                  _context.next = 5;
                  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__validaRecadastramento__["a" /* validaRecadastramentoPorId */])(periodoId, to);

                case 5:
                  isRecadastra = _context.sent;

                  if (isRecadastra) {
                    next();
                  } else {
                    next({ name: 'Encerrado' });
                  }

                case 7:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function beforeEnter(_x, _x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }()
    },
    /*
    {
      path: 'recadastramento/dados_pessoais',
      name: 'DadosPessoais',
      component: DadosPessoais,
      meta: {
        recadastraActive: true,
        contavel: false,
        titulo: 'Recadastro',
        imagem: 'ico-previdenciario.png',
        texto:
          'Mantenha seus dados atualizados podendo enviar seus documentos pela internet.',
        stepNumber: 1,
        displayName: 'Dados Pessoais',
      },
      beforeEnter: async (to, from, next) => {
        if (store.state.token) {
          const isRecadastra = await validaRecadastramento(next, router.app);
          if (isRecadastra) {
            next();
          } else {
            next({ name: 'Encerrado' });
          }
        }
      },
    },
    */
    {
      path: 'recadastramento/dependente_cpf',
      name: 'DependenteCpf',
      component: __WEBPACK_IMPORTED_MODULE_22__pages_dependente_cpf___default.a,
      meta: {
        recadastraActive: true,
        contavel: true,
        titulo: 'CPF do Familiar',
        imagem: 'ico-previdenciario.png',
        texto: 'Inclusão do CPF dos familiares.'
      },
      beforeEnter: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(to, from, next) {
          var isRecadastra;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (__WEBPACK_IMPORTED_MODULE_4__vuex_store__["a" /* default */].state.token) {
                    isRecadastra = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_44__validaPeriodoRecadastramentoFamiliar__["a" /* default */])('08/08/2022');

                    if (isRecadastra) {
                      next();
                    } else {
                      next({ name: 'EncerradoFamiliar' });
                    }
                  }

                case 1:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this);
        }));

        return function beforeEnter(_x4, _x5, _x6) {
          return _ref2.apply(this, arguments);
        };
      }()
    }, {
      path: 'recadastramento/dependente_cpf/encerrado',
      name: 'EncerradoFamiliar',
      component: __WEBPACK_IMPORTED_MODULE_16__pages_dependente_cpf_encerrado___default.a,
      meta: {
        recadastraActive: true,
        displayName: 'EncerradoFamiliar'
      }
    }, {
      path: 'recadastramento/endereco',
      name: 'Endereco',
      component: __WEBPACK_IMPORTED_MODULE_31__pages_recadastramento_endereco___default.a,
      meta: {
        recadastraActive: true,
        stepNumber: 2,
        displayName: 'Endereço'
      }
    }, {
      path: 'recadastramento/contatos',
      name: 'Contatos',
      component: __WEBPACK_IMPORTED_MODULE_32__pages_recadastramento_contatos___default.a,
      meta: {
        recadastraActive: true,
        stepNumber: 3,
        displayName: 'Contatos'
      }
    }, {
      path: 'recadastramento/documentacao',
      name: 'Documentacao',
      component: __WEBPACK_IMPORTED_MODULE_33__pages_recadastramento_documentacao___default.a,
      meta: {
        recadastraActive: true,
        stepNumber: 4,
        displayName: 'Documentação'
      }
    }, {
      path: 'recadastramento/filiacao',
      name: 'Filiacao',
      component: __WEBPACK_IMPORTED_MODULE_34__pages_recadastramento_filiacao___default.a,
      meta: {
        recadastraActive: true,
        stepNumber: 5,
        displayName: 'Família'
      }
    }, {
      path: 'recadastramento/envio',
      name: 'Envio',
      component: __WEBPACK_IMPORTED_MODULE_35__pages_recadastramento_envio___default.a,
      meta: {
        recadastraActive: true,
        stepNumber: 6,
        displayName: 'Envio'
      }
    }, {
      path: 'recadastramento/fim',
      name: 'Fim',
      component: __WEBPACK_IMPORTED_MODULE_36__pages_recadastramento_fim___default.a,
      meta: {
        recadastraActive: true,
        stepNumber: 7,
        displayName: 'Fim'
      }
    }, {
      path: 'recadastramento/encerrado',
      name: 'Encerrado',
      component: __WEBPACK_IMPORTED_MODULE_15__pages_recadastramento_encerrado___default.a,
      meta: {
        recadastraActive: true,
        displayName: 'Encerrado'
      }
    }, {
      path: 'ferias/agendamento',
      name: 'Ferias',
      component: __WEBPACK_IMPORTED_MODULE_37__pages_ferias_agendamento___default.a,
      meta: {
        feriasActive: true,
        contavel: true,
        titulo: 'Agendar Férias',
        imagem: 'ico-ferias.png',
        texto: 'Agende suas férias planejando o melhor período de acordo com feriados futuros.'
      }
    }, {
      path: 'ferias/aprovacao',
      name: 'Aprovacao',
      component: __WEBPACK_IMPORTED_MODULE_38__pages_ferias_aprovacao___default.a,
      meta: {
        feriasActive: true,
        contavel: true,
        titulo: 'Aprovar Férias',
        imagem: 'ico-ferias.png',
        texto: 'Analise e coordene as férias dos membros da sua equipe a partir de uma macro visão.'
      }
    }, {
      path: 'vale-alimentacao',
      name: 'ValeAlimentacao',
      component: __WEBPACK_IMPORTED_MODULE_47__pages_vale_alimentacao_index_vue___default.a,
      meta: {
        valeAlimentacaoActive: true,
        contavel: true,
        titulo: 'Solicitação de Vale Alimentação',
        imagem: 'ico-holerites.png',
        texto: 'Escolha a empresa de sua preferência para o Vale-Alimentação.'
      }
    }, {
      path: 'falta_lei',
      name: 'FaltaLei',
      component: __WEBPACK_IMPORTED_MODULE_39__pages_falta_lei___default.a,
      meta: {
        formulariosActive: true,
        contavel: true,
        titulo: 'Formulário Falta Lei',
        imagem: 'ico-previdenciario.png',
        texto: 'Imprima seu formulário de solicitação de falta lei com seus dados já inclusos.'
      }
    }, {
      path: 'declaracao-inclusao-imposto-renda',
      name: 'DeclaracaoInclusaoImpostoRenda',
      component: function component() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "E0cQ"));
      },
      meta: {
        formulariosActive: true,
        contavel: true,
        titulo: 'Declaração de Inclusão IR',
        imagem: 'ico-previdenciario.png',
        texto: 'Imprima sua declaração de inclusão de dependentes para Imposto de Renda.'
      }
    }, {
      path: 'declaracao-exclusao-imposto-renda',
      name: 'DeclaracaoExclusaoImpostoRenda',
      component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "W0Zq"));
      },
      meta: {
        formulariosActive: true,
        contavel: true,
        titulo: 'Declaração de Exclusão IR',
        imagem: 'ico-previdenciario.png',
        texto: 'Imprima sua declaração de exclusão de dependentes para Imposto de Renda.'
      }
    }, {
      path: 'nao-encontrado',
      name: 'NaoEncontrado',
      component: __WEBPACK_IMPORTED_MODULE_9__pages_nao_encontrado___default.a
    }, {
      path: '*',
      redirect: 'nao-encontrado'
    }, {
      path: '/credenciamento-sesc',
      name: 'CredenciamentoSesc',
      component: __WEBPACK_IMPORTED_MODULE_10__pages_credenciamento_sesc___default.a,
      meta: {
        titulo: 'Credenciamento Sesc'
      }
    }]
  }, {
    path: '/impresso',
    component: __WEBPACK_IMPORTED_MODULE_7__Impresso___default.a,
    children: [{
      path: 'falta_lei/:diaSolicitacao/:mesSolicitacao/:anoSolicitacao/' + ':diaFalta/:mesFalta/:anoFalta/:index',
      name: 'FaltaLeiImpresso',
      component: __WEBPACK_IMPORTED_MODULE_40__pages_falta_lei_pagina_impresso___default.a
    }, {
      path: 'declaracao-inclusao-imposto-renda',
      name: 'DeclaracaoInclusaoImpostoRendaImpresso',
      component: function component() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "HdCj"));
      }
    }, {
      path: 'declaracao-exclusao-imposto-renda',
      name: 'DeclaracaoExclusaoImpostoRendaImpresso',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "vrmS"));
      }
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  var tokenEhValido = __WEBPACK_IMPORTED_MODULE_4__vuex_store__["a" /* default */].state.token;
  var sshdLogado = __WEBPACK_IMPORTED_MODULE_4__vuex_store__["a" /* default */].state.usuarioLogado.sshd;

  if (from.name === 'Login' && tokenEhValido) {
    var rotas = router.options.routes[0].children;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__favoritos__["a" /* confereClicados */])(sshdLogado, rotas);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__tokenExpirado__["a" /* avisaAntesDeTokenExpirar */])(router.app);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__tokenExpirado__["b" /* forcaLogout */])(router);
  }

  if (to.path === '/' && tokenEhValido) {
    next({ name: 'Home' });
    return;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__favoritos__["b" /* contaCliques */])(to, sshdLogado);

  if (to.meta.requiresAuth === false) {
    next();
    return;
  }

  if (!tokenEhValido) {
    next({ path: '/' });
    return;
  }

  if (to.name === 'Sair') {
    __WEBPACK_IMPORTED_MODULE_18__pages_sair__["a" /* default */].logout(router.app, next);
    return;
  }

  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yjkh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var PeriodoAtualHelper = function () {
    function PeriodoAtualHelper() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PeriodoAtualHelper);

        throw 'Não é possível instanciar PeriodoAtualHelper';
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PeriodoAtualHelper, null, [{
        key: 'validaPeriodo',
        value: function validaPeriodo(dataInicial, dataFinal) {
            var hoje = new Date();
            var inicio = new Date(dataInicial);
            var fim = new Date(dataFinal);
            return inicio <= hoje && fim >= hoje;
        }
    }, {
        key: 'periodoEncerrado',
        value: function periodoEncerrado(dataFinal) {
            var hoje = new Date();
            var fim = new Date(dataFinal);
            return hoje > fim;
        }
    }]);

    return PeriodoAtualHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (PeriodoAtualHelper);

/***/ }),

/***/ "YtJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate__ = __webpack_require__("424j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_usuarioLogado__ = __webpack_require__("xUO3");






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
	state: {
		token: '',
		usuarioLogado: new __WEBPACK_IMPORTED_MODULE_4__domain_usuarioLogado__["a" /* default */](),
		autenticados: [],
		funcionario: {},
		graus: [],
		funcionarioCadastrado: {},
		cadastroModelo: {},
		estados: [],
		situacaoRecad: null,
		municipioSelecionado: ''
	},
	mutations: {
		setToken: function setToken(state, payload) {
			state.token = payload;
		},
		setUsuarioLogado: function setUsuarioLogado(state, payload) {
			state.usuarioLogado = payload;
		},
		setAutenticados: function setAutenticados(state, payload) {
			state.autenticados = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(payload));
		},
		setFuncionario: function setFuncionario(state, payload) {
			state.funcionario = payload;
		},
		setGraus: function setGraus(state, payload) {
			state.graus = payload;
		},
		setFuncionarioCadastrado: function setFuncionarioCadastrado(state, payload) {
			state.funcionarioCadastrado = payload;
		},
		setEstados: function setEstados(state, payload) {
			state.estados = payload;
		},
		setCadastroModelo: function setCadastroModelo(state, payload) {
			state.cadastroModelo = payload;
		},
		setArquivosRecadastramento: function setArquivosRecadastramento(state, payload) {
			state.funcionarioCadastrado.anexos = payload;
		},
		setSituacaoRecad: function setSituacaoRecad(state, situacaoRecad) {
			state.situacaoRecad = situacaoRecad;
		},
		setMunicipioSelecionado: function setMunicipioSelecionado(state, payload) {
			state.municipioSelecionado = payload;
		}
	},
	actions: {
		updateSituacaoRecad: function updateSituacaoRecad(_ref, situacaoRecad) {
			var commit = _ref.commit;

			commit('setSituacaoRecad', situacaoRecad);
		}
	},
	getters: {
		getSituacaoRecad: function getSituacaoRecad(state) {
			return state.situacaoRecad;
		}
	},
	plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate__["a" /* default */])({
		storage: window.sessionStorage
	})]
}));

/***/ }),

/***/ "YuI6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rodape',
  methods: {
    mostraRodape: function mostraRodape() {
      var html = document.querySelector('html').clientHeight;
      var tela = window.innerHeight;
      var posicao = window.innerHeight + window.scrollY;

      if (tela === posicao) {
        window.scrollTo({ top: html, behavior: 'smooth' });
      }
    }
  }
});

/***/ }),

/***/ "YydT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z4Us":
/***/ (function(module, exports) {

module.exports = {"idPessoa":13022,"cpf":"14894052830","sshd":"W0494373","primeiroNome":"Carlos","nome":"CARLOS HENRIQUE BORGES FORTES WIMMER","funcionarios":[{"id":9290,"cargoPrincipal":"TÉCNICO DE INFORMÁTICA","siglaUnidadeOrganizacional":"SEMAPRO","unidadeOrganizacional":"SEÇÃO DE PRODUCAO E MANUTENÇÃO DE PROGRAMAS DE INFORMAÇÃO","dataInicioAtividade":"2012-06-19","dataFimAtividade":null,"tipo":"QUADRO_PERMANENTE","centroCustoFormatado":"13.05.01.02","registroFormatado":"30.867-6","uorId":310,"perfis":["APROVADOR_AGENDAMENTO_FERIAS"]},{"id":9580,"cargoPrincipal":"PROFESSOR DE INFORMÁTICA","siglaUnidadeOrganizacional":"SEJA","unidadeOrganizacional":"SEÇÃO DE EDUCAÇÃO DE JOVENS E ADULTOS","dataInicioAtividade":"2010-01-20","dataFimAtividade":null,"tipo":"QUADRO_PERMANENTE","centroCustoFormatado":"13.05.01.03","registroFormatado":"30.999-9","uorId":584,"perfis":[]}]}

/***/ }),

/***/ "ZAwl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Dependente = function Dependente() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var responsavelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var tipoDependenteId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var nome = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var mae = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var sexo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var cpf = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
  var dataNascimento = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
  var alteracaoEstadoCivil = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
  var anexos = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : [];

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Dependente);

  this.id = id;
  this.responsavelId = responsavelId;
  this.tipoDependenteId = tipoDependenteId;
  this.nome = nome;
  this.mae = mae;
  this.sexo = sexo;
  this.cpf = cpf;
  this.dataNascimento = dataNascimento;
  this.alteracaoEstadoCivil = alteracaoEstadoCivil;
  this.anexos = anexos;
};

/* harmony default export */ __webpack_exports__["a"] = (Dependente);

/***/ }),

/***/ "ZDE/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LogoXs.d373107.jpg";

/***/ }),

/***/ "ZGkd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_support_sample_data_usuarioLogado__ = __webpack_require__("Z4Us");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_support_sample_data_usuarioLogado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_support_sample_data_usuarioLogado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_funcionario__ = __webpack_require__("ecUU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__registraUsuarioLogado__ = __webpack_require__("l6dw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_ErrorHelper__ = __webpack_require__("+h9g");




var _this = this;








var perfisFuncionarioPermitidos = ['CARGO_LIVRE_PROVIMENTO', 'QUADRO_PERMANENTE', 'CELETISTA_ESTAVEL', 'CELETISTA_TEMPORARIO', 'EX_CSTC', 'MUNICIPALIZADO', 'CARGO_ELETIVO', 'CAPEP_CEDIDOS', 'CONSELHEIRO_TUTELAR'];

var listaFuncionariosLogados = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(vm) {
    var usuarioLogado, autenticado, funcionarios, funcionariosAtivos, funcionariosOrdenados, funcionariosMapeados, logado;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            usuarioLogado = __WEBPACK_IMPORTED_MODULE_4__vuex_store__["a" /* default */].state.usuarioLogado;
            _context.prev = 1;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].get('pessoas-fisicas/autenticada');

          case 4:
            autenticado = _context.sent;
            funcionarios = autenticado.funcionarios;


            if (!funcionarios.length) bloqueiaUsuarioInvalido(vm);

            funcionariosAtivos = funcionarios.filter(function (item) {
              return item.dataFimAtividade === null && item.dataInicioAtividade !== null && item.lotacao !== null && perfisFuncionarioPermitidos.includes(item.tipo.nome);
            });

            if (!funcionariosAtivos.length) bloqueiaUsuarioInvalido(vm);

            funcionariosOrdenados = funcionariosAtivos.sort(function (a, b) {
              if (a.dataInicioAtividade > b.dataInicioAtividade) return -1;
              if (a.dataInicioAtividade < b.dataInicioAtividade) return 1;
            });
            funcionariosMapeados = mapeiaFuncionarios(funcionariosOrdenados);
            logado = mapeiaLogado(autenticado, usuarioLogado, funcionariosMapeados);

            // registraUsuarioLogado(mock);

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__registraUsuarioLogado__["a" /* default */])(logado);
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context['catch'](1);

            (function (error) {
              var mensagem = __WEBPACK_IMPORTED_MODULE_8__helpers_ErrorHelper__["a" /* default */].trataMensagem(error);
              vm.$root.$refs.toastr.e(mensagem, 'Atenção');
            });

          case 18:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 15]]);
  }));

  return function listaFuncionariosLogados(_x) {
    return _ref.apply(this, arguments);
  };
}();

var bloqueiaUsuarioInvalido = function bloqueiaUsuarioInvalido(vm) {
  vm.$root.$refs.toastr.removeByType('success');
  vm.$root.$data.isAuthenticated = false;
  __WEBPACK_IMPORTED_MODULE_4__vuex_store__["a" /* default */].commit('setToken', '');
  vm.$router.push({ name: 'SemAcesso' });
};

var mapeiaFuncionarios = function mapeiaFuncionarios(funcionarios) {
  var mapeados = funcionarios.map(function (item) {
    if (item.lotacao && item.tipo) {
      var funcionario = new __WEBPACK_IMPORTED_MODULE_6__domain_funcionario__["a" /* default */](item.id, item.cargoPrincipal, item.lotacao.sigla, item.lotacao.nome, item.dataInicioAtividade, item.dataFimAtividade, item.tipo.nome, item.lotacao.codigoCentroCustoFormatado, item.registroFormatado, item.lotacao.id, item.false);

      return funcionario;
    }
  });

  return mapeados;
};

var mapeiaLogado = function mapeiaLogado(autenticadoApi, usuario, funcionarios) {
  usuario.idPessoa = autenticadoApi.id;
  usuario.cpf = autenticadoApi.cpf;
  usuario.funcionarios = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(funcionarios));

  return usuario;
};

/* harmony default export */ __webpack_exports__["a"] = (listaFuncionariosLogados);

/***/ }),

/***/ "Zx+S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "anPr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bV+y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bu/5":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("XdQw"),
  /* template */
  __webpack_require__("2VWi"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "bx61":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var EnderecoService = function () {
    function EnderecoService() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, EnderecoService);

        throw 'Não é possível instanciar EnderecoService';
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(EnderecoService, null, [{
        key: 'listaEstados',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var endpoint;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                endpoint = mergeEndpoint() + "estados";
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

                            case 3:
                                return _context.abrupt('return', _context.sent);

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function listaEstados() {
                return _ref.apply(this, arguments);
            }

            return listaEstados;
        }()
    }, {
        key: 'listaMunicipios',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(siglaEstado) {
                var endpoint;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                endpoint = mergeEndpoint() + ('municipios/' + siglaEstado);
                                _context2.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

                            case 3:
                                return _context2.abrupt('return', _context2.sent);

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function listaMunicipios(_x) {
                return _ref2.apply(this, arguments);
            }

            return listaMunicipios;
        }()
    }]);

    return EnderecoService;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (EnderecoService);


var mergeEndpoint = function mergeEndpoint(id) {
    return 'api-endereco/' + (id || '');
};

/***/ }),

/***/ "c5jQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Aprovador = function Aprovador() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var nome = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var registro = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var cargo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Aprovador);

  this.id = id;
  this.nome = nome;
  this.registro = registro;
  this.cargo = cargo;
};

/* harmony default export */ __webpack_exports__["a"] = (Aprovador);

/***/ }),

/***/ "cTmi":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("XHEd")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("9cx5"),
  /* template */
  __webpack_require__("9nt4"),
  /* scopeId */
  "data-v-50ec9e62",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "cZEe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var validaPeriodoRecadastramentoFamiliar = function validaPeriodoRecadastramentoFamiliar(dataFim) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).isBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default()(dataFim, 'DD/MM/YYYY'));
};

/* harmony default export */ __webpack_exports__["a"] = (validaPeriodoRecadastramentoFamiliar);

/***/ }),

/***/ "cc5l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var AvaliacaoEstagioProbatorioService = function () {
  function AvaliacaoEstagioProbatorioService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AvaliacaoEstagioProbatorioService);

    throw 'Não é possível instanciar AvaliacaoEstagioProbatorioService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AvaliacaoEstagioProbatorioService, null, [{
    key: 'obtem',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint(id);
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function obtem(_x) {
        return _ref.apply(this, arguments);
      }

      return obtem;
    }()
  }, {
    key: 'atualiza',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id, item) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = mergeEndpoint(id);
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].put(endpoint, item);

              case 3:
                return _context2.abrupt('return', _context2.sent);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function atualiza(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return atualiza;
    }()
  }]);

  return AvaliacaoEstagioProbatorioService;
}();

/* harmony default export */ __webpack_exports__["a"] = (AvaliacaoEstagioProbatorioService);


var mergeEndpoint = function mergeEndpoint(id) {
  return 'avaliacoes-estagio-probatorio/' + id;
};

/***/ }),

/***/ "crW4":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("u3Op")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("gTyn"),
  /* template */
  __webpack_require__("NGiz"),
  /* scopeId */
  "data-v-6235ce5d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "d1MV":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "dC5d":
/***/ (function(module, exports) {

module.exports = [{"id":3,"periodoAquisitivo":2021,"registro":"44.733-2","nome":"Mônica Velasquez Paparrazzi","lotacao":"SEPAI","dataInicioFerias":null,"statusAprovacao":"PENDENTE"},{"id":11,"periodoAquisitivo":2020,"registro":"14.569-8","nome":"Sérgio Magalhães Santouro","lotacao":"SEMAPRO","dataInicioFerias":"2021-10-12","statusAprovacao":"EM_ANALISE"},{"id":10,"periodoAquisitivo":2021,"registro":"52.555-2","nome":"Silas Abreu Machado","lotacao":"SEMAPRO","dataInicioFerias":"2022-04-11","statusAprovacao":"REPROVADA"},{"id":6,"periodoAquisitivo":2021,"registro":"29.111-2","nome":"Silas de Albuquerque Coutinho","lotacao":"SEMAPRO","dataInicioFerias":null,"statusAprovacao":"PENDENTE"},{"id":4,"periodoAquisitivo":2021,"registro":"52.555-2","nome":"Silvio Abreu Machado","lotacao":"SEMAPRO","dataInicioFerias":"2022-04-11","statusAprovacao":"REPROVADA"}]

/***/ }),

/***/ "dLc8":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("PPzv"),
  /* template */
  __webpack_require__("TQeL"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "dPOl":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "go-to-top",
    on: {
      "click": function($event) {
        return _vm.paraTopo()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-up fa-3x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ "dWeg":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("Y651")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("zIxy"),
  /* template */
  __webpack_require__("gmzR"),
  /* scopeId */
  "data-v-686609a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "dm3l":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ "e78A":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "e9Zu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var RecadastramentoService = function () {
  function RecadastramentoService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, RecadastramentoService);

    throw 'Não é possível instanciar RecadastramentoService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(RecadastramentoService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint();
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista() {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }, {
    key: 'listaPorAno',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = mergeEndpoint() + 'mesCompetencia';
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context2.abrupt('return', _context2.sent);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function listaPorAno() {
        return _ref2.apply(this, arguments);
      }

      return listaPorAno;
    }()
  }, {
    key: 'obtemPorId',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                endpoint = mergeEndpoint(id);
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context3.abrupt('return', _context3.sent);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function obtemPorId(_x) {
        return _ref3.apply(this, arguments);
      }

      return obtemPorId;
    }()
  }, {
    key: 'grava',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id, cadastro) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                endpoint = mergeEndpoint(id);
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].put(endpoint, cadastro);

              case 3:
                return _context4.abrupt('return', _context4.sent);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function grava(_x2, _x3) {
        return _ref4.apply(this, arguments);
      }

      return grava;
    }()
  }]);

  return RecadastramentoService;
}();

/* harmony default export */ __webpack_exports__["a"] = (RecadastramentoService);


var mergeEndpoint = function mergeEndpoint(id) {
  return 'recadastramento-servidores/' + (id || '');
};

/***/ }),

/***/ "eMIN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_side_modal__ = __webpack_require__("dLc8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_side_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_side_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_support_sample_data_feriados_json__ = __webpack_require__("sTdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_support_sample_data_feriados_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_support_sample_data_feriados_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Side-Modal',

  data: function data() {
    return {
      ferias: {},
      calendario: __WEBPACK_IMPORTED_MODULE_7_moment___default()(),
      dataMinima: __WEBPACK_IMPORTED_MODULE_7_moment___default()(),
      dataEscolhida: null,
      dias: [],
      ehEditavel: true,
      salvarDesabilitado: true,
      navs: [{
        titulo: 'Férias',
        subtitulo: 'Período Aquisitivo',
        subtDetalhe: '',
        largura: 600,
        identidade: 'agendamento',
        abreProximo: false,
        aberto: false
      }],
      feriados: [],
      anoAtual: __WEBPACK_IMPORTED_MODULE_7_moment___default()().year(),
      showMonths: false,
      showYears: false,
      meses: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      anos: [],
      numeroMesesAgendaveis: 1,
      numeroMesesVisiveis: 3
    };
  },


  props: {
    inicioAtividade: {
      required: true,
      type: String
    },
    inicioSabado: {
      required: true,
      type: Boolean
    },
    inicioDomingoFeriado: {
      required: true,
      type: Boolean
    }
  },

  computed: {
    dataMinimaAgendamento: function dataMinimaAgendamento() {
      return this.dataMinima.subtract(1, 'days') && this.dataMinima.format('YYYY-MM-DD');
    },
    dataMaximaAgendamento: function dataMaximaAgendamento() {
      var dataMinimaMoment = this.dataMinima.add(1, 'days');

      if (this.dataMinima) {
        if (this.numeroMesesAgendaveis === 1) {

          var dataFinal = dataMinimaMoment.clone().endOf('month');
          var quantidadeDiasRestantes = dataFinal.diff(dataMinimaMoment, 'days', true);

          return __WEBPACK_IMPORTED_MODULE_7_moment___default()(dataMinimaMoment).add(quantidadeDiasRestantes, 'days').format('YYYY-MM-DD');
        }

        return __WEBPACK_IMPORTED_MODULE_7_moment___default()(dataMinimaMoment).add(this.numeroMesesAgendaveis - 1, 'months').add(dataMinimaMoment.daysInMonth(), 'days').format('YYYY-MM-DD');
      }
    },
    dataMinimaVisualizacao: function dataMinimaVisualizacao() {
      if (this.dataMinimaAgendamento) {
        if (this.numeroMesesVisiveis <= this.numeroMesesAgendaveis || this.numeroMesesVisiveis === this.numeroMesesAgendaveis + 1) {
          return this.dataMinimaAgendamento;
        }

        return this.dataMinimaAgendamento && __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.dataMinimaAgendamento).date(1).format('YYYY-MM-DD');
      }
    },
    dataMaximaVisualizacao: function dataMaximaVisualizacao() {
      if (this.dataMaximaAgendamento) {
        if (this.numeroMesesVisiveis <= this.numeroMesesAgendaveis) {
          return this.dataMaximaAgendamento;
        }

        if (this.numeroMesesVisiveis === this.numeroMesesAgendaveis + 1) {
          return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.dataMaximaAgendamento).add(1, 'months').format('YYYY-MM-DD');
        }

        return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.dataMaximaAgendamento).add(this.numeroMesesVisiveis - this.numeroMesesAgendaveis - 1, 'months').format('YYYY-MM-DD');
      }
    },
    dentroPeriodoAgendamento: function dentroPeriodoAgendamento() {
      var primeiroMes = this.calendario.isSame(this.dataMinimaAgendamento, 'month');
      var dentroPeriodoAgendavel = this.calendario.isBetween(this.dataMinimaAgendamento, this.dataMaximaAgendamento, undefined, []);

      return primeiroMes || dentroPeriodoAgendavel;
    },
    escolhidoDia: function escolhidoDia() {
      return this.dataEscolhida ? this.dataEscolhida.format('DD') : this.dataMinima.format('DD');
    },
    escolhidoMes: function escolhidoMes() {
      return this.dataEscolhida ? this.dataEscolhida.format('MM') : this.dataMinima.format('MM');
    },
    escolhidoMesFull: function escolhidoMesFull() {
      return this.dataEscolhida ? this.dataEscolhida.format('MMMM') : this.dataMinima.format('MMMM');
    },
    escolhidoAno: function escolhidoAno() {
      return this.dataEscolhida ? this.dataEscolhida.year() : this.dataMinima.year();
    },
    calendarioMes: function calendarioMes() {
      return this.calendario && this.calendario.format('MM');
    },
    calendarioMesLess: function calendarioMesLess() {
      return this.calendario && this.calendario.format('MMM');
    },
    calendarioMesFull: function calendarioMesFull() {
      return this.calendario && this.calendario.format('MMMM');
    },
    calendarioAno: function calendarioAno() {
      return this.calendario && this.calendario.year();
    },
    mostraSetaMudaMesAnterior: function mostraSetaMudaMesAnterior() {
      if (!this.ehEditavel) return false;
      if (this.calendario && this.dataMinimaVisualizacao) {
        return !this.calendario.isSame(this.dataMinimaVisualizacao, 'month');
      }

      return true;
    },
    mostraSetaMudaMesPosterior: function mostraSetaMudaMesPosterior() {
      if (!this.ehEditavel) return false;
      if (this.calendario && this.dataMaximaVisualizacao) {
        return !this.calendario.isSame(this.dataMaximaVisualizacao, 'month');
      }

      return true;
    },
    mostraSetaMudaMes: function mostraSetaMudaMes() {
      if (!this.ehEditavel) return false;

      return this.numeroMesesAgendaveis > 3;
    },
    mostraSetaMudaAno: function mostraSetaMudaAno() {
      if (!this.ehEditavel) return false;
      if (this.dataMinimaAgendamento && this.dataMaximaAgendamento) {
        var anoDiferente = !__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.dataMinimaAgendamento).isSame(this.dataMaximaAgendamento, 'year');

        return anoDiferente && this.mostraSetaMudaMes;
      }

      return true;
    },
    mostraHeaderMudaMes: function mostraHeaderMudaMes() {
      return this.mostraSetaMudaMes ? 'month-header' : 'month-header month-header-readonly';
    },
    mostraHeaderMudaAno: function mostraHeaderMudaAno() {
      return this.mostraSetaMudaAno ? 'year-header' : 'year-header year-header-readonly';
    },
    coloreSegASexHeader: function coloreSegASexHeader() {
      return this.dentroPeriodoAgendamento || !this.ehEditavel ? '' : 'weekend';
    },
    coloreSabDomHeader: function coloreSabDomHeader() {
      return this.dentroPeriodoAgendamento || !this.ehEditavel ? 'weekend' : 'weekend-readonly';
    },
    ehMobile: function ehMobile() {
      return window.innerWidth < 520;
    }
  },

  methods: {
    // Métodos de input
    chamaProtocolo: function chamaProtocolo() {
      var _ferias = this.ferias,
          protocolo = _ferias.protocolo,
          agendamentoId = _ferias.id;

      this.$emit('mostraProtocolo', { protocolo: protocolo, agendamentoId: agendamentoId });
      this.fechaModal('agendamento');
    },
    cancela: function cancela() {
      this.fechaModal('agendamento');
    },
    confirmaGravacao: function confirmaGravacao(inicio, agendamentoId) {
      var _this = this;

      var sentences = [{ id: 1, message: 'Essa data será enviada ao seu ', bold: false }, { id: 2, message: 'superior imediato', bold: true }, { id: 3, message: ' para aprovação. ', bold: false }, { id: 4, message: 'Após aprovada,', bold: true }, {
        id: 5,
        message: 'não poderá ser alterada. ',
        bold: false
      }, {
        id: 6,
        message: 'Você deseja enviar a data ',
        bold: false
      }, {
        id: 7,
        message: this.escolhidoDia + '/' + this.escolhidoMes + '/' + this.escolhidoAno,
        bold: true
      }, {
        id: 8,
        message: 'para análise?',
        bold: false
      }];

      this.$root.$refs.modal.confirm(sentences, {
        yes: function yes() {
          _this.$emit('agendaData', { inicio: inicio, agendamentoId: agendamentoId });
          _this.fechaModal('agendamento');
        },
        title: 'Agendar Férias'
      });
    },
    salva: function salva() {
      var inicio = this.dataEscolhida.format('YYYY-MM-DD');
      var agendamentoId = this.ferias.id;

      if (this.bloqueiaSalvamento(inicio)) return;

      this.confirmaGravacao(inicio, agendamentoId);
    },
    marcaDia: function marcaDia(dia) {
      if (!this.ehEditavel) return;

      var novaData = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.calendario).date(dia.numero);

      if (this.ehDiaInvalido(dia) || this.ehFeriado(novaData)) return;

      if (!this.valida1AnoDeAtividade(novaData)) {
        this.$root.$refs.toastr.e('Só pode agendar férias depois de completar 1 ano de trabalho', 'Atenção');
        return;
      }

      if (!novaData.isBetween(this.dataMinimaAgendamento, this.dataMaximaAgendamento)) return;

      this.salvarDesabilitado = false;
      this.dataEscolhida = novaData;
    },
    marcaMesAno: function marcaMesAno(type, value) {
      if (!this.ehEditavel) return;

      var novaData = type === 'mes' ? __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.calendario).month(value) : __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.calendario).year(value);

      if (!novaData.isBetween(this.dataMinimaAgendamento, this.dataMaximaAgendamento, undefined, [])) return;

      this.salvarDesabilitado = false;
      this.calendario = novaData;
      this.montaCalendario('mudancaMesAno');
      type === 'mes' ? this.toggleMonths() : this.toggleYears();
    },
    toggleMonths: function toggleMonths() {
      if (!this.ehEditavel) return;

      if (!this.mostraSetaMudaMes) return;

      this.showYears = false;

      if (!this.showMonths) {
        document.querySelector('.calendar-month').classList.add('open');
        document.querySelector('.calendar-year').classList.remove('open');
      } else {
        document.querySelector('.calendar-month').classList.remove('open');
      }

      this.showMonths = !this.showMonths;
    },
    toggleYears: function toggleYears() {
      if (!this.ehEditavel) return;

      if (!this.mostraSetaMudaAno) return;

      this.showMonths = false;

      if (!this.showYears) {
        document.querySelector('.calendar-year').classList.add('open');
        document.querySelector('.calendar-month').classList.remove('open');
      } else {
        document.querySelector('.calendar-year').classList.remove('open');
      }

      this.showYears = !this.showYears;
    },


    // Métodos de validações
    valida1AnoDeAtividade: function valida1AnoDeAtividade(dataAnalisada) {
      var dataPermitida = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.inicioAtividade).add(1, 'years');

      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(dataAnalisada).isAfter(dataPermitida) || __WEBPACK_IMPORTED_MODULE_7_moment___default()(dataAnalisada).isSame(dataPermitida);
    },
    validaDepoisDaDataMinima: function validaDepoisDaDataMinima(dataEscolhida, dataMinima) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(dataEscolhida).isSameOrAfter(dataMinima);
    },
    bloqueiaSalvamento: function bloqueiaSalvamento(inicio) {
      if (!this.valida1AnoDeAtividade(inicio)) {
        this.$root.$refs.toastr.e('Só pode agendar férias depois de completar 1 ano de trabalho', 'Atenção');
        return true;
      }

      var dia = {
        numero: __WEBPACK_IMPORTED_MODULE_7_moment___default()(inicio).date(),
        semana: __WEBPACK_IMPORTED_MODULE_7_moment___default()(inicio).day()
      };

      if (!this.validaDepoisDaDataMinima(inicio, this.dataMinima)) {
        this.$root.$refs.toastr.e('Escolha uma data válida', 'Atenção');
        return true;
      }

      if (this.ehDiaInvalido(dia)) {
        var primeiroDia = this.inicioDomingoFeriado ? 'domingo' : 'segunda-feira';
        var ultimoDia = this.inicioSabado ? 'sábado' : 'sexta-feira';
        this.$root.$refs.toastr.e('Escolha um dia entre ' + primeiroDia + ' e ' + ultimoDia, 'Atenção');
        return true;
      }

      if (this.ehFeriado(__WEBPACK_IMPORTED_MODULE_7_moment___default()(inicio))) {
        this.$root.$refs.toastr.e('Escolha um dia que n\xE3o seja feriado', 'Atenção');
        return true;
      }

      return false;
    },
    ehDiaInvalido: function ehDiaInvalido(dia) {
      var domingo = dia.semana === 0 && !this.inicioDomingoFeriado;
      var sabado = dia.semana === 6 && !this.inicioSabado;

      return domingo || sabado;
    },
    ehFeriado: function ehFeriado(dataInicio) {
      var data = dataInicio.format('YYYY-MM-DD');
      var dataEhFeriado = this.feriados.some(function (feriado) {
        return feriado.data === data;
      });
      var naoPermiteAgendarNoFeriado = !this.inicioDomingoFeriado;

      return dataEhFeriado && naoPermiteAgendarNoFeriado;
    },


    // Métodos de leitura de dados
    listaFeriados: function listaFeriados(anos) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endPointFeriados, anosJoined, queryParams, feriadosResponse, message;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                endPointFeriados = 'feriados-pontos-facultativos';
                anosJoined = anos.join(',');
                queryParams = { params: { anos: anosJoined } };
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6__services_api__["a" /* default */].get(endPointFeriados, queryParams);

              case 6:
                feriadosResponse = _context.sent;
                return _context.abrupt('return', feriadosResponse.length && feriadosResponse);

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);
                message = _context.t0.data[0].message;


                _this2.$root.$refs.toastr.e(message, 'Atenção');

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 10]]);
      }))();
    },


    // Métodos handle
    trataDataInicio: function trataDataInicio(inicio) {
      if (this.ehEditavel) {
        var dataPermitida = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.inicioAtividade).add(1, 'years');
        var hoje = __WEBPACK_IMPORTED_MODULE_7_moment___default()();
        var dataInicio = __WEBPACK_IMPORTED_MODULE_7_moment___default()(inicio);

        this.dataMinima = __WEBPACK_IMPORTED_MODULE_7_moment___default.a.max(dataPermitida, hoje, dataInicio);
        this.calendario = __WEBPACK_IMPORTED_MODULE_7_moment___default.a.max(dataPermitida, hoje, dataInicio);

        return;
      }

      this.dataEscolhida = __WEBPACK_IMPORTED_MODULE_7_moment___default()(inicio);
      this.calendario = __WEBPACK_IMPORTED_MODULE_7_moment___default()(inicio);
    },
    limpaTogglesMesAno: function limpaTogglesMesAno() {
      this.showMonths = false;
      this.showYears = false;
      document.querySelector('.calendar-month').classList.remove('open');
      document.querySelector('.calendar-year').classList.remove('open');
    },
    limpaSideModal: function limpaSideModal() {
      var _this3 = this;

      setTimeout(function () {
        _this3.dataEscolhida = null;
        _this3.limpaTogglesMesAno();
        _this3.salvarDesabilitado = true;
      }, 600);
    },
    montaCalendario: function montaCalendario(operacao) {
      var data = this.calendario.clone();

      if (operacao === 'soma') data.add(1, 'months');
      this.salvarDesabilitado = false;
      if (operacao === 'subtracao') data.subtract(1, 'months');

      this.calendario = data.clone();

      var diasNoMes = data.daysInMonth();
      var diasArray = [];

      while (diasNoMes) {
        var cadaDia = {};
        var current = data.date(diasNoMes);
        cadaDia.numero = current.date();
        cadaDia.semana = current.day();

        diasArray.push(cadaDia);
        diasNoMes--;
      }

      this.dias = diasArray.reverse();
    },
    listaAnos: function listaAnos() {
      var ano = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.dataMinimaVisualizacao).year();
      var ultimoAno = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.dataMaximaVisualizacao).year();
      var anosArray = [];

      while (ano <= ultimoAno) {
        anosArray.push(ano);
        ano++;
      }

      this.anos = [].concat(anosArray);
    },
    mudaCorDoDia: function mudaCorDoDia(dia) {
      var diaCalendario = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.calendario).date(dia.numero);

      if (this.ehEditavel) {
        if ((this.ehDiaInvalido(dia) || this.ehFeriado(diaCalendario)) && !this.dentroPeriodoAgendamento) return 'day weekend-readonly';

        if (this.ehDiaInvalido(dia) || this.ehFeriado(diaCalendario) || !diaCalendario.isBetween(this.dataMinimaAgendamento, this.dataMaximaAgendamento)) return 'day weekend';

        if (this.dataEscolhida && dia.numero === this.dataEscolhida.date() && this.calendario.isSame(this.dataEscolhida, 'month', 'year')) return 'day active';

        return 'day';
      }

      if (this.ehDiaInvalido(dia) || this.ehFeriado(diaCalendario)) {
        return 'readonly weekend';
      }

      if (diaCalendario.isSame(this.dataEscolhida)) return 'readonly active';

      return 'readonly';
    },
    trataFeriados: function trataFeriados() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var listaFeriados;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.listaFeriados(_this4.anos);

              case 2:
                listaFeriados = _context2.sent;

                _this4.feriados = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(listaFeriados));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    mudaCorDoMesAno: function mudaCorDoMesAno(type, value) {
      if (!this.ehEditavel) return;

      var novaData = type === 'mes' ? __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.calendario).month(value) : __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.calendario).year(value);

      if (type === 'mes' && value === this.calendarioMesFull) return 'month-year active';

      if (type === 'ano' && value === this.calendarioAno) return 'month-year active';

      if (novaData.isBetween(this.dataMinimaAgendamento, this.dataMaximaAgendamento, undefined, [])) return 'month-year';

      return 'month-year weekend';
    },


    // Outros métodos
    abreModal: function abreModal(identidade) {
      this.$emit('abreModal', identidade);
    },
    fechaModal: function fechaModal(identidade) {
      this.$emit('fechaModal', identidade);
      this.limpaSideModal();
    }
  },

  created: function created() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this5.$parent.$on('abreModal', function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref2) {
                  var identidade = _ref2.identidade,
                      ferias = _ref2.ferias,
                      inicio = _ref2.inicio,
                      editavel = _ref2.editavel;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _this5.ehEditavel = editavel;
                          _this5.trataDataInicio(inicio);
                          _this5.montaCalendario();
                          _this5.listaAnos();
                          _this5.navs[0].subtDetalhe = ferias.periodo.toString();
                          _this5.ferias = ferias;
                          _this5.salvarDesabilitado = true;
                          _context3.next = 9;
                          return _this5.trataFeriados();

                        case 9:
                          _this5.abreModal(identidade);

                        case 10:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this5);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this5);
    }))();
  },


  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_3__components_botao___default.a,
    SideModal: __WEBPACK_IMPORTED_MODULE_4__components_side_modal___default.a
  }
});

/***/ }),

/***/ "ecUU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Funcionario = function Funcionario() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var cargoPrincipal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var siglaUnidadeOrganizacional = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var unidadeOrganizacional = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var dataInicioAtividade = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var dataFimAtividade = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var tipo = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
  var centroCustoFormatado = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
  var registroFormatado = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
  var uorId = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
  var perfis = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : [];
  var cpf = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : '';
  var idPessoaFisica = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : null;
  var nome = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : '';

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Funcionario);

  this.id = id;
  this.cargoPrincipal = cargoPrincipal;
  this.siglaUnidadeOrganizacional = siglaUnidadeOrganizacional;
  this.unidadeOrganizacional = unidadeOrganizacional;
  this.dataInicioAtividade = dataInicioAtividade;
  this.dataFimAtividade = dataFimAtividade;
  this.tipo = tipo;
  this.centroCustoFormatado = centroCustoFormatado;
  this.registroFormatado = registroFormatado;
  this.uorId = uorId;
  this.perfis = perfis;
  this.cpf = cpf;
  this.idPessoaFisica = idPessoaFisica;
  this.nome = nome;
};

/* harmony default export */ __webpack_exports__["a"] = (Funcionario);

/***/ }),

/***/ "ex6t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_avaliacaoEstagioProbatorio__ = __webpack_require__("C6qM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_avaliado__ = __webpack_require__("vXSv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_avaliador__ = __webpack_require__("4JAb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_esconde_div__ = __webpack_require__("E20C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_esconde_div___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_esconde_div__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_avaliacaoEstagioProbatorioService__ = __webpack_require__("cc5l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_periodosEstagioProbatorioService__ = __webpack_require__("V1H8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_obtemImpressao__ = __webpack_require__("8QDf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelper__ = __webpack_require__("9t/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_PeriodoAtualHelper__ = __webpack_require__("Yjkh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_ErrorHelper__ = __webpack_require__("+h9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_timers__ = __webpack_require__("162o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DetalhaAvaliacaoEstagioProbatorio',

  data: function data() {
    return {
      avaliacao: {},
      periodos: {},
      notas: [],
      avaliadorId: this.$route.params.idAvaliador,
      funcionarioId: this.$route.params.idAvaliado,
      mostraParametros: false,
      mostraComprometimento: false,
      mostraDedicacao: false,
      mostraRelacionamento: false,
      mostraAtendimento: false,
      mostraCapacidade: false,
      apiErrors: null
    };
  },


  computed: {
    cargo: function cargo() {
      return this.avaliacao.avaliado.cargoReadaptado ? this.avaliacao.avaliado.cargoReadaptado : this.avaliacao.avaliado.cargoPrincipal;
    },
    cargoChefeImediato: function cargoChefeImediato() {
      return this.avaliacao.cargoAvaliador ? this.avaliacao.cargoAvaliador.toUpperCase() + ' ' + this.avaliacao.uorAvaliador.sigla : this.avaliacao.avaliador.cargoPrincipal + ' - ' + this.avaliacao.uorAvaliador.sigla;
    },
    dataInicioReferencia: function dataInicioReferencia() {
      return __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelper__["a" /* default */].convertDateToPtbr(this.periodos.dataInicioReferencia);
    },
    dataFimReferencia: function dataFimReferencia() {
      return __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelper__["a" /* default */].convertDateToPtbr(this.periodos.dataFimReferencia);
    },
    notasOrdenadas: function notasOrdenadas() {
      return this.avaliacao.notas.sort(function (a, b) {
        if (a.item.codigo < b.item.codigo) return -1;
        if (a.item.codigo > b.item.codigo) return 1;
      });
    },
    dataAvaliacao: function dataAvaliacao() {
      if (this.avaliacao.dataAvaliacao) {
        return __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelper__["a" /* default */].convertDateToPtbr(this.avaliacao.dataAvaliacao);
      }
    },
    peridoAvaliacao: function peridoAvaliacao() {
      return __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelper__["a" /* default */].convertDateToPtbr(this.avaliacao.dataInicioPeriodoAvaliacao) + ' a ' + __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelper__["a" /* default */].convertDateToPtbr(this.avaliacao.dataFimPeriodoAvaliacao);
    },
    somaPrimeiroAvaliador: function somaPrimeiroAvaliador() {
      var soma = 0;
      this.avaliacao.notas.forEach(function (nota) {
        return nota.notaAvaliador ? soma += parseInt(nota.notaAvaliador) : soma;
      });
      return soma;
    },
    somaSegundoAvaliador: function somaSegundoAvaliador() {
      var soma = 0;
      this.avaliacao.notas.forEach(function (nota) {
        return nota.notaSegundoAvaliador ? soma += parseInt(nota.notaSegundoAvaliador) : soma;
      });
      return soma;
    },
    mediaAvaliacoes: function mediaAvaliacoes() {
      var somaPrimeiroAvaliador = this.somaPrimeiroAvaliador;
      var somaSegundoAvaliador = this.somaSegundoAvaliador;

      if (!somaPrimeiroAvaliador || !somaSegundoAvaliador) {
        return null;
      }

      return (somaPrimeiroAvaliador + somaSegundoAvaliador) / 2;
    },
    pontuacaoFinal: function pontuacaoFinal() {
      var notaFichaFuncional = this.avaliacao.notaFichaFuncional;
      var notaHorasCursadas = this.avaliacao.notaHorasCursadas;
      var mediaAvaliacoes = this.mediaAvaliacoes;

      if (!mediaAvaliacoes) {
        return null;
      }

      return notaFichaFuncional + notaHorasCursadas + mediaAvaliacoes;
    },
    ehAvaliador: function ehAvaliador() {
      return this.ehPrimeiroAvaliador || this.ehSegundoAvaliador;
    },
    ehPrimeiroAvaliador: function ehPrimeiroAvaliador() {
      if (!this.avaliacao.avaliador) return false;
      return !this.ehAvaliado && this.avaliadorId == this.avaliacao.avaliador.id;
    },
    ehSegundoAvaliador: function ehSegundoAvaliador() {
      if (!this.avaliacao.segundoAvaliador) return false;
      return !this.ehAvaliado && this.avaliadorId == this.avaliacao.segundoAvaliador.id;
    },
    ehAvaliado: function ehAvaliado() {
      return this.avaliacao.avaliado.id == this.avaliadorId;
    },
    periodoValido: function periodoValido() {
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(new Date()).isBetween(this.periodos.dataInicioLancamento, this.periodos.dataFimLancamento, 'day', '[]');
    },
    naoFinalizadoComPeriodoEncerrado: function naoFinalizadoComPeriodoEncerrado() {
      return this.avaliacao.aceita == null && __WEBPACK_IMPORTED_MODULE_13__helpers_PeriodoAtualHelper__["a" /* default */].periodoEncerrado(this.periodos.dataFimLancamento);
    },
    avaliacaoFinalizada: function avaliacaoFinalizada() {
      return this.avaliacao.aceita != null;
    },
    habilitaNotasPrimeiroAvaliador: function habilitaNotasPrimeiroAvaliador() {
      var resultado = this.ehPrimeiroAvaliador && this.periodoValido && !this.avaliacaoFinalizada;
      return resultado;
    },
    habilitaNotasSegundoAvaliador: function habilitaNotasSegundoAvaliador() {
      var resultado = this.ehSegundoAvaliador && this.periodoValido && !this.avaliacaoFinalizada;
      return resultado;
    },
    mostraSalvar: function mostraSalvar() {
      var resultado = this.periodoValido && !this.avaliacaoFinalizada && this.ehAvaliador;
      return resultado;
    },
    mostraFinalizar: function mostraFinalizar() {
      var resultado = this.periodoValido && !this.ehAvaliador && this.foiAvaliado && !this.avaliacaoFinalizada;
      return resultado;
    },
    foiAvaliado: function foiAvaliado() {
      return this.somaPrimeiroAvaliador > 0 && this.somaSegundoAvaliador > 0;
    },
    mostraImprimir: function mostraImprimir() {
      return !this.periodoValido || this.ehAvaliador || this.avaliacaoFinalizada;
    }
  },

  methods: {
    voltar: function voltar() {
      if (this.ehAvaliador) {
        this.$router.push({ name: 'AvaliadosEstagioProbatorio', params: { params: { id: this.avaliadorId } } });
      } else {
        this.$router.push({ name: 'AvaliacaoEstagioProbatorio' });
      }
    },
    valida: function valida(metodo) {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (success) {
          metodo === 'salvar' ? _this.salvar() : _this.finalizar();
          return;
        }
        _this.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção');
      });
    },
    salvar: function salvar() {
      var _this2 = this;

      var sentences = [{
        id: 1,
        message: 'Deseja salvar essa avaliação?',
        bold: false
      }];

      this.$root.$refs.modal.confirm(sentences, {
        yes: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            var response;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return _this2.gravaFinalizaAvaliacao(_this2.avaliacao.id, _this2.avaliacao, null);

                  case 2:
                    response = _context.sent;


                    if (response.status == 200) {
                      _this2.$root.$refs.toastr.s('Avaliação salva', 'Sucesso');
                    }

                    _this2.chamaProximaTela();

                  case 5:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function yes() {
            return _ref.apply(this, arguments);
          };
        }(),
        title: 'Salvar Avaliação'
      });
    },
    gravaFinalizaAvaliacao: function gravaFinalizaAvaliacao(id, item, aceita) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var mensagem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                item.aceita = aceita;

                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9__services_avaliacaoEstagioProbatorioService__["a" /* default */].atualiza(id, item);

              case 4:
                return _context2.abrupt('return', _context2.sent);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_14__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context2.t0);

                _this3.$root.$refs.toastr.e(mensagem, 'Atenção');
                return _context2.abrupt('return', _context2.t0);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 7]]);
      }))();
    },
    finalizar: function finalizar() {
      jQuery('#finalizaModal').modal('show');
    },
    discorda: function discorda() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.gravaFinalizaAvaliacao(_this4.avaliacao.id, _this4.avaliacao, false);

              case 2:
                response = _context3.sent;


                if (response.status == 200) {
                  _this4.$root.$refs.toastr.s('Avaliação finalizada', 'Sucesso');
                }

                jQuery('#finalizaModal').modal('hide');
                _this4.$router.push({ name: 'AvaliacaoEstagioProbatorio' });

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    concorda: function concorda() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this5.gravaFinalizaAvaliacao(_this5.avaliacao.id, _this5.avaliacao, true);

              case 2:
                response = _context4.sent;


                if (response.status == 200) {
                  _this5.$root.$refs.toastr.s('Avaliação finalizada', 'Sucesso');
                }

                jQuery('#finalizaModal').modal('hide');
                _this5.$router.push({ name: 'AvaliacaoEstagioProbatorio' });

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    imprime: function imprime(id) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var endpoint, mensagem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                endpoint = 'avaliacoes-estagio-probatorio/' + id + '/ficha';
                _context5.prev = 1;
                _context5.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__services_obtemImpressao__["a" /* default */])(endpoint);

              case 4:
                _context5.next = 11;
                break;

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_14__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context5.t0);

                if (mensagem === 'Desbloqueie as pop-ups para este site') {
                  _this6.$root.$refs.toastr.w(mensagem, 'Pop-up bloqueada');
                }
                _this6.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[1, 6]]);
      }))();
    },
    obtemAvaliacaoENotas: function obtemAvaliacaoENotas() {
      var _this7 = this;

      var avaliacoes = JSON.parse(sessionStorage.getItem('periodosEstagioProbatorio'));
      this.avaliacao = avaliacoes.find(function (item) {
        return item.avaliado.id == _this7.funcionarioId;
      });
      this.periodos = this.avaliacao.competencia.periodos[0];
    },
    obtemAvaliados: function obtemAvaliados(funcionarioId, idMes) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var avaliacoes, mensagem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10__services_periodosEstagioProbatorioService__["a" /* default */].lista(funcionarioId, idMes);

              case 3:
                avaliacoes = _context6.sent;

                sessionStorage.setItem('periodosEstagioProbatorio', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(avaliacoes));
                _context6.next = 11;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6['catch'](0);
                mensagem = __WEBPACK_IMPORTED_MODULE_14__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context6.t0);

                _this8.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 11:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[0, 7]]);
      }))();
    },
    chamaProximaTela: function chamaProximaTela() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var avaliadorId;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!_this9.ehAvaliador) {
                  _context7.next = 6;
                  break;
                }

                avaliadorId = _this9.avaliacao.avaliador.id;
                _context7.next = 4;
                return _this9.obtemAvaliados(avaliadorId, _this9.avaliacao.competencia.id);

              case 4:
                _this9.$router.push({ name: 'AvaliadosEstagioProbatorio', params: { id: avaliadorId } });

                return _context7.abrupt('return');

              case 6:
                _this9.$router.push({ name: 'AvaliacaoEstagioProbatorio' });

              case 7:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9);
      }))();
    }
  },

  created: function created() {
    this.avaliacao = new __WEBPACK_IMPORTED_MODULE_4__domain_avaliacaoEstagioProbatorio__["a" /* default */](new __WEBPACK_IMPORTED_MODULE_5__domain_avaliado__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_6__domain_avaliador__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_6__domain_avaliador__["a" /* default */]());
    this.obtemAvaliacaoENotas();
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },


  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_7__components_botao___default.a,
    EscondeDiv: __WEBPACK_IMPORTED_MODULE_8__components_esconde_div___default.a
  }
});

/***/ }),

/***/ "f19i":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("YQgU"),
  /* template */
  __webpack_require__("P/VR"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "fK6S":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("OHw6"),
  /* template */
  __webpack_require__("W8LH"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "fPMj":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("uND1")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("eMIN"),
  /* template */
  __webpack_require__("WUBI"),
  /* scopeId */
  "data-v-19a36e30",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "fQ6R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */], {
  fieldsBagName: 'veeFields'
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "field-validation",

  computed: {
    problems: function problems() {
      var result = [];
      if (this.status.has(this.field)) {
        result.push(this.status.first(this.field));
      }

      if (this.customErrors && this.customErrors[this.field]) {
        this.customErrors[this.field].forEach(function (item) {
          result.push(item);
        });
      }

      return result.length > 0 ? result : false;
    }
  },
  props: {
    status: Object,
    field: String,
    label: String,
    cssClass: String,
    customErrors: Object,
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  locale: function locale(lang, label) {
    __WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* Validator */].localize(label, lang);
  }
});

/***/ }),

/***/ "fXuD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_card_header__ = __webpack_require__("8KSN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_card_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_card_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__impresso__ = __webpack_require__("kmnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__impresso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__impresso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelper__ = __webpack_require__("9t/u");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FaltaLei',
  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_0__components_botao___default.a,
    Impresso: __WEBPACK_IMPORTED_MODULE_2__impresso___default.a,
    CardHeader: __WEBPACK_IMPORTED_MODULE_1__components_card_header___default.a
  },
  data: function data() {
    return {
      autenticados: this.$store.state.usuarioLogado.funcionarios,
      funcionario: this.$store.state.funcionario,
      nomeFuncionario: this.$store.state.usuarioLogado.nome,
      dataSolicitacao: '',
      dataFalta: '',
      dataSolicitacaoSm: '',
      dataFaltaSm: ''
    };
  },

  computed: {
    telaEhMobile: function telaEhMobile() {
      return window.innerWidth <= 768;
    },
    usuarioAtual: function usuarioAtual() {
      return this.$store.state.funcionario;
    }
  },
  watch: {
    usuarioAtual: function usuarioAtual(novo, anterior) {
      this.funcionario = novo;
    }
  },
  methods: {
    pegaSolicitada: function pegaSolicitada(solicitacao) {
      this.dataSolicitacao = solicitacao;
    },
    pegaFalta: function pegaFalta(falta) {
      this.dataFalta = falta;
    },
    valida: function valida() {
      this.buscaDatas();
      var diaSolicitado = __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelper__["a" /* default */].convertDateToApiDate(this.dataSolicitacao);
      var diaAbonado = __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelper__["a" /* default */].convertDateToApiDate(this.dataFalta);
      if (this.dataSolicitacao && this.dataFalta && diaSolicitado < diaAbonado) {
        this.gerar();
        return;
      }
      this.$root.$refs.toastr.e('Data da solicitação deve ser anterior à data da falta abonada.', 'Atenção');
    },
    buscaDatas: function buscaDatas() {
      if (this.dataSolicitacaoSm && this.dataFaltaSm) {
        this.dataSolicitacao = __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelper__["a" /* default */].convertDateToPtbr(this.dataSolicitacaoSm);
        this.dataFalta = __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelper__["a" /* default */].convertDateToPtbr(this.dataFaltaSm);
        return;
      }
      this.$emit('enviaDatas');
    },
    gerar: function gerar() {
      var _this = this;

      var indexFuncionario = this.autenticados.findIndex(function (autenticado) {
        return autenticado.id === _this.funcionario.id;
      });

      this.$router.push({
        name: 'FaltaLeiImpresso',
        params: {
          diaFalta: this.dataFalta.split('/')[0],
          mesFalta: this.dataFalta.split('/')[1],
          anoFalta: this.dataFalta.split('/')[2],
          diaSolicitacao: this.dataSolicitacao.split('/')[0],
          mesSolicitacao: this.dataSolicitacao.split('/')[1],
          anoSolicitacao: this.dataSolicitacao.split('/')[2],
          index: indexFuncionario
        }
      });
    },
    anteriorLink: function anteriorLink() {
      this.$router.go(-1);
    }
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "fm+M":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "explicacaoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "explicacaoModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Entendi",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "side-modal"
    }
  }, [_c('side-modal', {
    attrs: {
      "sides": _vm.navs
    },
    on: {
      "cancela": function($event) {
        return _vm.cancela()
      }
    }
  }, [_c('template', {
    slot: _vm.navs[0].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "CPF",
      "field": "cpf",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:14'),
      expression: "'required|min:14'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenciaModal.dependente.cpf),
      expression: "dependenciaModal.dependente.cpf"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cpf",
      "id": "cpf",
      "data-vv-as": "CPF"
    },
    domProps: {
      "value": (_vm.dependenciaModal.dependente.cpf)
    },
    on: {
      "change": function($event) {
        return _vm.verificaCpf($event.target.value)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenciaModal.dependente, "cpf", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.telaEhMobile) ? _c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Data de Nascimento",
      "field": "dataNascimento",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenciaModal.dependente.dataNascimento),
      expression: "dependenciaModal.dependente.dataNascimento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "dataNascimento",
      "id": "dataNascimento",
      "data-vv-as": "Data de Nascimento"
    },
    domProps: {
      "value": (_vm.dependenciaModal.dependente.dataNascimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenciaModal.dependente, "dataNascimento", $event.target.value)
      }
    }
  })]) : _c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Data de Nascimento",
      "field": "dataNascimento",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataNascimento",
      "id": "dataNascimento",
      "config": _vm.config,
      "data-vv-as": "Data de Nascimento"
    },
    model: {
      value: (_vm.dependenciaModal.dependente.dataNascimento),
      callback: function($$v) {
        _vm.$set(_vm.dependenciaModal.dependente, "dataNascimento", $$v)
      },
      expression: "dependenciaModal.dependente.dataNascimento"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-12 col-sm-12",
      "label": "Nome",
      "field": "nome",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenciaModal.dependente.nome),
      expression: "dependenciaModal.dependente.nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:50'),
      expression: "'required|max:50'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome",
      "id": "nome",
      "autofocus": "autofocus",
      "data-vv-as": "Nome"
    },
    domProps: {
      "value": (_vm.dependenciaModal.dependente.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenciaModal.dependente, "nome", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Parentesco",
      "field": "parentesco",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenciaModal.grau),
      expression: "dependenciaModal.grau"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "parentesco",
      "data-vv-as": "Parentesco"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dependenciaModal, "grau", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.graus), function(grau) {
    return _c('option', {
      key: _vm.graus.indexOf(grau),
      domProps: {
        "value": grau.name
      }
    }, [_vm._v("\n                      " + _vm._s(_vm._f("tudoMaiusculo")(grau.displayName)) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Sexo",
      "field": "sexo",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenciaModal.dependente.sexo),
      expression: "dependenciaModal.dependente.sexo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "sexo",
      "id": "sexo",
      "data-vv-as": "Sexo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dependenciaModal.dependente, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.sexos), function(sexo) {
    return _c('option', {
      key: _vm.sexos.indexOf(sexo),
      domProps: {
        "value": sexo.name
      }
    }, [_vm._v("\n                      " + _vm._s(_vm._f("tudoMaiusculo")(sexo.displayName)) + "\n                    ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [(_vm.rendasOrdenadas.length === 0) ? _c('div', [_c('div', {
    staticClass: "col-xs-12 form-group",
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_c('label', [_vm._v("Renda Anual")])])]) : _c('div', [_c('div', {
    staticClass: "form-group col-lg-6 col-md-6 col-sm-6 col-xs-4"
  }, [_c('label', [_vm._v("Ano Referência")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.rendasOrdenadas[0].anoReferencia))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', [_vm._v("Renda Anual")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("monetarioMask")(_vm.rendasOrdenadas[0].valor)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-4",
    staticStyle: {
      "text-align": "right",
      "padding-top": "15px"
    }
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-cinza-sm",
      "icone": "editar-tabela"
    },
    on: {
      "clicado": function($event) {
        return _vm.editaRenda(_vm.dependenciaModal)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.rendaEhAnoAtual),
      expression: "!rendaEhAnoAtual"
    }],
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("\n                      Se houver, cadastre a renda de\n                    " + _vm._s(_vm.anoReferenciaAtual) + ".\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "row-field visible-xs"
  }, [_c('div', {
    staticClass: "col-xs-12 footer-controller-inner-modal",
    staticStyle: {
      "margin-top": "-7px"
    }
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde-dir",
      "rotulo": "Renda",
      "icone": "mais"
    },
    on: {
      "clicado": function($event) {
        return _vm.novaRenda()
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 footer-controller-inner-modal hidden-xs",
    staticStyle: {
      "margin-top": "-7px"
    }
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde-dir",
      "rotulo": "Renda",
      "icone": "mais"
    },
    on: {
      "clicado": function($event) {
        return _vm.novaRenda()
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancela()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Salvar",
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.valida()
      }
    }
  })], 1)]), _vm._v(" "), _c('template', {
    slot: _vm.navs[1].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row row-field"
  }, [(_vm.anoEditavel) ? _c('field-validation', {
    attrs: {
      "css-class": "col-xs-7 col-sm-4",
      "label": "Ano Ref.",
      "field": "ano-referencia",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rendaModal.anoReferencia),
      expression: "rendaModal.anoReferencia"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (
        ("required|numeric|max_value:" + _vm.anoReferenciaAtual)
      ),
      expression: "\n                    `required|numeric|max_value:${anoReferenciaAtual}`\n                  "
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "203px"
    },
    attrs: {
      "type": "text",
      "name": "ano-referencia",
      "id": "ano-referencia",
      "data-vv-as": "Ano Ref."
    },
    domProps: {
      "value": (_vm.rendaModal.anoReferencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rendaModal, "anoReferencia", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "form-group col-xs-7 col-sm-4"
  }, [_c('label', [_vm._v("Ano Ref.")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.rendaModal.anoReferencia))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Renda Anual")]), _vm._v(" "), _c('money', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "rendaModal",
      "id": "rendaModal"
    },
    model: {
      value: (_vm.rendaModal.valor),
      callback: function($$v) {
        _vm.$set(_vm.rendaModal, "valor", $$v)
      },
      expression: "rendaModal.valor"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde-inline",
      "icone": "fa-plus fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.incluiRenda()
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('section', {
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "padding": "0 15px"
    }
  }, [(_vm.listaDeRendasModal.length === 0) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Não existe renda\n                  cadastrada.\n                ")]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Ano")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rendasOrdenadasModal), function(cadaRenda) {
    return _c('tr', {
      key: cadaRenda.anoReferencia
    }, [_c('td', [_vm._v(_vm._s(cadaRenda.anoReferencia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("monetarioMask")(cadaRenda.valor)))]), _vm._v(" "), _c('td', {
      staticClass: "td-btns td-btns-alone"
    }, [_c('botao', {
      attrs: {
        "tipo": "button",
        "estilo": "vazado-cinza-sm",
        "icone": "editar-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.editaRendaModal(cadaRenda)
        }
      }
    })], 1)])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancelaRenda()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Salvar Rendas",
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.salvaRenda()
      }
    }
  })], 1)])], 2)], 1), _vm._v(" "), _c('section', {
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Parceiros Econômicos \n                "), _c('small', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.abreExplicacaoModal()
      }
    }
  }, [_vm._v("(Quem é considerado parceiro econômico?)")])])]), _vm._v(" "), _c('div', [_c('table-loader', {
    attrs: {
      "carregando": _vm.carregando
    }
  }, [(_vm.dependencias.length == 0) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Não existem\n                    parceiros cadastrados.\n                  ")]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs hidden-sm"
  }, [_vm._v("\n                          Grau de Parentesco\n                        ")]), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dependenciasOrdenadas), function(dependencia) {
    return _c('tr', {
      key: _vm.dependencias.indexOf(dependencia)
    }, [_c('td', [_vm._v(_vm._s(dependencia.dependente.nome))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                          " + _vm._s(_vm._f("cpfMask")(dependencia.dependente.cpf)) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs hidden-sm"
    }, [_vm._v("\n                          " + _vm._s(_vm._f("grauParentescoFilter")(dependencia.grau)) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "td-btns"
    }, [_c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Apagar'),
        expression: "'Apagar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "tipo": "button",
        "estilo": "vazado-vermelho-sm",
        "icone": "exclui-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.exclui(dependencia)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Editar'),
        expression: "'Editar'",
        modifiers: {
          "right": true
        }
      }],
      attrs: {
        "tipo": "button",
        "estilo": "vazado-cinza-sm",
        "icone": "editar-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.edita(dependencia)
        }
      }
    })], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 footer-controller-inner"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde-dir",
      "rotulo": "Novo",
      "icone": "novo-modal",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.novo()
      }
    }
  })], 1)])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "explicacaoModalLabel"
    }
  }, [_vm._v("\n              Entenda o Paraceiro Econômico\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Parceiro econômico")]), _vm._v(" é aquele que participa\n                  economicamente dos bens declarados.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Importante:")]), _vm._v(" não se faz necessário cadastrar\n                  parceiros\n                  "), _c('strong', [_vm._v("sem CPF.")])])])])])
}]}

/***/ }),

/***/ "g1YC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var RacasCoresService = function () {
  function RacasCoresService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, RacasCoresService);

    throw 'Não é possível instanciar RacasCoresService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(RacasCoresService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint();
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista() {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }]);

  return RacasCoresService;
}();

/* harmony default export */ __webpack_exports__["a"] = (RacasCoresService);


var mergeEndpoint = function mergeEndpoint() {
  return 'racas-cores';
};

/***/ }),

/***/ "gI/F":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "regraDiasPendentesModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "regraDiasPendentesModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Ciente",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "regraDiasPendentesModalLabel"
    }
  }, [_vm._v("\n            Dias de Férias Pendentes\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', [_vm._v("Você tem dias pendentes de férias!")]), _vm._v(" "), _c('p', [_vm._v("\n                Conforme item 4 da O.S. nº 02/2014 GP, os dias restantes de\n                férias deverão ser gozados de uma única vez, antes do gozo das\n                próximas férias.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                Você poderá fazer o agendamento na\n                tela seguinte, mas deverá agendar em paralelo os seus dias restantes\n                através de memorando enviando e-mail para\n                o endereço ferias@santos.sp.gov.br\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "alerta"
  }, [_vm._v("\n                ATENÇÃO, o não cumprimento do disposto acima implicará na perda do direito\n                ao gozo dos dias restantes.\n              ")])])])])
}]}

/***/ }),

/***/ "gTyn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_side_modal__ = __webpack_require__("dLc8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_side_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_side_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_StringHelper__ = __webpack_require__("1pbJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_ArrayHelper__ = __webpack_require__("5OEK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_timers__ = __webpack_require__("162o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_enderecoService__ = __webpack_require__("bx61");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_estadoService__ = __webpack_require__("2RzD");







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Endereco',

  data: function data() {
    return {
      enderecoEditado: {
        cep: '',
        tipoLogradouro: '',
        logradouro: '',
        bairro: '',
        municipio: '',
        estado: '',
        numero: '',
        complemento: '',
        georreferenciado: false,
        inseridoPeloUsuario: false
      },
      estados: [],
      municipios: [],
      enderecos: [],
      tiposLogradouros: [],
      navs: [{
        titulo: 'Recadastramento',
        subtitulo: 'Endereço',
        subtDetalhe: 'Recadastrar Endereço',
        largura: 750,
        identidade: 'endereco',
        abreProximo: false,
        aberto: false
      }],
      enderecoLista: {
        logradouro: {
          nome: ''
        },
        bairro: {
          nome: ''
        },
        cep: '',
        numero: '',
        complemento: ''
      },
      semNumero: false,
      mostraLista: false,
      naoValidaNumero: false,
      logradouroInvalido: false,
      apiErrors: null
    };
  },


  props: {
    api: '',
    apiUrl: '',
    parentCep: '',
    parentTipoLogradouro: '',
    parentLogradouro: '',
    parentBairro: '',
    parentMunicipio: '',
    parentEstado: '',
    parentNumero: '',
    parentComplemento: '',
    parentGeorreferenciado: false,
    parentInseridoPeloUsuario: false,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    errorInputCep: function errorInputCep() {
      if (this.errors.has('cep')) return 'form-control-login-error';
    },
    dadosCarregados: function dadosCarregados() {
      return this.estados.length > 0 && this.municipios.length > 0;
    }
  },

  methods: {
    /*
     * Manipula modal
     */
    abreModal: function abreModal(identidade) {
      this.$emit('abreModal', identidade);
    },
    fechaModal: function fechaModal(identidade) {
      this.$emit('fechaModal', identidade);
    },


    /*
     * Requisições
     */

    busca: function busca(cep) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var cepLimpo, apis, endereco, apiUsada, erros, axiosInstance, axiosConfig, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, api, response, estadoResponse, estados, estado, municipiosResponse, novoEndereco;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!cep && _this.enderecoEditado.cep) {
                  cep = _this.enderecoEditado.cep;
                }

                if (cep) {
                  _context.next = 4;
                  break;
                }

                _this.$root.$refs.toastr.e('Digite um CEP para buscar', 'Atenção');
                return _context.abrupt('return');

              case 4:
                cepLimpo = _this.cepPlain(cep);

                if (!(cepLimpo.length !== 8)) {
                  _context.next = 8;
                  break;
                }

                _this.$root.$refs.toastr.e('CEP inválido', 'Atenção');
                return _context.abrupt('return');

              case 8:

                // Mostra o carregamento manualmente sem usar o interceptor
                if (_this.$root.$refs.loading) {
                  _this.$root.$refs.loading.show();
                }

                _context.prev = 9;
                apis = [{
                  name: 'ViaCEP',
                  url: 'https://viacep.com.br/ws/' + cepLimpo + '/json/',
                  transform: function transform(data) {
                    return {
                      cep: data.cep,
                      uf: data.uf,
                      localidade: data.localidade,
                      bairro: data.bairro,
                      logradouro: data.logradouro
                    };
                  }
                }, {
                  name: 'BrasilAPI',
                  url: 'https://brasilapi.com.br/api/cep/v1/' + cepLimpo,
                  transform: function transform(data) {
                    return {
                      cep: data.cep,
                      uf: data.state,
                      localidade: data.city,
                      bairro: data.neighborhood,
                      logradouro: data.street
                    };
                  }
                }, {
                  name: 'ApiCEP',
                  url: 'https://cdn.apicep.com/file/apicep/' + cepLimpo.slice(0, 5) + '-' + cepLimpo.slice(5) + '.json',
                  transform: function transform(data) {
                    return {
                      cep: data.code,
                      uf: data.state,
                      localidade: data.city,
                      bairro: data.district,
                      logradouro: data.address
                    };
                  }
                }];
                endereco = null;
                apiUsada = '';
                erros = [];

                // Cria uma instância separada do axios que não usará o interceptor global

                axiosInstance = __WEBPACK_IMPORTED_MODULE_7_axios___default.a.create();

                // Define timeout mais curto para evitar esperas longas

                axiosConfig = {
                  timeout: 5000,
                  headers: {
                    'X-Request-Type': 'cep-service'
                  }
                };
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 19;
                _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(apis);

              case 21:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 41;
                  break;
                }

                api = _step.value;
                _context.prev = 23;
                _context.next = 26;
                return axiosInstance.get(api.url, axiosConfig);

              case 26:
                response = _context.sent;

                if (!(response.data && !response.data.erro)) {
                  _context.next = 31;
                  break;
                }

                endereco = api.transform(response.data);
                apiUsada = api.name;
                return _context.abrupt('break', 41);

              case 31:
                _context.next = 38;
                break;

              case 33:
                _context.prev = 33;
                _context.t0 = _context['catch'](23);

                erros.push(api.name + ': ' + _context.t0.message);
                console.warn('Falha ao buscar CEP via ' + api.name + ':', _context.t0);
                return _context.abrupt('continue', 38);

              case 38:
                _iteratorNormalCompletion = true;
                _context.next = 21;
                break;

              case 41:
                _context.next = 47;
                break;

              case 43:
                _context.prev = 43;
                _context.t1 = _context['catch'](19);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 47:
                _context.prev = 47;
                _context.prev = 48;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 50:
                _context.prev = 50;

                if (!_didIteratorError) {
                  _context.next = 53;
                  break;
                }

                throw _iteratorError;

              case 53:
                return _context.finish(50);

              case 54:
                return _context.finish(47);

              case 55:
                if (endereco) {
                  _context.next = 58;
                  break;
                }

                console.error('Falhas nas APIs:', erros);
                throw new Error('cep-service-unavailable');

              case 58:

                _this.enderecoEditado.cep = _this.cepMasked(cepLimpo);

                // Use a mesma instância do axios para todas as requisições subsequentes
                _context.next = 61;
                return axiosInstance.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados', axiosConfig);

              case 61:
                estadoResponse = _context.sent;
                estados = estadoResponse.data;
                estado = estados.find(function (e) {
                  return e.sigla === endereco.uf;
                });

                if (estado) {
                  _context.next = 66;
                  break;
                }

                throw new Error('Estado não encontrado');

              case 66:

                if (_this.estados.length === 0) {
                  _this.estados = estados.map(function (e) {
                    return {
                      id: e.id,
                      nome: e.nome,
                      sigla: e.sigla
                    };
                  });
                }

                _context.next = 69;
                return axiosInstance.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados/' + estado.id + '/municipios', axiosConfig);

              case 69:
                municipiosResponse = _context.sent;


                _this.municipios = municipiosResponse.data.map(function (m) {
                  return {
                    id: m.id,
                    nome: _this.removerAcentos(m.nome)
                  };
                });

                _context.next = 73;
                return _this.$nextTick();

              case 73:
                novoEndereco = {
                  cep: _this.cepMasked(cepLimpo),
                  estado: endereco.uf,
                  municipio: _this.removerAcentos(endereco.localidade),
                  bairro: _this.removerAcentos(endereco.bairro),
                  logradouro: _this.removerAcentos(endereco.logradouro),
                  tipoLogradouro: _this.extrairTipoLogradouro(endereco.logradouro),
                  complemento: _this.enderecoEditado.complemento || '',
                  numero: _this.enderecoEditado.numero || '',
                  georreferenciado: false,
                  inseridoPeloUsuario: false
                };


                __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(_this.enderecoEditado, novoEndereco);

                console.log('CEP encontrado via ' + apiUsada);

                _context.next = 78;
                return _this.$nextTick();

              case 78:
                _this.$validator.reset();

                _context.next = 86;
                break;

              case 81:
                _context.prev = 81;
                _context.t2 = _context['catch'](9);

                console.error('Erro na busca de CEP:', _context.t2);
                if (_context.t2.message === 'cep-service-unavailable') {
                  _this.emiteAlertaInfo('Sistema de CEP indisponível', 'Por favor, tente novamente em alguns instantes ou preencha os campos manualmente');
                }
                _this.enderecoEditado.cep = '';

              case 86:
                _context.prev = 86;

                // Esconde o carregamento manualmente
                if (_this.$root.$refs.loading) {
                  _this.$root.$refs.loading.hide();
                }
                return _context.finish(86);

              case 89:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[9, 81, 86, 89], [19, 43, 47, 55], [23, 33], [48,, 50, 54]]);
      }))();
    },
    buscaAbreModal: function buscaAbreModal(listar) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(this.api + 'estados/' + this.enderecoEditado.estado + '/municipios').then(function (municipios) {
        return _this2.municipios = municipios.data.data;
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_11__helpers_ArrayHelper__["a" /* default */].geraTamanhoLimitado(_this2.municipios, 'nome', 20);
        _this2.mostraLista = listar;
        _this2.abreModal('endereco');
        _this2.errors.clear();
      }).catch(function (error) {
        return _this2.emiteAlerta(error.response.data.message);
      });
    },
    removerAcentos: function removerAcentos(str) {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove acentos
      .replace(/[^a-zA-Z0-9\s]/g, '') // Remove caracteres especiais
      .toUpperCase().trim();
    },
    obtemMunicipios: function obtemMunicipios(sigla, elemento) {
      var _this3 = this;

      if (!sigla) return;

      this.obtemMunicipiosPor(sigla).then(function () {
        if (elemento === 'modal') {
          _this3.enderecoEditado.municipio = '';
          _this3.limpaModal();
        }
        if (elemento === 'formulario') {
          var municipioAtual = _this3.enderecoEditado.municipio;
          _this3.enderecoEditado.municipio = '';

          if (municipioAtual && _this3.municipios.some(function (m) {
            return m.nome === municipioAtual;
          })) {
            _this3.$nextTick(function () {
              _this3.enderecoEditado.municipio = municipioAtual;
            });
          }
        }
      }).catch(function (error) {
        console.error('Erro ao obter municípios:', error);
        _this3.emiteAlerta('Erro ao carregar municípios');
      });
    },
    obtemTiposLogradouros: function obtemTiposLogradouros() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(this.apiUrl + 'recadastramento-servidores/tipos-logradouros', {
        headers: {
          Authorization: this.$store.state.token
        }
      }).then(function (response) {
        return response.data;
      }).then(function (tipos) {
        return _this4.tiposLogradouros = tipos;
      }).catch(function (error) {
        return _this4.emiteAlerta(error.response.data.message);
      });
    },
    buscaModal: function buscaModal(nome, municipio, estado) {
      var _this5 = this;

      // Previne clique em 'Buscar' com logradouro vazio
      if (!nome) {
        this.$validator.validate('logradouroModal', this.enderecoEditado.logradouro);
        return;
      }
      // Previne clique em 'Buscar' com município vazio e força alerta de erro no input (valorando com null)
      if (!municipio) {
        this.enderecoEditado.municipio = null;
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(this.api + 'logradouros?nome=' + nome + '&municipio=' + municipio + '&estado=' + estado).then(function (enderecos) {
        _this5.enderecos = enderecos.data.data;
        _this5.mostraLista = true;
        _this5.logradouroInvalido = false;
      }).catch(function (error) {
        if (error.response.data.message === 'Logradouro não encontrado') {
          _this5.logradouroInvalido = true;
          _this5.enderecoEditado.inseridoPeloUsuario = true;
          _this5.enderecoEditado.bairro = '';
          _this5.emiteAlertaInfo('Logradouro não encontrado', 'Preencha os campos ao lado e cadastre seu endereço');
          _this5.$nextTick(function () {
            return _this5.$validator.reset();
          });
        } else {
          _this5.emiteAlerta(error.response.data.nome[0]);
        }
      });
    },
    normalizaString: function normalizaString(str) {
      if (!str) return '';
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove acentos
      .replace(/[^a-zA-Z0-9\s]/g, '') // Remove caracteres especiais
      .toUpperCase().trim();
    },
    obtemMunicipiosPor: function obtemMunicipiosPor(sigla) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados/' + sigla + '/municipios');

              case 3:
                response = _context2.sent;


                // Normalizar os nomes dos municípios removendo acentos
                _this6.municipios = response.data.map(function (municipio) {
                  return {
                    id: municipio.id,
                    nome: _this6.removerAcentos(municipio.nome) // Remove acentos e converte para maiúsculas
                  };
                });

                // Ordenar os municípios por nome
                _this6.municipios.sort(function (a, b) {
                  return a.nome.localeCompare(b.nome);
                });

                return _context2.abrupt('return', _this6.municipios);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.error('Erro ao carregar munic\xEDpios para ' + sigla + ':', _context2.t0);
                _this6.municipios = [];
                throw _context2.t0;

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[0, 9]]);
      }))();
    },
    sanitizarDados: function sanitizarDados() {
      var dados = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.enderecoEditado;

      var dadosLimpos = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, dados);

      // Garantir que o município seja uma string simples
      if (dadosLimpos.municipio && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(dadosLimpos.municipio) === 'object') {
        dadosLimpos.municipio = dadosLimpos.municipio.nome;
      }

      // Garantir que o estado seja uma string simples
      if (dadosLimpos.estado && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(dadosLimpos.estado) === 'object') {
        dadosLimpos.estado = dadosLimpos.estado.sigla;
      }

      // Garantir que todos os campos de texto sejam strings e limpos
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dadosLimpos).forEach(function (key) {
        if (typeof dadosLimpos[key] === 'string') {
          dadosLimpos[key] = dadosLimpos[key].replace(/[^\w\s\.\-\,]/g, '').trim();
        }
      });

      return dadosLimpos;
    },
    obtemEstados: function obtemEstados() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var estadosData;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                try {
                  estadosData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__services_estadoService__["a" /* getEstados */])();

                  _this7.estados = estadosData.map(function (estado) {
                    return {
                      id: estado.id,
                      nome: estado.nome,
                      sigla: _this7.getSiglaFromNome(estado.nome)
                    };
                  });
                } catch (error) {
                  console.error('Erro ao carregar estados:', error);
                  _this7.emiteAlerta("Erro ao carregar estados");
                }

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    getSiglaFromNome: function getSiglaFromNome(nome) {
      var siglas = {
        'Acre': 'AC',
        'Alagoas': 'AL',
        'Amapá': 'AP',
        'Amazonas': 'AM',
        'Bahia': 'BA',
        'Ceará': 'CE',
        'Distrito Federal': 'DF',
        'Espírito Santo': 'ES',
        'Goiás': 'GO',
        'Maranhão': 'MA',
        'Mato Grosso': 'MT',
        'Mato Grosso do Sul': 'MS',
        'Minas Gerais': 'MG',
        'Pará': 'PA',
        'Paraíba': 'PB',
        'Paraná': 'PR',
        'Pernambuco': 'PE',
        'Piauí': 'PI',
        'Rio de Janeiro': 'RJ',
        'Rio Grande do Norte': 'RN',
        'Rio Grande do Sul': 'RS',
        'Rondônia': 'RO',
        'Roraima': 'RR',
        'Santa Catarina': 'SC',
        'São Paulo': 'SP',
        'Sergipe': 'SE',
        'Tocantins': 'TO'
      };
      return siglas[nome] || '';
    },
    naoSeiMeuCep: function naoSeiMeuCep() {
      this.enderecoEditado.cep = '';
      this.busca(this.enderecoEditado.cep);
    },


    /*
     * Manipulação de dados
     */

    carregaDadosIniciais: function carregaDadosIniciais() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var municipioParentNormalizado, municipioEncontrado;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _this8.obtemEstados();

              case 3:

                // Primeiro definir o estado
                _this8.enderecoEditado.estado = _this8.parentEstado || '';

                // Se tiver estado, carrega os municípios

                if (!_this8.enderecoEditado.estado) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 7;
                return _this8.obtemMunicipiosPor(_this8.enderecoEditado.estado);

              case 7:
                _context4.next = 9;
                return _this8.$nextTick();

              case 9:

                if (_this8.parentMunicipio) {
                  municipioParentNormalizado = _this8.normalizaString(_this8.parentMunicipio);
                  municipioEncontrado = _this8.municipios.find(function (m) {
                    return _this8.normalizaString(m.nome) === municipioParentNormalizado;
                  });


                  if (municipioEncontrado) {
                    _this8.enderecoEditado.municipio = municipioEncontrado.nome;
                  } else {
                    console.warn('Município não encontrado na lista:', _this8.parentMunicipio);
                  }
                }

              case 10:

                if (typeof _this8.obtemTiposLogradouros === 'function') {
                  _this8.obtemTiposLogradouros();
                }

                if (typeof _this8.cepMasked === 'function' && _this8.parentCep) {
                  _this8.enderecoEditado.cep = _this8.cepMasked(_this8.parentCep);
                } else if (_this8.parentCep) {
                  _this8.enderecoEditado.cep = _this8.formatarCep(_this8.parentCep);
                }

                _this8.enderecoEditado.tipoLogradouro = _this8.parentTipoLogradouro || '';

                if (_this8.parentLogradouro) {
                  _this8.enderecoEditado.logradouro = _this8.parentLogradouro.toUpperCase();
                }

                if (_this8.parentBairro) {
                  _this8.enderecoEditado.bairro = _this8.parentBairro.toUpperCase();
                }

                _this8.enderecoEditado.numero = _this8.parentNumero || '';

                if (_this8.parentComplemento) {
                  _this8.enderecoEditado.complemento = _this8.parentComplemento.toUpperCase();
                }

                _this8.enderecoEditado.georreferenciado = _this8.parentGeorreferenciado || false;
                _this8.enderecoEditado.inseridoPeloUsuario = _this8.parentInseridoPeloUsuario || false;
                _context4.next = 24;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t0 = _context4['catch'](0);

                console.error('Erro ao carregar dados iniciais:', _context4.t0);

              case 24:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this8, [[0, 21]]);
      }))();
    },
    cepPlain: function cepPlain(cep) {
      return cep.replace(/\D+/g, '');
    },
    cepMasked: function cepMasked(cep) {
      if (cep) {
        if (typeof cep === 'string') {
          return cep.slice(0, 2) + '.' + cep.slice(2, 5) + '-' + cep.slice(5, 8);
        }
        if (cep.unico) {
          return cep.unico.slice(0, 2) + '.' + cep.unico.slice(2, 5) + '-' + cep.unico.slice(5, 8);
        }
        return cep.lado.direito.slice(0, 2) + '.' + cep.lado.direito.slice(2, 5) + '-' + cep.lado.direito.slice(5, 8);
      }
    },
    valoraEnderecoEditado: function valoraEnderecoEditado(dados) {
      dados = __WEBPACK_IMPORTED_MODULE_10__helpers_StringHelper__["a" /* default */].toUpperCaseInJson(dados);
      this.enderecoEditado.tipoLogradouro = this.valoraTipoLogradouro(dados.logradouro.tipo);
      this.enderecoEditado.logradouro = __WEBPACK_IMPORTED_MODULE_10__helpers_StringHelper__["a" /* default */].limpaCaracterEspecial(dados.logradouro.nome);
      this.enderecoEditado.bairro = __WEBPACK_IMPORTED_MODULE_10__helpers_StringHelper__["a" /* default */].limpaCaracterEspecial(dados.bairro.nome);
      this.enderecoEditado.municipio = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(dados.municipio) === 'object' ? dados.municipio.nome.toUpperCase() : dados.municipio ? dados.municipio.toUpperCase() : '';
      this.enderecoEditado.estado = dados.estado.sigla;
      this.enderecoEditado.georreferenciado = dados.georreferenciado;
      this.enderecoEditado.numero = '';
      this.enderecoEditado.complemento = '';
    },
    escolheEntreCepsIguais: function escolheEntreCepsIguais(dados) {
      var _this9 = this;

      this.enderecoEditado.estado = dados[0].estado.sigla;
      if (dados[0].municipio) this.enderecoEditado.municipio = dados.municipio && dados.municipio.nome ? this.removerAcentos(dados.municipio.nome) : dados.municipio ? this.removerAcentos(dados.municipio) : '';
      this.buscaAbreModal(true).then(function () {
        return _this9.enderecos = dados;
      });
    },
    montaModal: function montaModal(listar) {
      if (!this.enderecoEditado.estado) this.enderecoEditado.estado = 'SP';
      if (!this.enderecoEditado.municipio) this.enderecoEditado.municipio = 'SANTOS';
      this.mostraLista = listar;
      this.logradouroInvalido = true;
    },
    valoraLista: function valoraLista() {
      if (this.enderecoLista) {
        this.enderecoEditado.inseridoPeloUsuario = false;
        this.enderecoEditado.cep = this.cepMasked(this.enderecoLista.cep);
        this.enderecoLista = __WEBPACK_IMPORTED_MODULE_10__helpers_StringHelper__["a" /* default */].toUpperCaseInJson(this.enderecoLista);
        this.enderecoEditado.tipoLogradouro = this.valoraTipoLogradouro(this.enderecoLista.logradouro.tipo);
        this.enderecoEditado.logradouro = __WEBPACK_IMPORTED_MODULE_10__helpers_StringHelper__["a" /* default */].limpaCaracterEspecial(this.enderecoLista.logradouro.nome);
        this.enderecoEditado.bairro = __WEBPACK_IMPORTED_MODULE_10__helpers_StringHelper__["a" /* default */].limpaCaracterEspecial(this.enderecoLista.bairro.nome);
        this.enderecoEditado.georreferenciado = this.enderecoLista.georreferenciado;
        this.enderecoEditado.numero = '';
        this.enderecoEditado.complemento = '';
      }
    },
    valoraTipoLogradouro: function valoraTipoLogradouro(tipo) {
      if (this.tiposLogradouros.some(function (item) {
        return item.descricao === tipo;
      })) {
        return tipo;
      }
      return '';
    },
    inclui: function inclui() {
      // Previne o submit sem ter selecionado endereço na lista
      if (this.mostraLista && !this.enderecoLista.cep) {
        this.emiteAlertaInfo('Nenhum endereço foi selecionado', 'Selecione seu endereço ou refine sua busca');
        return;
      }
      // Previne o submit sem ter buscado o logradouro
      if (this.enderecoEditado.logradouro && !this.enderecoEditado.cep && !this.enderecoEditado.inseridoPeloUsuario) {
        this.emiteAlertaInfo('Você não buscou o endereço', 'Clique em Buscar e selecione seu endereço');
        return;
      }
      this.logradouroInvalido = false;
      this.fechaModal('endereco');
      return;
    },
    cancela: function cancela() {
      this.carregaDadosIniciais();
      this.mostraLista = false;
      this.logradouroInvalido = false;
      this.semNumero = false;
      this.fechaModal('endereco');
    },
    limpaModal: function limpaModal() {
      var _this10 = this;

      this.enderecoEditado.logradouro = '';
      this.enderecoEditado.bairro = '';
      this.mostraLista = false;
      this.logradouroInvalido = false;
      this.$nextTick(function () {
        return _this10.$validator.reset();
      });
    },
    zeraNumero: function zeraNumero(htmlId) {
      if (this.semNumero) {
        this.enderecoEditado.numero = '0';
        document.querySelector(htmlId).disabled = true;
      } else {
        this.enderecoEditado.numero = '';
        document.querySelector(htmlId).disabled = false;
        document.querySelector(htmlId).focus();
      }
    },
    salvar: function salvar() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var success, dadosSanitizados, editado;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return _this11.$validator.validateAll();

              case 3:
                success = _context5.sent;

                if (success) {
                  _context5.next = 7;
                  break;
                }

                _this11.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção');
                return _context5.abrupt('return', false);

              case 7:
                if (!(!_this11.enderecoEditado.municipio || !_this11.enderecoEditado.estado)) {
                  _context5.next = 10;
                  break;
                }

                _this11.$root.$refs.toastr.e('Selecione estado e município', 'Atenção');
                return _context5.abrupt('return', false);

              case 10:
                dadosSanitizados = _this11.sanitizarDados(_this11.enderecoEditado);
                editado = _this11.montaEditadoApi(dadosSanitizados);

                // Em vez de salvar na API, apenas emitir os eventos com os dados

                _this11.$emit('submitEndereco', editado);

                // Armazenar localmente no componente pai
                _this11.$emit('atualizaEnderecoLocal', editado);

                return _context5.abrupt('return', true);

              case 17:
                _context5.prev = 17;
                _context5.t0 = _context5['catch'](0);

                console.error('Erro ao validar dados:', _context5.t0);
                return _context5.abrupt('return', false);

              case 21:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this11, [[0, 17]]);
      }))();
    },
    montaEditadoApi: function montaEditadoApi(base) {
      var final = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, base);

      // Garantir que os valores existam
      if (!final.municipio || !final.estado) {
        console.error('Município ou estado faltando:', final);
        return final;
      }

      final.cep = this.cepPlain(base.cep);

      // Garantir que município e estado sejam strings e em maiúsculas
      final.cidade = String(final.municipio).trim().toUpperCase();
      final.uf = String(final.estado).trim().toUpperCase();
      return final;
    },


    /*
     * Emissor de Mensagens
     */

    emiteSucesso: function emiteSucesso(msgSucesso) {
      this.$emit('dadosOk', msgSucesso);
    },
    emiteAlertaInfo: function emiteAlertaInfo(msgAlerta, msgInfo) {
      this.$emit('dadosInvalidosInfo', msgAlerta, msgInfo);
    },
    emiteAlerta: function emiteAlerta(msgAlerta) {
      this.$emit('dadosInvalidos', msgAlerta);
    },
    extrairTipoLogradouro: function extrairTipoLogradouro(logradouro) {
      if (!logradouro) return '';

      var tipos = ['RUA', 'AVENIDA', 'TRAVESSA', 'ALAMEDA', 'PRAÇA', 'ESTRADA', 'RODOVIA', 'VILA', 'VIELA', 'BECO'];

      var palavras = logradouro.toUpperCase().split(' ');
      var tipo = tipos.find(function (t) {
        return t === palavras[0];
      });

      return tipo || '';
    }
  },

  watch: {
    'enderecoEditado.estado': function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6(novoEstado, antigoEstado) {
        var _this12 = this;

        var municipioAtual, municipioParentNormalizado, municipioEncontrado, municipioAtualNormalizado, _municipioEncontrado;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!novoEstado) {
                  _context6.next = 13;
                  break;
                }

                _context6.prev = 1;
                municipioAtual = this.enderecoEditado.municipio;
                _context6.next = 5;
                return this.obtemMunicipios(novoEstado, 'formulario');

              case 5:

                if (!antigoEstado && this.parentMunicipio) {
                  municipioParentNormalizado = this.normalizaString(this.parentMunicipio);
                  municipioEncontrado = this.municipios.find(function (m) {
                    return _this12.normalizaString(m.nome) === municipioParentNormalizado;
                  });


                  if (municipioEncontrado) {
                    this.enderecoEditado.municipio = municipioEncontrado.nome;
                  }
                } else if (municipioAtual) {
                  municipioAtualNormalizado = this.normalizaString(municipioAtual);
                  _municipioEncontrado = this.municipios.find(function (m) {
                    return _this12.normalizaString(m.nome) === municipioAtualNormalizado;
                  });


                  if (_municipioEncontrado) {
                    this.enderecoEditado.municipio = _municipioEncontrado.nome;
                  }
                }
                _context6.next = 11;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6['catch'](1);

                console.error('Erro ao atualizar municípios:', _context6.t0);

              case 11:
                _context6.next = 15;
                break;

              case 13:
                this.municipios = [];
                this.enderecoEditado.municipio = '';

              case 15:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[1, 8]]);
      }));

      function enderecoEditadoEstado(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return enderecoEditadoEstado;
    }(),
    'enderecoEditado.municipio': function enderecoEditadoMunicipio(novoValor) {
      if (novoValor) {
        // Armazenar no state local em vez do Vuex
        this.$set(this.enderecoEditado, 'municipio', novoValor);
      }
    },
    municipios: function municipios(novosmunicipios) {}
  },

  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_8__components_botao___default.a,
    SideModal: __WEBPACK_IMPORTED_MODULE_9__components_side_modal___default.a
  },

  created: function created() {
    console.log(this.situacaoRecad);
    this.carregaDadosIniciais();

    this.$parent.$on('salvaPessoaEndereco', this.salvar);
  }
});

/***/ }),

/***/ "giWo":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Registro Geral\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-sm-3",
      "label": "RG",
      "field": "rgNumero",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false,
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.rg.numero),
      expression: "cadastrado.pessoa.rg.numero"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "rgNumero",
      "id": "rgNumero",
      "data-vv-as": "RG",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.rg.numero)
    },
    on: {
      "focus": _vm.removeMascaraRg,
      "blur": _vm.aplicaMascaraRg,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.rg, "numero", $event.target.value)
      }, _vm.limitaRgInput],
      "change": function($event) {
        return _vm.zeraDataEmissao()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [(!_vm.cadastrado.lancamentoPermitido) ? _c('div', [_c('campo-calendario', {
    attrs: {
      "rotulo": "Data da Emissão",
      "nome": "dataEmissao",
      "validacao": {
        required: true
      },
      "disabled": _vm.situacaoRecad === 'CONFIRMADO'
    },
    model: {
      value: (_vm.cadastrado.pessoa.rg.dataEmissao),
      callback: function($$v) {
        _vm.$set(_vm.cadastrado.pessoa.rg, "dataEmissao", $$v)
      },
      expression: "cadastrado.pessoa.rg.dataEmissao"
    }
  })], 1) : _c('div', [_c('label', {
    attrs: {
      "for": "dataEmissao"
    }
  }, [_vm._v("Data da Emissão")]), _vm._v(" "), _c('p', {
    staticClass: "textoAlinhadoAoInput form-control",
    staticStyle: {
      "background-color": "#eeee",
      "opacity": "1"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.formatarData(_vm.cadastrado.pessoa.rg.dataEmissao)) + "\n                        ")])])]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-3",
      "label": "Orgão Emissor",
      "field": "orgaoEmissor",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.rg.orgaoEmissor),
      expression: "cadastrado.pessoa.rg.orgaoEmissor"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:5'),
      expression: "'required|max:5'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "orgaoEmissor",
      "id": "orgaoEmissor",
      "data-vv-as": "Orgão Emissor",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.rg.orgaoEmissor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.rg, "orgaoEmissor", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-3",
      "label": "Estado Emissor",
      "field": "uf",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.rg.uf),
      expression: "cadastrado.pessoa.rg.uf"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "uf",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO',
      "data-vv-as": "Estado Emissor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa.rg, "uf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.ufs), function(uf) {
    return _c('option', {
      key: uf.sigla,
      attrs: {
        "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
      },
      domProps: {
        "value": uf.sigla
      }
    }, [_vm._v("\n                          " + _vm._s(_vm._f("tudoMaiusculo")(uf.nome)) + "\n                        ")])
  })], 2)])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Título de Eleitor")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-sm-6",
      "label": "Título",
      "field": "tituloNumero",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.tituloEleitor.numero),
      expression: "cadastrado.pessoa.tituloEleitor.numero"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('####.####.#####'),
      expression: "'####.####.#####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "tituloNumero",
      "id": "tituloNumero",
      "data-vv-as": "Título",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.tituloEleitor.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.tituloEleitor, "numero", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-3 col-xs-6",
      "label": "Zona",
      "field": "zona",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.tituloEleitor.zona),
      expression: "cadastrado.pessoa.tituloEleitor.zona"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###'),
      expression: "'###'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "zona",
      "id": "zona",
      "data-vv-as": "Zona",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.tituloEleitor.zona)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.tituloEleitor, "zona", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-3 col-xs-6",
      "label": "Seção",
      "field": "secao",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.tituloEleitor.secao),
      expression: "cadastrado.pessoa.tituloEleitor.secao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('####'),
      expression: "'####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "secao",
      "id": "secao",
      "data-vv-as": "Seção",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.tituloEleitor.secao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.tituloEleitor, "secao", $event.target.value)
      }
    }
  })])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Trabalhista")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-sm-4",
      "label": "PIS/PASEP",
      "field": "pisPasep",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.pisPasep),
      expression: "cadastrado.pessoa.pisPasep"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###.#####.##-#'),
      expression: "'###.#####.##-#'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "pisPasep",
      "id": "pisPasep",
      "data-vv-as": "PIS/PASEP",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.pisPasep)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa, "pisPasep", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-4",
      "label": "Orgão de Classe",
      "field": "orgaoClasse",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.orgaoClasse.descricao),
      expression: "cadastrado.pessoa.orgaoClasse.descricao"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:7'),
      expression: "'max:7'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "orgaoClasse",
      "id": "orgaoClasse",
      "data-vv-as": "Orgão de Classe",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.orgaoClasse.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.orgaoClasse, "descricao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-4",
      "label": "Número",
      "field": "numeroOrgao",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.orgaoClasse.numero),
      expression: "cadastrado.pessoa.orgaoClasse.numero"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.temOrgaoClasse,
        max: 10
      }),
      expression: "{ required: temOrgaoClasse, max: 10 }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "numeroOrgao",
      "id": "numeroOrgao",
      "data-vv-as": "Número",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.orgaoClasse.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.orgaoClasse, "numero", $event.target.value)
      }
    }
  })])], 1)])])])]), _vm._v(" "), (_vm.cadastrado.pessoa.motorista) ? _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Carteira de Habilitação")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-sm-4",
      "label": "CNH",
      "field": "numeroCnh",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.cnh.numero),
      expression: "cadastrado.pessoa.cnh.numero"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('############'),
      expression: "'############'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|is_not:0'),
      expression: "'required|is_not:0'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "numeroCnh",
      "id": "numeroCnh",
      "data-vv-as": "CNH",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.cnh.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.cnh, "numero", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-4 col-xs-6",
      "label": "Categoria",
      "field": "categoria",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.cnh.categoria),
      expression: "cadastrado.pessoa.cnh.categoria"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "categoria",
      "data-vv-as": "Categoria",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa.cnh, "categoria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.categorias), function(categoria) {
    return _c('option', {
      key: categoria.id,
      attrs: {
        "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
      },
      domProps: {
        "value": categoria.codigo
      }
    }, [_vm._v("\n                          " + _vm._s(categoria.codigo) + "\n                        ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-xs-6"
  }, [_c('campo-calendario', {
    attrs: {
      "rotulo": "Validade",
      "nome": "validadeCnh",
      "data-maxima": _vm.daquiADezAnos,
      "validacao": {
        required: true
      },
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    model: {
      value: (_vm.cadastrado.pessoa.cnh.validade),
      callback: function($$v) {
        _vm.$set(_vm.cadastrado.pessoa.cnh, "validade", $$v)
      },
      expression: "cadastrado.pessoa.cnh.validade"
    }
  })], 1)], 1)])])])]) : _vm._e()])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.volta()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Avançar",
      "icone": "avancar",
      "icone-direita": true
    },
    on: {
      "clicado": function($event) {
        return _vm.avanca(_vm.cadastrado, 'Filiacao')
      }
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ "glyJ":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("AeWN")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("IbFM"),
  /* template */
  __webpack_require__("UmM+"),
  /* scopeId */
  "data-v-520919a3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "gmzR":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "side-modal"
    }
  }, [_c('side-modal', {
    attrs: {
      "sides": _vm.navs
    },
    on: {
      "cancela": function($event) {
        return _vm.cancela()
      }
    }
  }, [_c('template', {
    slot: _vm.navs[0].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('upload-arquivos', {
    ref: "uploader",
    attrs: {
      "api": _vm.apiUrl,
      "endPoint": _vm.endPointUpload,
      "arquivos": _vm.anexosTemporarios,
      "podeDeletar": _vm.mostraDelete
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancela()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Enviar",
      "icone": "fa-upload"
    },
    on: {
      "clicado": function($event) {
        return _vm.enviaArquivo(_vm.cadastrado)
      }
    }
  })], 1)])], 2)], 1), _vm._v(" "), _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraTituloUpload),
      expression: "mostraTituloUpload"
    }]
  }, [_vm._v("\n                Envio de Arquivos\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e()]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraTituloEnvio),
      expression: "mostraTituloEnvio"
    }]
  }, [_vm._v("\n                Envio de Atualização Cadastral\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e()]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraTituloFinalizado),
      expression: "mostraTituloFinalizado"
    }]
  }, [_vm._v("\n                Atualização Cadastral Finalizada\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.salvando),
      expression: "salvando"
    }]
  }, [_c('h2', {
    staticClass: "carregando",
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("\n                          Salvando...\n                        ")])]), _vm._v(" "), (_vm.cadastrado.status === _vm.Status.RECADASTRAMENTO_PENDENTE) ? _c('div', [_vm._m(0)]) : _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoButao === 'Anexar' || _vm.tipoButao === 'Enviar'),
      expression: "tipoButao === 'Anexar' || tipoButao === 'Enviar'"
    }]
  }, [_c('p', [_vm._v("\n                            Clique em\n                            "), _c('strong', [_vm._v("ANEXAR")]), _vm._v(" para fazer o upload (envio\n                            de arquivos digitais) dos seus documentos\n                            digitalizados para suas alterações serem\n                            "), _c('strong', [_vm._v("validadas")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoButao === 'Anexar'),
      expression: "tipoButao === 'Anexar'"
    }]
  }, [_vm._v("\n                              , e abrir a opção\n                              "), _c('strong', [_vm._v("SALVAR")])]), _vm._v(".\n                          ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.listaDocumentosExigidos), function(documento) {
    return _c('ul', {
      key: documento
    }, [_c('li', [_vm._v(_vm._s(documento))])])
  })], 2), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoButao === 'Enviar'),
      expression: "tipoButao === 'Enviar'"
    }]
  }, [_vm._v("    \n                          Caso todos os campos a serem alterados estiverem\n                          completos e de acordo com seus dados mais atuais,\n                          clique em\n                          "), _c('strong', [_vm._v("ENVIAR")]), _vm._v(" para finalizar seu\n                          recadastramento.\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "espacado"
  }, [(_vm.cadastrado.status === _vm.Status.RECADASTRAMENTO_PENDENTE) ? _c('botao', {
    attrs: {
      "estilo": "cheio-verde-lg",
      "rotulo": "Confirmar",
      "icone": "ok-modal",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "clicado": function($event) {
        return _vm.confirma(_vm.cadastrado)
      }
    }
  }) : [_c('botao', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoButao === 'Anexar' && !this.salvando || _vm.situacaoInicial == _vm.Status.ALTERADO),
      expression: "tipoButao === 'Anexar' && !this.salvando || situacaoInicial == Status.ALTERADO"
    }],
    attrs: {
      "estilo": "cheio-verde-lg",
      "rotulo": "Anexar",
      "icone": "fa-upload",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "clicado": function($event) {
        return _vm.selecionaArquivo()
      }
    }
  }), _vm._v(" "), _c('botao', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoButao === 'Enviar'),
      expression: "tipoButao === 'Enviar'"
    }],
    attrs: {
      "estilo": "cheio-verde-lg",
      "rotulo": "Enviar",
      "icone": "fa-send",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "clicado": function($event) {
        return _vm.salvaValidado(_vm.cadastrado)
      }
    }
  })], _vm._v(" "), _c('botao', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraFinalizado),
      expression: "mostraFinalizado"
    }],
    attrs: {
      "estilo": "cheio-verde-lg",
      "rotulo": "Ver Protocolo",
      "icone": "fa-info-circle",
      "disabled": _vm.cadastrado.lancamentoPermitido
    },
    on: {
      "clicado": function($event) {
        return _vm.$router.push({
          name: 'Fim'
        })
      }
    }
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoButao === 'Anexar' || _vm.situacaoInicial == _vm.Status.ALTERADO),
      expression: "tipoButao === 'Anexar' || situacaoInicial == Status.ALTERADO"
    }],
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Envio de Atualização Cadastral")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "espacado"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde-lg",
      "rotulo": "Salvar",
      "icone": "salvar",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "clicado": function($event) {
        return _vm.salvaAlterado(_vm.cadastrado)
      }
    }
  })], 1)])])])])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.volta()
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                          Caso não haja alteração e todos os seus dados estejam\n                          corretos, clique em\n                          "), _c('strong', [_vm._v("CONFIRMAR")]), _vm._v(" para enviar seu\n                          recadastramento.\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                            De acordo com suas alterações, segue a lista dos\n                            documentos necessários\n                            "), _c('strong', [_vm._v("(frente e verso)")]), _vm._v(":\n                          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                      A atualização ficará\n                      "), _c('strong', [_vm._v("pendente de anexação")]), _vm._v(", de documentação\n                      comprobatória (digitalizada).\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                      As informações\n                      "), _c('strong', [_vm._v("não validadas")]), _vm._v(" pelo setor competente\n                      (por inconsistência ou ausência de documentação\n                      comprobatória), "), _c('strong', [_vm._v("serão descartadas")]), _vm._v(",\n                      mantendo-se os dados já constantes no sistema.\n                    ")])
}]}

/***/ }),

/***/ "gy/Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var Renda = function Renda() {
    var anoReferencia = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()).year() - 1;
    var valor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Renda);

    this.anoReferencia = anoReferencia;
    this.valor = valor;
};

/* harmony default export */ __webpack_exports__["a"] = (Renda);

/***/ }),

/***/ "h5d5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var DependenciasService = function () {
  function DependenciasService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DependenciasService);

    throw 'Não é possível instanciar DependenciasService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DependenciasService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint();
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista() {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }, {
    key: 'grava',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dependencia) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = mergeEndpoint();
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].post(endpoint, dependencia);

              case 3:
                return _context2.abrupt('return', _context2.sent);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function grava(_x) {
        return _ref2.apply(this, arguments);
      }

      return grava;
    }()
  }, {
    key: 'atualiza',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id, dependencia) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                endpoint = mergeEndpoint(id);
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].put(endpoint, dependencia);

              case 3:
                return _context3.abrupt('return', _context3.sent);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function atualiza(_x2, _x3) {
        return _ref3.apply(this, arguments);
      }

      return atualiza;
    }()
  }, {
    key: 'apaga',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                endpoint = mergeEndpoint(id);
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].delete(endpoint);

              case 3:
                return _context4.abrupt('return', _context4.sent);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function apaga(_x4) {
        return _ref4.apply(this, arguments);
      }

      return apaga;
    }()
  }, {
    key: 'obtemDependente',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(cpf) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                endpoint = mergeEndpoint(cpf);
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context5.abrupt('return', _context5.sent);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function obtemDependente(_x5) {
        return _ref5.apply(this, arguments);
      }

      return obtemDependente;
    }()
  }]);

  return DependenciasService;
}();

/* harmony default export */ __webpack_exports__["a"] = (DependenciasService);


var mergeEndpoint = function mergeEndpoint(value) {
  return 'dependentes/' + (value || '');
};

/***/ }),

/***/ "h5sb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var AvaliacaoService = function () {
  function AvaliacaoService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AvaliacaoService);

    throw 'Não é possível instanciar AvaliacaoService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AvaliacaoService, null, [{
    key: 'obtem',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint(id);
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function obtem(_x) {
        return _ref.apply(this, arguments);
      }

      return obtem;
    }()
  }, {
    key: 'atualiza',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id, item) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = mergeEndpoint(id);
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].put(endpoint, item);

              case 3:
                return _context2.abrupt('return', _context2.sent);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function atualiza(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return atualiza;
    }()
  }]);

  return AvaliacaoService;
}();

/* harmony default export */ __webpack_exports__["a"] = (AvaliacaoService);


var mergeEndpoint = function mergeEndpoint(id) {
  return 'avaliacoes-periodicas/' + id;
};

/***/ }),

/***/ "h6wb":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("yCKt")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("LlmX"),
  /* template */
  __webpack_require__("YUax"),
  /* scopeId */
  "data-v-0ef596ad",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "hVVH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var Declaracao = function Declaracao() {
    var declarante = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var itens = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var semBens = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var situacao = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'EM_BRANCO';
    var dataDeclaracao = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD');
    var numeroRetificacao = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    var justificativa = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Declaracao);

    this.declarante = declarante;
    this.itens = itens;
    this.semBens = semBens;
    this.situacao = situacao;
    this.dataDeclaracao = dataDeclaracao;
    this.numeroRetificacao = numeroRetificacao;
    this.justificativa = justificativa;
};

/* harmony default export */ __webpack_exports__["a"] = (Declaracao);

/***/ }),

/***/ "hmlq":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("y909")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("56G/"),
  /* template */
  __webpack_require__("ze16"),
  /* scopeId */
  "data-v-4cf4c8e7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "hwPX":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Contatos\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "col-md-4"
  }, [(_vm.ehEmailPrefeitura) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "textoAlinhadoAoInput"
  }, [_vm._v("\n                        " + _vm._s(_vm.cadastrado.pessoa.contato.email) + "\n                      ")])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('field-validation', {
    attrs: {
      "label": "Email",
      "field": "email",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false,
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.contato.email),
      expression: "cadastrado.pessoa.contato.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|max:70'),
      expression: "'required|email|max:70'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "none"
    },
    attrs: {
      "type": "text",
      "name": "email",
      "id": "email",
      "data-vv-as": "Email",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.contato.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.contato, "email", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "dddCelular"
    }
  }, [_vm._v("DDD")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.contato.dddCelular),
      expression: "cadastrado.pessoa.contato.dddCelular"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##'),
      expression: "'##'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "dddCelular",
      "id": "dddCelular",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.contato.dddCelular)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.contato, "dddCelular", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "telefoneCelular"
    }
  }, [_vm._v("Tel Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.contato.numeroCelular),
      expression: "cadastrado.pessoa.contato.numeroCelular"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('#####-####'),
      expression: "'#####-####'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "telefoneCelular",
      "id": "telefoneCelular",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.contato.numeroCelular)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.contato, "numeroCelular", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "dddResidencial"
    }
  }, [_vm._v("DDD")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.contato.dddTelefone),
      expression: "cadastrado.pessoa.contato.dddTelefone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##'),
      expression: "'##'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "dddResidencial",
      "id": "dddResidencial",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.contato.dddTelefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.contato, "dddTelefone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "telefoneResidencial"
    }
  }, [_vm._v("Tel Fixo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.contato.numeroTelefone),
      expression: "cadastrado.pessoa.contato.numeroTelefone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('####-####'),
      expression: "'####-####'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "telefoneResidencial",
      "id": "telefoneResidencial",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.contato.numeroTelefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.contato, "numeroTelefone", $event.target.value)
      }
    }
  })])])])])])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.volta()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Avançar",
      "icone": "avancar",
      "icone-direita": true
    },
    on: {
      "clicado": function($event) {
        return _vm.avanca(_vm.cadastrado, 'Documentacao')
      }
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ "hzvd":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("uRbf")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("9RXk"),
  /* template */
  __webpack_require__("60R7"),
  /* scopeId */
  "data-v-6b12d1e0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "iHSL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_avaliacao__ = __webpack_require__("I/bL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_avaliado__ = __webpack_require__("vXSv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_avaliador__ = __webpack_require__("4JAb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_esconde_div__ = __webpack_require__("E20C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_esconde_div___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_esconde_div__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_avaliacaoService__ = __webpack_require__("h5sb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_periodosService__ = __webpack_require__("N9Gh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_obtemImpressao__ = __webpack_require__("8QDf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelper__ = __webpack_require__("9t/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_PeriodoAtualHelper__ = __webpack_require__("Yjkh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_ErrorHelper__ = __webpack_require__("+h9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_timers__ = __webpack_require__("162o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_timers__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DetalhaAvaliacao',

  data: function data() {
    return {
      avaliacao: {},
      periodos: {},
      notas: [],
      avaliadorId: this.$route.params.idAvaliador,
      funcionarioId: this.$route.params.idAvaliado,
      mostraParametros: false,
      mostraComprometimento: false,
      mostraDedicacao: false,
      mostraRelacionamento: false,
      mostraAtendimento: false,
      mostraCapacidade: false,
      apiErrors: null
    };
  },


  computed: {
    cargo: function cargo() {
      return this.avaliacao.avaliado.cargoReadaptado ? this.avaliacao.avaliado.cargoReadaptado : this.avaliacao.avaliado.cargoPrincipal;
    },
    cargoChefeImediato: function cargoChefeImediato() {
      return this.avaliacao.avaliador.cargoPrincipal + ' - ' + this.avaliacao.uorAvaliador.sigla;
    },
    dataInicioReferencia: function dataInicioReferencia() {
      return __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelper__["a" /* default */].convertDateToPtbr(this.periodos.dataInicioReferencia);
    },
    dataFimReferencia: function dataFimReferencia() {
      return __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelper__["a" /* default */].convertDateToPtbr(this.periodos.dataFimReferencia);
    },
    notasOrdenadas: function notasOrdenadas() {
      return this.avaliacao.notas.sort(function (a, b) {
        if (a.item.codigo < b.item.codigo) return -1;
        if (a.item.codigo > b.item.codigo) return 1;
      });
    },
    dataAvaliacao: function dataAvaliacao() {
      if (this.avaliacao.dataAvaliacao) {
        return __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelper__["a" /* default */].convertDateToPtbr(this.avaliacao.dataAvaliacao);
      }
    },
    somaAutoavaliacao: function somaAutoavaliacao() {
      var soma = 0;
      this.avaliacao.notas.forEach(function (nota) {
        return nota.notaAutoAvaliacao ? soma += parseInt(nota.notaAutoAvaliacao) : soma;
      });
      return soma;
    },
    somaAvaliador: function somaAvaliador() {
      var soma = 0;
      this.avaliacao.notas.forEach(function (nota) {
        return nota.notaAvaliador ? soma += parseInt(nota.notaAvaliador) : soma;
      });
      return soma;
    },
    mediaAvaliacoes: function mediaAvaliacoes() {
      return (this.somaAutoavaliacao + this.somaAvaliador) / 2;
    },
    pontuacaoFinal: function pontuacaoFinal() {
      return this.avaliacao.notaFichaFuncional + this.mediaAvaliacoes;
    },
    pontuacaoFinalProbatorio: function pontuacaoFinalProbatorio() {
      return this.avaliacao.notaFichaFuncional + this.avaliacao.mediaEstagioProbatorio;
    },
    ehAvaliador: function ehAvaliador() {
      if (!this.avaliadorId || !this.avaliacao.avaliador) return false;
      return this.avaliadorId == this.avaliacao.avaliador.id;
    },
    periodoValido: function periodoValido() {
      return __WEBPACK_IMPORTED_MODULE_13__helpers_PeriodoAtualHelper__["a" /* default */].validaPeriodo(this.periodos.dataInicioLancamento, this.periodos.dataFimLancamento);
    },
    naoFinalizadoComPeriodoEncerrado: function naoFinalizadoComPeriodoEncerrado() {
      return this.avaliacao.aceita == null && __WEBPACK_IMPORTED_MODULE_13__helpers_PeriodoAtualHelper__["a" /* default */].periodoEncerrado(this.periodos.dataFimLancamento);
    },
    avaliacaoFinalizada: function avaliacaoFinalizada() {
      return this.avaliacao.aceita != null;
    },
    ehRecemEstavel: function ehRecemEstavel() {
      return this.avaliacao.mediaEstagioProbatorio > 0;
    },
    habilitaCampoAvaliado: function habilitaCampoAvaliado() {
      var resultado = !this.ehAvaliador && this.periodoValido && !this.avaliacaoFinalizada;
      return !resultado;
    },
    habilitaNotasAvaliador: function habilitaNotasAvaliador() {
      var resultado = this.ehAvaliador && this.periodoValido && !this.avaliacaoFinalizada;
      return !resultado;
    },
    mostraSalvar: function mostraSalvar() {
      var resultado = this.periodoValido && !this.avaliacaoFinalizada && !this.ehRecemEstavel;
      return resultado;
    },
    mostraFinalizar: function mostraFinalizar() {
      var foiAvaliado = this.somaAvaliador > 0;
      var seAutoAvaliou = this.somaAutoavaliacao > 0;
      var resultado = this.periodoValido && !this.ehAvaliador && foiAvaliado && seAutoAvaliou && !this.avaliacaoFinalizada && !this.ehRecemEstavel;
      return resultado;
    },
    mostraImprimir: function mostraImprimir() {
      return !this.periodoValido || this.ehAvaliador || this.avaliacaoFinalizada;
    }
  },

  methods: {
    voltar: function voltar() {
      this.$router.go(-1);
    },
    valida: function valida(metodo) {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (success) {
          metodo === 'salvar' ? _this.salvar() : _this.finalizar();
          return;
        }
        _this.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção');
      });
    },
    salvar: function salvar() {
      var _this2 = this;

      var sentences = [{
        id: 1,
        message: 'Deseja salvar essa avaliação?',
        bold: false
      }];

      this.$root.$refs.modal.confirm(sentences, {
        yes: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return _this2.gravaFinalizaAvaliacao(_this2.avaliacao.id, _this2.avaliacao, null);

                  case 2:
                    _this2.$root.$refs.toastr.s('Avaliação salva', 'Sucesso');
                    _this2.chamaProximaTela();

                  case 4:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function yes() {
            return _ref.apply(this, arguments);
          };
        }(),
        title: 'Salvar Avaliação'
      });
    },
    gravaFinalizaAvaliacao: function gravaFinalizaAvaliacao(id, item, aceita) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var mensagem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                item.dataAvaliacao = __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelper__["a" /* default */].convertDateToApiDate(new Date());
                item.aceita = aceita;
                _context2.prev = 2;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_9__services_avaliacaoService__["a" /* default */].atualiza(id, item);

              case 5:
                return _context2.abrupt('return', _context2.sent);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](2);
                mensagem = __WEBPACK_IMPORTED_MODULE_14__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context2.t0);

                _this3.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[2, 8]]);
      }))();
    },
    finalizar: function finalizar() {
      jQuery('#finalizaModal').modal('show');
    },
    discorda: function discorda() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.gravaFinalizaAvaliacao(_this4.avaliacao.id, _this4.avaliacao, false);

              case 2:
                _this4.$root.$refs.toastr.s('Avaliação finalizada', 'Sucesso');
                jQuery('#finalizaModal').modal('hide');
                _this4.$router.push({ name: 'Avaliacao' });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    concorda: function concorda() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this5.gravaFinalizaAvaliacao(_this5.avaliacao.id, _this5.avaliacao, true);

              case 2:
                _this5.$root.$refs.toastr.s('Avaliação finalizada', 'Sucesso');
                jQuery('#finalizaModal').modal('hide');
                _this5.$router.push({ name: 'Avaliacao' });

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    imprime: function imprime(id) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var endpoint, mensagem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                endpoint = 'avaliacoes-periodicas/' + id + '/ficha';
                _context5.prev = 1;
                _context5.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__services_obtemImpressao__["a" /* default */])(endpoint);

              case 4:
                _context5.next = 11;
                break;

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_14__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context5.t0);

                if (mensagem === 'Desbloqueie as pop-ups para este site') {
                  _this6.$root.$refs.toastr.w(mensagem, 'Pop-up bloqueada');
                }
                _this6.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[1, 6]]);
      }))();
    },
    obtemAvaliacaoENotas: function obtemAvaliacaoENotas() {
      var _this7 = this;

      var avaliacoes = JSON.parse(sessionStorage.getItem('periodos'));
      console.log(avaliacoes);
      this.avaliacao = avaliacoes.find(function (item) {
        return item.avaliado.id == _this7.funcionarioId;
      });
      this.periodos = this.avaliacao.competencia.periodos[0];
    },
    obtemAvaliados: function obtemAvaliados(funcionarioId, idMes) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var avaliacoes, mensagem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10__services_periodosService__["a" /* default */].lista(funcionarioId, idMes);

              case 3:
                avaliacoes = _context6.sent;

                sessionStorage.setItem('periodos', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(avaliacoes));
                _context6.next = 11;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6['catch'](0);
                mensagem = __WEBPACK_IMPORTED_MODULE_14__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context6.t0);

                _this8.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 11:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[0, 7]]);
      }))();
    },
    chamaProximaTela: function chamaProximaTela() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var avaliadorId;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!_this9.ehAvaliador) {
                  _context7.next = 6;
                  break;
                }

                avaliadorId = _this9.avaliacao.avaliador.id;
                _context7.next = 4;
                return _this9.obtemAvaliados(avaliadorId, _this9.avaliacao.competencia.id);

              case 4:
                _this9.$router.push({ name: 'Avaliados', params: { id: avaliadorId } });

                return _context7.abrupt('return');

              case 6:
                _this9.$router.push({ name: 'Avaliacao' });

              case 7:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9);
      }))();
    }
  },

  created: function created() {
    this.avaliacao = new __WEBPACK_IMPORTED_MODULE_4__domain_avaliacao__["a" /* default */](new __WEBPACK_IMPORTED_MODULE_5__domain_avaliado__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_6__domain_avaliador__["a" /* default */]());
    this.obtemAvaliacaoENotas();
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },


  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_7__components_botao___default.a,
    EscondeDiv: __WEBPACK_IMPORTED_MODULE_8__components_esconde_div___default.a
  }
});

/***/ }),

/***/ "iXI6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_object_hash__ = __webpack_require__("eZXE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_object_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_object_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pms_endereco_aberto_alternativo__ = __webpack_require__("crW4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pms_endereco_aberto_alternativo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pms_endereco_aberto_alternativo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_StringHelper__ = __webpack_require__("1pbJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__domain_endereco_Endereco_js__ = __webpack_require__("5VMd");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Endereco',

  data: function data() {
    return {
      cadastrado: this.$store.state.funcionarioCadastrado,
      estados: this.$store.state.estados,
      municipios: [],
      enderecos: [],
      dataEnderecoModal: {
        logradouro: {
          nome: ''
        },
        bairro: {
          nome: ''
        },
        cep: '',
        numero: '',
        complemento: ''
      },
      cepInvalido: false,
      mostraLista: false,
      mostraRefresh: false,
      desabilitaCampo: true,
      logradouroInvalido: false,
      proximoComponente: '',
      apiErrors: null
    };
  },


  computed: {
    situacaoRecad: function situacaoRecad() {
      return this.$store.getters.getSituacaoRecad;
    },
    georreferenciado: function georreferenciado() {
      return this.cadastrado.pessoa.endereco.georreferenciado ? this.cadastrado.endereco.georreferenciado : false;
    },
    inseridoPeloUsuario: function inseridoPeloUsuario() {
      return this.cadastrado.pessoa.endereco.inseridoPeloUsuario ? this.cadastrado.endereco.inseridoPeloUsuario : false;
    },
    enderecoEditavel: function enderecoEditavel() {
      // Se não recebe vale-transporte, sempre editável
      if (!this.cadastrado.pessoa.recebeValeTransporte) return true;
      // Se recebe vale-transporte, só entre 16/07/2025 e 15/08/2025
      var hoje = new Date();
      var inicio = new Date('2025-05-06T00:00:00');
      var fim = new Date('2025-08-15T23:59:59');
      // A partir de 16/08/2025, deixar o endereço apenas para consulta.
      if (hoje.getTime() > fim.getTime()) return false;
      return hoje.getTime() >= inicio.getTime() && hoje.getTime() <= fim.getTime();
    }
  },

  methods: {
    abreExplicacaoModal: function abreExplicacaoModal() {
      jQuery('#explicacaoModal').modal('show');
    },
    sucesso: function sucesso(_sucesso) {
      this.$root.$refs.toastr.s(_sucesso, 'Sucesso');
    },
    alerta: function alerta(_alerta) {
      this.$root.$refs.toastr.e(_alerta, 'Atenção');
    },
    alertaInfo: function alertaInfo(alerta, informacao) {
      var _this = this;

      this.$root.$refs.toastr.Add({
        title: 'Atenção',
        msg: alerta,
        type: 'error',
        timeout: 6000
      });
      setTimeout(function () {
        _this.$root.$refs.toastr.i(informacao, 'Para prosseguir');
      }, 1000);
    },
    gravaPessoaEndereco: function gravaPessoaEndereco(editado) {
      try {
        editado.cidade = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(editado.municipio));
        editado.uf = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(editado.estado));
        delete editado.municipio;
        delete editado.estado;
        editado.numero = parseInt(editado.numero);
        this.cadastrado.pessoa.endereco = editado;
        this.tiraAcentuacao(this.cadastrado.pessoa.endereco);
        this.setAnexos(this.cadastrado, this.$store.state.cadastroModelo);
        this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
        return true;
      } catch (error) {
        console.error('Error saving address:', error);
        this.$root.$refs.toastr.e('Erro ao salvar endereço', 'Erro');
        return false;
      }
    },
    tiraAcentuacao: function tiraAcentuacao(endereco) {
      var _this2 = this;

      var campos = [endereco.bairro, endereco.cidade, endereco.complemento, endereco.logradouro, endereco.tipoLogradouro];
      var index = 0;

      campos.map(function (element) {
        if (__WEBPACK_IMPORTED_MODULE_8__helpers_StringHelper__["a" /* default */].verificaCaracterEspecial(element)) {
          campos[index] = __WEBPACK_IMPORTED_MODULE_8__helpers_StringHelper__["a" /* default */].limpaCaracterEspecial(element);
          _this2.$root.$refs.toastr.w('A Atualização Cadastral não aceita acentos e cedilhas. A aplicação já fez as correções necessárias.', 'Atenção');
        }
        index++;
      });
      this.cadastrado.pessoa.endereco.bairro = campos[0];
      this.cadastrado.pessoa.endereco.cidade = campos[1];
      this.cadastrado.pessoa.endereco.complemento = campos[2];
      this.cadastrado.pessoa.endereco.logradouro = campos[3];
    },
    setAnexos: function setAnexos(cadastrado, original) {
      var endereco = __WEBPACK_IMPORTED_MODULE_5_object_hash___default()(cadastrado.pessoa.endereco) != __WEBPACK_IMPORTED_MODULE_5_object_hash___default()(original.pessoa.endereco) ? true : false;
      var documentos = [];

      if (endereco) documentos.push('Comprovante de Residência recente (com menos de 90 dias)');

      if (cadastrado.documentosExigidos) {
        var novosDocumentos = documentos.filter(function (item) {
          return !cadastrado.documentosExigidos.includes(item);
        });
        cadastrado.documentosExigidos = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(cadastrado.documentosExigidos), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(novosDocumentos));
      } else {
        cadastrado.documentosExigidos = [].concat(documentos);
      }
    },
    volta: function volta() {
      this.$router.go(-1);
    },
    avanca: function avanca(proximoLink) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var enderecoComponent;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                enderecoComponent = _this3.$refs.enderecoComponente;
                _context.next = 4;
                return enderecoComponent.salvar();

              case 4:
                _this3.proximoComponente = proximoLink;
                _this3.$router.push({ name: proximoLink });
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                console.error('Error saving address:', _context.t0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 8]]);
      }))();
    }
  },

  created: function created() {
    var _this4 = this;

    this.$eventBus.$on('salvaAvanca', function (nomeComponente) {
      _this4.avanca(nomeComponente);
    });
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off('salvaAvanca');
  },


  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_6__components_botao___default.a,
    PmsEndereco: __WEBPACK_IMPORTED_MODULE_7__components_pms_endereco_aberto_alternativo___default.a
  }
});

/***/ }),

/***/ "ijob":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var DeclaracoesService = function () {
  function DeclaracoesService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DeclaracoesService);

    throw 'Não é possível instanciar DeclaracoesService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DeclaracoesService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint();
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista() {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }, {
    key: 'grava',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(declaracao) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = mergeEndpoint();
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].post(endpoint, declaracao);

              case 3:
                return _context2.abrupt('return', _context2.sent);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function grava(_x) {
        return _ref2.apply(this, arguments);
      }

      return grava;
    }()
  }, {
    key: 'atualiza',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id, declaracao) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                endpoint = mergeEndpoint(id);
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].put(endpoint, declaracao);

              case 3:
                return _context3.abrupt('return', _context3.sent);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function atualiza(_x2, _x3) {
        return _ref3.apply(this, arguments);
      }

      return atualiza;
    }()
  }, {
    key: 'obtem',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                endpoint = mergeEndpoint(id);
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context4.abrupt('return', _context4.sent);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function obtem(_x4) {
        return _ref4.apply(this, arguments);
      }

      return obtem;
    }()
  }]);

  return DeclaracoesService;
}();

/* harmony default export */ __webpack_exports__["a"] = (DeclaracoesService);


var mergeEndpoint = function mergeEndpoint(id) {
  return 'declaracoes-bens/' + (id || '');
};

/***/ }),

/***/ "ikHu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jT7l":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("Zx+S")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Wbwb"),
  /* template */
  __webpack_require__("R583"),
  /* scopeId */
  "data-v-3c919c1e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "jUxG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jaCG":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "main"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top vale-page"
  }, [(!_vm.carregando && !_vm.habilitado) ? _c('div', {
    staticClass: "alert alert-warning mensagem-estado"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v("\n      Você não atende aos critérios para realizar a escolha do vale-alimentação.\n    ")]) : (!_vm.carregando && !_vm.periodoAberto) ? _c('div', {
    staticClass: "alert alert-info mensagem-estado"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("\n      Aguarde o próximo período para escolha do vale-alimentação.\n    ")]) : (!_vm.carregando) ? [_c('div', {
    staticClass: "row cabecalho-row"
  }, [_c('div', {
    staticClass: "col-md-12 cabecalho-vale"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    class: _vm.badgeClass,
    attrs: {
      "title": _vm.badgeLabel
    }
  }, [_c('i', {
    class: _vm.badgeIcon
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.badgeLabel))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row cards-resumo"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-default card-info resumo-card"
  }, [_c('div', {
    staticClass: "card-content d-flex-center"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "resumo-conteudo"
  }, [_c('small', [_vm._v("Ano da competência")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.anoCompetencia))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-default card-info resumo-card"
  }, [_c('div', {
    staticClass: "card-content d-flex-center"
  }, [_c('span', {
    staticClass: "resumo-icone",
    style: ({
      color: _vm.statusColor
    })
  }, [_c('i', {
    class: _vm.statusIconClass
  })]), _vm._v(" "), _c('div', {
    staticClass: "resumo-conteudo"
  }, [_c('small', [_vm._v("Situação")]), _vm._v(" "), _c('strong', {
    style: ({
      color: _vm.statusColor
    })
  }, [_vm._v(_vm._s(_vm.statusLabel))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-default card-info resumo-card"
  }, [_c('div', {
    staticClass: "card-content d-flex-center"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "resumo-conteudo"
  }, [_c('small', [_vm._v("Data da escolha")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.dataEscolhaFormatada))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default escolha-card"
  }, [_c('div', {
    staticClass: "card-content escolha-card-content"
  }, [_c('div', {
    staticClass: "servidor-info"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "servidor-dados"
  }, [_c('small', [_vm._v("Nome do servidor")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.nomeServidor))])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), (!_vm.temEscolha && !_vm.modoEscolha) ? _c('div', {
    staticClass: "escolha-vazia"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "icone": "fa-check",
      "rotulo": "ESCOLHER EMPRESA"
    },
    on: {
      "clicado": _vm.iniciarEscolha
    }
  })], 1) : [_c('div', {
    staticClass: "escolha-cabecalho"
  }, [_c('div', [_c('h5', {
    staticClass: "titulo-escolha"
  }, [_vm._v(_vm._s(_vm.temEscolha ? 'Sua escolha' : 'Escolha sua empresa'))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.somenteConsulta ? 'Esta escolha está disponível somente para consulta.' : 'Selecione a empresa desejada e salve para confirmar.'))])])]), _vm._v(" "), _c('div', {
    staticClass: "lista-empresas"
  }, _vm._l((_vm.empresasExibidas), function(empresa) {
    return _c('div', {
      key: empresa.id,
      staticClass: "empresa-item",
      class: _vm.classeItem(empresa.id)
    }, [_c('div', {
      staticClass: "empresa-conteudo"
    }, [_c('label', {
      staticClass: "radio-inline radio-empresa"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.empresaSelecionada),
        expression: "empresaSelecionada"
      }],
      attrs: {
        "type": "radio",
        "disabled": _vm.somenteConsulta
      },
      domProps: {
        "value": empresa.id,
        "checked": _vm._q(_vm.empresaSelecionada, empresa.id)
      },
      on: {
        "change": function($event) {
          _vm.empresaSelecionada = empresa.id
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "nome-empresa"
    }, [_vm._v(_vm._s(_vm.nomeDaEmpresa(empresa)))])]), _vm._v(" "), (empresa.temMaterial !== false) ? _c('a', {
      staticClass: "link-detalhes",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.abrirAnexoEmNovaAba(empresa.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v("\n                          Material informativo\n                          "), _c('i', {
      staticClass: "fa fa-external-link"
    })]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "actions-footer"
  }, [(!_vm.somenteConsulta) ? _c('botao', {
    attrs: {
      "estilo": _vm.podeSalvar ? 'vazado-verde' : 'vazado-cinza',
      "icone": "salvar",
      "rotulo": "SALVAR",
      "disabled": !_vm.podeSalvar || _vm.salvando
    },
    on: {
      "clicado": _vm.salvar
    }
  }) : _vm._e(), _vm._v(" "), (_vm.temEscolha) ? _c('botao', {
    attrs: {
      "estilo": "vazado-verde",
      "icone": "fa-print",
      "rotulo": "IMPRIMIR PROTOCOLO",
      "disabled": _vm.imprimindo
    },
    on: {
      "clicado": _vm.imprimirProtocolo
    }
  }) : _vm._e()], 1)]], 2)])])])] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titulo-vale"
  }, [_c('div', {
    staticClass: "icone-titulo"
  }, [_c('i', {
    staticClass: "fa fa-cutlery"
  })]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Escolher Vale-Alimentação")]), _vm._v(" "), _c('span', [_vm._v("Selecione a empresa de sua preferência.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "resumo-icone icone-verde"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "resumo-icone icone-verde"
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "servidor-icone"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mensagem-fixa"
  }, [_c('p', [_c('span', {
    staticClass: "destaque"
  }, [_vm._v("Aviso:")]), _vm._v(" A votação é obrigatória. O servidor deverá escolher uma das empresas disponíveis.")]), _vm._v(" "), _c('p', {
    staticClass: "paragrafo"
  }, [_vm._v("Caso não seja registrada nenhuma opção, será considerada automaticamente a empresa que obtiver o maior número de votos.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "escolha-vazia-icone"
  }, [_c('i', {
    staticClass: "fa fa-cutlery"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "escolha-vazia-texto"
  }, [_c('h5', [_vm._v("Nenhuma empresa selecionada")]), _vm._v(" "), _c('p', [_vm._v("Escolha uma das empresas credenciadas para concluir sua opção de vale-alimentação.")])])
}]}

/***/ }),

/***/ "jy/c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_side_modal__ = __webpack_require__("dLc8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_side_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_side_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__encerramento_modal__ = __webpack_require__("nK9I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__encerramento_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__encerramento_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_table_loader__ = __webpack_require__("pKzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_table_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_table_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_recadastroDependenteService__ = __webpack_require__("vUyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_pessoaFisicaService__ = __webpack_require__("WD1U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__domain_recadastroDependente__ = __webpack_require__("ZAwl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__domain_recadastroDependente_anexo__ = __webpack_require__("X/AL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_DateHelper__ = __webpack_require__("9t/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_StringHelper__ = __webpack_require__("1pbJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_CpfHelper__ = __webpack_require__("moXt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_ArrayHelper__ = __webpack_require__("5OEK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__ = __webpack_require__("+h9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_obtemImpressao__ = __webpack_require__("8QDf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__filters_filters__ = __webpack_require__("V1NV");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DependenteCPF',

  data: function data() {
    return {
      apiErrors: null,
      carregando: false,
      autenticado: this.$store.state.usuarioLogado,
      pessoaAutenticada: {},
      funcionarioId: this.$store.state.funcionario.id,
      dependentes: [],
      dependenteModal: {},
      tiposDependencia: [],
      sexos: [{
        displayName: 'Masculino',
        name: 'M'
      }, {
        displayName: 'Feminino',
        name: 'F'
      }],
      anoEditavel: false,
      anoReferenciaAtual: 0,
      navs: [{
        titulo: 'Familiar',
        subtitulo: 'Dados Pessoais',
        subtDetalhe: 'Novo Familiar',
        largura: 800,
        identidade: 'dependente',
        abreProximo: false,
        aberto: false
      }],
      config: {
        format: 'L',
        useCurrent: true,
        locale: 'pt-br',
        maxDate: __WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date()),
        minDate: __WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date()).add(-150, 'years')
      }
    };
  },


  computed: {
    dependentesOrdenados: function dependentesOrdenados() {
      return this.dependentes.sort(__WEBPACK_IMPORTED_MODULE_16__helpers_ArrayHelper__["a" /* default */].compareValues('nome'));
    },
    temDependentesSemCpf: function temDependentesSemCpf() {
      return this.dependentes.some(function (dependente) {
        return !dependente.cpf;
      });
    },
    podeImprimirProtocolo: function podeImprimirProtocolo() {
      return this.dependentes.length === 0 || !this.temDependentesSemCpf;
    },
    telaEhMobile: function telaEhMobile() {
      return window.innerWidth <= 768;
    },
    usuarioAtual: function usuarioAtual() {
      return this.$store.state.funcionario;
    }
  },

  methods: {
    abreModal: function abreModal(identidade) {
      this.$emit('abreModal', identidade);
    },
    fechaModal: function fechaModal(identidade) {
      this.$emit('fechaModal', identidade);
    },
    novo: function novo() {
      this.navs[0].subtDetalhe = 'Novo Familiar';
      this.$validator.reset();
      this.dependenteModal = new __WEBPACK_IMPORTED_MODULE_11__domain_recadastroDependente__["a" /* default */]();

      this.abreModal('dependente');
    },
    imprimeProtocolo: function imprimeProtocolo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint, mensagem;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.podeImprimirProtocolo) {
                  _context.next = 3;
                  break;
                }

                _this.$root.$refs.toastr.e("Não é possível imprimir protocolo", 'Atenção');
                return _context.abrupt('return');

              case 3:
                endpoint = 'recadastro-dependentes/funcionarios/' + _this.funcionarioId + '/protocolo';
                _context.prev = 4;
                _context.next = 7;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__services_obtemImpressao__["a" /* default */])(endpoint);

              case 7:
                _context.next = 14;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](4);
                mensagem = __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context.t0);

                if (mensagem === 'Desbloqueie as pop-ups para este site') {
                  _this.$root.$refs.toastr.w(mensagem, 'Pop-up bloqueada');
                }
                _this.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 9]]);
      }))();
    },
    verificaCpf: function verificaCpf(cpf) {
      try {
        this.validaCpf(this.dependenteModal.id, cpf);
      } catch (error) {
        this.dependenteModal.cpf = cpf;
        var mensagem = __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    limpaCpfAnterior: function limpaCpfAnterior() {
      this.dependenteModal = new __WEBPACK_IMPORTED_MODULE_11__domain_recadastroDependente__["a" /* default */]();
    },
    valida: function valida() {
      var _this2 = this;

      this.$validator.validateAll().then(function (success) {

        if (success) {
          if (_this2.validaDados()) {
            _this2.salva();
          }
          return;
        }
        _this2.$root.$refs.toastr.e('Preencha ou corrija os campos em vermelho', 'Atenção');
      });
    },
    validaDados: function validaDados() {
      try {
        this.validaAnexos();

        var id = this.dependenteModal.id;
        var cpf = this.dependenteModal.cpf;
        this.validaCpf(id, cpf);
      } catch (error) {
        this.$root.$refs.toastr.e(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(error), 'Atenção');

        return false;
      }

      return true;
    },
    validaAnexos: function validaAnexos() {
      if (!this.dependenteModal.anexos.length) {
        throw new Error("É obrigatório anexar comprovantes");
      }
    },
    validaCpf: function validaCpf(idDependente, cpf) {
      var cpfLimpo = __WEBPACK_IMPORTED_MODULE_14__helpers_StringHelper__["a" /* default */].limpaFormato(cpf);

      if (cpfLimpo === this.autenticado.cpf) {
        throw new Error('O declarante não pode ser o dependente. Verifique o CPF.');
      }
      if (this.dependentes.some(function (dependencia) {
        return dependencia.cpf === cpfLimpo && dependencia.id != idDependente;
      })) {
        throw new Error('Dependente já cadastrado');
      }
      if (!__WEBPACK_IMPORTED_MODULE_15__helpers_CpfHelper__["a" /* default */].testaCpf(cpfLimpo)) {
        throw new Error('Número de CPF inválido');
      }
    },
    edita: function edita(dependente) {
      this.navs[0].subtDetalhe = dependente.nome;

      var dataNascimento = dependente.dataNascimento;
      if (!this.telaEhMobile) {
        dataNascimento = __WEBPACK_IMPORTED_MODULE_13__helpers_DateHelper__["a" /* default */].convertDateToPtbr(dataNascimento);
      }

      this.dependenteModal = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dependente));
      this.dependenteModal.dataNascimento = dataNascimento;

      this.abreModal('dependente');
    },
    salva: function salva() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var dependenteJson, anexosJson, dependente, novosAnexos, mensagemSucesso, response, mensagem;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dependenteJson = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this3.dependenteModal));
                anexosJson = _this3.dependenteModal.anexos.map(function (anexo) {
                  return {
                    id: anexo.id,
                    nomeArquivo: anexo.nomeArquivo
                  };
                });
                dependente = new __WEBPACK_IMPORTED_MODULE_11__domain_recadastroDependente__["a" /* default */](dependenteJson.id, _this3.funcionarioId, dependenteJson.tipoDependenteId, dependenteJson.nome, dependenteJson.mae, dependenteJson.sexo, __WEBPACK_IMPORTED_MODULE_14__helpers_StringHelper__["a" /* default */].limpaFormato(dependenteJson.cpf), dependenteJson.dataNascimento, dependenteJson.alteracaoEstadoCivil, anexosJson);


                dependente = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dependente));
                dependente = __WEBPACK_IMPORTED_MODULE_14__helpers_StringHelper__["a" /* default */].toUpperCaseInJson(dependente);

                if (!_this3.telaEhMobile) {
                  dependente.dataNascimento = __WEBPACK_IMPORTED_MODULE_13__helpers_DateHelper__["a" /* default */].convertPtbrToApiDate(dependente.dataNascimento);
                }

                novosAnexos = _this3.dependenteModal.anexos.filter(function (anexo) {
                  return anexo.conteudo instanceof File && !anexo.id;
                }).map(function (anexo) {
                  return anexo.conteudo;
                });


                if (dependente.anexos === 0) delete dependente.anexos;

                _context2.prev = 8;
                mensagemSucesso = 'Informação salva';

                if (!dependente.id) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 13;
                return __WEBPACK_IMPORTED_MODULE_9__services_recadastroDependenteService__["a" /* default */].atualiza(dependente.id, dependente, novosAnexos);

              case 13:
                _context2.next = 15;
                return _this3.listaDependentesFuncionarioSelecionado();

              case 15:
                mensagemSucesso = 'Dependente atualizado';

                _context2.next = 22;
                break;

              case 18:
                _context2.next = 20;
                return __WEBPACK_IMPORTED_MODULE_9__services_recadastroDependenteService__["a" /* default */].grava(dependente, novosAnexos);

              case 20:
                response = _context2.sent;

                _this3.dependentes.push(_this3.criaDependenteResponse(response));

              case 22:

                _this3.fechaModal('dependente');
                _this3.limpaModal();
                _this3.$root.$refs.toastr.s(mensagemSucesso, 'Sucesso');

                _context2.next = 31;
                break;

              case 27:
                _context2.prev = 27;
                _context2.t0 = _context2['catch'](8);
                mensagem = __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context2.t0);

                _this3.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 31:
                _context2.prev = 31;

                _this3.carregando = false;
                return _context2.finish(31);

              case 34:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[8, 27, 31, 34]]);
      }))();
    },
    exclui: function exclui(dependente) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var sentences;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                sentences = [{
                  id: 1,
                  message: 'Deseja excluir esse dependente da sua lista?',
                  bold: false
                }];


                _this4.$root.$refs.modal.confirm(sentences, {
                  yes: function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
                      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              _context3.prev = 0;
                              _context3.next = 3;
                              return __WEBPACK_IMPORTED_MODULE_9__services_recadastroDependenteService__["a" /* default */].exclui(dependente.id);

                            case 3:
                              _this4.dependentes.splice(_this4.dependentes.indexOf(dependente), 1);
                              _this4.$root.$refs.toastr.s('Dependente excluído', 'Sucesso');
                              _context3.next = 10;
                              break;

                            case 7:
                              _context3.prev = 7;
                              _context3.t0 = _context3['catch'](0);

                              _this4.$root.$refs.toastr.e(__WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context3.t0), 'Atenção');

                            case 10:
                            case 'end':
                              return _context3.stop();
                          }
                        }
                      }, _callee3, _this4, [[0, 7]]);
                    }));

                    return function yes() {
                      return _ref.apply(this, arguments);
                    };
                  }(),
                  title: 'Deletando Dependente'
                });

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    cancela: function cancela() {
      this.limpaModal();
      this.fechaModal('dependente');
    },
    limpaModal: function limpaModal() {
      var _this5 = this;

      setTimeout(function () {
        return _this5.dependenteModal = new __WEBPACK_IMPORTED_MODULE_11__domain_recadastroDependente__["a" /* default */]();
      }, 600);
    },
    anexarArquivo: function anexarArquivo() {
      var _this6 = this;

      var arquivos = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$refs.file.files));

      arquivos.forEach(function (arquivo) {
        var totalArquivos = _this6.dependenteModal.anexos.length;

        if (totalArquivos >= 6) {
          _this6.$root.$refs.toastr.e('Não é possível anexar mais que 6 arquivos por dependente', 'Atenção');
          return;
        }

        var dataAtual = __WEBPACK_IMPORTED_MODULE_13__helpers_DateHelper__["a" /* default */].convertPtbrToApiDate(__WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date()).format('YYYY-MM-DD'));
        _this6.dependenteModal.anexos.push(new __WEBPACK_IMPORTED_MODULE_12__domain_recadastroDependente_anexo__["a" /* default */](null, arquivo.name, dataAtual, arquivo));
      });

      document.getElementById("comprovantes").value = '';
    },
    excluiAnexo: function excluiAnexo(anexo) {
      this.dependenteModal.anexos.splice(this.dependenteModal.anexos.indexOf(anexo), 1);
    },
    podeAlterar: function podeAlterar(dependente) {
      return dependente.id == null;
    },
    podeExcluir: function podeExcluir(dependente) {
      return dependente.tipoAlteracao == 'I' && dependente.statusValidacao == 'P';
    },
    podeSalvar: function podeSalvar(dependente) {
      return !dependente.statusValidacao || dependente.statusValidacao == 'C' || dependente.statusValidacao == 'P';
    },
    dependenteEhTipoEsposo: function dependenteEhTipoEsposo() {
      var _this7 = this;

      if (!this.dependenteModal || !this.dependenteModal.tipoDependenteId) return false;

      var tipoDependencia = this.tiposDependencia.find(function (tipo) {
        return _this7.dependenteModal.tipoDependenteId == tipo.id;
      });
      return ['ESPOSO', 'ESPOSA', 'COMPANHEIRA', 'COMPANHEIRO'].includes(tipoDependencia.nome);
    },
    validacaoMaeSeAutenticadoMasculinoEDependenteFilha: function validacaoMaeSeAutenticadoMasculinoEDependenteFilha() {
      var _this8 = this;

      if (!this.dependenteModal || !this.dependenteModal.tipoDependenteId) return '';

      var tipoDependencia = this.tiposDependencia.find(function (tipo) {
        return _this8.dependenteModal.tipoDependenteId == tipo.id;
      });

      if (!tipoDependencia) return;

      var autenticadoEhMasculino = "M" === this.pessoaAutenticada.sexo;

      var dependenteEhFilha = tipoDependencia.nome.includes("FILHA") || tipoDependencia.nome.includes("ENTEADA") || tipoDependencia.nome.includes("TUTELADA");

      if (autenticadoEhMasculino && dependenteEhFilha) {
        return 'required|max:50';
      }

      return '';
    },
    alteraParentesco: function alteraParentesco() {
      if (!this.dependenteModal || this.dependenteModal.id) return;

      this.dependenteModal.mae = null;
      this.dependenteModal.alteracaoEstadoCivil = false;
    },
    abreEncerramentoModal: function abreEncerramentoModal() {
      var dataAtual = __WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date());
      var dataInicioAviso = __WEBPACK_IMPORTED_MODULE_8_moment___default()('06/08/2022', 'DD/MM/YYYY');

      if (dataAtual.isSameOrAfter(dataInicioAviso)) {
        jQuery('#encerramentoModal').modal('show');
      }
    },


    // Requisição
    listaDependentesFuncionarioSelecionado: function listaDependentesFuncionarioSelecionado() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this9.executaRequisicao(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
                  var dependentesFuncionario;
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _this9.dependentes = [];

                          if (!_this9.funcionarioId) {
                            _context5.next = 6;
                            break;
                          }

                          _context5.next = 4;
                          return __WEBPACK_IMPORTED_MODULE_9__services_recadastroDependenteService__["a" /* default */].lista(_this9.funcionarioId);

                        case 4:
                          dependentesFuncionario = _context5.sent;

                          dependentesFuncionario.content.map(function (response) {
                            return _this9.dependentes.push(_this9.criaDependenteResponse(response));
                          });

                        case 6:
                        case 'end':
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this9);
                })));

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    criaDependenteResponse: function criaDependenteResponse(response) {
      var dependente = {};

      dependente.id = response.id;
      dependente.nome = response.nome ? response.nome : response.nomeCarga;
      dependente.mae = response.mae ? response.mae : response.maeCarga;
      dependente.cpf = response.cpf ? response.cpf : response.cpfCarga;
      dependente.sexo = response.sexo ? response.sexo : response.sexoCarga;
      dependente.dataNascimento = response.dataNascimento ? response.dataNascimento : response.dataNascimentoCarga;
      dependente.tipoDependenteId = response.tipoDependenteId;
      dependente.tipoDependenteNome = response.tipoDependenteNome;
      dependente.dependenteIR = response.dependenteIR;
      dependente.responsavelId = response.responsavelId;
      dependente.alteracaoEstadoCivil = response.alteracaoEstadoCivil;
      dependente.anexos = response.anexos;
      dependente.tipoAlteracao = response.tipoAlteracao;
      dependente.statusValidacao = response.statusValidacao;

      dependente.nomeCarga = response.nomeCarga;
      dependente.maeCarga = response.maeCarga;
      dependente.cpfCarga = response.cpfCarga;
      dependente.sexoCarga = response.sexoCarga;
      dependente.dataNascimentoCarga = response.dataNascimentoCarga;

      return dependente;
    },
    listaTiposDependencia: function listaTiposDependencia() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this10.executaRequisicao(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          _context7.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_9__services_recadastroDependenteService__["a" /* default */].listaTiposDependencia();

                        case 2:
                          _this10.tiposDependencia = _context7.sent;

                        case 3:
                        case 'end':
                          return _context7.stop();
                      }
                    }
                  }, _callee7, _this10);
                })));

              case 1:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this10);
      }))();
    },
    buscaPessoaAutenticada: function buscaPessoaAutenticada() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__services_pessoaFisicaService__["a" /* default */].obtemAutenticada();

              case 2:
                _this11.pessoaAutenticada = _context9.sent;

              case 3:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this11);
      }))();
    },
    executaRequisicao: function executaRequisicao(requisicao) {
      this.carregando = true;
      try {
        requisicao();
      } catch (error) {
        var mensagem = __WEBPACK_IMPORTED_MODULE_17__helpers_ErrorHelper__["a" /* default */].trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      } finally {
        this.carregando = false;
      }
    }
  },

  created: function created() {
    this.buscaPessoaAutenticada();
    this.listaTiposDependencia();
    this.listaDependentesFuncionarioSelecionado();
    this.anoReferenciaAtual = __WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date()).year();
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
    this.abreEncerramentoModal();
  },


  watch: {
    usuarioAtual: function usuarioAtual(novo, anterior) {
      this.funcionarioId = novo.id;
    },
    funcionarioId: function funcionarioId(novo, anterior) {
      var _this12 = this;

      var funcionario = this.autenticado.funcionarios.find(function (func) {
        return _this12.funcionarioId == func.id;
      });
      this.$store.commit('setFuncionario', funcionario);

      this.listaDependentesFuncionarioSelecionado();
    }
  },

  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_4__components_botao___default.a,
    SideModal: __WEBPACK_IMPORTED_MODULE_5__components_side_modal___default.a,
    EncerramentoModal: __WEBPACK_IMPORTED_MODULE_6__encerramento_modal___default.a,
    TableLoader: __WEBPACK_IMPORTED_MODULE_7__components_table_loader___default.a
  }
});

/***/ }),

/***/ "kmnI":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("Kw2F")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("2rAA"),
  /* template */
  __webpack_require__("B6Ps"),
  /* scopeId */
  "data-v-4f9fc508",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ktDO":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Avaliados")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.periodosOrdenados), function(periodo) {
    return _c('tr', {
      key: periodo.id,
      class: _vm.situacaoPendente(periodo, 'class')
    }, [_c('td', [_vm._v(_vm._s(periodo.avaliado.pessoa.nome))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.mostraNota(periodo)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                        " + _vm._s(_vm.situacaoAtual(periodo) ?
      'EM ANDAMENTO' :
      'FINALIZADA') + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "td-btns td-btns-alone"
    }, [_c('botao', {
      attrs: {
        "estilo": _vm.situacaoPendente(periodo, 'estilo'),
        "icone": _vm.situacaoAtual(periodo) ?
          'editar-tabela' :
          'visualizar'
      },
      on: {
        "clicado": function($event) {
          return _vm.editaAvaliacao(periodo.avaliado.id)
        }
      }
    })], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 footer-controller-inner"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.volta()
      }
    }
  })], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Notas Atribuídas")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v(" ")])])])
}]}

/***/ }),

/***/ "l6dw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_store__ = __webpack_require__("YtJ0");


var registraUsuarioLogado = function registraUsuarioLogado(logado) {
  __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */].commit('setUsuarioLogado', logado);
  if (logado.funcionarios.length) {
    __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */].commit('setFuncionario', logado.funcionarios[0]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (registraUsuarioLogado);

/***/ }),

/***/ "lIAz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "lonj":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("WCqJ"),
  /* template */
  __webpack_require__("1K/T"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ltYo":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pagina-erro', {
    attrs: {
      "titulo": "Período encerrado",
      "icone": "fa fa-hourglass-end",
      "imagemTexto": "centralservidor-logo-texto.png",
      "imagem": "centralservidor-logo.png",
      "texto": "Periodo está fechado para lançamento."
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "mGlk":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("Y2k2")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("fQ6R"),
  /* template */
  __webpack_require__("MuUL"),
  /* scopeId */
  "data-v-49b96d05",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "mLKy":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "mWGn":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("4z+e")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("4aHL"),
  /* template */
  __webpack_require__("ysmu"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "mWIn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mhA2":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("6Geg")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("/doR"),
  /* template */
  __webpack_require__("oQj+"),
  /* scopeId */
  "data-v-39c2896c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "mhWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'construcao',
	computed: {
		logoComTexto: function logoComTexto() {
			var bodyWidth = document.body.clientWidth;
			return bodyWidth >= 520 ? true : false;
		}
	},
	props: {
		titulo: {
			required: true,
			type: String
		},
		icone: {
			required: true,
			type: String
		},
		imagemTexto: {
			required: true,
			type: String
		},
		imagem: {
			required: true,
			type: String
		},
		texto: {
			required: true,
			type: String
		}
	},
	mounted: function mounted() {
		var bodyHeight = document.body.clientHeight - 109;
		document.querySelector('.canvas').style.height = bodyHeight + 'px';
		window.scrollTo(0, 0);
	}
});

/***/ }),

/***/ "moXt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var CpfHelper = function () {
    function CpfHelper() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CpfHelper);

        throw 'Não é possível instanciar CpfHelper';
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CpfHelper, null, [{
        key: 'testaCpf',
        value: function testaCpf(strCPF) {
            var soma = void 0;
            var resto = void 0;
            var digito = void 0;
            var i = void 0;
            soma = 0;
            digito = 0;

            if (!strCPF) return false;

            for (i = 1; i < 11; i++) {
                if (i === 1) {
                    parseInt(strCPF.substring(i - 1, i)) === parseInt(strCPF.substring(i, i + 1)) ? digito = parseInt(strCPF.substring(i - 1, i)) : i = 12;
                } else {
                    parseInt(strCPF.substring(i - 1, i)) === digito ? digito = parseInt(strCPF.substring(i - 1, i)) : i = 12;
                }
            }
            if (i === 11) return false;

            for (i = 1; i <= 9; i++) {
                soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
            }resto = soma * 10 % 11;

            if (resto == 10 || resto == 11) resto = 0;
            if (resto != parseInt(strCPF.substring(9, 10))) return false;

            soma = 0;
            for (i = 1; i <= 10; i++) {
                soma = soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
            }resto = soma * 10 % 11;

            if (resto == 10 || resto == 11) resto = 0;
            if (resto != parseInt(strCPF.substring(10, 11))) return false;
            return true;
        }
    }, {
        key: 'cpfFormatado',
        value: function cpfFormatado(cpf) {
            if (cpf && cpf.length < 14) {
                return cpf.slice(0, 3) + '.' + cpf.slice(3, 6) + '.' + cpf.slice(6, 9) + '-' + cpf.slice(9);
            } else {
                return cpf;
            }
        }
    }]);

    return CpfHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (CpfHelper);

/***/ }),

/***/ "nK9I":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("pMej")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("NVOK"),
  /* template */
  __webpack_require__("UAGg"),
  /* scopeId */
  "data-v-778e480a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "nva8":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("XR3h")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("/vKb"),
  /* template */
  __webpack_require__("JJBI"),
  /* scopeId */
  "data-v-7990d3c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "oGAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var OrientacaoSexualService = function () {
  function OrientacaoSexualService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, OrientacaoSexualService);

    throw 'Não é possível instanciar OrientacaoSexualService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(OrientacaoSexualService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint();

                console.log('Orienta\xE7\xE3o Sexual: ' + endpoint);
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 4:
                return _context.abrupt('return', _context.sent);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista() {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }]);

  return OrientacaoSexualService;
}();

/* harmony default export */ __webpack_exports__["a"] = (OrientacaoSexualService);


var mergeEndpoint = function mergeEndpoint() {
  return 'orientacoes-sexuais';
};

/***/ }),

/***/ "oQj+":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "periodoAberturaModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "periodoAberturaModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Estou ciente",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "leiModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "leiModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Estou ciente",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "salvaModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "salvaModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal",
      "dismiss": "modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.limpaModal()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde",
      "rotulo": "Rascunho",
      "icone": "fa-pencil-square-o fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.salva(_vm.declaracaoModal, 'PENDENTE')
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Entregar",
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.salva(_vm.declaracaoModal, 'FINALIZADA')
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "retificaModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "retificaModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal",
      "dismiss": "modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.limpaModal()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Retificar",
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.salvaRetificada(_vm.declaracaoModal)
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "side-modal"
    }
  }, [_c('side-modal', {
    attrs: {
      "sides": _vm.navs
    }
  }, [_c('template', {
    slot: _vm.navs[0].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', [_c('strong', [_vm._v("Eu declaro...")]), _vm._v(" "), _c('esconde-div', [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                      Declaro, sob as penas da lei, que as informações aqui\n                      prestadas são verdadeiras, autorizando a Administração a\n                      proceder, por meio eletrônico, à guarda das informações\n                      constantes neste formulário, bem como das informações\n                      posteriores que atualizarão a presente, resguardado o\n                      sigilo destas. Em conformidade com o disposto nos\n                      artigos 57 e 63, da Lei Orgânica do Município, com a\n                      alteração dada pela Emenda nº 09 de 22/11/92, declaro\n                      possuir na presente data os seguintes bens:\n                    ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(
    _vm.declaracaoModal.situacao == 'RETIFICADA' ||
    _vm.declaracaoModal.situacao == 'FINALIZADA'
  ) ? _c('p', [_c('strong', [_vm._v("Entregue em")]), _vm._v("\n                  " + _vm._s(_vm._f("formataData")(_vm.declaracaoModal.dataDeclaracao)) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.declaracaoModal.situacao == 'RETIFICADORA') ? _c('p', [_c('strong', [_vm._v("Retificada em")]), _vm._v("\n                  " + _vm._s(_vm._f("formataData")(_vm.declaracaoModal.dataDeclaracao)) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', [(_vm.carregandoItens) ? _c('div', [_c('h2', {
    staticClass: "carregando"
  }, [_vm._v("Carregando...")])]) : _c('div', [(_vm.declaracaoModal.semBens) ? _c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-check fa-lg"
  }), _vm._v(" \n                  "), _c('strong', [_vm._v("Você declarou não possuir bens nos termos da legislação\n                    vigente.")])]) : (!_vm.declaracaoModal.itens.length) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center",
      "cursor": "pointer"
    },
    attrs: {
      "role": "alert"
    },
    on: {
      "click": function($event) {
        return _vm.novoItem()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Você ainda não tem\n                  bens declarados.\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraCopiaAnteriorNoSideModal()),
      expression: "mostraCopiaAnteriorNoSideModal()"
    }]
  }, [_c('br')]), _vm._v("\n                  Para começar, clique em NOVO.\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraCopiaAnteriorNoSideModal()),
      expression: "mostraCopiaAnteriorNoSideModal()"
    }]
  }, [_vm._v("\n                    Ou importe dados clicando em DECLARAÇÃO ANTERIOR.\n                  ")])]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
    class: _vm.declaracaoModal.situacao == 'EM_BRANCO' ?
      'hidden-xs' :
      ''
  }, [_vm._v("\n                        Valor\n                      ")]), _vm._v(" "), (
    _vm.mostraBotoesDeEdicaoNoSideModal(_vm.declaracaoModal)
  ) ? _c('th', [_vm._v("\n                         \n                      ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.declaracaoModal.itens), function(item) {
    return _c('tr', {
      key: _vm.declaracaoModal.itens.indexOf(item)
    }, [_c('td', [_vm._v(_vm._s(item.tipo.descricao.toUpperCase()))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                        " + _vm._s(item.descricao.toUpperCase()) + "\n                      ")]), _vm._v(" "), _c('td', {
      class: _vm.declaracaoModal.situacao == 'EM_BRANCO' ?
        'hidden-xs' :
        ''
    }, [_vm._v("\n                        " + _vm._s(_vm._f("monetarioMask")(item.valor)) + "\n                      ")]), _vm._v(" "), (
      _vm.mostraBotoesDeEdicaoNoSideModal(_vm.declaracaoModal)
    ) ? _c('td', {
      staticClass: "td-btns"
    }, [_c('botao', {
      attrs: {
        "estilo": "vazado-vermelho-sm",
        "icone": "exclui-tabela",
        "toggle": "",
        "target": ""
      },
      on: {
        "clicado": function($event) {
          return _vm.apagaItem(item)
        }
      }
    }), _vm._v(" "), _c('botao', {
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "editar-tabela",
        "toggle": "",
        "target": ""
      },
      on: {
        "clicado": function($event) {
          return _vm.editaItem(item)
        }
      }
    })], 1) : _vm._e()])
  }), 0)]), _vm._v(" "), (_vm.mostraBotoesDeEdicaoNoSideModal(_vm.declaracaoModal)) ? _c('div', {
    staticClass: "col-xs-12 footer-controller-inner-modal"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-dir",
      "rotulo": "Novo",
      "icone": "novo-modal",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.novoItem()
      }
    }
  }), _vm._v(" "), (
    !_vm.declaracaoModal.itens.length &&
    !_vm.declaracaoModal.semBens
  ) ? _c('botao', {
    attrs: {
      "estilo": "vazado-verde-dir",
      "rotulo": _vm.telaEhBigMobile ? 'S/ bens' : 'Sem bens',
      "icone": "cancela-modal",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.semBensModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mostraCopiaAnteriorNoSideModal()) ? _c('botao', {
    attrs: {
      "estilo": "vazado-verde-dir",
      "rotulo": _vm.telaEhBigMobile ? 'Decl. Ant.' : 'Declaração Anterior',
      "icone": "fa-magic",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.copiaDeclaracaoAnterior()
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.mostraJustificativaNoSideModal(_vm.declaracaoModal)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "justificativa"
    }
  }, [_vm._v("\n                    Observação ou justificativa (não obrigatório)\n                  ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.declaracaoModal.justificativa),
      expression: "declaracaoModal.justificativa"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "justificativa",
      "id": "justificativa",
      "rows": "4",
      "readonly": !_vm.mostraBotoesDeEdicaoNoSideModal(_vm.declaracaoModal),
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.declaracaoModal.justificativa)
    },
    on: {
      "keyup": function($event) {
        return _vm.charCount()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.declaracaoModal, "justificativa", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.totalCharacter) + "/500")]), _vm._v(" "), (_vm.totalCharacter == 500) ? _c('div', [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "characterAlert"
  }, [_vm._v("A justificativa deve conter no máximo 500\n                      caracteres.")])]) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancela()
      }
    }
  }), _vm._v(" "), (_vm.mostraBotoesDeEdicaoNoSideModal(_vm.declaracaoModal)) ? _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "icone": "ok-modal",
      "rotulo": _vm.declaracaoModal.situacao == 'RETIFICANTE' ?
        'Retificar' :
        'Salvar'
    },
    on: {
      "clicado": function($event) {
        _vm.declaracaoModal.situacao == 'RETIFICANTE' ?
          _vm.abreEnviaModal(_vm.declaracaoModal, '#retificaModal') :
          _vm.abreEnviaModal(_vm.declaracaoModal, '#salvaModal')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('botao', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.declaracaoModal.id),
      expression: "declaracaoModal.id"
    }],
    attrs: {
      "estilo": _vm.declaracaoModal.situacao == 'RETIFICADA' ||
        _vm.declaracaoModal.situacao == 'FINALIZADA' ||
        _vm.declaracaoModal.situacao == 'RETIFICADORA' ?
        'cheio-verde' :
        'vazado-verde',
      "rotulo": "Imprimir",
      "icone": "fa-print fa-lg",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.imprime(_vm.declaracaoModal.id)
      }
    }
  })], 1)]), _vm._v(" "), _c('template', {
    slot: _vm.navs[1].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Tipo de Bem",
      "field": "tipoBem",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemModal.tipo),
      expression: "itemModal.tipo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tipoBem",
      "data-vv-as": "Tipo de Bem"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.itemModal, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.tiposBens), function(tipo) {
    return _c('option', {
      key: _vm.tiposBens.indexOf(tipo),
      domProps: {
        "value": tipo
      }
    }, [_vm._v("\n                      " + _vm._s(((tipo.descricao) + " (cód. IR - " + (tipo.codigo) + ")")) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Valor",
      "field": "valor",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        is_not: 0
      }),
      expression: "{ is_not: 0 }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "valor",
      "id": "valor",
      "data-vv-as": "Valor"
    },
    model: {
      value: (_vm.itemModal.valor),
      callback: function($$v) {
        _vm.$set(_vm.itemModal, "valor", $$v)
      },
      expression: "itemModal.valor"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "heranca"
    }
  }, [_vm._v("Herança")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemModal.heranca),
      expression: "itemModal.heranca"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "heranca",
      "name": "heranca"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.itemModal, "heranca", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "true"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("SIM")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("NÃO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Parceiro Econômico")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemModal.dependencia),
      expression: "itemModal.dependencia"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "dependente"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.itemModal, "dependencia", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.incluiDependente(_vm.itemModal)
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": "true"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.dependencias), function(dependencia) {
    return _c('option', {
      key: dependencia.id,
      domProps: {
        "value": dependencia
      }
    }, [_vm._v("\n                        " + _vm._s(dependencia.dependente.nome) + "\n                      ")])
  })], 2)])])]), _vm._v(" "), (_vm.mostraAtualizarRenda) ? _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-12 col-sm-12",
      "label": "Renda Anual do Parceiro",
      "field": "rendaAnual",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        is_not: 0
      }),
      expression: "{ is_not: 0 }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "rendaAnual",
      "id": "rendaAnual",
      "data-vv-as": "Renda Anual"
    },
    model: {
      value: (_vm.rendaAnualDependenteModal),
      callback: function($$v) {
        _vm.rendaAnualDependenteModal = $$v
      },
      expression: "rendaAnualDependenteModal"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-12 col-sm-12",
      "label": "Descrição",
      "field": "descricao",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemModal.descricao),
      expression: "itemModal.descricao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:500'),
      expression: "'required|max:500'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "name": "descricao",
      "id": "descricao",
      "data-vv-as": "Descrição"
    },
    domProps: {
      "value": (_vm.itemModal.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.itemModal, "descricao", $event.target.value)
      }
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancelaItem()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Incluir",
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.validaItem()
      }
    }
  })], 1)])], 2)], 1), _vm._v(" "), _c('section', {
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Declaração de Bens \n                "), _c('small', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.abreLeiModal()
      }
    }
  }, [_vm._v("(Por que devo declarar meus bens?)")])])]), _vm._v(" "), _c('div', [_c('table-loader', {
    attrs: {
      "carregando": _vm.carregando
    }
  }, [(_vm.declaracoes.length == 0) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center",
      "cursor": "pointer"
    },
    attrs: {
      "role": "alert"
    },
    on: {
      "click": function($event) {
        return _vm.novo(_vm.declaracao)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Você ainda não\n                    tem declarações de bens.\n                  ")]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Ano Base")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Data da Declaração")]), _vm._v(" "), _c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.declaracoesOrdenadasDistintas), function(declaracaoItem) {
    return _c('tr', {
      key: declaracaoItem.competencia &&
        declaracaoItem.competencia.ano +
        declaracaoItem.competencia.mes +
        declaracaoItem.dataDeclaracao +
        declaracaoItem.situacao,
      class: declaracaoItem.situacao == 'EM_BRANCO' ?
        'situacao-pendente' :
        ''
    }, [_c('td', [_vm._v("\n                          " + _vm._s(_vm.obtemAnoBase(declaracaoItem.competencia)) + "\n                        ")]), _vm._v(" "), (declaracaoItem.dataDeclaracao) ? _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                          " + _vm._s(_vm._f("formataData")(declaracaoItem.dataDeclaracao)) + "\n                        ")]) : _c('td', {
      staticClass: "hidden-xs"
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-h fa-lg",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.obtemSituacao(declaracaoItem.situacao)))]), _vm._v(" "), _c('td', {
      staticClass: "td-btns"
    }, [_c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mostraNova(declaracaoItem)),
        expression: "mostraNova(declaracaoItem)"
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Declarar'),
        expression: "'Declarar'",
        modifiers: {
          "left": true
        }
      }],
      staticStyle: {
        "width": "83px"
      },
      attrs: {
        "estilo": "vazado-laranja-sm",
        "icone": declaracaoItem.situacao == 'PENDENTE' ?
          'editar-tabela' :
          'fa-file-o fa-lg',
        "toggle": "",
        "target": "",
        "disabled": _vm.desabilitaEdicaoDasAtrasadas(declaracaoItem)
      },
      on: {
        "clicado": function($event) {
          return _vm.novo(declaracaoItem)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mostraEditar(declaracaoItem)),
        expression: "mostraEditar(declaracaoItem)"
      }, {
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Editar'),
        expression: "'Editar'",
        modifiers: {
          "right": true
        }
      }],
      staticStyle: {
        "width": "83px"
      },
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "editar-tabela",
        "toggle": "",
        "target": ""
      },
      on: {
        "clicado": function($event) {
          return _vm.edita(declaracaoItem)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mostraRetificarVer(declaracaoItem)),
        expression: "mostraRetificarVer(declaracaoItem)"
      }]
    }, [_c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Retificar'),
        expression: "'Retificar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "fa-wrench fa-lg",
        "toggle": "",
        "target": ""
      },
      on: {
        "clicado": function($event) {
          return _vm.edita(declaracaoItem, 'RETIFICANTE')
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Visualizar'),
        expression: "'Visualizar'",
        modifiers: {
          "right": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar",
        "toggle": "",
        "target": ""
      },
      on: {
        "clicado": function($event) {
          return _vm.edita(declaracaoItem)
        }
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mostraVisualizar(declaracaoItem)),
        expression: "mostraVisualizar(declaracaoItem)"
      }]
    }, [_c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Decl.Original'),
        expression: "'Decl.Original'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "fa-history fa-lg",
        "toggle": "",
        "target": ""
      },
      on: {
        "clicado": function($event) {
          return _vm.visualizaOriginal(declaracaoItem)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Retificada'),
        expression: "'Retificada'",
        modifiers: {
          "right": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar",
        "toggle": "",
        "target": ""
      },
      on: {
        "clicado": function($event) {
          return _vm.edita(declaracaoItem)
        }
      }
    })], 1)], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 footer-controller-inner"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Declarar",
      "icone": "fa-file-o",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.novo(_vm.declaracao)
      }
    }
  }), _vm._v(" "), (
    _vm.declaracoesOrdenadasDistintas[0].situacao ==
    'EM_BRANCO'
  ) ? _c('botao', {
    attrs: {
      "estilo": "vazado-verde-dir",
      "rotulo": "Sem bens",
      "icone": "cancela-modal",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.semBens(_vm.declaracao)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/faq"
    }
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-laranja-esq",
      "rotulo": _vm.telaEhBigMobile ? '' : 'Faq',
      "icone": "fa fa-question-circle-o fa-lg"
    }
  })], 1)], 1)])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "periodoAberturaModalLabel"
    }
  }, [_vm._v("\n              Período de entrega da Declaração\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "1.6rem"
    }
  }, [_c('strong', [_vm._v(" Atenção ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  O período para a entrega da Declaração de Bens via Central\n                  do Servidor se encerrou. Aguarde um novo período ou envie um\n                  email para\n                  "), _c('strong', [_vm._v("declaracaodebens@santos.sp.gov.br")]), _vm._v(" para\n                  esclarecer suas dúvidas.\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "leiModalLabel"
    }
  }, [_vm._v("\n              Declarações de Bens e Valores Anteriores\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Após 30 (trinta) dias, contados da data limite fixada pela\n                  Secretaria da Receita Federal do Ministério da Fazenda,\n                  todos os servidores municipais no exercício de mandatos,\n                  cargos, funções ou empregos em órgãos da administração\n                  direta e indireta devem efetuar a Declaração Anual de Bens e\n                  Valores, prevista no Decreto Municipal nº 7.517/2016. O\n                  informe é feito exclusivamente por meio do sistema\n                  eletrônico, disponibilizado no site da Prefeitura através da\n                  Secretaria de Finanças e Gestão. Todos os bens e valores de propriedade\n                  do servidor (imóveis, móveis, dinheiro, títulos, ações,\n                  investimentos financeiros, participações societárias e\n                  qualquer outra espécie de bens e valores patrimoniais\n                  existentes no país ou no exterior) devem ser informados.\n                  Também fazem parte da declaração, bens e valores\n                  relacionados ao cônjuge ou companheiro (a), aos filhos ou a\n                  outras pessoas que tenham dependência econômica do\n                  declarante.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                    Atenção: o servidor que não entregar o documento no prazo\n                    previsto tem a sua remuneração suspensa e está sujeito a\n                    outras medidas administrativas.\n                  ")])]), _vm._v(" "), _c('p', [_vm._v("\n                  Lembrando que aposentados e pensionistas estão isentos da\n                  Declaração Anual de Bens e Valores.\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "salvaModalLabel"
    }
  }, [_vm._v("\n              Entregar Declaraçao\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Deseja\n                  "), _c('strong', [_vm._v("entregar")]), _vm._v(" sua declaração agora ou prefere\n                  apenas salvar um "), _c('strong', [_vm._v("rascunho")]), _vm._v("?\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "retificaModalLabel"
    }
  }, [_vm._v("\n              Retificar Declaração\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Atenção")]), _vm._v(" A declaração só pode ser retificada\n                  "), _c('strong', [_vm._v("uma vez")]), _vm._v(". Deseja retificar agora?\n                ")])])])])
}]}

/***/ }),

/***/ "ottn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__ = __webpack_require__("MPt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Encerrado',
	components: {
		PaginaErro: __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default.a
	}
});

/***/ }),

/***/ "pBDI":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pagina-erro', {
    attrs: {
      "titulo": "Atualização do CPF do Familiar Encerrado",
      "icone": "fa fa-hourglass-end",
      "imagemTexto": "centralservidor-logo-texto.png",
      "imagem": "centralservidor-logo.png",
      "texto": "Conforme portaria 06/2022-SEGES, o período do recadastramento se encerrou."
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "pKzR":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("+K3d")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("x98e"),
  /* template */
  __webpack_require__("Ufsi"),
  /* scopeId */
  "data-v-0751044b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "pMej":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pUc1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pVN0":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("wcTJ")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("/97V"),
  /* template */
  __webpack_require__("8EMK"),
  /* scopeId */
  "data-v-b12c71ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "pmgo":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "card-header"
  }, [_c('h4', [_vm._v("\n    " + _vm._s(_vm.titulo) + " \n    "), _c('small', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.abreModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.subtitulo))])])]), _vm._v(" "), (this.autenticados.length > 1) ? _c('div', {
    staticClass: "registros"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionario),
      expression: "funcionario"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.funcionario = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.trocaUsuario(_vm.funcionario)
      }]
    }
  }, _vm._l((_vm.autenticados), function(autenticado) {
    return _c('option', {
      key: autenticado.id,
      domProps: {
        "value": autenticado
      }
    }, [_vm._v("\n          " + _vm._s('Registro ' + autenticado.registroFormatado) + "\n        ")])
  }), 0)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-user-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),

/***/ "qPY7":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("bV+y")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("39rQ"),
  /* template */
  __webpack_require__("jaCG"),
  /* scopeId */
  "data-v-2aaf0924",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "r65U":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    class: _vm.estilo,
    on: {
      "click": function($event) {
        _vm.mostra = !_vm.mostra
      }
    }
  }, [(!_vm.mostra) ? _c('i', {
    staticClass: "fa fa-chevron-circle-down",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-chevron-circle-up",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostra),
      expression: "mostra"
    }]
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "rD6O":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('registros-modal'), _vm._v(" "), _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "bemVindoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bemVindoModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Entendi",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top",
    staticStyle: {
      "padding-bottom": "25px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 hidden-xs hidden-sm card-group"
  }, [_c('h2', [_vm._v("Mais acessados")]), _vm._v(" "), _vm._l((_vm.rotas), function(rota) {
    return _c('div', {
      key: _vm.rotas.indexOf(rota)
    }, [_c('div', {
      staticClass: "col-md-3 col-xs-6"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: rota.name
        }
      }
    }, [_c('div', {
      staticClass: "card card-servico"
    }, [_c('div', {
      staticClass: "card-content"
    }, [_c('h2', [_vm._v(_vm._s(rota.meta.titulo))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 col-sm-12",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__("PvXa")("./" + (rota.meta.imagem)),
        "alt": rota.meta.titulo
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-group",
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('label', [_vm._v("\n                          CONSULTAR \n                          "), _c('i', {
      staticClass: "fa fa-external-link fa-fw",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(rota.meta.texto))])])])])])])])], 1)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 hidden-md hidden-lg card-group"
  }, [_c('div', {
    staticClass: "row row-group"
  }, [_c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.rotas[0].name
      }
    }
  }, [_c('div', {
    staticClass: "card card-servico"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.rotas[0].meta.titulo))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("PvXa")("./" + (_vm.rotas[0].meta.imagem)),
      "alt": _vm.rotas[0].meta.titulo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', [_vm._v("\n                          CONSULTAR \n                          "), _c('i', {
    staticClass: "fa fa-external-link fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.rotas[0].meta.texto))])])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.rotas[1].name
      }
    }
  }, [_c('div', {
    staticClass: "card card-servico"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.rotas[1].meta.titulo))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("PvXa")("./" + (_vm.rotas[1].meta.imagem)),
      "alt": _vm.rotas[1].meta.titulo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', [_vm._v("\n                          CONSULTAR \n                          "), _c('i', {
    staticClass: "fa fa-external-link fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.rotas[1].meta.texto))])])])])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row-group"
  }, [_c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.rotas[2].name
      }
    }
  }, [_c('div', {
    staticClass: "card card-servico"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.rotas[2].meta.titulo))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("PvXa")("./" + (_vm.rotas[2].meta.imagem)),
      "alt": _vm.rotas[2].meta.titulo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', [_vm._v("\n                          CONSULTAR \n                          "), _c('i', {
    staticClass: "fa fa-external-link fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.rotas[2].meta.texto))])])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.rotas[3].name
      }
    }
  }, [_c('div', {
    staticClass: "card card-servico"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.rotas[3].meta.titulo))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("PvXa")("./" + (_vm.rotas[3].meta.imagem)),
      "alt": _vm.rotas[3].meta.titulo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', [_vm._v("\n                          CONSULTAR \n                          "), _c('i', {
    staticClass: "fa fa-external-link fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.rotas[3].meta.texto))])])])])])])])], 1)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bemVindoModalLabel"
    }
  }, [_vm._v("\n              Meu Primeiro Acesso\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Seja bem-vindo à\n                  "), _c('strong', [_vm._v("Central do Servidor")]), _vm._v(". Aqui centralizamos as\n                  informações da sua vida profissional na Prefeitura. Escolha\n                  um "), _c('strong', [_vm._v("item do menu")]), _vm._v(" e tenha acesso à informação\n                  que precisar.\n                ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Ao centro você tem os links mais clicados da aplicação, eles\n                  são um\n                  "), _c('strong', [_vm._v("atalho")]), _vm._v("\n                  para as informações do menu.\n                ")]), _vm._v(" "), _c('p', [_vm._v("Experimente e tenha uma boa navegação.")])])])])
}]}

/***/ }),

/***/ "sJIn":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("vdvY"),
  /* template */
  __webpack_require__("fm+M"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "sTdX":
/***/ (function(module, exports) {

module.exports = [{"data":"2020-01-01"},{"data":"2020-01-27"},{"data":"2021-01-01"},{"data":"2021-01-26"},{"data":"2021-04-02"},{"data":"2021-04-21"},{"data":"2021-05-01"},{"data":"2021-06-03"},{"data":"2021-07-09"},{"data":"2021-09-07"},{"data":"2021-10-12"},{"data":"2021-10-28"},{"data":"2021-11-02"},{"data":"2021-11-15"},{"data":"2021-11-20"},{"data":"2021-12-25"}]

/***/ }),

/***/ "sVKh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("H/Zg");




var ValeAlimentacaoService = function () {
  function ValeAlimentacaoService() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ValeAlimentacaoService);

    throw new Error('Não é possível instanciar ValeAlimentacaoService');
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ValeAlimentacaoService, null, [{
    key: 'verificarHabilitacao',
    value: function verificarHabilitacao() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get('vale-alimentacao/habilitado');
    }
  }, {
    key: 'carregarContexto',
    value: function carregarContexto() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get('vale-alimentacao/contexto');
    }
  }, {
    key: 'visualizarAnexo',
    value: function visualizarAnexo(id) {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get('vale-alimentacao/detalhes/anexo', {
        params: { id: id },
        responseType: 'blob'
      });
    }
  }, {
    key: 'listaEmpresas',
    value: function listaEmpresas() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get('vale-alimentacao/empresas');
    }
  }, {
    key: 'salvar',
    value: function salvar(item) {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post('vale-alimentacao', item);
    }
  }, {
    key: 'atualiza',
    value: function atualiza(id, item) {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].put('vale-alimentacao/' + id, item);
    }
  }, {
    key: 'imprimirProtocolo',
    value: function imprimirProtocolo(id) {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get('vale-alimentacao/' + id + '/protocolo', {
        responseType: 'blob'
      });
    }
  }]);

  return ValeAlimentacaoService;
}();

/* harmony default export */ __webpack_exports__["a"] = (ValeAlimentacaoService);

/***/ }),

/***/ "sXEj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Agendamento = function Agendamento() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var nome = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var possuiDiasPendentes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var lotacao = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var ano = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var dataInicioFerias = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var statusAprovacao = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'PENDENTE';
  var idFuncionarioResponsavel = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var idFuncionarioResponsavelSegundo = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Agendamento);

  this.id = id;
  this.nome = nome;
  this.possuiDiasPendentes = possuiDiasPendentes;
  this.lotacao = lotacao;
  this.ano = ano;
  this.dataInicioFerias = dataInicioFerias;
  this.statusAprovacao = statusAprovacao;
  this.idFuncionarioResponsavel = idFuncionarioResponsavel;
  this.idFuncionarioResponsavelSegundo = idFuncionarioResponsavelSegundo;
};

/* harmony default export */ __webpack_exports__["a"] = (Agendamento);

/***/ }),

/***/ "soYb":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("Mp9a")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("iXI6"),
  /* template */
  __webpack_require__("IOhd"),
  /* scopeId */
  "data-v-55dc2de6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "tSzk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var AvaliacoesService = function () {
  function AvaliacoesService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AvaliacoesService);

    throw 'Não é possível instanciar AvaliacoesService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AvaliacoesService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint(id);
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista(_x) {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }]);

  return AvaliacoesService;
}();

AvaliacoesService.id = null;
/* harmony default export */ __webpack_exports__["a"] = (AvaliacoesService);


var mergeEndpoint = function mergeEndpoint(id) {
  return 'avaliacoes-periodicas/avaliados/' + id + '/avaliacoes-periodicas/competencias';
};

/***/ }),

/***/ "tzjS":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("8ZOQ")

var Component = __webpack_require__("VU/8")(
  /* script */
  null,
  /* template */
  __webpack_require__("N2/l"),
  /* scopeId */
  "data-v-59d0caac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "u1pV":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "u3Op":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uND1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uRbf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ufme":
/***/ (function(module, exports) {

module.exports = {"publicPath":"/centraldoservidor/","apiUrl":"https://egov.santos.sp.gov.br/centralservidor-api/","apiEnderecoUrl":"https://egov.santos.sp.gov.br/endereco/api/v1/","staticUrl":"https://egov.santos.sp.gov.br/centraldoservidor/static/"}

/***/ }),

/***/ "unEG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_text__ = __webpack_require__("Rg0L");


/* unused harmony default export */ var _unused_webpack_default_export = ({
  bind: function bind(el) {
    el.addEventListener('input', function (e) {
      var valorLimpo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_text__["a" /* limparTexto */])(e.target.value);

      if (e.target.value !== valorLimpo) {
        e.target.value = valorLimpo;

        // força atualização do v-model
        el.dispatchEvent(new Event('input'));
      }
    });
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v0od":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("+Xrt"),
  /* template */
  __webpack_require__("26OG"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "v5Jx":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("IBCJ"),
  /* template */
  __webpack_require__("Onna"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "v6Um":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "vB7S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__ = __webpack_require__("MPt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'NaoEncontrado',
	components: {
		PaginaErro: __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default.a
	}
});

/***/ }),

/***/ "vN2Z":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("Catl")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("YuI6"),
  /* template */
  __webpack_require__("NVyW"),
  /* scopeId */
  "data-v-42514e88",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "vSKJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vUyM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__("H/Zg");







var RecadastroDependenteService = function () {
  function RecadastroDependenteService() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RecadastroDependenteService);

    throw 'Não é possível instanciar RecadastroDependenteService';
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(RecadastroDependenteService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(funcionarioId) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint('funcionarios/' + funcionarioId + '/dependentes');
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista(_x) {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }, {
    key: 'listaTiposDependencia',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = mergeEndpoint('tipos-dependentes');
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].get(endpoint);

              case 3:
                return _context2.abrupt('return', _context2.sent);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function listaTiposDependencia() {
        return _ref2.apply(this, arguments);
      }

      return listaTiposDependencia;
    }()
  }, {
    key: 'obtemDependente',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(funcionarioId, cpfDependente) {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                endpoint = mergeEndpoint('funcionarios/' + funcionarioId + '/dependentes/' + cpfDependente);
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].get(endpoint);

              case 3:
                return _context3.abrupt('return', _context3.sent);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function obtemDependente(_x2, _x3) {
        return _ref3.apply(this, arguments);
      }

      return obtemDependente;
    }()
  }, {
    key: 'grava',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(dependente, anexos) {
        var endpoint, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                endpoint = mergeEndpoint();
                data = new FormData();

                data.append('dependente', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dependente));

                if (anexos.length) {
                  anexos.forEach(function (anexo, i) {
                    return data.append('anexos', anexo);
                  });
                }

                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].post(endpoint, data);

              case 6:
                return _context4.abrupt('return', _context4.sent);

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function grava(_x4, _x5) {
        return _ref4.apply(this, arguments);
      }

      return grava;
    }()
  }, {
    key: 'atualiza',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(id, dependente, anexos) {
        var endpoint, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                endpoint = mergeEndpoint(id);
                data = new FormData();

                data.append('dependente', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dependente));

                if (anexos.length) {
                  anexos.forEach(function (anexo, i) {
                    return data.append('anexos', anexo);
                  });
                }

                _context5.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].put(endpoint, data);

              case 6:
                return _context5.abrupt('return', _context5.sent);

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function atualiza(_x6, _x7, _x8) {
        return _ref5.apply(this, arguments);
      }

      return atualiza;
    }()
  }, {
    key: 'exclui',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].delete(mergeEndpoint(id));

              case 2:
                return _context6.abrupt('return', _context6.sent);

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function exclui(_x9) {
        return _ref6.apply(this, arguments);
      }

      return exclui;
    }()
  }]);

  return RecadastroDependenteService;
}();

/* harmony default export */ __webpack_exports__["a"] = (RecadastroDependenteService);


var mergeEndpoint = function mergeEndpoint(value) {
  return 'recadastro-dependentes/' + (value || '');
};

/***/ }),

/***/ "vWEU":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.anteriorLink()
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Perguntas Frequentes")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', [_c('strong', [_vm._v("\n                      1. Por que os agentes públicos devem prestar declaração\n                      de seus bens e valores?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Por exigência da Lei Federal nº 8.429/1992, regulamentada\n                    pelo Decreto Municipal n.º 7.517/2016.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      2. Quem deve declarar?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Todos os agentes públicos municipais, ou seja, os que\n                    exerçam, ainda que transitoriamente ou sem remuneração,\n                    por eleição, nomeação, designação, contratação ou qualquer\n                    outra forma de investidura ou vínculo, mandato, cargo,\n                    emprego ou função na Administração Pública Direta ou\n                    Indireta.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      3. Quem está dispensado de prestar a declaração?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Estão dispensados do preenchimento da declaração\n                    servidores aposentados, pensionistas, estagiários, agentes\n                    públicos cedidos a outros órgãos durante o período de\n                    cessão"), _c('strong', [_vm._v(" SEM VENCIMENTOS")]), _vm._v(" e os funcionários\n                    contratados por empresas prestadoras de serviços\n                    (terceirizados).\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      4. Prestei a declaração no ano passado. Preciso declarar\n                      novamente neste ano?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Sim. A entrega deve ser renovada anualmente, com dados\n                    atualizados.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      5. Quando devo declarar?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    O agente público deverá apresentar a declaração através da\n                    CENTRAL DO SERVIDOR nas seguintes situações:\n                    "), _c('br'), _vm._v("  • anualmente (atualização) 30 dias após\n                    data limite para a entrega da Declaração de Imposto de\n                    Renda, fixado pela Receita Federal; "), _c('br'), _vm._v("  • no\n                    ato de posse ou admissão em cargo, função ou emprego; • na\n                    data em que o agente público deixar o vínculo;\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      6. Onde posso acessar o sistema para preencher a\n                      declaração?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    O acesso ao CENTRAL DO SERVIDOR está disponível, via\n                    internet, no seguinte endereço:\n                    https://egov.santos.sp.gov.br/centraldoservidor\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      7. Quais bens e valores devo incluir na minha\n                      declaração?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    A declaração compreenderá imóveis, móveis, semoventes\n                    (rebanhos), dinheiro, títulos, ações, investimentos\n                    financeiros, participações societárias e qualquer outra\n                    espécie de bens e valores patrimoniais localizados no país\n                    ou no exterior, e abrangerá, se existentes, os bens e\n                    valores patrimoniais do cônjuge ou companheiro, dos filhos\n                    e/ou de outras pessoas que sejam parceiros econômicos do\n                    declarante.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      8. Os valores da minha declaração devem estar\n                      atualizados até qual data?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Na atualização anual, a declaração deve conter os valores\n                    atualizados até o dia 31 de dezembro do ano anterior, nos\n                    mesmos moldes da declaração de ajuste do Imposto de Renda\n                    Pessoa Física.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      9. Como defino o valor do bem a ser declarado? Pelo\n                      valor de aquisição ou pelo valor atual de mercado?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Os bens devem ser declarados sempre pelo seu valor de\n                    aquisição, seguindo a regra da Receita Federal. Portanto,\n                    os bens não devem ser valorizados ou depreciados em razão\n                    da variação do seu valor de mercado no decorrer do ano.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      10. De que forma declaro bens adquiridos por meio de\n                      financiamento?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Os bens adquiridos por meio de financiamento podem ser\n                    declarados da seguinte maneira: "), _c('br'), _vm._v("  •\n                    Somando-se os valores pagos de entrada e das parcelas de\n                    financiamento quitadas até o dia 31 de dezembro de cada\n                    ano e informando na descrição a composição do cálculo.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      11. Devo incluir na minha declaração meus ativos\n                      bancários (saldo em conta corrente, conta poupança,\n                      aplicações financeiras, entre outros)?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Sim. Recomenda-se a utilização do informe de rendimentos\n                    fornecido pelas instituições financeiras para fins de\n                    declaração de ajuste do Imposto de Renda Pessoa Física.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      12. Em que situações devo incluir os bens do meu\n                      cônjuge?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    A declaração deverá abranger os bens comuns do casal, isto\n                    é, os bens adquiridos pelo cônjuge, ainda que apenas em\n                    seu nome, a título oneroso e durante o casamento, quando o\n                    regime matrimonial for a comunhão total ou parcial de bens\n                    ou, ainda, nos casos de união estável. Não são\n                    consideradas aquisições a título oneroso, por exemplo, as\n                    provenientes de herança ou doação recebidas pelo cônjuge.\n                    Não é obrigatória a declaração de bens do cônjuge quando o\n                    regime matrimonial for a separação de bens ou a\n                    comunicação final de aquestos, exceto se o cônjuge for\n                    dependente econômico do declarante.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      13. De que forma declaro os bens e valores do meu\n                      cônjuge ou companheiro (a)?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Informe essa titularidade na descrição do bem\n                    correspondente. O valor atribuído ao bem deve ser\n                    integral, e não de 50% do total.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      14. Meu cônjuge ou companheiro (a) também é agente\n                      público municipal e terá que a fazer a declaração de\n                      bens. Neste caso, as regras para declaração de bens do\n                      cônjuge permanecem as mesmas?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Sim. Ambas as declarações são independentes entre si.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      15. Tenho plano de previdência privada. Como declarar?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Caso o plano seja um VGBL, os saldos devem ser declarados\n                    normalmente. Os saldos dos planos do tipo PGBL não\n                    precisam ser declarados. Facultativamente, o agente\n                    público pode informar os pagamentos efetuados nesse plano\n                    (vide questão 16).\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      16. Além dos bens e valores, quais outros itens posso\n                      incluir na minha declaração?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Caso queira, o agente público pode declarar os rendimentos\n                    recebidos, os pagamentos e as doações efetuados e as suas\n                    dívidas. Estes itens podem se referir ao próprio agente\n                    público, ao seu cônjuge ou aos seus dependentes.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      17. Tenho dois ou mais vínculos. Estou ativo em um deles\n                      e aposentado no outro. Devo fazer a declaração de bens e\n                      valores?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Sim. A declaração deverá ser prestada normalmente.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      18. Estou dispensado da apresentação da declaração anual\n                      de ajuste de imposto de renda à Receita Federal. Tenho\n                      que apresentar a declaração de bens e valores?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Sim. Neste caso, o agente público pode utilizar\n                    normalmente a CENTRAL DO SERVIDOR.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      19. Comecei a trabalhar neste ano na Prefeitura e já\n                      apresentei declaração de bens e valores na minha posse.\n                      Devo entregar a declaração novamente?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Sim, caso a declaração apresentada para fins de posse ou\n                    admissão tenha sido feita antes do início do prazo\n                    determinado da declaração anual.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      20. Como faço para comprovar que entreguei minha\n                      declaração?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    O sistema registra automaticamente a entrega da sua\n                    declaração. O agente público poderá imprimir o protocolo\n                    de entrega ou salvar o arquivo correspondente a qualquer\n                    tempo, mediante acesso ao sistema.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      21. Entreguei a declaração com dados incorretos ou\n                      incompletos. Posso retificá-la?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Sim. O sistema agora permite declarações de retificação,\n                    mas só será permitida uma retificação por declaração.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      22. Quais as consequências de se deixar de prestar a\n                      declaração de bens e valores?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    O agente que não prestar a declaração de bens e valores\n                    dentro dos prazos previstos ficará sujeito à suspensão do\n                    pagamento de sua remuneração até o efetivo cumprimento da\n                    obrigação, sem prejuízo da aplicação das demais sanções\n                    previstas em lei.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      23. Quais os navegadores compatíveis com a CENTRAL DO\n                      SERVIDOR?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Google Chrome e Mozilla Firefox.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      24. Ainda tenho outras dúvidas e não encontrei a\n                      resposta nesse questionário. Quem pode me ajudar?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Eventuais dúvidas devem ser encaminhadas para o email\n                    declaracaodebens@santos.sp.gov.br\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                      25. Caso eu não possua bens a declarar, como procedo na\n                      declaração?\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Para uma declaração sem bens, você pode clicar no botão\n                    SEM BENS, que se encontra na tela de declaração e no\n                    painel lateral, e confirmar quando solicitado. OU basta\n                    não informar nenhum bem (item), salvar e confirmar.\n                    Automaticamente, o sistema reconhece sua declaração como\n                    não possuir bens para declarar.\n                  ")]), _vm._v(" "), _c('br')])])])])])])])])
}]}

/***/ }),

/***/ "vXSv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Avaliado = function Avaliado() {
    var pessoa = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var tipo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var lotacao = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Avaliado);

    this.pessoa = pessoa;
    this.tipo = tipo;
    this.lotacao = lotacao;
};

/* harmony default export */ __webpack_exports__["a"] = (Avaliado);

/***/ }),

/***/ "vdvY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_side_modal__ = __webpack_require__("dLc8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_side_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_side_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_table_loader__ = __webpack_require__("pKzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_table_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_table_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_dependenciasService__ = __webpack_require__("h5d5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_dependencia__ = __webpack_require__("9fBi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__domain_dependencia_dependente__ = __webpack_require__("9NYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__domain_dependencia_renda__ = __webpack_require__("gy/Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_DateHelper__ = __webpack_require__("9t/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelper__ = __webpack_require__("1pbJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_CpfHelper__ = __webpack_require__("moXt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_ArrayHelper__ = __webpack_require__("5OEK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_ErrorHelper__ = __webpack_require__("+h9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__filters_filters__ = __webpack_require__("V1NV");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dependente',

  data: function data() {
    return {
      apiErrors: null,
      carregando: false,
      dependencias: [],
      autenticado: {},
      declarante: { id: null },
      dependente: {},
      dependencia: {},
      dependenciaModal: {},
      graus: this.$store.state.graus,
      sexos: [{
        displayName: 'Masculino',
        name: 'M'
      }, {
        displayName: 'Feminino',
        name: 'F'
      }],
      rendaModal: {},
      listaDeRendasModal: [],
      anoEditavel: false,
      anoReferenciaAtual: 0,
      navs: [{
        titulo: 'Parceiro',
        subtitulo: 'Dados Pessoais',
        subtDetalhe: 'Novo Parceiro',
        largura: 600,
        identidade: 'dependente',
        abreProximo: false,
        aberto: false
      }, {
        titulo: 'Parceiro',
        subtitulo: 'Rendas Anuais',
        subtDetalhe: 'Novo Parceiro',
        largura: 600,
        identidade: 'rendas',
        abreProximo: false,
        aberto: false
      }],
      config: {
        format: 'L',
        useCurrent: false,
        locale: 'pt-br',
        maxDate: __WEBPACK_IMPORTED_MODULE_6_moment___default()(new Date()),
        minDate: __WEBPACK_IMPORTED_MODULE_6_moment___default()(new Date()).add(-100, 'years')
      }
    };
  },


  computed: {
    dependenciasOrdenadas: function dependenciasOrdenadas() {
      this.dependencias.forEach(function (dependencia) {
        return dependencia.nomeDependente = dependencia.dependente.nome;
      });

      return this.dependencias.sort(__WEBPACK_IMPORTED_MODULE_14__helpers_ArrayHelper__["a" /* default */].compareValues('nomeDependente'));
    },
    rendasOrdenadas: function rendasOrdenadas() {
      return this.dependenciaModal.rendas.sort(function (a, b) {
        return b.anoReferencia - a.anoReferencia;
      });
    },
    rendasOrdenadasModal: function rendasOrdenadasModal() {
      return this.listaDeRendasModal.sort(function (a, b) {
        return b.anoReferencia - a.anoReferencia;
      });
    },
    rendaEhAnoAtual: function rendaEhAnoAtual() {
      return this.rendasOrdenadas.length ? this.rendasOrdenadas[0].anoReferencia == this.anoReferenciaAtual : false;
    },
    telaEhMobile: function telaEhMobile() {
      return window.innerWidth <= 768;
    }
  },

  methods: {
    abreModal: function abreModal(identidade) {
      this.$emit('abreModal', identidade);
    },
    fechaModal: function fechaModal(identidade) {
      this.$emit('fechaModal', identidade);
    },
    abreExplicacaoModal: function abreExplicacaoModal() {
      jQuery('#explicacaoModal').modal('show');
    },
    novo: function novo() {
      this.navs[0].subtDetalhe = 'Novo Parceiro';
      this.desabilitaCampos(false, false, false, false);
      this.abreModal('dependente');
      this.errors.clear();
    },
    verificaCpf: function verificaCpf(cpf) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var cpfLimpo, dependente, mensagem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cpfLimpo = __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelper__["a" /* default */].limpaFormato(cpf);
                _context.prev = 1;

                if (!(cpfLimpo === _this.autenticado.cpf)) {
                  _context.next = 4;
                  break;
                }

                throw new Error('O declarante não pode ser o parceiro. Verifique o CPF.');

              case 4:
                if (!_this.dependencias.some(function (dependencia) {
                  return dependencia.dependente.cpf === cpf;
                })) {
                  _context.next = 6;
                  break;
                }

                throw new Error('Parceiro já cadastrado');

              case 6:
                if (__WEBPACK_IMPORTED_MODULE_13__helpers_CpfHelper__["a" /* default */].testaCpf(cpfLimpo)) {
                  _context.next = 8;
                  break;
                }

                throw new Error('Número de CPF inválido');

              case 8:
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_7__services_dependenciasService__["a" /* default */].obtemDependente(cpfLimpo);

              case 10:
                dependente = _context.sent;

                _this.dependente = dependente;
                _this.dependente.cpf = __WEBPACK_IMPORTED_MODULE_13__helpers_CpfHelper__["a" /* default */].cpfFormatado(dependente.cpf);

                if (!_this.telaEhMobile) {
                  _this.dependente.dataNascimento = __WEBPACK_IMPORTED_MODULE_11__helpers_DateHelper__["a" /* default */].convertDateToPtbr(dependente.dataNascimento);
                }

                _this.dependenciaModal.dependente = _this.dependente;
                _this.desabilitaCampos(false, true, true, true);
                _context.next = 26;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](1);

                _this.limpaCpfAnterior();
                _this.dependente.cpf = cpf;
                mensagem = __WEBPACK_IMPORTED_MODULE_15__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context.t0);

                if (!(mensagem === 'Recurso não encontrado')) {
                  _context.next = 25;
                  break;
                }

                return _context.abrupt('return');

              case 25:
                _this.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 18]]);
      }))();
    },
    limpaCpfAnterior: function limpaCpfAnterior() {
      this.dependente = new __WEBPACK_IMPORTED_MODULE_9__domain_dependencia_dependente__["a" /* default */]();
      this.dependenciaModal = new __WEBPACK_IMPORTED_MODULE_8__domain_dependencia__["a" /* default */](this.declarante, this.dependente);
      this.desabilitaCampos(false, false, false, false);
    },
    valida: function valida() {
      var _this2 = this;

      this.$validator.validateAll().then(function (success) {
        if (success) {
          _this2.salva();
          return;
        }
        _this2.$root.$refs.toastr.e('Preencha ou corrija os campos em vermelho', 'Atenção');
      });
    },
    edita: function edita(dependencia) {
      this.navs[0].subtDetalhe = dependencia.dependente.nome;

      if (!this.telaEhMobile) {
        dependencia.dependente.dataNascimento = __WEBPACK_IMPORTED_MODULE_11__helpers_DateHelper__["a" /* default */].convertDateToPtbr(dependencia.dependente.dataNascimento);
      }
      this.dependenciaModal = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dependencia));
      this.desabilitaCampos(true, false, false, false);
      this.abreModal('dependente');
    },
    exclui: function exclui(dependencia) {
      var _this3 = this;

      var sentences = [{
        id: 1,
        message: 'Deseja excluir esse dependente da sua lista?',
        bold: false
      }];

      this.$root.$refs.modal.confirm(sentences, {
        yes: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var mensagem;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return __WEBPACK_IMPORTED_MODULE_7__services_dependenciasService__["a" /* default */].apaga(dependencia.id);

                  case 3:
                    _this3.dependencias.splice(_this3.dependencias.indexOf(dependencia), 1);
                    _this3.$root.$refs.toastr.s('Dependente excluído', 'Sucesso');
                    _context2.next = 11;
                    break;

                  case 7:
                    _context2.prev = 7;
                    _context2.t0 = _context2['catch'](0);
                    mensagem = __WEBPACK_IMPORTED_MODULE_15__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context2.t0);

                    _this3.$root.$refs.toastr.e(mensagem, 'Atenção');

                  case 11:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this3, [[0, 7]]);
          }));

          return function yes() {
            return _ref.apply(this, arguments);
          };
        }(),
        title: 'Deletando Dependente'
      });
    },
    salva: function salva() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, mensagem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.dependencia = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this4.dependenciaModal));
                _this4.dependencia.dependente.cpf = __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelper__["a" /* default */].limpaFormato(_this4.dependencia.dependente.cpf);
                _this4.dependencia.dependente = __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelper__["a" /* default */].toUpperCaseInJson(_this4.dependencia.dependente);
                if (!_this4.telaEhMobile) {
                  _this4.dependencia.dependente.dataNascimento = __WEBPACK_IMPORTED_MODULE_11__helpers_DateHelper__["a" /* default */].convertPtbrToApiDate(_this4.dependencia.dependente.dataNascimento);
                }
                if (_this4.dependencia.rendas.length === 0) delete _this4.dependencia.rendas;

                _context3.prev = 5;

                if (!_this4.dependencia.id) {
                  _context3.next = 16;
                  break;
                }

                _context3.next = 9;
                return __WEBPACK_IMPORTED_MODULE_7__services_dependenciasService__["a" /* default */].atualiza(_this4.dependencia.id, _this4.dependencia);

              case 9:
                _context3.next = 11;
                return _this4.listaDependentes();

              case 11:
                _this4.fechaModal('dependente');
                _this4.limpaModal();
                _this4.$root.$refs.toastr.s('Dependente atualizado', 'Sucesso');
                _context3.next = 23;
                break;

              case 16:
                _context3.next = 18;
                return __WEBPACK_IMPORTED_MODULE_7__services_dependenciasService__["a" /* default */].grava(_this4.dependencia);

              case 18:
                response = _context3.sent;

                _this4.dependencias.push(response);
                _this4.fechaModal('dependente');
                _this4.limpaModal();
                _this4.$root.$refs.toastr.s('Informação salva', 'Sucesso');

              case 23:
                _context3.next = 29;
                break;

              case 25:
                _context3.prev = 25;
                _context3.t0 = _context3['catch'](5);
                mensagem = __WEBPACK_IMPORTED_MODULE_15__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context3.t0);

                _this4.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 29:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[5, 25]]);
      }))();
    },
    cancela: function cancela() {
      this.limpaModal();
      this.fechaModal('dependente');
    },
    desabilitaCampos: function desabilitaCampos(cpfBoolean, dataBoolean, nomeBoolean, sexoBoolean) {
      document.querySelector('#cpf').disabled = cpfBoolean;
      document.querySelector('#dataNascimento').disabled = dataBoolean;
      document.querySelector('#nome').disabled = nomeBoolean;
      document.querySelector('#sexo').disabled = sexoBoolean;
    },
    limpaModal: function limpaModal() {
      var _this5 = this;

      setTimeout(function () {
        _this5.dependente = new __WEBPACK_IMPORTED_MODULE_9__domain_dependencia_dependente__["a" /* default */]();
        _this5.dependenciaModal = new __WEBPACK_IMPORTED_MODULE_8__domain_dependencia__["a" /* default */](_this5.declarante, _this5.dependente);
      }, 600);
    },


    // Métodos do SidePanel
    novaRenda: function novaRenda() {
      this.dependenciaModal.dependente.nome ? this.navs[1].subtDetalhe = this.dependenciaModal.dependente.nome : this.navs[1].subtDetalhe = 'Novo Parceiro';
      this.listaDeRendasModal = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.rendasOrdenadas));
      this.anoEditavel = true;

      this.abreModal('rendas');
    },
    editaRenda: function editaRenda(dependencia) {
      dependencia.dependente.nome ? this.navs[1].subtDetalhe = dependencia.dependente.nome : this.navs[1].subtDetalhe = 'Novo Parceiro';
      this.listaDeRendasModal = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.rendasOrdenadas));
      this.rendaModal = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.listaDeRendasModal[0]));

      this.abreModal('rendas');
    },
    incluiRenda: function incluiRenda() {
      var _this6 = this;

      if (this.rendaModal.valor) {
        this.rendaModal.valor = parseFloat(this.rendaModal.valor);
        var indexRenda = this.listaDeRendasModal.findIndex(function (renda) {
          return renda.anoReferencia == _this6.rendaModal.anoReferencia;
        });
        indexRenda >= 0 ? this.listaDeRendasModal.splice(indexRenda, 1, this.rendaModal) : this.listaDeRendasModal.push(this.rendaModal);

        this.$root.$refs.toastr.s('Renda incluída', 'Sucesso');
        this.rendaModal = new __WEBPACK_IMPORTED_MODULE_10__domain_dependencia_renda__["a" /* default */]();
      } else {
        this.$root.$refs.toastr.e('Preencha um valor a ser incluído', 'Atenção');
      }
    },
    editaRendaModal: function editaRendaModal(renda) {
      this.rendaModal = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(renda));
    },
    salvaRenda: function salvaRenda() {
      if (this.listaDeRendasModal.length && this.rendaModal.valor == 0) {
        this.dependenciaModal.rendas = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.listaDeRendasModal));
        this.$root.$refs.toastr.s('Renda salva na lista', 'Sucesso');
      } else {
        this.$root.$refs.toastr.e('Voc\xEA n\xE3o incluiu um valor na lista.\n                    Clique no bot\xE3o "+" para alterar o valor ou clique em Cancelar', 'Atenção');
        return;
      }
      this.fechaModal('rendas');
      this.limpaModalRenda();
    },
    cancelaRenda: function cancelaRenda() {
      this.fechaModal('rendas');
      this.limpaModalRenda();
    },


    // Métodos auxiliares para SideModal Rendas
    desabilitaCamposRenda: function desabilitaCamposRenda(cpfBoolean, dataBoolean, nomeBoolean, sexoBoolean) {
      document.querySelector('#cpf').disabled = cpfBoolean;
      document.querySelector('#dataNascimento').disabled = dataBoolean;
      document.querySelector('#nome').disabled = nomeBoolean;
      document.querySelector('#sexo').disabled = sexoBoolean;
    },
    limpaModalRenda: function limpaModalRenda() {
      var _this7 = this;

      setTimeout(function () {
        _this7.rendaModal = new __WEBPACK_IMPORTED_MODULE_10__domain_dependencia_renda__["a" /* default */]();
        _this7.listaDeRendasModal = [];
        _this7.anoEditavel = false;
      }, 600);
    },


    // Requisição
    listaDependentes: function listaDependentes() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var dependencias, mensagem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this8.carregando = true;

                _context4.prev = 1;
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__services_dependenciasService__["a" /* default */].lista();

              case 4:
                dependencias = _context4.sent;

                _this8.dependencias = dependencias.content;
                _context4.next = 12;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](1);
                mensagem = __WEBPACK_IMPORTED_MODULE_15__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context4.t0);

                _this8.$root.$refs.toastr.e(mensagem, 'Atenção');

              case 12:
                _context4.prev = 12;

                _this8.carregando = false;
                return _context4.finish(12);

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this8, [[1, 8, 12, 15]]);
      }))();
    }
  },

  created: function created() {
    this.autenticado = this.$store.state.usuarioLogado;
    this.declarante.id = this.autenticado.idPessoa;
    this.anoReferenciaAtual = __WEBPACK_IMPORTED_MODULE_6_moment___default()(new Date()).year() - 1;
    this.dependente = new __WEBPACK_IMPORTED_MODULE_9__domain_dependencia_dependente__["a" /* default */]();
    this.rendaModal = new __WEBPACK_IMPORTED_MODULE_10__domain_dependencia_renda__["a" /* default */]();
    this.dependenciaModal = new __WEBPACK_IMPORTED_MODULE_8__domain_dependencia__["a" /* default */](this.declarante, this.dependente);

    this.listaDependentes();
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },


  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_3__components_botao___default.a,
    SideModal: __WEBPACK_IMPORTED_MODULE_4__components_side_modal___default.a,
    TableLoader: __WEBPACK_IMPORTED_MODULE_5__components_table_loader___default.a
  }
});

/***/ }),

/***/ "vzcd":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "explicacaoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "explicacaoModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Entendi",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "explicacaoModalLabel"
    }
  }, [_vm._v("\n            Fluxo do Agendamento de Férias\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('ol', [_c('li', [_vm._v("\n                  Você deverá escolher, no calendário, uma data válida para o seu\n                  início de férias e salvá-la.\n                ")]), _vm._v(" "), _c('li', [_vm._v("\n                  A data salva não poderá ser alterada.\n                ")]), _vm._v(" "), _c('li', [_vm._v("\n                  Essa data proposta será analisada pelo seu chefe direto ou por um\n                  responsável, que poderá aprová-la ou não.\n                ")]), _vm._v(" "), _c('li', [_vm._v("\n                  Caso a data escolhida não seja aprovada, você receberá um email\n                  notificando a reprovação, e o seu agendamento de férias ficará\n                  aberto para que você possa escolher uma nova data.\n                ")])])])])])
}]}

/***/ }),

/***/ "w1KV":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("zJ2E")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("iHSL"),
  /* template */
  __webpack_require__("/aLi"),
  /* scopeId */
  "data-v-2f0f6c3f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "wcTJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x/Th":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("U9pR"),
  /* template */
  __webpack_require__("5j8y"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "x00c":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("24L3"),
  /* template */
  __webpack_require__("hwPX"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "x1eA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return confereClicados; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return contaCliques; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var confereClicados = function confereClicados(sshdLogado, rotas) {
  var clicados = [];
  if (!localStorage.clicados) {
    criaClicados(clicados, sshdLogado);
  }
  clicados = JSON.parse(localStorage.getItem("clicados"));
  var existeLogado = clicados.some(function (item) {
    return item.sshd === sshdLogado;
  });
  if (!existeLogado) {
    criaClicados(clicados, sshdLogado);
  }
  var clicksDoLogado = clicados.find(function (item) {
    return item.sshd === sshdLogado;
  });
  if (!clicksDoLogado.links.length) {
    criaClicadosUsuario(sshdLogado, clicados, rotas);
  } else {
    atualizaClicados(JSON.parse(localStorage.getItem("clicados")), sshdLogado, rotas);
  }
};

var contaCliques = function contaCliques(link, sshdLogado) {
  if (localStorage.clicados) {
    var clicados = JSON.parse(localStorage.getItem("clicados"));
    var clicadosDoLogado = clicados.find(function (item) {
      return item.sshd === sshdLogado;
    });
    if (clicadosDoLogado) {
      clicadosDoLogado.links.forEach(function (clicado) {
        if (clicado.name === link.name) {
          clicado.cliques++;
        }
      });
      salvaMudancas(clicadosDoLogado, clicados, sshdLogado);
    }
  }
};

var criaClicados = function criaClicados(clicados, sshdLogado) {
  var clicksDoLogado = { sshd: sshdLogado, links: [] };
  clicados.push(clicksDoLogado);
  localStorage.setItem("clicados", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(clicados));
};

var criaClicadosUsuario = function criaClicadosUsuario(sshdLogado, clicados, rotas) {
  var clicksDoLogado = { sshd: sshdLogado, links: [] };
  rotas.forEach(function (rota) {
    if (rota.meta && rota.meta.contavel) {
      var card = {};
      card.cliques = 1;
      card.meta = rota.meta;
      card.name = rota.name;
      clicksDoLogado.links.push(card);
    }
  });
  var indexDoLogado = clicados.findIndex(function (item) {
    return item.sshd == sshdLogado;
  });
  clicados.splice(indexDoLogado, 1, clicksDoLogado);
  localStorage.setItem("clicados", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(clicados));
};

var atualizaClicados = function atualizaClicados(clicados, sshdLogado, rotas) {
  var linksAtualizados = [];
  var clicksDoLogado = clicados.find(function (item) {
    return item.sshd === sshdLogado;
  });
  var rotasClicaveis = rotas.filter(function (rota) {
    return rota.meta && rota.meta.contavel;
  });

  rotasClicaveis.forEach(function (rota) {
    var card = {};
    card.meta = rota.meta;
    card.name = rota.name;
    var existente = clicksDoLogado.links.find(function (link) {
      return link.name === rota.name;
    });
    card.cliques = !!existente ? existente.cliques : 1;
    linksAtualizados.push(card);
  });

  clicksDoLogado.links = [].concat(linksAtualizados);

  salvaMudancas(clicksDoLogado, clicados, sshdLogado);
};

var salvaMudancas = function salvaMudancas(rotasDoLogado, clicados, sshdLogado) {
  rotasDoLogado.links = rotasDoLogado.links.sort(function (a, b) {
    return b.cliques - a.cliques;
  });
  var clicadosLocalIndex = clicados.findIndex(function (item) {
    return item.sshd === sshdLogado;
  });
  clicados.splice(clicadosLocalIndex, 1, rotasDoLogado);
  localStorage.setItem("clicados", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(clicados));
};

/***/ }),

/***/ "x98e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TableLoader',
  props: {
    carregando: {
      required: true,
      type: Boolean
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app'
});

/***/ }),

/***/ "xUO3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var UsuarioLogado = function UsuarioLogado() {
  var sshd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var nome = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var perfis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var primeiroNome = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var idPessoa = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var cpf = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var funcionarios = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UsuarioLogado);

  this.sshd = sshd;
  this.nome = nome;
  this.perfis = perfis;
  this.primeiroNome = primeiroNome;
  this.idPessoa = idPessoa;
  this.cpf = cpf;
  this.funcionarios = funcionarios;
};

/* harmony default export */ __webpack_exports__["a"] = (UsuarioLogado);

/***/ }),

/***/ "xfTI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__ = __webpack_require__("MPt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pagina_erro__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Encerrado',
	components: {
		PaginaErro: __WEBPACK_IMPORTED_MODULE_0__components_pagina_erro___default.a
	}
});

/***/ }),

/***/ "xxzF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Conta',

  data: function data() {
    return {
      usuarioLogado: this.$store.state.usuarioLogado,
      autenticados: this.$store.state.usuarioLogado.funcionarios
    };
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "xyKs":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("NV+5")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("CmI8"),
  /* template */
  __webpack_require__("PhhY"),
  /* scopeId */
  "data-v-1b889aae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "xyqo":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("IYHZ"),
  /* template */
  __webpack_require__("VdY4"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "y0j6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "y2Rf":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("xfTI"),
  /* template */
  __webpack_require__("pBDI"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "y909":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yCKt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ydoK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ysmu":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: "version1.0.3"
  }, [_c('ajax-intercept', {
    on: {
      "start": _vm.start,
      "finish": _vm.finish
    }
  }), _vm._v(" "), _c('barra-navegacao', {
    attrs: {
      "autenticado": _vm.auth,
      "rotas": _vm.routes,
      "usuario": _vm.usuarioLogado.primeiroNome,
      "sshd": _vm.usuarioLogado.sshd
    }
  }), _vm._v(" "), _c('barra-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auth),
      expression: "auth"
    }],
    staticClass: "hidden-xs hidden-sm",
    attrs: {
      "rotas": _vm.routes,
      "declaracaoVisitada": _vm.declaraVisited,
      "avaliacaoVisitada": _vm.avaliaVisited,
      "recadastramentoVisitada": _vm.recadastraVisited,
      "formulariosVisitada": _vm.formulariosVisited,
      "feriasVisitada": _vm.feriasVisited,
      "valeAlimentacaoVisitada": _vm.valeAlimentacaoVisited
    }
  }), _vm._v(" "), _c('barra-evolucao', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stepVisible),
      expression: "stepVisible"
    }],
    attrs: {
      "stepOne": _vm.number,
      "stepTwo": _vm.number,
      "stepThree": _vm.number,
      "stepFour": _vm.number,
      "stepFive": _vm.number,
      "stepSix": _vm.number,
      "stepSeven": _vm.number,
      "textOne": _vm.number,
      "textTwo": _vm.number,
      "textThree": _vm.number,
      "textFour": _vm.number,
      "textFive": _vm.number,
      "textSix": _vm.number,
      "textSeven": _vm.number,
      "contentNumber": _vm.number,
      "contentName": _vm.stepName
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('rodape', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auth),
      expression: "auth"
    }],
    attrs: {
      "id": "footer"
    }
  }), _vm._v(" "), _c('botao-ir-para-topo'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.carregando) ? _c('loader') : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "zIxy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_botao__ = __webpack_require__("SMiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_botao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_botao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_side_modal__ = __webpack_require__("dLc8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_side_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_side_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_upload_arquivos__ = __webpack_require__("cTmi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_upload_arquivos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_upload_arquivos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_StringHelper__ = __webpack_require__("1pbJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_ErrorHelper__ = __webpack_require__("+h9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_object_hash__ = __webpack_require__("eZXE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_object_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_object_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_recadastramentoService__ = __webpack_require__("e9Zu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__status__ = __webpack_require__("9a4s");











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Envio',

  components: {
    Botao: __WEBPACK_IMPORTED_MODULE_12__components_botao___default.a,
    SideModal: __WEBPACK_IMPORTED_MODULE_13__components_side_modal___default.a,
    UploadArquivos: __WEBPACK_IMPORTED_MODULE_14__components_upload_arquivos___default.a
  },

  data: function data() {
    return {
      Status: __WEBPACK_IMPORTED_MODULE_19__status__["default"],
      cadastrado: this.$store.state.funcionarioCadastrado,
      apiUrl: this.$root.$data.apiUrl,
      endPointUpload: '',
      salvando: false,
      apiErrors: null,
      totalAlteracoes: 0,
      anexosTemporarios: [],
      situacaoInicial: '',
      tipoButao: '',
      camposAlterados: {
        grupoContato: {
          isValidado: false,
          email: false,
          dddCelular: false,
          numeroCelular: false,
          dddTelefone: false,
          numeroTelefone: false
        },
        grupoNome: {
          isValidado: true,
          nome: false
        },
        grupoRg: {
          isValidado: true,
          rg: false
        },
        grupoTituloEleitor: {
          isValidado: true,
          tituloEleitor: false
        },
        grupoPispasep: {
          isValidado: true,
          pisPasep: false
        },
        grupoFiliacao: {
          isValidado: true,
          pai: false,
          mae: false
        },
        grupoEndereco: {
          isValidado: true,
          cep: false,
          tipoLogradouro: false,
          logradouro: false,
          numero: false,
          complemento: false,
          bairro: false,
          cidade: false,
          uf: false,
          georreferenciado: false
        },
        grupoGenero: {
          isValidado: false,
          genero: false,
          orientacaoSexual: false
        },
        grupoEstadoCivil: {
          isValidado: true,
          estadoCivil: false
        },
        grupoCNH: {
          isValidado: true,
          cnh: false,
          categoria: false,
          validade: false
        },
        grupoDependentes: {
          isValidado: true,
          dependentes: false
        },
        grupoOrgaoClasse: {
          isValidado: true,
          orgaoClasse: false
        },
        grupoDataNascimento: {
          isValidado: true,
          dataNascimento: false
        },
        grupoRacaCor: {
          isValidado: false,
          racaCor: false
        },
        grupoCidadeNascimento: {
          isValidado: true,
          cidadeNaturalidade: false,
          ufNaturalidade: false
        }
      },
      navs: [{
        titulo: 'Atualização Cadastral',
        subtitulo: 'Documentos',
        subtDetalhe: 'Envio de Arquivos',
        largura: 600,
        identidade: 'upload',
        abreProximo: false,
        aberto: false
      }],
      verificacaoRealizada: false
    };
  },


  computed: {
    tituloResponsivo: function tituloResponsivo() {
      return window.innerWidth <= 540 ? 'Atualização Cadastral' : 'Atualização Cadastral';
    },
    situacaoRecad: function situacaoRecad() {
      return this.$store.getters.getSituacaoRecad;
    },
    mostraConfirmar: function mostraConfirmar() {
      return this.cadastrado.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].RECADASTRAMENTO_PENDENTE && !this.cadastrado.validacaoPendente && !this.cadastrado.alteracoes.some(function (item) {
        return item.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].NAO_VALIDADO;
      }) && !this.cadastrado.ultimoProtocolo;
    },
    mostraEnviar: function mostraEnviar() {
      return this.cadastrado.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].SEM_VALIDACAO && !this.cadastrado.validacaoPendente;
    },
    mostraFazerUpload: function mostraFazerUpload() {
      return this.cadastrado.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].COM_VALIDACAO && !this.cadastrado.validacaoPendente && this.verificaAlteracoes();
    },
    mostraUploadClaro: function mostraUploadClaro() {
      return this.verificaAlteracoes() && (this.cadastrado.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].ALTERADO || !!this.cadastrado.validacaoPendente || this.cadastrado.alteracoes.some(function (item) {
        return item.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].NAO_VALIDADO;
      })) && !this.salvando;
    },
    mostraSalvar: function mostraSalvar() {
      return (this.cadastrado.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].ALTERADO || !!this.cadastrado.validacaoPendente) && !this.salvando && this.verificaAlteracoes();
    },
    listaDocumentosExigidos: function listaDocumentosExigidos() {
      var documentosDistintos = [];
      if (this.cadastrado.alteracoes) {
        var documentosPendentes = this.cadastrado.alteracoes.filter(function (item) {
          return item.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].PENDENTE_DE_VALIDACAO || item.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].NAO_VALIDADO;
        });
        var documentosMensagens = this.incluiMensagem(documentosPendentes, this.cadastrado.documentosExigidos);
        documentosDistintos = documentosMensagens.filter(function (value, index, array) {
          return array.indexOf(value) === index;
        });
      }
      return documentosDistintos;
    },
    mostraDelete: function mostraDelete() {
      if (this.cadastrado.alteracoes.length) {
        var validaveis = this.cadastrado.alteracoes.filter(function (item) {
          return item.grupo !== 'contato' && item.grupo !== 'racaCor';
        });
        var existeNaoDeletavel = validaveis.some(function (item) {
          return item.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].VALIDADO || item.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].NAO_VALIDADO || item.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].ATUALIZADO;
        });
        var ehDeletavel = !existeNaoDeletavel;

        return ehDeletavel;
      }
      return true;
    },
    mostraFinalizado: function mostraFinalizado() {
      return !this.mostraConfirmar && !this.mostraEnviar && !this.mostraFazerUpload && !this.mostraUploadClaro && !this.salvando && this.cadastrado.status !== __WEBPACK_IMPORTED_MODULE_19__status__["default"].RECADASTRAMENTO_PENDENTE;
    },
    mostraTituloEnvio: function mostraTituloEnvio() {
      // return (
      //   this.cadastrado.status === Status.RECADASTRAMENTO_PENDENTE ||
      //   this.mostraConfirmar ||
      //   this.mostraEnviar
      // );
      return this.cadastrado.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].RECADASTRAMENTO_PENDENTE || this.situacaoInicial == __WEBPACK_IMPORTED_MODULE_19__status__["default"].ALTERADO || this.mostraConfirmar || this.mostraEnviar;
    },
    mostraTituloUpload: function mostraTituloUpload() {
      // return (
      //   this.mostraFazerUpload ||
      //   this.mostraUploadClaro 
      // );
      // return (
      //   this.mostraFazerUpload ||
      //   this.mostraUploadClaro
      // );

      return this.mostraFazerUpload;
    },
    mostraTituloFinalizado: function mostraTituloFinalizado() {
      return this.mostraFinalizado;
    }
  },

  methods: {
    abreModal: function abreModal(identidade) {
      this.$emit('abreModal', identidade);
    },
    fechaModal: function fechaModal(identidade) {
      this.$emit('fechaModal', identidade);
    },
    cancela: function cancela() {
      this.fechaModal('upload');
      this.limpaModal();
    },
    limpaModal: function limpaModal() {
      this.$eventBus.$emit('limpa-uploads');
    },
    novo: function novo() {
      this.errors.clear();
    },
    mesclarAnexos: function mesclarAnexos() {
      this.cadastrado.anexos = this.cadastrado.anexos.concat(this.anexosTemporarios);
    },
    limparEstadoLocal: function limparEstadoLocal() {
      var _this = this;

      this.anexosTemporarios = [];
      this.totalAlteracoes = 0;
      this.situacaoInicial = "";
      this.camposAlterados = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(this.camposAlterados).reduce(function (acc, key) {
        acc[key] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, _this.camposAlterados[key], Object.fromEntries(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default()(_this.camposAlterados[key]).map(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              k = _ref2[0],
              v = _ref2[1];

          return [k, k === 'isValidado' ? v : false];
        })));
        return acc;
      }, {});
    },
    determinarBotao: function determinarBotao() {
      this.tipoButao = "";
      var cadastroModelo = this.$store.state.cadastroModelo;
      var rgAtual = this.cadastrado.pessoa.rg ? this.cadastrado.pessoa.rg : null;

      var rgOriginal = cadastroModelo.pessoa.rg ? cadastroModelo.pessoa.rg : null;

      var enderecoAtual = this.normalizaEndereco(this.cadastrado.pessoa.endereco || {});
      var enderecoOriginal = this.normalizaEndereco(cadastroModelo.pessoa.endereco || {});

      var contatoAtual = this.normalizaContato(this.cadastrado.pessoa.contato || {});
      var contatoOriginal = this.normalizaContato(this.$store.state.cadastroModelo.pessoa.contato || {});

      var tituloAtual = this.cadastrado.pessoa.tituloEleitor ? this.cadastrado.pessoa.tituloEleitor : null;
      var tituloOriginal = cadastroModelo.pessoa.tituloEleitor ? cadastroModelo.pessoa.tituloEleitor : null;

      var dadosPessoaisAtuais = this.normalizaDadosPessoais(this.cadastrado.pessoa);
      var dadosPessoaisOriginais = this.normalizaDadosPessoais(cadastroModelo.pessoa);

      // PIS/PASEP
      var pisPasepAtual = this.cadastrado.pessoa.pisPasep;
      var pisPasepOriginal = cadastroModelo.pessoa.pisPasep;

      // Órgão de Classe
      var orgaoClasseAtual = this.cadastrado.pessoa.orgaoClasse ? this.cadastrado.pessoa.orgaoClasse : null;
      var orgaoClasseOriginal = cadastroModelo.pessoa.orgaoClasse ? cadastroModelo.pessoa.orgaoClasse : null;

      // CNH
      var cnhAtual = this.cadastrado.pessoa.cnh ? this.cadastrado.pessoa.cnh : null;
      var cnhOriginal = cadastroModelo.pessoa.cnh ? cadastroModelo.pessoa.cnh : null;

      // Verificação para filiação (nome do pai e da mãe)
      var paiAtual = this.cadastrado.pessoa.filiacao ? this.cadastrado.pessoa.filiacao.pai : null;
      var paiOriginal = cadastroModelo.pessoa.filiacao ? cadastroModelo.pessoa.filiacao.pai : null;

      var maeAtual = this.cadastrado.pessoa.filiacao ? this.cadastrado.pessoa.filiacao.mae : null;
      var maeOriginal = cadastroModelo.pessoa.filiacao ? cadastroModelo.pessoa.filiacao.mae : null;

      var rgAtualNormalizado = this.normalizaRG(rgAtual);
      var rgOriginalNormalizado = this.normalizaRG(rgOriginal);

      var tituloAtualNormalizado = this.normalizaTitulo(tituloAtual);
      var tituloOriginalNormalizado = this.normalizaTitulo(tituloOriginal);

      var pisPasepAtualLimpo = pisPasepAtual ? String(pisPasepAtual).replace(/\D/g, '') : null;
      var pisPasepOriginalLimpo = pisPasepOriginal ? String(pisPasepOriginal).replace(/\D/g, '') : null;

      var orgaoClasseAtualNormalizado = this.normalizaOrgaoClasse(orgaoClasseAtual);
      var orgaoClasseOriginalNormalizado = this.normalizaOrgaoClasse(orgaoClasseOriginal);

      var dataNascimentoAlterada = dadosPessoaisAtuais.dataNascimento !== dadosPessoaisOriginais.dataNascimento;
      var racaCorAlterada = dadosPessoaisAtuais.racaCor !== dadosPessoaisOriginais.racaCor;
      var estadoCivilAlterado = dadosPessoaisAtuais.estadoCivil !== dadosPessoaisOriginais.estadoCivil;
      var cidadeNatalidadeAlterada = dadosPessoaisAtuais.naturalidade.cidade !== dadosPessoaisOriginais.naturalidade.cidade;
      var ufNatalidadeAlterada = dadosPessoaisAtuais.naturalidade.uf !== dadosPessoaisOriginais.naturalidade.uf;

      var orientacaoSexualAlterada = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dadosPessoaisAtuais.orientacaoSexual) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dadosPessoaisOriginais.orientacaoSexual);
      var identidadeGeneroAlterada = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dadosPessoaisAtuais.genero) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dadosPessoaisOriginais.genero);

      var cnhAtualNormalizado = this.normalizaCNH(cnhAtual);
      var cnhOriginalNormalizado = this.normalizaCNH(cnhOriginal);

      var emailAlterado = contatoAtual.email !== contatoOriginal.email;
      var dddCelularAlterado = contatoAtual.dddCelular !== contatoOriginal.dddCelular;
      var numeroCelularAlterado = contatoAtual.numeroCelular !== contatoOriginal.numeroCelular;
      var dddTelefoneAlterado = contatoAtual.dddTelefone !== contatoOriginal.dddTelefone;
      var numeroTelefoneAlterado = contatoAtual.numeroTelefone !== contatoOriginal.numeroTelefone;

      var temAlteracoesRG = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(rgAtualNormalizado) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(rgOriginalNormalizado);
      var temAlteracoesTitulo = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(tituloAtualNormalizado) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(tituloOriginalNormalizado);
      var temAlteracoesPisPasep = pisPasepAtualLimpo !== pisPasepOriginalLimpo;
      var temAlteracoesOrgaoClasse = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(orgaoClasseAtualNormalizado) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(orgaoClasseOriginalNormalizado);
      var temAlteracoesCNH = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(cnhAtualNormalizado) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(cnhOriginalNormalizado);

      var cepAlterado = enderecoAtual.cep !== enderecoOriginal.cep;
      var tipoLogradouroAlterado = enderecoAtual.tipoLogradouro !== enderecoOriginal.tipoLogradouro;
      var logradouroAlterado = enderecoAtual.logradouro !== enderecoOriginal.logradouro;
      var numeroAlterado = enderecoAtual.numero !== enderecoOriginal.numero;
      var complementoAlterado = enderecoAtual.complemento !== enderecoOriginal.complemento;
      var bairroAlterado = enderecoAtual.bairro !== enderecoOriginal.bairro;
      var cidadeAlterado = enderecoAtual.cidade !== enderecoOriginal.cidade;
      var ufAlterado = enderecoAtual.uf !== enderecoOriginal.uf;
      var georreferenciadoAlterado = enderecoAtual.georreferenciado !== enderecoOriginal.georreferenciado;

      var dependentesAtuais = this.cadastrado.pessoa.dependentes || [];
      var dependentesOriginais = cadastroModelo.pessoa.dependentes || [];

      var temAlteracoesDependentes = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dependentesAtuais) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dependentesOriginais);

      this.camposAlterados.grupoFiliacao.pai = paiAtual !== paiOriginal;
      this.camposAlterados.grupoFiliacao.mae = maeAtual !== maeOriginal;

      this.camposAlterados.grupoContato.email = emailAlterado;
      this.camposAlterados.grupoContato.dddCelular = dddCelularAlterado;
      this.camposAlterados.grupoContato.numeroCelular = numeroCelularAlterado;
      this.camposAlterados.grupoContato.dddTelefone = dddTelefoneAlterado;
      this.camposAlterados.grupoContato.numeroTelefone = numeroTelefoneAlterado;

      this.camposAlterados.grupoRg.rg = temAlteracoesRG;

      this.camposAlterados.grupoTituloEleitor.tituloEleitor = temAlteracoesTitulo;
      this.camposAlterados.grupoPispasep.pisPasep = temAlteracoesPisPasep;
      this.camposAlterados.grupoOrgaoClasse.orgaoClasse = temAlteracoesOrgaoClasse;
      this.camposAlterados.grupoCNH.cnh = temAlteracoesCNH;

      this.camposAlterados.grupoEndereco.cep = cepAlterado;
      this.camposAlterados.grupoEndereco.tipoLogradouro = tipoLogradouroAlterado;
      this.camposAlterados.grupoEndereco.logradouro = logradouroAlterado;
      this.camposAlterados.grupoEndereco.numero = numeroAlterado;
      this.camposAlterados.grupoEndereco.complemento = complementoAlterado;
      this.camposAlterados.grupoEndereco.bairro = bairroAlterado;
      this.camposAlterados.grupoEndereco.cidade = cidadeAlterado;
      this.camposAlterados.grupoEndereco.uf = ufAlterado;
      this.camposAlterados.grupoEndereco.georreferenciado = georreferenciadoAlterado;

      this.camposAlterados.grupoDataNascimento.dataNascimento = dataNascimentoAlterada;
      this.camposAlterados.grupoRacaCor.racaCor = racaCorAlterada;
      this.camposAlterados.grupoEstadoCivil.estadoCivil = estadoCivilAlterado;

      this.camposAlterados.grupoCidadeNascimento.cidadeNaturalidade = cidadeNatalidadeAlterada;
      this.camposAlterados.grupoCidadeNascimento.ufNaturalidade = ufNatalidadeAlterada;

      this.camposAlterados.grupoGenero.orientacaoSexual = orientacaoSexualAlterada;
      this.camposAlterados.grupoGenero.genero = identidadeGeneroAlterada;

      this.camposAlterados.grupoDependentes.dependentes = temAlteracoesDependentes;

      // Adicionando o monitoramento do campo nome
      this.camposAlterados.grupoNome.nome = dadosPessoaisAtuais.nome !== dadosPessoaisOriginais.nome;

      var contadorValidadosAlterados = this.contarGruposValidadosAlterados(this.camposAlterados);
      var contadorInvalidadosAlterados = this.contarGruposInvalidadosAlterados(this.camposAlterados);
      // TESTE DO TIPO DE GENERO
      if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(this.cadastrado.pessoa.genero) === 'object') {
        console.log('Gênero é um objeto:', this.cadastrado.pessoa.genero);
      } else if (typeof this.cadastrado.pessoa.genero === 'string') {
        console.log('Gênero é uma string:', this.cadastrado.pessoa.genero);
      }

      // TESTE DO TIPO DE ORIENTACAO SEXUAL
      if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(this.cadastrado.pessoa.orientacaoSexual) === 'object') {
        console.log('Orientação Sexual é um objeto:', this.cadastrado.pessoa.orientacaoSexual);
      } else if (typeof this.cadastrado.pessoa.orientacaoSexual === 'string') {
        console.log('Orientação Sexual é uma string:', this.cadastrado.pessoa.orientacaoSexual);
      }

      console.log('Contador Validados Alterados: ' + contadorValidadosAlterados);
      console.log('Contador Invalidados Alterados: ' + contadorInvalidadosAlterados);

      console.log('Orienta\xE7\xE3o Sexual Atual:' + dadosPessoaisAtuais.orientacaoSexual);
      console.log('Orienta\xE7\xE3o Sexual Original:' + dadosPessoaisOriginais.orientacaoSexual);

      console.log('Identidade de G\xEAnero Atual:' + dadosPessoaisAtuais.genero);
      console.log('Identidade de G\xEAnero Original:' + dadosPessoaisOriginais.genero);

      // if (this.cadastrado.status === Status.RECADASTRAMENTO_PENDENTE) {
      if (contadorValidadosAlterados === 0 && contadorInvalidadosAlterados === 0) {
        this.tipoButao = "Confirmar"; // Nada foi alterado
      } else if (contadorValidadosAlterados === 0 && contadorInvalidadosAlterados > 0) {
        this.tipoButao = "Enviar"; // Apenas grupos sem validação foram alterados
      } else {
        this.totalAlteracoes = contadorValidadosAlterados;
        this.tipoButao = "Anexar"; // Pelo menos um grupo com validação foi alterado
      }

      // }
    },
    contarGruposValidadosAlterados: function contarGruposValidadosAlterados(obj) {
      var count = 0;

      for (var key in obj) {
        if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(obj[key]) === 'object' && obj[key] !== null) {
          // Verifica se é um grupo validado (tem isValidado === true)
          if (obj[key].isValidado === true) {
            // Verifica se pelo menos um campo (exceto isValidado) está true
            var camposAlterados = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default()(obj[key]).some(function (_ref3) {
              var _ref4 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                  subKey = _ref4[0],
                  value = _ref4[1];

              return subKey !== 'isValidado' && value === true;
            });

            if (camposAlterados) {
              count++;
            }
          }
          count += this.contarGruposValidadosAlterados(obj[key]);
        }
      }
      return count;
    },
    contarGruposInvalidadosAlterados: function contarGruposInvalidadosAlterados(obj) {
      var count = 0;

      for (var key in obj) {
        if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(obj[key]) === 'object' && obj[key] !== null) {
          // Verifica se é um grupo invalidado (isValidado === false)
          if (obj[key].isValidado === false) {
            // Verifica se pelo menos um campo (exceto isValidado) está true (alterado)
            var camposAlterados = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default()(obj[key]).some(function (_ref5) {
              var _ref6 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
                  subKey = _ref6[0],
                  value = _ref6[1];

              return subKey !== 'isValidado' && value === true;
            });

            if (camposAlterados) {
              count++;
            }
          }
          count += this.contarGruposInvalidadosAlterados(obj[key]);
        }
      }
      return count;
    },

    // Validação de CPF
    validaCPF: function validaCPF(cpf) {
      // Remove caracteres não numéricos
      cpf = cpf.replace(/\D/g, '');

      // Verifica se tem 11 dígitos
      if (cpf.length !== 11) return false;

      // Verifica se todos os dígitos são iguais
      if (/^(\d)\1+$/.test(cpf)) return false;

      // Validação do primeiro dígito verificador
      var soma = 0;
      for (var i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i);
      }
      var resto = 11 - soma % 11;
      var dv1 = resto > 9 ? 0 : resto;

      // Validação do segundo dígito verificador
      soma = 0;
      for (var _i = 0; _i < 10; _i++) {
        soma += parseInt(cpf.charAt(_i)) * (11 - _i);
      }
      resto = 11 - soma % 11;
      var dv2 = resto > 9 ? 0 : resto;

      // Verifica se os dígitos verificadores estão corretos
      return parseInt(cpf.charAt(9)) === dv1 && parseInt(cpf.charAt(10)) === dv2;
    },

    // Verifica CPFs dos dependentes
    verificaCPFsDependentes: function verificaCPFsDependentes() {
      var _this2 = this;

      if (!this.cadastrado.pessoa || !this.cadastrado.pessoa.dependentes) return true;

      var dependentesComCPFInvalido = this.cadastrado.pessoa.dependentes.filter(function (dependente) {
        // Se não tiver CPF ou o CPF for inválido
        return !dependente.cpfDependente || !_this2.validaCPF(dependente.cpfDependente);
      });

      if (dependentesComCPFInvalido.length > 0) {
        var mensagem = 'Os seguintes dependentes possuem CPF inválido ou não preenchido:';

        dependentesComCPFInvalido.forEach(function (dependente) {
          var cpfExibido = dependente.cpfDependente ? dependente.cpfDependente : '000.000.000-00';
          mensagem += '\n- ' + dependente.nome + ': ' + cpfExibido;
        });

        mensagem += '\n\nPor favor, corrija o CPF de todos os dependentes antes de enviar o recadastramento.';

        this.$root.$refs.toastr.e(mensagem, 'CPF Inválido Detectado');
        return false;
      }

      return true;
    },
    getDadosParaComparacao: function getDadosParaComparacao() {
      var cadastroAtual = this.cadastrado.pessoa;
      var cadastroOriginal = this.$store.state.cadastroModelo.pessoa;

      return {
        // RG
        rg: {
          atual: cadastroAtual.rg ? this.normalizaRG(cadastroAtual.rg) : null,
          original: cadastroOriginal.rg ? this.normalizaRG(cadastroOriginal.rg) : null
        },

        // Endereço
        endereco: {
          atual: this.normalizaEndereco(cadastroAtual.endereco || {}),
          original: this.normalizaEndereco(cadastroOriginal.endereco || {})
        },

        // Contato
        contato: {
          atual: this.normalizaContato(cadastroAtual.contato || {}),
          original: this.normalizaContato(cadastroOriginal.contato || {})
        },

        // Título de Eleitor
        tituloEleitor: {
          atual: cadastroAtual.tituloEleitor ? this.normalizaTitulo(cadastroAtual.tituloEleitor) : null,
          original: cadastroOriginal.tituloEleitor ? this.normalizaTitulo(cadastroOriginal.tituloEleitor) : null
        },

        // Dados Pessoais
        dadosPessoais: {
          atual: this.normalizaDadosPessoais(cadastroAtual),
          original: this.normalizaDadosPessoais(cadastroOriginal)
        },

        // PIS/PASEP
        pisPasep: {
          atual: cadastroAtual.pisPasep ? String(cadastroAtual.pisPasep).replace(/\D/g, '') : null,
          original: cadastroOriginal.pisPasep ? String(cadastroOriginal.pisPasep).replace(/\D/g, '') : null
        },

        // Órgão de Classe
        orgaoClasse: {
          atual: cadastroAtual.orgaoClasse ? this.normalizaOrgaoClasse(cadastroAtual.orgaoClasse) : null,
          original: cadastroOriginal.orgaoClasse ? this.normalizaOrgaoClasse(cadastroOriginal.orgaoClasse) : null
        },

        // CNH
        cnh: {
          atual: cadastroAtual.cnh ? this.normalizaCNH(cadastroAtual.cnh) : null,
          original: cadastroOriginal.cnh ? this.normalizaCNH(cadastroOriginal.cnh) : null
        },

        // Filiação (Pai e Mãe)
        filiacao: {
          pai: {
            //atual: cadastroAtual.filiacao?.pai || null,
            //original: cadastroOriginal.filiacao?.pai || null,
          },
          mae: {
            //atual: cadastroAtual.filiacao?.mae || null,
            //original: cadastroOriginal.filiacao?.mae || null,
          }
        },

        // Dependentes
        dependentes: {
          atual: cadastroAtual.dependentes || [],
          original: cadastroOriginal.dependentes || []
        }
      };
    },
    verificarQuantidadeAnexos: function verificarQuantidadeAnexos() {
      if (this.situacaoInicial === 'RECADASTRAMENTO_PENDENTE') {
        if (this.totalAlteracoes > 0) {
          if (this.anexosTemporarios.length < this.totalAlteracoes) {
            this.$root.$refs.toastr.e('Favor anexar todos os arquivos referentes \xE0s altera\xE7\xF5es realizadas.\n              \nNumero de anexos: ' + this.anexosTemporarios.length + '\n\n\n              N\xFAmero de Altera\xE7\xF5es: ' + this.totalAlteracoes + '\n', 'Erro', { timeOut: 2000 });
            return false;
          }
          return true;
        }
      }
      return true;
    },
    normalizaEndereco: function normalizaEndereco(endereco) {
      if (!endereco) return {
        cep: '',
        tipoLogradouro: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        uf: '',
        georreferenciado: false,
        inseridoPeloUsuario: false
      };

      return {
        cep: endereco.cep ? String(endereco.cep).replace(/\D/g, '') : '',
        tipoLogradouro: (endereco.tipoLogradouro || '').trim().toUpperCase(),
        logradouro: (endereco.logradouro || '').trim().toUpperCase(),
        numero: endereco.numero ? String(endereco.numero).replace(/\D/g, '') : '',
        complemento: (endereco.complemento || '').trim().toUpperCase(),
        bairro: (endereco.bairro || '').trim().toUpperCase(),
        cidade: (endereco.cidade || '').trim().toUpperCase(),
        uf: (endereco.uf || '').trim().toUpperCase(),
        georreferenciado: !!endereco.georreferenciado,
        inseridoPeloUsuario: !!endereco.inseridoPeloUsuario
      };
    },
    normalizaContato: function normalizaContato(contato) {
      if (!contato) return {
        email: '',
        dddCelular: '',
        numeroCelular: '',
        dddTelefone: '',
        numeroTelefone: ''
      };

      // Função auxiliar para limpar e converter para número
      var paraNumero = function paraNumero(valor) {
        if (!valor) return '';
        var limpo = String(valor).replace(/\D/g, '');
        return limpo;
      };

      return {
        email: (contato.email || '').toLowerCase().trim(),
        dddCelular: paraNumero(contato.dddCelular),
        numeroCelular: paraNumero(contato.numeroCelular),
        dddTelefone: paraNumero(contato.dddTelefone),
        numeroTelefone: paraNumero(contato.numeroTelefone)
      };
    },
    normalizaDocumentos: function normalizaDocumentos(pessoa) {
      if (!pessoa) return null;

      // Cria uma cópia profunda para não modificar o objeto original
      var pessoaNormalizada = JSON.parse(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(pessoa));

      try {
        // Normaliza RG
        if (pessoaNormalizada.rg) {
          pessoaNormalizada.rg = {
            numero: pessoaNormalizada.rg.numero ? String(pessoaNormalizada.rg.numero).replace(/\D/g, '') : '',
            dataEmissao: pessoaNormalizada.rg.dataEmissao || '',
            orgaoEmissor: pessoaNormalizada.rg.orgaoEmissor || '',
            uf: pessoaNormalizada.rg.uf || ''
          };
        }

        // Normaliza Título de Eleitor
        if (pessoaNormalizada.tituloEleitor) {
          pessoaNormalizada.tituloEleitor = {
            numero: pessoaNormalizada.tituloEleitor.numero ? parseInt(String(pessoaNormalizada.tituloEleitor.numero).replace(/\D/g, '')) || 0 : 0,
            zona: pessoaNormalizada.tituloEleitor.zona ? parseInt(String(pessoaNormalizada.tituloEleitor.zona).replace(/\D/g, '')) || 0 : 0,
            secao: pessoaNormalizada.tituloEleitor.secao ? parseInt(String(pessoaNormalizada.tituloEleitor.secao).replace(/\D/g, '')) || 0 : 0
          };
        }

        // Normaliza PIS/PASEP - IMPORTANTE: Converte para número inteiro
        if (pessoaNormalizada.pisPasep) {
          var pisPasepLimpo = String(pessoaNormalizada.pisPasep).replace(/\D/g, '');
          pessoaNormalizada.pisPasep = pisPasepLimpo ? parseInt(pisPasepLimpo) : null;
        }

        // Normaliza Órgão de Classe
        if (pessoaNormalizada.orgaoClasse) {
          pessoaNormalizada.orgaoClasse = {
            descricao: pessoaNormalizada.orgaoClasse.descricao || '',
            numero: pessoaNormalizada.orgaoClasse.numero || ''
          };
        }

        // Normaliza CNH
        if (pessoaNormalizada.cnh) {
          pessoaNormalizada.cnh = {
            numero: pessoaNormalizada.cnh.numero ? parseInt(String(pessoaNormalizada.cnh.numero).replace(/\D/g, '')) || 0 : 0,
            categoria: pessoaNormalizada.cnh.categoria || '',
            validade: pessoaNormalizada.cnh.validade || ''
          };
        }
      } catch (error) {
        console.error('Erro ao normalizar documentos completos:', error);
      }

      return pessoaNormalizada;
    },
    normalizaDadosPessoais: function normalizaDadosPessoais(pessoa) {
      if (!pessoa) return {
        nome: '',
        dataNascimento: '',
        racaCor: '',
        estadoCivil: '',
        naturalidade: {
          cidade: '',
          uf: ''
        },
        orientacaoSexual: '',
        genero: ''
      };

      return {
        nome: (pessoa.nome || '').trim().toUpperCase(),
        dataNascimento: pessoa.dataNascimento || '',
        racaCor: (pessoa.racaCor || '').trim(),
        estadoCivil: (pessoa.estadoCivil || '').trim(),
        naturalidade: {
          cidade: pessoa.naturalidade && pessoa.naturalidade.cidade ? pessoa.naturalidade.cidade.trim().toUpperCase() : '',
          uf: pessoa.naturalidade && pessoa.naturalidade.uf ? pessoa.naturalidade.uf.trim().toUpperCase() : ''
        },
        orientacaoSexual: (pessoa.orientacaoSexual || '').trim(),
        genero: (pessoa.genero || '').trim()
      };
    },
    verificaAlteracoes: function verificaAlteracoes() {

      var cadastroModelo = this.$store.state.cadastroModelo;
      if (!cadastroModelo) return false;

      // Se o status já for diferente de RECADASTRAMENTO_PENDENTE, retorne true
      // para manter o comportamento atual e não mostrar o botão "Confirmar"
      if (this.cadastrado.status !== __WEBPACK_IMPORTED_MODULE_19__status__["default"].RECADASTRAMENTO_PENDENTE) {
        return true;
      }

      // Verificação detalhada para documentos
      // RG
      var rgAtual = this.cadastrado.pessoa.rg ? this.cadastrado.pessoa.rg : null;
      var rgOriginal = cadastroModelo.pessoa.rg ? cadastroModelo.pessoa.rg : null;

      // Título de Eleitor
      var tituloAtual = this.cadastrado.pessoa.tituloEleitor ? this.cadastrado.pessoa.tituloEleitor : null;
      var tituloOriginal = cadastroModelo.pessoa.tituloEleitor ? cadastroModelo.pessoa.tituloEleitor : null;

      // PIS/PASEP
      var pisPasepAtual = this.cadastrado.pessoa.pisPasep;
      var pisPasepOriginal = cadastroModelo.pessoa.pisPasep;

      // Órgão de Classe
      var orgaoClasseAtual = this.cadastrado.pessoa.orgaoClasse ? this.cadastrado.pessoa.orgaoClasse : null;
      var orgaoClasseOriginal = cadastroModelo.pessoa.orgaoClasse ? cadastroModelo.pessoa.orgaoClasse : null;

      // CNH
      var cnhAtual = this.cadastrado.pessoa.cnh ? this.cadastrado.pessoa.cnh : null;
      var cnhOriginal = cadastroModelo.pessoa.cnh ? cadastroModelo.pessoa.cnh : null;

      // Verificação para filiação (nome do pai e da mãe)
      var paiAtual = this.cadastrado.pessoa.filiacao ? this.cadastrado.pessoa.filiacao.pai : null;
      var paiOriginal = cadastroModelo.pessoa.filiacao ? cadastroModelo.pessoa.filiacao.pai : null;

      var maeAtual = this.cadastrado.pessoa.filiacao ? this.cadastrado.pessoa.filiacao.mae : null;
      var maeOriginal = cadastroModelo.pessoa.filiacao ? cadastroModelo.pessoa.filiacao.mae : null;

      // Verificação para dependentes (Quadro Familiar)
      var dependentesAtuais = this.cadastrado.pessoa.dependentes || [];
      var dependentesOriginais = cadastroModelo.pessoa.dependentes || [];

      // Normaliza os dados para comparação
      var rgAtualNormalizado = this.normalizaRG(rgAtual);
      var rgOriginalNormalizado = this.normalizaRG(rgOriginal);

      var tituloAtualNormalizado = this.normalizaTitulo(tituloAtual);
      var tituloOriginalNormalizado = this.normalizaTitulo(tituloOriginal);

      var pisPasepAtualLimpo = pisPasepAtual ? String(pisPasepAtual).replace(/\D/g, '') : null;
      var pisPasepOriginalLimpo = pisPasepOriginal ? String(pisPasepOriginal).replace(/\D/g, '') : null;

      var orgaoClasseAtualNormalizado = this.normalizaOrgaoClasse(orgaoClasseAtual);
      var orgaoClasseOriginalNormalizado = this.normalizaOrgaoClasse(orgaoClasseOriginal);

      var cnhAtualNormalizado = this.normalizaCNH(cnhAtual);
      var cnhOriginalNormalizado = this.normalizaCNH(cnhOriginal);

      // Verifique se há alterações nos documentos
      var temAlteracoesRG = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(rgAtualNormalizado) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(rgOriginalNormalizado);
      var temAlteracoesTitulo = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(tituloAtualNormalizado) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(tituloOriginalNormalizado);
      var temAlteracoesPisPasep = pisPasepAtualLimpo !== pisPasepOriginalLimpo;
      var temAlteracoesOrgaoClasse = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(orgaoClasseAtualNormalizado) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(orgaoClasseOriginalNormalizado);
      var temAlteracoesCNH = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(cnhAtualNormalizado) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(cnhOriginalNormalizado);

      var temAlteracoesDocumentos = temAlteracoesRG || temAlteracoesTitulo || temAlteracoesPisPasep || temAlteracoesOrgaoClasse || temAlteracoesCNH;

      //  Verifique se há alterações na filiação
      var temAlteracoesFiliacao = paiAtual !== paiOriginal || maeAtual !== maeOriginal;

      // Verifique se há alterações nos dependentes
      var temAlteracoesDependentes = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dependentesAtuais) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dependentesOriginais);

      // Adicione logs para facilitar a depuração de dependentes
      if (temAlteracoesDependentes) {
        console.log('Diferenças nos dependentes detectadas:');
        console.log('Dependentes atuais:', dependentesAtuais.length);
        console.log('Dependentes originais:', dependentesOriginais.length);

        // Se os números forem diferentes, já sabemos que houve mudança
        if (dependentesAtuais.length !== dependentesOriginais.length) {
          console.log('Quantidade de dependentes foi alterada');
        }
      }

      // Verificação detalhada para contatos
      var contatoAtual = this.normalizaContato(this.cadastrado.pessoa.contato || {});
      var contatoOriginal = this.normalizaContato(cadastroModelo.pessoa.contato || {});

      // Verifica cada campo individualmente para facilitar o debug
      var emailAlterado = contatoAtual.email !== contatoOriginal.email;
      var dddCelularAlterado = contatoAtual.dddCelular !== contatoOriginal.dddCelular;
      var numeroCelularAlterado = contatoAtual.numeroCelular !== contatoOriginal.numeroCelular;
      var dddTelefoneAlterado = contatoAtual.dddTelefone !== contatoOriginal.dddTelefone;
      var numeroTelefoneAlterado = contatoAtual.numeroTelefone !== contatoOriginal.numeroTelefone;

      var temAlteracoesContato = emailAlterado || dddCelularAlterado || numeroCelularAlterado || dddTelefoneAlterado || numeroTelefoneAlterado;

      // Verifique alterações em raçaCor
      var racaCorAtual = this.cadastrado.pessoa.racaCor || '';
      var racaCorOriginal = cadastroModelo.pessoa.racaCor || '';

      var temAlteracoesRacaCor = racaCorAtual !== racaCorOriginal;

      // Verificação detalhada para endereço
      var enderecoAtual = this.normalizaEndereco(this.cadastrado.pessoa.endereco || {});
      var enderecoOriginal = this.normalizaEndereco(cadastroModelo.pessoa.endereco || {});

      // Verifica cada campo individualmente para facilitar o debug
      var cepAlterado = enderecoAtual.cep !== enderecoOriginal.cep;
      var tipoLogradouroAlterado = enderecoAtual.tipoLogradouro !== enderecoOriginal.tipoLogradouro;
      var logradouroAlterado = enderecoAtual.logradouro !== enderecoOriginal.logradouro;
      var numeroAlterado = enderecoAtual.numero !== enderecoOriginal.numero;
      var complementoAlterado = enderecoAtual.complemento !== enderecoOriginal.complemento;
      var bairroAlterado = enderecoAtual.bairro !== enderecoOriginal.bairro;
      var cidadeAlterado = enderecoAtual.cidade !== enderecoOriginal.cidade;
      var ufAlterado = enderecoAtual.uf !== enderecoOriginal.uf;
      var georreferenciadoAlterado = enderecoAtual.georreferenciado !== enderecoOriginal.georreferenciado;

      var temAlteracoesEndereco = cepAlterado || tipoLogradouroAlterado || logradouroAlterado || numeroAlterado || complementoAlterado || bairroAlterado || cidadeAlterado || ufAlterado || georreferenciadoAlterado;

      // Verificação detalhada para dados pessoais
      var dadosPessoaisAtuais = this.normalizaDadosPessoais(this.cadastrado.pessoa);
      var dadosPessoaisOriginais = this.normalizaDadosPessoais(cadastroModelo.pessoa);

      // Verifica cada campo individualmente para facilitar o debug
      var nomeAlterado = dadosPessoaisAtuais.nome !== dadosPessoaisOriginais.nome;
      var dataNascimentoAlterada = dadosPessoaisAtuais.dataNascimento !== dadosPessoaisOriginais.dataNascimento;
      var racaCorAlterada = dadosPessoaisAtuais.racaCor !== dadosPessoaisOriginais.racaCor;
      var estadoCivilAlterado = dadosPessoaisAtuais.estadoCivil !== dadosPessoaisOriginais.estadoCivil;

      // Verificação de naturalidade
      var cidadeNatalidadeAlterada = dadosPessoaisAtuais.naturalidade.cidade !== dadosPessoaisOriginais.naturalidade.cidade;
      var ufNatalidadeAlterada = dadosPessoaisAtuais.naturalidade.uf !== dadosPessoaisOriginais.naturalidade.uf;

      // Verificação de orientação sexual e identidade de gênero
      var orientacaoSexualAlterada = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dadosPessoaisAtuais.orientacaoSexual) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dadosPessoaisOriginais.orientacaoSexual);
      var identidadeGeneroAlterada = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dadosPessoaisAtuais.genero) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dadosPessoaisOriginais.genero);

      var temAlteracoesDadosPessoais = nomeAlterado || dataNascimentoAlterada || racaCorAlterada || estadoCivilAlterado || cidadeNatalidadeAlterada || ufNatalidadeAlterada || orientacaoSexualAlterada || identidadeGeneroAlterada;

      return temAlteracoesDocumentos || temAlteracoesFiliacao || temAlteracoesDependentes || temAlteracoesContato || temAlteracoesRacaCor || temAlteracoesEndereco || temAlteracoesDadosPessoais;
    },
    verificaMudancasAValidar: function verificaMudancasAValidar(cadastroNovo, cadastroOriginal) {
      if (!cadastroNovo || !cadastroOriginal) return false;
      if (!cadastroNovo.pessoa || !cadastroOriginal.pessoa) return false;

      try {
        var pessoaAtual = this.normalizaDocumentos(cadastroNovo.pessoa);
        var pessoaOriginal = this.normalizaDocumentos(cadastroOriginal.pessoa);

        if (pessoaAtual.endereco) {
          pessoaAtual.endereco = this.normalizaEndereco(pessoaAtual.endereco);
        }

        if (pessoaOriginal.endereco) {
          pessoaOriginal.endereco = this.normalizaEndereco(pessoaOriginal.endereco);
        }

        delete pessoaAtual.contato;
        delete pessoaAtual.racaCor;
        delete pessoaOriginal.contato;
        delete pessoaOriginal.racaCor;

        var strPessoaAtual = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(pessoaAtual);
        var strPessoaOriginal = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(pessoaOriginal);

        return strPessoaAtual !== strPessoaOriginal;
      } catch (error) {
        console.error('Erro ao verificar mudanças que precisam de validação:', error);
        return false;
      }
    },
    verificaMudancasSemValidacao: function verificaMudancasSemValidacao(cadastroNovo, cadastroOriginal) {
      if (!cadastroNovo || !cadastroOriginal) return false;
      if (!cadastroNovo.pessoa || !cadastroOriginal.pessoa) return false;

      try {
        var contatoAtual = this.normalizaContato(cadastroNovo.pessoa.contato || {});
        var contatoOriginal = this.normalizaContato(cadastroOriginal.pessoa.contato || {});

        var racaCorAtual = cadastroNovo.pessoa.racaCor || '';
        var racaCorOriginal = cadastroOriginal.pessoa.racaCor || '';

        var strContatoAtual = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(contatoAtual);
        var strContatoOriginal = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(contatoOriginal);
        var strRacaCorAtual = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(racaCorAtual);
        var strRacaCorOriginal = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(racaCorOriginal);

        return strContatoAtual !== strContatoOriginal || strRacaCorAtual !== strRacaCorOriginal;
      } catch (error) {
        console.error('Erro ao verificar mudanças sem validação:', error);
        return false;
      }
    },
    normalizaCamposData: function normalizaCamposData(obj) {
      if (!obj) return;

      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          var value = obj[key];

          if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(value)) === 'object' && value !== null) {
            this.normalizaCamposData(value);
          }

          if (typeof value === 'string' && (value.includes('/') || value.includes('-') || value.match(/^\d{4}/) || value.match(/^\d{2}/))) {
            try {
              var date = new Date(value.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1'));
              if (!isNaN(date.getTime())) {
                obj[key] = date.toISOString().split('T')[0];
              }
            } catch (e) {
              // Ignora erros de conversão
            }
          }
        }
      }
    },
    atualizaStatusParaEnvio: function atualizaStatusParaEnvio() {
      //console.log('atualizaStatusParaEnvio - Status atual:', this.cadastrado.status);

      // Se o status já for CONFIRMADO ou VALIDADO, não altere
      if (this.cadastrado.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].CONFIRMADO || this.cadastrado.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].VALIDADO || this.cadastrado.status === __WEBPACK_IMPORTED_MODULE_19__status__["default"].PENDENTE_VALE_TRANSPORTE) {
        console.log('Status já finalizado, não será alterado');
        return;
      }

      // Se o status já for diferente de RECADASTRAMENTO_PENDENTE, vamos verificar
      // se realmente existem alterações para mantê-lo
      if (this.cadastrado.status !== __WEBPACK_IMPORTED_MODULE_19__status__["default"].RECADASTRAMENTO_PENDENTE) {
        var temAlteracoes = this.verificaAlteracoes();
        if (!temAlteracoes) {
          // console.log('Não há alterações, status será redefinido para RECADASTRAMENTO_PENDENTE');
          this.cadastrado.status = __WEBPACK_IMPORTED_MODULE_19__status__["default"].RECADASTRAMENTO_PENDENTE;
          this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
          this.$store.dispatch('updateSituacaoRecad', __WEBPACK_IMPORTED_MODULE_19__status__["default"].RECADASTRAMENTO_PENDENTE);
          return;
        }

        console.log('Status atual será mantido pois existem alterações');
        return;
      }

      // Verificação detalhada para documentos
      // RG
      var rgAtual = this.cadastrado.pessoa.rg ? this.cadastrado.pessoa.rg : null;
      var rgOriginal = this.$store.state.cadastroModelo.pessoa.rg ? this.$store.state.cadastroModelo.pessoa.rg : null;

      // Título de Eleitor
      var tituloAtual = this.cadastrado.pessoa.tituloEleitor ? this.cadastrado.pessoa.tituloEleitor : null;
      var tituloOriginal = this.$store.state.cadastroModelo.pessoa.tituloEleitor ? this.$store.state.cadastroModelo.pessoa.tituloEleitor : null;

      // PIS/PASEP
      var pisPasepAtual = this.cadastrado.pessoa.pisPasep;
      var pisPasepOriginal = this.$store.state.cadastroModelo.pessoa.pisPasep;

      // Órgão de Classe
      var orgaoClasseAtual = this.cadastrado.pessoa.orgaoClasse ? this.cadastrado.pessoa.orgaoClasse : null;
      var orgaoClasseOriginal = this.$store.state.cadastroModelo.pessoa.orgaoClasse ? this.$store.state.cadastroModelo.pessoa.orgaoClasse : null;

      // CNH
      var cnhAtual = this.cadastrado.pessoa.cnh ? this.cadastrado.pessoa.cnh : null;
      var cnhOriginal = this.$store.state.cadastroModelo.pessoa.cnh ? this.$store.state.cadastroModelo.pessoa.cnh : null;

      // Verificação para filiação (nome do pai e da mãe)
      var paiAtual = this.cadastrado.pessoa.filiacao ? this.cadastrado.pessoa.filiacao.pai : null;
      var paiOriginal = this.$store.state.cadastroModelo.pessoa.filiacao ? this.$store.state.cadastroModelo.pessoa.filiacao.pai : null;

      var maeAtual = this.cadastrado.pessoa.filiacao ? this.cadastrado.pessoa.filiacao.mae : null;
      var maeOriginal = this.$store.state.cadastroModelo.pessoa.filiacao ? this.$store.state.cadastroModelo.pessoa.filiacao.mae : null;

      // Verificação para dependentes (Quadro Familiar)
      var dependentesAtuais = this.cadastrado.pessoa.dependentes || [];
      var dependentesOriginais = this.$store.state.cadastroModelo.pessoa.dependentes || [];

      // Normaliza os dados para comparação
      var rgAtualNormalizado = this.normalizaRG(rgAtual);
      var rgOriginalNormalizado = this.normalizaRG(rgOriginal);

      var tituloAtualNormalizado = this.normalizaTitulo(tituloAtual);
      var tituloOriginalNormalizado = this.normalizaTitulo(tituloOriginal);

      var pisPasepAtualLimpo = pisPasepAtual ? String(pisPasepAtual).replace(/\D/g, '') : null;
      var pisPasepOriginalLimpo = pisPasepOriginal ? String(pisPasepOriginal).replace(/\D/g, '') : null;

      var orgaoClasseAtualNormalizado = this.normalizaOrgaoClasse(orgaoClasseAtual);
      var orgaoClasseOriginalNormalizado = this.normalizaOrgaoClasse(orgaoClasseOriginal);

      var cnhAtualNormalizado = this.normalizaCNH(cnhAtual);
      var cnhOriginalNormalizado = this.normalizaCNH(cnhOriginal);

      // Verifique se há alterações nos documentos
      var temAlteracoesRG = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(rgAtualNormalizado) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(rgOriginalNormalizado);
      var temAlteracoesTitulo = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(tituloAtualNormalizado) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(tituloOriginalNormalizado);
      var temAlteracoesPisPasep = pisPasepAtualLimpo !== pisPasepOriginalLimpo;
      var temAlteracoesOrgaoClasse = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(orgaoClasseAtualNormalizado) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(orgaoClasseOriginalNormalizado);
      var temAlteracoesCNH = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(cnhAtualNormalizado) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(cnhOriginalNormalizado);

      var temAlteracoesDocumentos = temAlteracoesRG || temAlteracoesTitulo || temAlteracoesPisPasep || temAlteracoesOrgaoClasse || temAlteracoesCNH;

      // Verifique se há alterações na filiação
      var temAlteracoesFiliacao = paiAtual !== paiOriginal || maeAtual !== maeOriginal;

      // Verifique se há alterações nos dependentes
      var temAlteracoesDependentes = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dependentesAtuais) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dependentesOriginais);

      // Verificação detalhada para contatos
      var contatoAtual = this.normalizaContato(this.cadastrado.pessoa.contato || {});
      var contatoOriginal = this.normalizaContato(this.$store.state.cadastroModelo.pessoa.contato || {});

      // Verifica cada campo individualmente para facilitar o debug
      var emailAlterado = contatoAtual.email !== contatoOriginal.email;
      var dddCelularAlterado = contatoAtual.dddCelular !== contatoOriginal.dddCelular;
      var numeroCelularAlterado = contatoAtual.numeroCelular !== contatoOriginal.numeroCelular;
      var dddTelefoneAlterado = contatoAtual.dddTelefone !== contatoOriginal.dddTelefone;
      var numeroTelefoneAlterado = contatoAtual.numeroTelefone !== contatoOriginal.numeroTelefone;

      var temAlteracoesContato = emailAlterado || dddCelularAlterado || numeroCelularAlterado || dddTelefoneAlterado || numeroTelefoneAlterado;

      // Verifique alterações em raçaCor
      var racaCorAtual = this.cadastrado.pessoa.racaCor || '';
      var racaCorOriginal = this.$store.state.cadastroModelo.pessoa.racaCor || '';

      var temAlteracoesRacaCor = racaCorAtual !== racaCorOriginal;

      // Verificação detalhada para endereço
      var enderecoAtual = this.normalizaEndereco(this.cadastrado.pessoa.endereco || {});
      var enderecoOriginal = this.normalizaEndereco(this.$store.state.cadastroModelo.pessoa.endereco || {});

      // Verifica cada campo individualmente para facilitar o debug
      var cepAlterado = enderecoAtual.cep !== enderecoOriginal.cep;
      var tipoLogradouroAlterado = enderecoAtual.tipoLogradouro !== enderecoOriginal.tipoLogradouro;
      var logradouroAlterado = enderecoAtual.logradouro !== enderecoOriginal.logradouro;
      var numeroAlterado = enderecoAtual.numero !== enderecoOriginal.numero;
      var complementoAlterado = enderecoAtual.complemento !== enderecoOriginal.complemento;
      var bairroAlterado = enderecoAtual.bairro !== enderecoOriginal.bairro;
      var cidadeAlterado = enderecoAtual.cidade !== enderecoOriginal.cidade;
      var ufAlterado = enderecoAtual.uf !== enderecoOriginal.uf;
      var georreferenciadoAlterado = enderecoAtual.georreferenciado !== enderecoOriginal.georreferenciado;

      var temAlteracoesEndereco = cepAlterado || tipoLogradouroAlterado || logradouroAlterado || numeroAlterado || complementoAlterado || bairroAlterado || cidadeAlterado || ufAlterado || georreferenciadoAlterado;

      // Verificação detalhada para dados pessoais
      var dadosPessoaisAtuais = this.normalizaDadosPessoais(this.cadastrado.pessoa);
      var dadosPessoaisOriginais = this.normalizaDadosPessoais(this.$store.state.cadastroModelo.pessoa);

      // Verifica cada campo individualmente para facilitar o debug
      var nomeAlterado = dadosPessoaisAtuais.nome !== dadosPessoaisOriginais.nome;
      var dataNascimentoAlterada = dadosPessoaisAtuais.dataNascimento !== dadosPessoaisOriginais.dataNascimento;
      var racaCorAlterada = dadosPessoaisAtuais.racaCor !== dadosPessoaisOriginais.racaCor;
      var estadoCivilAlterado = dadosPessoaisAtuais.estadoCivil !== dadosPessoaisOriginais.estadoCivil;

      // Verificação de naturalidade
      var cidadeNatalidadeAlterada = dadosPessoaisAtuais.naturalidade.cidade !== dadosPessoaisOriginais.naturalidade.cidade;
      var ufNatalidadeAlterada = dadosPessoaisAtuais.naturalidade.uf !== dadosPessoaisOriginais.naturalidade.uf;

      // Verificação de orientação sexual e identidade de gênero
      var orientacaoSexualAlterada = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dadosPessoaisAtuais.orientacaoSexual) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dadosPessoaisOriginais.orientacaoSexual);
      var identidadeGeneroAlterada = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dadosPessoaisAtuais.genero) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(dadosPessoaisOriginais.genero);
      console.log;
      var temAlteracoesDadosPessoais = nomeAlterado || dataNascimentoAlterada || racaCorAlterada || estadoCivilAlterado || cidadeNatalidadeAlterada || ufNatalidadeAlterada || orientacaoSexualAlterada || identidadeGeneroAlterada;

      // Log para ajudar na depuração
      if (temAlteracoesDependentes) {
        console.log('Detectada alteração nos dependentes');
      }

      // Defina o status com base nas alterações
      if (temAlteracoesDocumentos || temAlteracoesFiliacao || temAlteracoesDependentes || dataNascimentoAlterada || estadoCivilAlterado || cidadeNatalidadeAlterada || ufNatalidadeAlterada || nomeAlterado) {
        console.log('Alterações exigem validação (COM_VALIDACAO)');
        this.cadastrado.status = __WEBPACK_IMPORTED_MODULE_19__status__["default"].COM_VALIDACAO;
      } else if (temAlteracoesContato || racaCorAlterada || orientacaoSexualAlterada || identidadeGeneroAlterada || temAlteracoesEndereco) {
        console.log('Alterações não exigem validação (SEM_VALIDACAO)');
        this.cadastrado.status = __WEBPACK_IMPORTED_MODULE_19__status__["default"].SEM_VALIDACAO;
      } else {
        console.log('Não há alterações (RECADASTRAMENTO_PENDENTE)');
        this.cadastrado.status = __WEBPACK_IMPORTED_MODULE_19__status__["default"].RECADASTRAMENTO_PENDENTE;
      }

      this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
      this.$store.dispatch('updateSituacaoRecad', this.cadastrado.status);
    },
    volta: function volta() {
      this.$router.go(-1);
    },
    chamaComponente: function chamaComponente(nomeComponente) {
      this.$router.push({ name: nomeComponente });
    },
    confirma: function confirma(cadastrado) {
      // Verifica os CPFs dos dependentes antes de prosseguir
      if (!this.verificaCPFsDependentes()) {
        return;
      }

      if (!this.verificarQuantidadeAnexos()) {
        return;
      }
      // Formata os números de telefone antes de enviar
      this.formataNumerosContato(cadastrado);

      var status = cadastrado.checkValetransporteEndereco ? __WEBPACK_IMPORTED_MODULE_19__status__["default"].PENDENTE_VALE_TRANSPORTE : __WEBPACK_IMPORTED_MODULE_19__status__["default"].CONFIRMADO;
      this.$store.dispatch('updateSituacaoRecad', status);

      this.salvaRecadastramento(cadastrado, cadastrado.status, status, true);
    },
    salvaValidado: function salvaValidado(cadastrado) {
      // Verifica os CPFs dos dependentes antes de prosseguir
      if (!this.verificaCPFsDependentes()) {
        return;
      }

      if (!this.verificarQuantidadeAnexos()) {
        return;
      }
      // Formata os números de telefone antes de enviar
      this.formataNumerosContato(cadastrado);

      var status = cadastrado.checkValetransporteEndereco ? __WEBPACK_IMPORTED_MODULE_19__status__["default"].PENDENTE_VALE_TRANSPORTE : __WEBPACK_IMPORTED_MODULE_19__status__["default"].VALIDADO;
      this.$store.dispatch('updateSituacaoRecad', status);

      this.salvaRecadastramento(cadastrado, cadastrado.status, status, true);
    },
    atualizaEnderecoLocal: function atualizaEnderecoLocal(endereco) {
      if (this.cadastrado && this.cadastrado.pessoa) {
        this.cadastrado.pessoa.endereco = endereco;
      }
    },
    salvaAlterado: function salvaAlterado(cadastrado) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var status;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this3.verificaCPFsDependentes()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (_this3.verificarQuantidadeAnexos()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                // Formata os números de telefone antes de enviar
                _this3.formataNumerosContato(cadastrado);

                status = cadastrado.checkValetransporteEndereco ? __WEBPACK_IMPORTED_MODULE_19__status__["default"].PENDENTE_VALE_TRANSPORTE : __WEBPACK_IMPORTED_MODULE_19__status__["default"].ALTERADO;


                _this3.$store.dispatch('updateSituacaoRecad', status);

                _context.next = 9;
                return _this3.salvaRecadastramento(cadastrado, cadastrado.status, status, true);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    salvaRecadastramento: function salvaRecadastramento(cadastrado, statusPrimario, statusNovo, finaliza) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var cadastroModelo, emailOriginal, ehEmailPrefeitura, email, response, cadastroAlterado, temMultiplosRegistros, cadastradoModelo, mensagem;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this4.verificaCPFsDependentes()) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                if (_this4.verificarQuantidadeAnexos()) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:

                // Valida email obrigatório (exceto se for email da prefeitura)
                cadastroModelo = _this4.$store.state.cadastroModelo;
                emailOriginal = cadastroModelo && cadastroModelo.pessoa && cadastroModelo.pessoa.contato && cadastroModelo.pessoa.contato.email;
                ehEmailPrefeitura = emailOriginal && emailOriginal.includes('@santos.sp.gov.br');

                if (ehEmailPrefeitura) {
                  _context2.next = 13;
                  break;
                }

                email = cadastrado && cadastrado.pessoa && cadastrado.pessoa.contato && cadastrado.pessoa.contato.email;

                if (!(!email || email.trim() === '')) {
                  _context2.next = 13;
                  break;
                }

                _this4.$root.$refs.toastr.e('O campo Email é obrigatório', 'Atenção');
                _this4.$router.push({ name: 'Contatos' });
                return _context2.abrupt('return');

              case 13:
                _context2.prev = 13;

                _this4.salvando = true;
                cadastrado.status = statusNovo;
                _this4.$store.dispatch('updateSituacaoRecad', statusNovo);

                // Formata os números de telefone antes de enviar
                _this4.formataNumerosContato(cadastrado);

                _context2.next = 20;
                return __WEBPACK_IMPORTED_MODULE_18__services_recadastramentoService__["a" /* default */].grava(cadastrado.id, cadastrado);

              case 20:
                response = _context2.sent;
                _context2.next = 23;
                return response;

              case 23:
                cadastroAlterado = _context2.sent;
                temMultiplosRegistros = _this4.cadastrado.mostraMultiplosRegistros;

                _this4.cadastrado = cadastroAlterado;
                _this4.cadastrado.mostraMultiplosRegistros = temMultiplosRegistros;
                _this4.$store.commit('setFuncionarioCadastrado', _this4.cadastrado);
                _this4.$store.dispatch('updateSituacaoRecad', _this4.cadastrado.status);

                cadastradoModelo = JSON.parse(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(_this4.cadastrado));

                _this4.$store.commit('setCadastroModelo', cadastradoModelo);

                if (finaliza) {
                  _this4.$router.push({ name: 'Fim' });
                }
                _this4.$root.$refs.toastr.s('Atualização Cadastral enviada', 'Sucesso');
                _this4.salvando = false;
                _context2.next = 44;
                break;

              case 36:
                _context2.prev = 36;
                _context2.t0 = _context2['catch'](13);

                cadastrado.status = statusPrimario;
                _this4.$store.dispatch('updateSituacaoRecad', statusPrimario);
                mensagem = __WEBPACK_IMPORTED_MODULE_16__helpers_ErrorHelper__["a" /* default */].trataMensagem(_context2.t0);

                console.log('Erro ao salvar recadastramento: ' + mensagem);
                _this4.$root.$refs.toastr.e(mensagem, 'Atenção');
                _this4.salvando = false;

              case 44:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[13, 36]]);
      }))();
    },
    selecionaArquivo: function selecionaArquivo() {
      if (this.verificaAlteracoes()) {
        this.abreModal('upload');
        this.cadastrado.status = __WEBPACK_IMPORTED_MODULE_19__status__["default"].ALTERADO;
        this.$store.dispatch('updateSituacaoRecad', __WEBPACK_IMPORTED_MODULE_19__status__["default"].ALTERADO);
      } else {
        this.$root.$refs.toastr.i('Não há alterações para anexar documentos', 'Informação');
      }
    },
    enviaArquivo: function enviaArquivo(cadastrado) {
      var _anexosTemporarios;

      // console.log(`Anexos Ref: ${this.$refs.uploader.arquivosParaEnviar}`);
      (_anexosTemporarios = this.anexosTemporarios).push.apply(_anexosTemporarios, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.$refs.uploader.arquivosParaEnviar));
      this.cadastrado.anexos = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.cadastrado.anexos), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.anexosTemporarios));
      // console.log(`Anexos Temporario: ${this.anexosTemporarios}`);
      // console.log(`Anexos: ${this.cadastrado.anexos}`);
      this.$eventBus.$emit('salva-arquivos');
    },
    finalizaUpload: function finalizaUpload() {
      this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
      this.$store.dispatch('updateSituacaoRecad', this.cadastrado.status);
      this.fechaModal('upload');
    },
    incluiMensagem: function incluiMensagem(documentosApi, documentosLocal) {
      if (!documentosLocal) documentosLocal = [];

      // Primeiro, remover todos os documentos de dependentes que possam estar na lista
      // para evitar duplicações quando houver alterações de tipo
      documentosLocal = documentosLocal.filter(function (doc) {
        return !doc.includes('Certidão de Nascimento ou de Óbito do parente') && !doc.includes('Certidão de Casamento Averbada') && !doc.includes('Escritura de União Estável');
      });

      // Usar um Set para controlar quais documentos serão adicionados
      var docsParaAdicionar = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();

      // Flag para verificar se temos alterações nos dependentes
      var temAlteracoesDependentes = false;

      // Verificar se houve alterações nos dependentes (antes do loop principal)
      if (this.cadastrado && this.cadastrado.pessoa && this.$store.state.cadastroModelo && this.$store.state.cadastroModelo.pessoa) {

        var dependentesAtuais = this.cadastrado.pessoa.dependentes || [];
        var dependentesOriginais = this.$store.state.cadastroModelo.pessoa.dependentes || [];

        // Verifica se há diferença no número de dependentes
        if (dependentesAtuais.length !== dependentesOriginais.length) {
          temAlteracoesDependentes = true;
        } else {
          // Verifica se algum dependente foi modificado
          dependentesAtuais.forEach(function (depAtual) {
            var depOriginal = dependentesOriginais.find(function (d) {
              return d.id === depAtual.id;
            });
            if (!depOriginal || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(depOriginal) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(depAtual)) {
              temAlteracoesDependentes = true;
            }
          });
        }
      }

      documentosApi.forEach(function (element) {
        switch (element.grupo) {
          case 'cnh':
            docsParaAdicionar.add('Carteira de Habilitação');
            break;
          case 'dependentes':
            temAlteracoesDependentes = true; // Se o grupo dependentes está explicitamente marcado, há alterações
            break;
          case 'dataNascimento':
            docsParaAdicionar.add('RG ou Certidão de Nascimento ou Decisão Judicial');
            break;
          case 'naturalidade':
            docsParaAdicionar.add('RG ou Certidão de Nascimento ou Decisão Judicial');
            break;
          case 'estadoCivil':
            docsParaAdicionar.add('Certidão de Casamento (a mais recente)');
            break;
          case 'filiacao':
            docsParaAdicionar.add('RG ou Certidão de Nascimento ou Decisão Judicial');
            break;
          case 'endereco':
            docsParaAdicionar.add('Comprovante de Residência recente (com menos de 90 dias)');
            break;
          case 'rg':
            docsParaAdicionar.add('RG (caso ainda não estiver anexado)');
            break;
          case 'tituloEleitor':
            docsParaAdicionar.add('Título de Eleitor');
            break;
          case 'pisPasep':
            docsParaAdicionar.add('PIS/PASEP');
            break;
          case 'orgaoClasse':
            docsParaAdicionar.add('Documento oficial do Conselho de Classe');
            break;
          default:
            break;
        }
      });

      // Se foi detectada alteração em dependentes, processar independente de estar nos grupos
      if (temAlteracoesDependentes && this.cadastrado && this.cadastrado.pessoa && this.cadastrado.pessoa.dependentes && this.$store.state.cadastroModelo && this.$store.state.cadastroModelo.pessoa) {

        var _dependentesAtuais = this.cadastrado.pessoa.dependentes || [];
        var _dependentesOriginais = this.$store.state.cadastroModelo.pessoa.dependentes || [];

        // Para cada dependente atual, verificar documentos necessários
        _dependentesAtuais.forEach(function (depAtual) {
          var depOriginal = _dependentesOriginais.find(function (d) {
            return d.id === depAtual.id;
          });

          // Se é novo OU se foi alterado
          if (!depOriginal || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(depOriginal) !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(depAtual)) {
            var tipoDesc = depAtual.tipo && depAtual.tipo.descricao ? depAtual.tipo.descricao.toUpperCase() : '';

            if (tipoDesc.includes('COMPANHEIRO') || tipoDesc.includes('COMPANHEIRA')) {
              docsParaAdicionar.add('Escritura de União Estável');
            } else if (tipoDesc.includes('ESPOSO') || tipoDesc.includes('ESPOSA')) {
              docsParaAdicionar.add('Certidão de Casamento Averbada');
            } else if (tipoDesc) {
              // Só adiciona se tiver algum tipo definido
              docsParaAdicionar.add('Certidão de Nascimento ou de Óbito do parente');
            }
          }
        });

        // Se não houve documentos adicionados para dependentes, mas há alterações
        // (por exemplo, um dependente foi removido), adicionar documento padrão
        var temDocumentoDependente = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(docsParaAdicionar).some(function (doc) {
          return doc.includes('Certidão') || doc.includes('Escritura');
        });

        if (!temDocumentoDependente && _dependentesAtuais.length > 0) {
          docsParaAdicionar.add('Certidão de Nascimento ou de Óbito do parente');
        }
      }

      // Adicionar os documentos acumulados ao array de documentosLocal
      docsParaAdicionar.forEach(function (doc) {
        return documentosLocal.push(doc);
      });

      return documentosLocal;
    },
    gravaPessoaEndereco: function gravaPessoaEndereco(editado) {
      try {
        if (!editado.cidade || !editado.uf) {
          throw new Error('Dados de endereço incompletos');
        }

        this.cadastrado.pessoa.endereco = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, editado, {
          numero: parseInt(editado.numero) || 0
        });

        this.tiraAcentuacao(this.cadastrado.pessoa.endereco);
        this.setAnexos(this.cadastrado, this.$store.state.cadastroModelo);
        this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
        return true;
      } catch (error) {
        this.$root.$refs.toastr.e('Erro ao salvar endereço', 'Erro');
        return false;
      }
    },
    forcaVerificacaoStatus: function forcaVerificacaoStatus() {
      console.log('Forçando verificação de status...');

      var temAlteracoes = this.verificaAlteracoes();
      //console.log('Tem alterações:', temAlteracoes);
      //console.log(`Anexos temporários: ${this.anexosTemporarios}`);

      if (!temAlteracoes) {
        console.log('Definindo status como RECADASTRAMENTO_PENDENTE');
        this.cadastrado.status = __WEBPACK_IMPORTED_MODULE_19__status__["default"].RECADASTRAMENTO_PENDENTE;
        this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
        this.$store.dispatch('updateSituacaoRecad', __WEBPACK_IMPORTED_MODULE_19__status__["default"].RECADASTRAMENTO_PENDENTE);
        this.$forceUpdate();
      } else {
        console.log('Atualizando status com base nas alterações');
        this.atualizaStatusParaEnvio();
      }
    },
    redefinirCadastroModelo: function redefinirCadastroModelo() {
      console.log('Redefinindo cadastro modelo...');
      var cadastroAtual = JSON.parse(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(this.cadastrado));
      this.$store.commit('setCadastroModelo', cadastroAtual);
      console.log('Cadastro modelo redefinido');
    },

    // Métodos auxiliares para normalização de documentos
    normalizaRG: function normalizaRG(rg) {
      if (!rg) return { numero: '', dataEmissao: '', orgaoEmissor: '', uf: '' };

      return {
        numero: rg.numero ? String(rg.numero).replace(/\D/g, '') : '',
        dataEmissao: rg.dataEmissao || '',
        orgaoEmissor: rg.orgaoEmissor || '',
        uf: rg.uf || ''
      };
    },
    normalizaTitulo: function normalizaTitulo(titulo) {
      if (!titulo) return { numero: '', zona: '', secao: '' };

      return {
        numero: titulo.numero ? String(titulo.numero).replace(/\D/g, '') : '',
        zona: titulo.zona ? String(titulo.zona).replace(/\D/g, '') : '',
        secao: titulo.secao ? String(titulo.secao).replace(/\D/g, '') : ''
      };
    },
    normalizaOrgaoClasse: function normalizaOrgaoClasse(orgaoClasse) {
      if (!orgaoClasse) return { descricao: '', numero: '' };

      return {
        descricao: orgaoClasse.descricao || '',
        numero: orgaoClasse.numero ? String(orgaoClasse.numero).replace(/\D/g, '') : ''
      };
    },
    normalizaCNH: function normalizaCNH(cnh) {
      if (!cnh) return { numero: '', categoria: '', validade: '' };

      return {
        numero: cnh.numero ? String(cnh.numero).replace(/\D/g, '') : '',
        categoria: cnh.categoria || '',
        validade: cnh.validade || ''
      };
    },
    formataNumerosContato: function formataNumerosContato(cadastrado) {
      // Verifica se existe pessoa e contato antes de tentar formatar
      if (!cadastrado || !cadastrado.pessoa || !cadastrado.pessoa.contato) return;

      var contato = cadastrado.pessoa.contato;

      // Função para limpar formatação (remove caracteres não numéricos)
      var limpaFormato = function limpaFormato(valor) {
        if (!valor) return null;
        return String(valor).replace(/\D/g, '');
      };

      // Função para converter para número inteiro
      var paraNumeroPossivelmente = function paraNumeroPossivelmente(valor) {
        if (!valor) return null;
        var limpo = limpaFormato(valor);
        return limpo ? Number(limpo) : null;
      };

      // Aplica a limpeza e conversão em todos os campos numéricos do contato
      contato.numeroCelular = paraNumeroPossivelmente(contato.numeroCelular);
      contato.numeroTelefone = paraNumeroPossivelmente(contato.numeroTelefone);
      contato.dddCelular = paraNumeroPossivelmente(contato.dddCelular);
      contato.dddTelefone = paraNumeroPossivelmente(contato.dddTelefone);
    }
  },

  created: function created() {
    var _this5 = this;

    //this.limparEstadoLocal();
    this.situacaoInicial = this.$store.state.situacaoRecad;
    console.log("Situacao Inicial:", this.situacaoInicial);
    console.log(this.determinarBotao());
    this.endPointUpload = 'recadastramento-servidores/' + this.cadastrado.id + '/anexos';
    this.navs[0].titulo = this.tituloResponsivo;
    this.cadastrado.pessoa = __WEBPACK_IMPORTED_MODULE_15__helpers_StringHelper__["a" /* default */].toUpperCaseInJson(this.cadastrado.pessoa, ['email']);

    if (!this.$store.state.cadastroModelo) {
      console.log('Criando cadastroModelo inicial');
      var cadastroInicial = JSON.parse(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(this.cadastrado));
      this.$store.commit('setCadastroModelo', cadastroInicial);
    }

    console.log('Forçando verificação inicial de status');
    this.forcaVerificacaoStatus();

    this.$eventBus.$on('dispensaUploader', function () {
      return _this5.finalizaUpload();
    });
    this.$eventBus.$on('salvaAvanca', function (nomeComponente) {
      _this5.chamaComponente(nomeComponente);
    });
    this.$on('atualizaEnderecoLocal', this.atualizaEnderecoLocal);

    this.$nextTick(function () {
      _this5.$forceUpdate();
    });
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  mutations: {
    limparAnexos: function limparAnexos(state) {
      if (state.funcionarioCadastrado !== undefined && state.funcionarioCadastrado !== null && state.funcionarioCadastrado.anexos) {
        state.funcionarioCadastrado.anexos = []; // Limpa o array
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.limparEstadoLocal();
    this.$eventBus.$off('dispensaUploader');
    this.$eventBus.$off('salvaAvanca');
    this.$off('atualizaEnderecoLocal');
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      console.log('beforeRouteEnter - Entrando na rota Envio');
      console.log('Rota anterior:', from.path);

      // Se estiver vindo da página de documentação ou filiação, redefina o cadastro modelo
      if (from.path.includes('documentacao') || from.path.includes('filiacao')) {
        console.log('Vindo de página que pode ter alterações, redefinindo cadastro modelo');
        // Não redefina todo o modelo, apenas force a verificação do status
        vm.forcaVerificacaoStatus();
      } else if (!vm.$store.state.cadastroModelo) {
        console.log('Criando cadastroModelo na entrada da rota');
        var cadastroInicial = JSON.parse(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(vm.cadastrado));
        vm.$store.commit('setCadastroModelo', cadastroInicial);
        vm.forcaVerificacaoStatus();
      } else {
        // Force a verificação de status em todos os casos
        vm.forcaVerificacaoStatus();
      }
    });
  },


  watch: {
    'cadastrado.status': {
      immediate: true,
      handler: function handler(newStatus, oldStatus) {
        console.log('Status alterado: ' + oldStatus + ' -> ' + newStatus);
        this.$store.dispatch('updateSituacaoRecad', newStatus);

        if (newStatus !== __WEBPACK_IMPORTED_MODULE_19__status__["default"].RECADASTRAMENTO_PENDENTE && !this.verificaAlteracoes()) {
          console.log('Forçando status para RECADASTRAMENTO_PENDENTE no watcher');
          this.cadastrado.status = __WEBPACK_IMPORTED_MODULE_19__status__["default"].RECADASTRAMENTO_PENDENTE;
          this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
          this.$store.dispatch('updateSituacaoRecad', __WEBPACK_IMPORTED_MODULE_19__status__["default"].RECADASTRAMENTO_PENDENTE);

          this.$forceUpdate();
        }
      }
    }
  }
});

/***/ }),

/***/ "zJ2E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ze16":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "navbar navbar-default navbar-fixed-top",
    attrs: {
      "id": "navbar",
      "role": "banner"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.overlaySuperior) ? _c('div', {
    attrs: {
      "id": "overlay"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenuSuperior()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.overlayLateral) ? _c('div', {
    attrs: {
      "id": "overlay"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row hidden-xs hidden-sm"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "navbar-brand navbar-brand-topo",
    attrs: {
      "to": "/",
      "title": "Início"
    }
  }, [_vm._v("Prefeitura de Santos")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.autenticado),
      expression: "autenticado"
    }],
    staticClass: "col-md-9"
  }, [_c('button', {
    staticClass: "navbar-toggle show",
    attrs: {
      "type": "button",
      "id": "btn-menu-superior"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenuSuperior()
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Menu lateral")]), _vm._v(" "), _c('span', {
    staticClass: "btntxt"
  }, [(_vm.usuario) ? _c('span', [_vm._v("Olá " + _vm._s(_vm.usuario) + "  ")]) : _c('span', [_vm._v("Olá " + _vm._s(_vm.sshd) + "  ")]), _vm._v(" "), (_vm.autenticados && _vm.autenticados.length > 1) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ('Trocar Registro'),
      expression: "'Trocar Registro'",
      modifiers: {
        "bottom": true
      }
    }],
    staticStyle: {
      "font-size": "0.9em"
    }
  }, [_vm._v(_vm._s(_vm.funcionario.registroFormatado) + "  ")]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "upper-off-canvas"
  }, [_c('div', {
    attrs: {
      "id": "menu-superior"
    }
  }, [_c('h3', [_vm._v("Usuário")]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills nav-stacked",
    attrs: {
      "id": "main-menu"
    }
  }, [(_vm.autenticados && _vm.autenticados.length > 1) ? _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoTrocaRegistro = !_vm.paraBaixoTrocaRegistro
      }
    }
  }, [_vm._v("\n                  Trocar Registro\n                  "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoTrocaRegistro)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuSuperior()
      }
    }
  }, [_c('li', _vm._l((_vm.autenticados), function(user) {
    return _c('a', {
      key: user.id,
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.trocaRegistro(user)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(user.registroFormatado) + "\n                    ")])
  }), 0), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toggleMenuSuperior()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/websshd",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Trocar Senha")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toggleMenuSuperior()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Conta'
      }
    }
  }, [_vm._v("Meus Dados")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toggleMenuSuperior()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Sair'
      }
    }
  }, [_vm._v("Sair")])], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row visible-xs visible-sm"
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-4"
  }, [_c('router-link', {
    staticClass: "navbar-brand navbar-brand-topo",
    attrs: {
      "to": "/",
      "title": "Início"
    }
  }, [_vm._v("Prefeitura de Santos")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.autenticado),
      expression: "autenticado"
    }],
    staticClass: "col-xs-4 col-sm-8"
  }, [_c('button', {
    staticClass: "navbar-toggle show",
    attrs: {
      "type": "button",
      "id": "btn-menu-lateral"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Menu lateral")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "off-canvas"
  }, [_c('div', {
    attrs: {
      "id": "menu-lateral"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "-15px",
      "margin-left": "-21px"
    },
    attrs: {
      "src": __webpack_require__("ZDE/"),
      "alt": "Logo Central Servidor"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Aplicação")]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav",
    attrs: {
      "id": "main-menu"
    }
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoDeclaracao = !_vm.paraBaixoDeclaracao
      }
    }
  }, [_vm._v("\n                Declarações\n                "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoDeclaracao)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'DeclaracaoBens'
      }
    }
  }, [_vm._v("Declaração de Bens")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dependente'
      }
    }
  }, [_vm._v("Parceiro Econômico")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoAvaliacao = !_vm.paraBaixoAvaliacao
      }
    }
  }, [_vm._v("\n                Avaliações\n                "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoAvaliacao)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Avaliacao'
      }
    }
  }, [_vm._v("Avaliação Periódica")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'AvaliacaoEstagioProbatorio'
      }
    }
  }, [_vm._v("Estágio Probatório")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoRecadastro = !_vm.paraBaixoRecadastro
      }
    }
  }, [_vm._v("\n                Atualização Cadastral\n                "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoRecadastro)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'MesCompetenciaOrdenado'
      }
    }
  }, [_vm._v("Dados Pessoais")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoFerias = !_vm.paraBaixoFerias
      }
    }
  }, [_vm._v("\n                Férias\n                "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoFerias)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Ferias'
      }
    }
  }, [_vm._v("Agendamento de Férias\n                  ")])], 1), _vm._v(" "), (_vm.ehResponsavelAprovador) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Aprovacao'
      }
    }
  }, [_vm._v("\n                    Aprovação de Férias\n                  ")])], 1) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoFormulario = !_vm.paraBaixoFormulario
      }
    }
  }, [_vm._v("\n                Formulários\n                "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoFormulario)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'FaltaLei'
      }
    }
  }, [_vm._v("Falta Lei")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'DeclaracaoInclusaoImpostoRenda'
      }
    }
  }, [_vm._v("Declaração de Inclusão\n                    IR")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'DeclaracaoExclusaoImpostoRenda'
      }
    }
  }, [_vm._v("Declaração de Exclusao\n                    IR")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoLinks = !_vm.paraBaixoLinks
      }
    }
  }, [_vm._v("\n                Links\n                "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoLinks)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  })])])]), _vm._v(" "), _c('h3', [_vm._v("\n            Usuário\n            "), (_vm.autenticados && _vm.autenticados.length > 1) ? _c('span', {
    staticStyle: {
      "font-size": "0.9em",
      "font-weight": "700",
      "color": "#b9d8b3"
    }
  }, [_vm._v("  " + _vm._s(_vm.funcionario.registroFormatado))]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav",
    attrs: {
      "id": "user-menu"
    }
  }, [(_vm.autenticados && _vm.autenticados.length > 1) ? _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.paraBaixoTrocaRegistro = !_vm.paraBaixoTrocaRegistro
      }
    }
  }, [_vm._v("\n                Trocar Registro\n                "), _c('span', {
    staticClass: "to-the-right"
  }, [_c('i', {
    class: _vm.downUp(_vm.paraBaixoTrocaRegistro)
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('li', _vm._l((_vm.autenticados), function(user) {
    return _c('a', {
      key: user.id,
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.trocaRegistro(user)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(user.registroFormatado) + "\n                  ")])
  }), 0), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/websshd",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Trocar Senha")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Conta'
      }
    }
  }, [_vm._v("Meus Dados")])], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-bottom": "32px"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenuLateral()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Sair'
      }
    }
  }, [_vm._v("Sair")])], 1)])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btnico"
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btnico"
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/jornada",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Jornada\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/jornada/downloads/manual.pdf",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-book",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Manual\n                    Jornada\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/jornada/downloads/formularios.docx",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Anexo Único\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://entrega.santos.sp.gov.br",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Entrega\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://webmail.santos.sp.gov.br",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" WebMail\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/sigm_web_adm_sistema",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-stethoscope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Perícia Médica\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-usd",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Holerite\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-paw",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Informe\n                    de Rendimentos\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Contagem de Tempo\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/legis/documents/55",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Estatuto\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://www.santos.sp.gov.br/portal/servidor",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Portal\n                    do Servidor\n                  ")])])
}]}

/***/ }),

/***/ "zfz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H/Zg");






var TiposBensService = function () {
  function TiposBensService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TiposBensService);

    throw 'Não é possível instanciar TiposBensService';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TiposBensService, null, [{
    key: 'lista',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var endpoint;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = mergeEndpoint();
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(endpoint);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lista() {
        return _ref.apply(this, arguments);
      }

      return lista;
    }()
  }]);

  return TiposBensService;
}();

/* harmony default export */ __webpack_exports__["a"] = (TiposBensService);


var mergeEndpoint = function mergeEndpoint() {
  return 'declaracoes-bens/tipos-itens';
};

/***/ }),

/***/ "zu1O":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('card-header', {
    attrs: {
      "titulo": ("Aprovação de Férias " + _vm.periodoAquisitivo)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row row-input hidden-xs"
  }, [(_vm.comboUors.length > 1) ? _c('div', {
    staticClass: "col-xs-4 col-sm-3 filter-element"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.uor),
      expression: "filter.uor"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "uor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.buscaFeriasAgendadas(_vm.funcionario, _vm.filter)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Unid. Organ.")]), _vm._v(" "), _vm._l((_vm.comboUors), function(uor) {
    return _c('option', {
      key: uor.id,
      domProps: {
        "value": uor
      }
    }, [_vm._v("\n                        " + _vm._s(uor.sigla) + " - " + _vm._s(uor.codigoCentroCusto) + "\n                      ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-sm-3 filter-element"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.status),
      expression: "filter.status"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.buscaFeriasAgendadas(_vm.funcionario, _vm.filter)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.comboStatus), function(status) {
    return _c('option', {
      key: status.name,
      domProps: {
        "value": status
      }
    }, [_vm._v("\n                        " + _vm._s(status.displayName &&
      status.displayName.toUpperCase()) + "\n                      ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    staticStyle: {
      "margin-top": "-1px"
    }
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde",
      "rotulo": "Limpar",
      "icone": "fa-refresh",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.limpa()
      }
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row row-input visible-xs"
  }, [_c('div', {
    staticClass: "filter-group"
  }, [(_vm.comboUors.length > 1) ? _c('div', {
    staticClass: "filter-field"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.uor),
      expression: "filter.uor"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "uor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.buscaFeriasAgendadas(_vm.funcionario, _vm.filter)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Unid. Organ.")]), _vm._v(" "), _vm._l((_vm.comboUors), function(uor) {
    return _c('option', {
      key: uor.id,
      domProps: {
        "value": uor.sigla
      }
    }, [_vm._v("\n                          " + _vm._s(uor.sigla) + "\n                        ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter-field-button"
  }, [_c('div', {
    staticClass: "filter-field"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.status),
      expression: "filter.status"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.buscaFeriasAgendadas(_vm.funcionario, _vm.filter)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.comboStatus), function(status) {
    return _c('option', {
      key: status.name,
      domProps: {
        "value": status
      }
    }, [_vm._v("\n                            " + _vm._s(status.displayName &&
      status.displayName.toUpperCase()) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "filter-button"
  }, [_c('botao', {
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "estilo": "vazado-verde",
      "rotulo": "",
      "icone": "fa-refresh",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.limpa()
      }
    }
  })], 1)]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', [_c('table-loader', {
    attrs: {
      "carregando": _vm.carregando
    }
  }, [(_vm.agendamentos && !_vm.agendamentos.length) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Você não tem\n                    agendamentos que correspondam com essa busca.\n                  ")]) : _c('div', [_c('table', {
    staticClass: "table table-striped table-hover table-standard"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Dias pendentes")]), _vm._v(" "), (_vm.temMultiplasUors) ? _c('th', [_vm._v("Lotação")]) : _vm._e(), _vm._v(" "), (_vm.temMultiplosAnos) ? _c('th', [_vm._v("Ano")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Início")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.agendamentos), function(ferias) {
    return _c('tr', {
      key: ferias.id,
      class: ferias.statusAprovacao === 'EM_ANALISE' ?
        'situacao-pendente' :
        ''
    }, [_c('td', [_vm._v("\n                            " + _vm._s(ferias.nome.toUpperCase()) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                            " + _vm._s(ferias.possuiDiasPendentes ? 'SIM' : '') + "\n                          ")]), _vm._v(" "), (_vm.temMultiplasUors) ? _c('td', [_vm._v("\n                            " + _vm._s(ferias.lotacao) + "\n                          ")]) : _vm._e(), _vm._v(" "), (_vm.temMultiplosAnos) ? _c('td', [_vm._v("\n                            " + _vm._s(ferias.ano) + "\n                          ")]) : _vm._e(), _vm._v(" "), (ferias.dataInicioFerias) ? _c('td', [_vm._v("\n                            " + _vm._s(_vm._f("formataData")(ferias.dataInicioFerias)) + "\n                          ")]) : _c('td', [_c('i', {
      staticClass: "fa fa-ellipsis-h fa-lg",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm._f("descricaoStatus")(ferias.statusAprovacao)) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticClass: "td-btns"
    }, [_c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Reprovar'),
        expression: "'Reprovar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-vermelho-sm",
        "icone": "fa fa-close fa-lg",
        "disabled": _vm.desabilitaAprovacaoOuReprovacao(ferias)
      },
      on: {
        "clicado": function($event) {
          return _vm.reprovar(ferias)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Aprovar'),
        expression: "'Aprovar'",
        modifiers: {
          "right": true
        }
      }],
      attrs: {
        "estilo": "vazado-verde-sm",
        "icone": "fa fa-check fa-lg",
        "disabled": _vm.desabilitaAprovacaoOuReprovacao(ferias)
      },
      on: {
        "clicado": function($event) {
          return _vm.aprovar(ferias)
        }
      }
    })], 1)])
  }), 0)]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover table-cards"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Agendamentos")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.agendamentos), function(ferias) {
    return _c('tr', {
      key: ferias.id,
      class: ferias.statusAprovacao === 'EM_ANALISE' ?
        'situacao-pendente' :
        ''
    }, [_c('td', [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                              " + _vm._s(ferias.nome.toUpperCase()) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "legends"
    }, [(_vm.temMultiplasUors) ? _c('div', [_vm._v("Lotação:")]) : _vm._e(), _vm._v(" "), (_vm.temMultiplosAnos) ? _c('div', [_vm._v("Ano:")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("Férias:")]), _vm._v(" "), _c('div', [_vm._v("Status:")]), _vm._v(" "), _c('div', [_vm._v("Dias pendentes:")])]), _vm._v(" "), _c('div', {
      staticClass: "values"
    }, [(_vm.temMultiplasUors) ? _c('div', [_vm._v("\n                                " + _vm._s(ferias.lotacao) + "\n                              ")]) : _vm._e(), _vm._v(" "), (_vm.temMultiplosAnos) ? _c('div', [_vm._v("\n                                " + _vm._s(ferias.ano) + "\n                              ")]) : _vm._e(), _vm._v(" "), (ferias.dataInicioFerias) ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("formataData")(ferias.dataInicioFerias)) + "\n                              ")]) : _c('div', [_c('i', {
      staticClass: "fa fa-ellipsis-h fa-lg",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("descricaoStatus")(ferias.statusAprovacao)) + "\n                              ")]), _vm._v(" "), _c('div', [_vm._v("\n                                " + _vm._s(ferias.possuiDiasPendentes ? 'SIM' : '') + "\n                              ")])]), _vm._v(" "), _c('div', {
      staticClass: "td-btns actions"
    }, [_c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Reprovar'),
        expression: "'Reprovar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-vermelho-sm",
        "icone": "fa fa-close fa-lg",
        "disabled": _vm.desabilitaAprovacaoOuReprovacao(ferias)
      },
      on: {
        "clicado": function($event) {
          return _vm.reprovar(ferias)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Aprovar'),
        expression: "'Aprovar'",
        modifiers: {
          "right": true
        }
      }],
      attrs: {
        "estilo": "vazado-verde-sm",
        "icone": "fa fa-check fa-lg",
        "disabled": _vm.desabilitaAprovacaoOuReprovacao(ferias)
      },
      on: {
        "clicado": function($event) {
          return _vm.aprovar(ferias)
        }
      }
    })], 1)])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-offset-4 col-sm-4 footer-controller-inner footer-center"
  }, [(!_vm.paginacao.ultimo) ? _c('botao', {
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "id": "mais-resultados",
      "tipo": "button",
      "estilo": "vazado-verde-dir",
      "rotulo": "Mais resultados",
      "icone": "fa-chevron-down"
    },
    on: {
      "clicado": function($event) {
        return _vm.listaMaisResultados(_vm.funcionario, _vm.filter)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 footer-controller-inner"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Imprimir",
      "icone": "imprimir-tabela"
    },
    on: {
      "clicado": function($event) {
        return _vm.imprime(_vm.funcionario.id, _vm.filter)
      }
    }
  })], 1)])])], 1)], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5",
    staticStyle: {
      "margin-top": "-1px"
    }
  }, [_c('p', {
    staticClass: "alerta"
  }, [_vm._v("\n                    Após aprovação das férias, essa data só poderá ser alterada mediante\n                    abertura de processo administrativo.\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-field"
  }, [_c('p', {
    staticClass: "alerta"
  }, [_vm._v("\n                        Após aprovação das férias, essa data só poderá ser alterada mediante\n                        abertura de processo administrativo.\n                      ")])])
}]}

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.9729966f09e2d2b412eb.js